const metaPref =
  [
    {
      "label": "基礎データ",
      "statId": "kiso",
      "children": [
        {
          "label": "Ａ人口・世帯",
          "statId": "0000010101",
          "children": [
            {
              "statId": "0000010101/A1101/人/a01/総人口",
              "label": "総人口",
              "cat01": "A1101",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A110101/人/a01/総人口（男）",
              "label": "総人口（男）",
              "cat01": "A110101",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A110102/人/a01/総人口（女）",
              "label": "総人口（女）",
              "cat01": "A110102",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1102/人/a01/日本人人口",
              "label": "日本人人口",
              "cat01": "A1102",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A110201/人/a01/日本人人口（男）",
              "label": "日本人人口（男）",
              "cat01": "A110201",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A110202/人/a01/日本人人口（女）",
              "label": "日本人人口（女）",
              "cat01": "A110202",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1201/人/a01/０～４歳人口",
              "label": "０～４歳人口",
              "cat01": "A1201",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120101/人/a01/０～４歳人口（男）",
              "label": "０～４歳人口（男）",
              "cat01": "A120101",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120102/人/a01/０～４歳人口（女）",
              "label": "０～４歳人口（女）",
              "cat01": "A120102",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1202/人/a01/５～９歳人口",
              "label": "５～９歳人口",
              "cat01": "A1202",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120201/人/a01/５～９歳人口（男）",
              "label": "５～９歳人口（男）",
              "cat01": "A120201",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120202/人/a01/５～９歳人口（女）",
              "label": "５～９歳人口（女）",
              "cat01": "A120202",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1203/人/a01/１０～１４歳人口",
              "label": "１０～１４歳人口",
              "cat01": "A1203",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120301/人/a01/１０～１４歳人口（男）",
              "label": "１０～１４歳人口（男）",
              "cat01": "A120301",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120302/人/a01/１０～１４歳人口（女）",
              "label": "１０～１４歳人口（女）",
              "cat01": "A120302",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1204/人/a01/１５～１９歳人口",
              "label": "１５～１９歳人口",
              "cat01": "A1204",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120401/人/a01/１５～１９歳人口（男）",
              "label": "１５～１９歳人口（男）",
              "cat01": "A120401",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120402/人/a01/１５～１９歳人口（女）",
              "label": "１５～１９歳人口（女）",
              "cat01": "A120402",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1205/人/a01/２０～２４歳人口",
              "label": "２０～２４歳人口",
              "cat01": "A1205",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120501/人/a01/２０～２４歳人口（男）",
              "label": "２０～２４歳人口（男）",
              "cat01": "A120501",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120502/人/a01/２０～２４歳人口（女）",
              "label": "２０～２４歳人口（女）",
              "cat01": "A120502",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1206/人/a01/２５～２９歳人口",
              "label": "２５～２９歳人口",
              "cat01": "A1206",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120601/人/a01/２５～２９歳人口（男）",
              "label": "２５～２９歳人口（男）",
              "cat01": "A120601",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120602/人/a01/２５～２９歳人口（女）",
              "label": "２５～２９歳人口（女）",
              "cat01": "A120602",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1207/人/a01/３０～３４歳人口",
              "label": "３０～３４歳人口",
              "cat01": "A1207",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120701/人/a01/３０～３４歳人口（男）",
              "label": "３０～３４歳人口（男）",
              "cat01": "A120701",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120702/人/a01/３０～３４歳人口（女）",
              "label": "３０～３４歳人口（女）",
              "cat01": "A120702",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1208/人/a01/３５～３９歳人口",
              "label": "３５～３９歳人口",
              "cat01": "A1208",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120801/人/a01/３５～３９歳人口（男）",
              "label": "３５～３９歳人口（男）",
              "cat01": "A120801",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120802/人/a01/３５～３９歳人口（女）",
              "label": "３５～３９歳人口（女）",
              "cat01": "A120802",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1209/人/a01/４０～４４歳人口",
              "label": "４０～４４歳人口",
              "cat01": "A1209",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120901/人/a01/４０～４４歳人口（男）",
              "label": "４０～４４歳人口（男）",
              "cat01": "A120901",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A120902/人/a01/４０～４４歳人口（女）",
              "label": "４０～４４歳人口（女）",
              "cat01": "A120902",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1210/人/a01/４５～４９歳人口",
              "label": "４５～４９歳人口",
              "cat01": "A1210",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121001/人/a01/４５～４９歳人口（男）",
              "label": "４５～４９歳人口（男）",
              "cat01": "A121001",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121002/人/a01/４５～４９歳人口（女）",
              "label": "４５～４９歳人口（女）",
              "cat01": "A121002",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1211/人/a01/５０～５４歳人口",
              "label": "５０～５４歳人口",
              "cat01": "A1211",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121101/人/a01/５０～５４歳人口（男）",
              "label": "５０～５４歳人口（男）",
              "cat01": "A121101",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121102/人/a01/５０～５４歳人口（女）",
              "label": "５０～５４歳人口（女）",
              "cat01": "A121102",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1212/人/a01/５５～５９歳人口",
              "label": "５５～５９歳人口",
              "cat01": "A1212",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121201/人/a01/５５～５９歳人口（男）",
              "label": "５５～５９歳人口（男）",
              "cat01": "A121201",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121202/人/a01/５５～５９歳人口（女）",
              "label": "５５～５９歳人口（女）",
              "cat01": "A121202",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1213/人/a01/６０～６４歳人口",
              "label": "６０～６４歳人口",
              "cat01": "A1213",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121301/人/a01/６０～６４歳人口（男）",
              "label": "６０～６４歳人口（男）",
              "cat01": "A121301",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121302/人/a01/６０～６４歳人口（女）",
              "label": "６０～６４歳人口（女）",
              "cat01": "A121302",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1214/人/a01/６５～６９歳人口",
              "label": "６５～６９歳人口",
              "cat01": "A1214",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121401/人/a01/６５～６９歳人口（男）",
              "label": "６５～６９歳人口（男）",
              "cat01": "A121401",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121402/人/a01/６５～６９歳人口（女）",
              "label": "６５～６９歳人口（女）",
              "cat01": "A121402",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1215/人/a01/７０～７４歳人口",
              "label": "７０～７４歳人口",
              "cat01": "A1215",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121501/人/a01/７０～７４歳人口（男）",
              "label": "７０～７４歳人口（男）",
              "cat01": "A121501",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121502/人/a01/７０～７４歳人口（女）",
              "label": "７０～７４歳人口（女）",
              "cat01": "A121502",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1216/人/a01/７５～７９歳人口",
              "label": "７５～７９歳人口",
              "cat01": "A1216",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121601/人/a01/７５～７９歳人口（男）",
              "label": "７５～７９歳人口（男）",
              "cat01": "A121601",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A121602/人/a01/７５～７９歳人口（女）",
              "label": "７５～７９歳人口（女）",
              "cat01": "A121602",
              "unit": "人",
              "sourceId": "a01"
            },
            {
              "statId": "0000010101/A1217/人/a02/８０～８４歳人口",
              "label": "８０～８４歳人口",
              "cat01": "A1217",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121701/人/a02/８０～８４歳人口（男）",
              "label": "８０～８４歳人口（男）",
              "cat01": "A121701",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121702/人/a02/８０～８４歳人口（女）",
              "label": "８０～８４歳人口（女）",
              "cat01": "A121702",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1218/人/a02/８５～８９歳人口",
              "label": "８５～８９歳人口",
              "cat01": "A1218",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121801/人/a02/８５～８９歳人口（男）",
              "label": "８５～８９歳人口（男）",
              "cat01": "A121801",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121802/人/a02/８５～８９歳人口（女）",
              "label": "８５～８９歳人口（女）",
              "cat01": "A121802",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1219/人/a02/９０～９４歳人口",
              "label": "９０～９４歳人口",
              "cat01": "A1219",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121901/人/a02/９０～９４歳人口（男）",
              "label": "９０～９４歳人口（男）",
              "cat01": "A121901",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A121902/人/a02/９０～９４歳人口（女）",
              "label": "９０～９４歳人口（女）",
              "cat01": "A121902",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1220/人/a02/９５～９９歳人口",
              "label": "９５～９９歳人口",
              "cat01": "A1220",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A122001/人/a02/９５～９９歳人口（男）",
              "label": "９５～９９歳人口（男）",
              "cat01": "A122001",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A122002/人/a02/９５～９９歳人口（女）",
              "label": "９５～９９歳人口（女）",
              "cat01": "A122002",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1221/人/a02/１００歳以上人口",
              "label": "１００歳以上人口",
              "cat01": "A1221",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A122101/人/a02/１００歳以上人口（男）",
              "label": "１００歳以上人口（男）",
              "cat01": "A122101",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A122102/人/a02/１００歳以上人口（女）",
              "label": "１００歳以上人口（女）",
              "cat01": "A122102",
              "unit": "人",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1231/歳/a02/年齢中位数",
              "label": "年齢中位数",
              "cat01": "A1231",
              "unit": "歳",
              "sourceId": "a02"
            },
            {
              "statId": "0000010101/A1301/人/a03/１５歳未満人口",
              "label": "１５歳未満人口",
              "cat01": "A1301",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130101/人/a03/１５歳未満人口（男）",
              "label": "１５歳未満人口（男）",
              "cat01": "A130101",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130102/人/a03/１５歳未満人口（女）",
              "label": "１５歳未満人口（女）",
              "cat01": "A130102",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1302/人/a03/１５～６４歳人口",
              "label": "１５～６４歳人口",
              "cat01": "A1302",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130201/人/a03/１５～６４歳人口（男）",
              "label": "１５～６４歳人口（男）",
              "cat01": "A130201",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130202/人/a03/１５～６４歳人口（女）",
              "label": "１５～６４歳人口（女）",
              "cat01": "A130202",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1303/人/a03/６５歳以上人口",
              "label": "６５歳以上人口",
              "cat01": "A1303",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130301/人/a03/６５歳以上人口（男）",
              "label": "６５歳以上人口（男）",
              "cat01": "A130301",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130302/人/a03/６５歳以上人口（女）",
              "label": "６５歳以上人口（女）",
              "cat01": "A130302",
              "unit": "人",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1304/％/a03/１５歳未満人口割合",
              "label": "１５歳未満人口割合",
              "cat01": "A1304",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130401/％/a03/１５歳未満人口割合（男）",
              "label": "１５歳未満人口割合（男）",
              "cat01": "A130401",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130402/％/a03/１５歳未満人口割合（女）",
              "label": "１５歳未満人口割合（女）",
              "cat01": "A130402",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1305/％/a03/１５～６４歳人口割合",
              "label": "１５～６４歳人口割合",
              "cat01": "A1305",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130501/％/a03/１５～６４歳人口割合（男）",
              "label": "１５～６４歳人口割合（男）",
              "cat01": "A130501",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130502/％/a03/１５～６４歳人口割合（女）",
              "label": "１５～６４歳人口割合（女）",
              "cat01": "A130502",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1306/％/a03/６５歳以上人口割合",
              "label": "６５歳以上人口割合",
              "cat01": "A1306",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130601/％/a03/６５歳以上人口割合（男）",
              "label": "６５歳以上人口割合（男）",
              "cat01": "A130601",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A130602/％/a03/６５歳以上人口割合（女）",
              "label": "６５歳以上人口割合（女）",
              "cat01": "A130602",
              "unit": "％",
              "sourceId": "a03"
            },
            {
              "statId": "0000010101/A1401/人/a04/３歳人口",
              "label": "３歳人口",
              "cat01": "A1401",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140101/人/a04/３歳人口（男）",
              "label": "３歳人口（男）",
              "cat01": "A140101",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140102/人/a04/３歳人口（女）",
              "label": "３歳人口（女）",
              "cat01": "A140102",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1402/人/a04/４歳人口",
              "label": "４歳人口",
              "cat01": "A1402",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140201/人/a04/４歳人口（男）",
              "label": "４歳人口（男）",
              "cat01": "A140201",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140202/人/a04/４歳人口（女）",
              "label": "４歳人口（女）",
              "cat01": "A140202",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1403/人/a04/５歳人口",
              "label": "５歳人口",
              "cat01": "A1403",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140301/人/a04/５歳人口（男）",
              "label": "５歳人口（男）",
              "cat01": "A140301",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140302/人/a04/５歳人口（女）",
              "label": "５歳人口（女）",
              "cat01": "A140302",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1404/人/a04/０～３歳人口",
              "label": "０～３歳人口",
              "cat01": "A1404",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140401/人/a04/０～３歳人口（男）",
              "label": "０～３歳人口（男）",
              "cat01": "A140401",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140402/人/a04/０～３歳人口（女）",
              "label": "０～３歳人口（女）",
              "cat01": "A140402",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1405/人/a04/０～５歳人口",
              "label": "０～５歳人口",
              "cat01": "A1405",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140501/人/a04/０～５歳人口（男）",
              "label": "０～５歳人口（男）",
              "cat01": "A140501",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140502/人/a04/０～５歳人口（女）",
              "label": "０～５歳人口（女）",
              "cat01": "A140502",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1406/人/a04/０～１５歳人口",
              "label": "０～１５歳人口",
              "cat01": "A1406",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140601/人/a04/０～１５歳人口（男）",
              "label": "０～１５歳人口（男）",
              "cat01": "A140601",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140602/人/a04/０～１５歳人口（女）",
              "label": "０～１５歳人口（女）",
              "cat01": "A140602",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1407/人/a04/０～１７歳人口",
              "label": "０～１７歳人口",
              "cat01": "A1407",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140701/人/a04/０～１７歳人口（男）",
              "label": "０～１７歳人口（男）",
              "cat01": "A140701",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140702/人/a04/０～１７歳人口（女）",
              "label": "０～１７歳人口（女）",
              "cat01": "A140702",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1408/人/a04/３～５歳人口",
              "label": "３～５歳人口",
              "cat01": "A1408",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140801/人/a04/３～５歳人口（男）",
              "label": "３～５歳人口（男）",
              "cat01": "A140801",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140802/人/a04/３～５歳人口（女）",
              "label": "３～５歳人口（女）",
              "cat01": "A140802",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1409/人/a04/６～１１歳人口",
              "label": "６～１１歳人口",
              "cat01": "A1409",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140901/人/a04/６～１１歳人口（男）",
              "label": "６～１１歳人口（男）",
              "cat01": "A140901",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A140902/人/a04/６～１１歳人口（女）",
              "label": "６～１１歳人口（女）",
              "cat01": "A140902",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1410/人/a04/１０～１３歳人口",
              "label": "１０～１３歳人口",
              "cat01": "A1410",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141001/人/a04/１０～１３歳人口（男）",
              "label": "１０～１３歳人口（男）",
              "cat01": "A141001",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141002/人/a04/１０～１３歳人口（女）",
              "label": "１０～１３歳人口（女）",
              "cat01": "A141002",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1411/人/a04/１２～１４歳人口",
              "label": "１２～１４歳人口",
              "cat01": "A1411",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141101/人/a04/１２～１４歳人口（男）",
              "label": "１２～１４歳人口（男）",
              "cat01": "A141101",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141102/人/a04/１２～１４歳人口（女）",
              "label": "１２～１４歳人口（女）",
              "cat01": "A141102",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1412/人/a04/１４～１９歳人口",
              "label": "１４～１９歳人口",
              "cat01": "A1412",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141201/人/a04/１４～１９歳人口（男）",
              "label": "１４～１９歳人口（男）",
              "cat01": "A141201",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141202/人/a04/１４～１９歳人口（女）",
              "label": "１４～１９歳人口（女）",
              "cat01": "A141202",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1413/人/a04/１５～１７歳人口",
              "label": "１５～１７歳人口",
              "cat01": "A1413",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141301/人/a04/１５～１７歳人口（男）",
              "label": "１５～１７歳人口（男）",
              "cat01": "A141301",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A141302/人/a04/１５～１７歳人口（女）",
              "label": "１５～１７歳人口（女）",
              "cat01": "A141302",
              "unit": "人",
              "sourceId": "a04"
            },
            {
              "statId": "0000010101/A1414/人/a05/１５歳以上人口（国勢調査結果）",
              "label": "１５歳以上人口（国勢調査結果）",
              "cat01": "A1414",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141401/人/a05/１５歳以上人口（男）（国勢調査結果）",
              "label": "１５歳以上人口（男）（国勢調査結果）",
              "cat01": "A141401",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141402/人/a05/１５歳以上人口（女）（国勢調査結果）",
              "label": "１５歳以上人口（女）（国勢調査結果）",
              "cat01": "A141402",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1415/人/a05/４０歳以上人口",
              "label": "４０歳以上人口",
              "cat01": "A1415",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141501/人/a05/４０歳以上人口（男）",
              "label": "４０歳以上人口（男）",
              "cat01": "A141501",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141502/人/a05/４０歳以上人口（女）",
              "label": "４０歳以上人口（女）",
              "cat01": "A141502",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1416/人/a05/６０歳以上人口",
              "label": "６０歳以上人口",
              "cat01": "A1416",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141601/人/a05/６０歳以上人口（男）",
              "label": "６０歳以上人口（男）",
              "cat01": "A141601",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141602/人/a05/６０歳以上人口（女）",
              "label": "６０歳以上人口（女）",
              "cat01": "A141602",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1417/人/a05/７０歳以上人口",
              "label": "７０歳以上人口",
              "cat01": "A1417",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141701/人/a05/７０歳以上人口（男）",
              "label": "７０歳以上人口（男）",
              "cat01": "A141701",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141702/人/a05/７０歳以上人口（女）",
              "label": "７０歳以上人口（女）",
              "cat01": "A141702",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1418/人/a05/８０歳以上人口",
              "label": "８０歳以上人口",
              "cat01": "A1418",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141801/人/a05/８０歳以上人口（男）",
              "label": "８０歳以上人口（男）",
              "cat01": "A141801",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141802/人/a05/８０歳以上人口（女）",
              "label": "８０歳以上人口（女）",
              "cat01": "A141802",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1419/人/a05/７５歳以上人口",
              "label": "７５歳以上人口",
              "cat01": "A1419",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141901/人/a05/７５歳以上人口（男）",
              "label": "７５歳以上人口（男）",
              "cat01": "A141901",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A141902/人/a05/７５歳以上人口（女）",
              "label": "７５歳以上人口（女）",
              "cat01": "A141902",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1420/人/a05/８５歳以上人口",
              "label": "８５歳以上人口",
              "cat01": "A1420",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A142001/人/a05/８５歳以上人口（男）",
              "label": "８５歳以上人口（男）",
              "cat01": "A142001",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A142002/人/a05/８５歳以上人口（女）",
              "label": "８５歳以上人口（女）",
              "cat01": "A142002",
              "unit": "人",
              "sourceId": "a05"
            },
            {
              "statId": "0000010101/A1501/人/a06/－１歳人口",
              "label": "－１歳人口",
              "cat01": "A1501",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1502/人/a06/０歳人口",
              "label": "０歳人口",
              "cat01": "A1502",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150201/人/a06/０歳人口（男）",
              "label": "０歳人口（男）",
              "cat01": "A150201",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150202/人/a06/０歳人口（女）",
              "label": "０歳人口（女）",
              "cat01": "A150202",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1503/人/a06/１歳人口",
              "label": "１歳人口",
              "cat01": "A1503",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150301/人/a06/１歳人口（男）",
              "label": "１歳人口（男）",
              "cat01": "A150301",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150302/人/a06/１歳人口（女）",
              "label": "１歳人口（女）",
              "cat01": "A150302",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1504/人/a06/２歳人口",
              "label": "２歳人口",
              "cat01": "A1504",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150401/人/a06/２歳人口（男）",
              "label": "２歳人口（男）",
              "cat01": "A150401",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150402/人/a06/２歳人口（女）",
              "label": "２歳人口（女）",
              "cat01": "A150402",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1505/人/a06/６歳人口",
              "label": "６歳人口",
              "cat01": "A1505",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150501/人/a06/６歳人口（男）",
              "label": "６歳人口（男）",
              "cat01": "A150501",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150502/人/a06/６歳人口（女）",
              "label": "６歳人口（女）",
              "cat01": "A150502",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1506/人/a06/７歳人口",
              "label": "７歳人口",
              "cat01": "A1506",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150601/人/a06/７歳人口（男）",
              "label": "７歳人口（男）",
              "cat01": "A150601",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150602/人/a06/７歳人口（女）",
              "label": "７歳人口（女）",
              "cat01": "A150602",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1507/人/a06/８歳人口",
              "label": "８歳人口",
              "cat01": "A1507",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150701/人/a06/８歳人口（男）",
              "label": "８歳人口（男）",
              "cat01": "A150701",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150702/人/a06/８歳人口（女）",
              "label": "８歳人口（女）",
              "cat01": "A150702",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1508/人/a06/９歳人口",
              "label": "９歳人口",
              "cat01": "A1508",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150801/人/a06/９歳人口（男）",
              "label": "９歳人口（男）",
              "cat01": "A150801",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150802/人/a06/９歳人口（女）",
              "label": "９歳人口（女）",
              "cat01": "A150802",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1509/人/a06/１０歳人口",
              "label": "１０歳人口",
              "cat01": "A1509",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150901/人/a06/１０歳人口（男）",
              "label": "１０歳人口（男）",
              "cat01": "A150901",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A150902/人/a06/１０歳人口（女）",
              "label": "１０歳人口（女）",
              "cat01": "A150902",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1510/人/a06/１１歳人口",
              "label": "１１歳人口",
              "cat01": "A1510",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151001/人/a06/１１歳人口（男）",
              "label": "１１歳人口（男）",
              "cat01": "A151001",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151002/人/a06/１１歳人口（女）",
              "label": "１１歳人口（女）",
              "cat01": "A151002",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1511/人/a06/１２歳人口",
              "label": "１２歳人口",
              "cat01": "A1511",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151101/人/a06/１２歳人口（男）",
              "label": "１２歳人口（男）",
              "cat01": "A151101",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151102/人/a06/１２歳人口（女）",
              "label": "１２歳人口（女）",
              "cat01": "A151102",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1512/人/a06/１３歳人口",
              "label": "１３歳人口",
              "cat01": "A1512",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151201/人/a06/１３歳人口（男）",
              "label": "１３歳人口（男）",
              "cat01": "A151201",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151202/人/a06/１３歳人口（女）",
              "label": "１３歳人口（女）",
              "cat01": "A151202",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1513/人/a06/１４歳人口",
              "label": "１４歳人口",
              "cat01": "A1513",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151301/人/a06/１４歳人口（男）",
              "label": "１４歳人口（男）",
              "cat01": "A151301",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151302/人/a06/１４歳人口（女）",
              "label": "１４歳人口（女）",
              "cat01": "A151302",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1514/人/a06/１５歳人口",
              "label": "１５歳人口",
              "cat01": "A1514",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151401/人/a06/１５歳人口（男）",
              "label": "１５歳人口（男）",
              "cat01": "A151401",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151402/人/a06/１５歳人口（女）",
              "label": "１５歳人口（女）",
              "cat01": "A151402",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1515/人/a06/１６歳人口",
              "label": "１６歳人口",
              "cat01": "A1515",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151501/人/a06/１６歳人口（男）",
              "label": "１６歳人口（男）",
              "cat01": "A151501",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151502/人/a06/１６歳人口（女）",
              "label": "１６歳人口（女）",
              "cat01": "A151502",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1516/人/a06/１７歳人口",
              "label": "１７歳人口",
              "cat01": "A1516",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151601/人/a06/１７歳人口（男）",
              "label": "１７歳人口（男）",
              "cat01": "A151601",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151602/人/a06/１７歳人口（女）",
              "label": "１７歳人口（女）",
              "cat01": "A151602",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1517/人/a06/１８歳人口",
              "label": "１８歳人口",
              "cat01": "A1517",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151701/人/a06/１８歳人口（男）",
              "label": "１８歳人口（男）",
              "cat01": "A151701",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A151702/人/a06/１８歳人口（女）",
              "label": "１８歳人口（女）",
              "cat01": "A151702",
              "unit": "人",
              "sourceId": "a06"
            },
            {
              "statId": "0000010101/A1601001/人/a07/未婚人口（１５歳以上）（男）",
              "label": "未婚人口（１５歳以上）（男）",
              "cat01": "A1601001",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601002/人/a07/未婚人口（１５歳以上）（女）",
              "label": "未婚人口（１５歳以上）（女）",
              "cat01": "A1601002",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601011/人/a07/未婚人口（１５～１９歳）（男）",
              "label": "未婚人口（１５～１９歳）（男）",
              "cat01": "A1601011",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601012/人/a07/未婚人口（１５～１９歳）（女）",
              "label": "未婚人口（１５～１９歳）（女）",
              "cat01": "A1601012",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601021/人/a07/未婚人口（２０～２４歳）（男）",
              "label": "未婚人口（２０～２４歳）（男）",
              "cat01": "A1601021",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601022/人/a07/未婚人口（２０～２４歳）（女）",
              "label": "未婚人口（２０～２４歳）（女）",
              "cat01": "A1601022",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601031/人/a07/未婚人口（２５～２９歳）（男）",
              "label": "未婚人口（２５～２９歳）（男）",
              "cat01": "A1601031",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601032/人/a07/未婚人口（２５～２９歳）（女）",
              "label": "未婚人口（２５～２９歳）（女）",
              "cat01": "A1601032",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601041/人/a07/未婚人口（３０～３４歳）（男）",
              "label": "未婚人口（３０～３４歳）（男）",
              "cat01": "A1601041",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601042/人/a07/未婚人口（３０～３４歳）（女）",
              "label": "未婚人口（３０～３４歳）（女）",
              "cat01": "A1601042",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601051/人/a07/未婚人口（３５～３９歳）（男）",
              "label": "未婚人口（３５～３９歳）（男）",
              "cat01": "A1601051",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601052/人/a07/未婚人口（３５～３９歳）（女）",
              "label": "未婚人口（３５～３９歳）（女）",
              "cat01": "A1601052",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601061/人/a07/未婚人口（４０～４４歳）（男）",
              "label": "未婚人口（４０～４４歳）（男）",
              "cat01": "A1601061",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601062/人/a07/未婚人口（４０～４４歳）（女）",
              "label": "未婚人口（４０～４４歳）（女）",
              "cat01": "A1601062",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601071/人/a07/未婚人口（４５～４９歳）（男）",
              "label": "未婚人口（４５～４９歳）（男）",
              "cat01": "A1601071",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601072/人/a07/未婚人口（４５～４９歳）（女）",
              "label": "未婚人口（４５～４９歳）（女）",
              "cat01": "A1601072",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601081/人/a07/未婚人口（５０～５４歳）（男）",
              "label": "未婚人口（５０～５４歳）（男）",
              "cat01": "A1601081",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601082/人/a07/未婚人口（５０～５４歳）（女）",
              "label": "未婚人口（５０～５４歳）（女）",
              "cat01": "A1601082",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601091/人/a07/未婚人口（５５～５９歳）（男）",
              "label": "未婚人口（５５～５９歳）（男）",
              "cat01": "A1601091",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601092/人/a07/未婚人口（５５～５９歳）（女）",
              "label": "未婚人口（５５～５９歳）（女）",
              "cat01": "A1601092",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601101/人/a07/未婚人口（６０～６４歳）（男）",
              "label": "未婚人口（６０～６４歳）（男）",
              "cat01": "A1601101",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601102/人/a07/未婚人口（６０～６４歳）（女）",
              "label": "未婚人口（６０～６４歳）（女）",
              "cat01": "A1601102",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601111/人/a07/未婚人口（６５～６９歳）（男）",
              "label": "未婚人口（６５～６９歳）（男）",
              "cat01": "A1601111",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601112/人/a07/未婚人口（６５～６９歳）（女）",
              "label": "未婚人口（６５～６９歳）（女）",
              "cat01": "A1601112",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601121/人/a07/未婚人口（７０～７４歳）（男）",
              "label": "未婚人口（７０～７４歳）（男）",
              "cat01": "A1601121",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601122/人/a07/未婚人口（７０～７４歳）（女）",
              "label": "未婚人口（７０～７４歳）（女）",
              "cat01": "A1601122",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601131/人/a07/未婚人口（７５～７９歳）（男）",
              "label": "未婚人口（７５～７９歳）（男）",
              "cat01": "A1601131",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601132/人/a07/未婚人口（７５～７９歳）（女）",
              "label": "未婚人口（７５～７９歳）（女）",
              "cat01": "A1601132",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601141/人/a07/未婚人口（８０～８４歳）（男）",
              "label": "未婚人口（８０～８４歳）（男）",
              "cat01": "A1601141",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601142/人/a07/未婚人口（８０～８４歳）（女）",
              "label": "未婚人口（８０～８４歳）（女）",
              "cat01": "A1601142",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601151/人/a07/未婚人口（８５歳以上）（男）",
              "label": "未婚人口（８５歳以上）（男）",
              "cat01": "A1601151",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1601152/人/a07/未婚人口（８５歳以上）（女）",
              "label": "未婚人口（８５歳以上）（女）",
              "cat01": "A1601152",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602001/人/a07/有配偶人口（１５歳以上）（男）",
              "label": "有配偶人口（１５歳以上）（男）",
              "cat01": "A1602001",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602002/人/a07/有配偶人口（１５歳以上）（女）",
              "label": "有配偶人口（１５歳以上）（女）",
              "cat01": "A1602002",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602021/人/a07/有配偶人口（２０～２４歳）（男）",
              "label": "有配偶人口（２０～２４歳）（男）",
              "cat01": "A1602021",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602022/人/a07/有配偶人口（２０～２４歳）（女）",
              "label": "有配偶人口（２０～２４歳）（女）",
              "cat01": "A1602022",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602031/人/a07/有配偶人口（２５～２９歳）（男）",
              "label": "有配偶人口（２５～２９歳）（男）",
              "cat01": "A1602031",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602032/人/a07/有配偶人口（２５～２９歳）（女）",
              "label": "有配偶人口（２５～２９歳）（女）",
              "cat01": "A1602032",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602041/人/a07/有配偶人口（３０～３４歳）（男）",
              "label": "有配偶人口（３０～３４歳）（男）",
              "cat01": "A1602041",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602042/人/a07/有配偶人口（３０～３４歳）（女）",
              "label": "有配偶人口（３０～３４歳）（女）",
              "cat01": "A1602042",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602051/人/a07/有配偶人口（３５～３９歳）（男）",
              "label": "有配偶人口（３５～３９歳）（男）",
              "cat01": "A1602051",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602052/人/a07/有配偶人口（３５～３９歳）（女）",
              "label": "有配偶人口（３５～３９歳）（女）",
              "cat01": "A1602052",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602061/人/a07/有配偶人口（４０～４４歳）（男）",
              "label": "有配偶人口（４０～４４歳）（男）",
              "cat01": "A1602061",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602062/人/a07/有配偶人口（４０～４４歳）（女）",
              "label": "有配偶人口（４０～４４歳）（女）",
              "cat01": "A1602062",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602071/人/a07/有配偶人口（４５～４９歳）（男）",
              "label": "有配偶人口（４５～４９歳）（男）",
              "cat01": "A1602071",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602072/人/a07/有配偶人口（４５～４９歳）（女）",
              "label": "有配偶人口（４５～４９歳）（女）",
              "cat01": "A1602072",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602081/人/a07/有配偶人口（５０～５４歳）（男）",
              "label": "有配偶人口（５０～５４歳）（男）",
              "cat01": "A1602081",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602082/人/a07/有配偶人口（５０～５４歳）（女）",
              "label": "有配偶人口（５０～５４歳）（女）",
              "cat01": "A1602082",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602091/人/a07/有配偶人口（５５～５９歳）（男）",
              "label": "有配偶人口（５５～５９歳）（男）",
              "cat01": "A1602091",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602092/人/a07/有配偶人口（５５～５９歳）（女）",
              "label": "有配偶人口（５５～５９歳）（女）",
              "cat01": "A1602092",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602101/人/a07/有配偶人口（６０～６４歳）（男）",
              "label": "有配偶人口（６０～６４歳）（男）",
              "cat01": "A1602101",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602102/人/a07/有配偶人口（６０～６４歳）（女）",
              "label": "有配偶人口（６０～６４歳）（女）",
              "cat01": "A1602102",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602111/人/a07/有配偶人口（６５～６９歳）（男）",
              "label": "有配偶人口（６５～６９歳）（男）",
              "cat01": "A1602111",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602112/人/a07/有配偶人口（６５～６９歳）（女）",
              "label": "有配偶人口（６５～６９歳）（女）",
              "cat01": "A1602112",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602121/人/a07/有配偶人口（７０～７４歳）（男）",
              "label": "有配偶人口（７０～７４歳）（男）",
              "cat01": "A1602121",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602122/人/a07/有配偶人口（７０～７４歳）（女）",
              "label": "有配偶人口（７０～７４歳）（女）",
              "cat01": "A1602122",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602131/人/a07/有配偶人口（７５～７９歳）（男）",
              "label": "有配偶人口（７５～７９歳）（男）",
              "cat01": "A1602131",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602132/人/a07/有配偶人口（７５～７９歳）（女）",
              "label": "有配偶人口（７５～７９歳）（女）",
              "cat01": "A1602132",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602141/人/a07/有配偶人口（８０～８４歳）（男）",
              "label": "有配偶人口（８０～８４歳）（男）",
              "cat01": "A1602141",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602142/人/a07/有配偶人口（８０～８４歳）（女）",
              "label": "有配偶人口（８０～８４歳）（女）",
              "cat01": "A1602142",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602151/人/a07/有配偶人口（８５歳以上）（男）",
              "label": "有配偶人口（８５歳以上）（男）",
              "cat01": "A1602151",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1602152/人/a07/有配偶人口（８５歳以上）（女）",
              "label": "有配偶人口（８５歳以上）（女）",
              "cat01": "A1602152",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603001/人/a07/死別人口（１５歳以上）（男）",
              "label": "死別人口（１５歳以上）（男）",
              "cat01": "A1603001",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603002/人/a07/死別人口（１５歳以上）（女）",
              "label": "死別人口（１５歳以上）（女）",
              "cat01": "A1603002",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603031/人/a07/死別人口（２５～２９歳）（男）",
              "label": "死別人口（２５～２９歳）（男）",
              "cat01": "A1603031",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603032/人/a07/死別人口（２５～２９歳）（女）",
              "label": "死別人口（２５～２９歳）（女）",
              "cat01": "A1603032",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603041/人/a07/死別人口（３０～３４歳）（男）",
              "label": "死別人口（３０～３４歳）（男）",
              "cat01": "A1603041",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603042/人/a07/死別人口（３０～３４歳）（女）",
              "label": "死別人口（３０～３４歳）（女）",
              "cat01": "A1603042",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603051/人/a07/死別人口（３５～３９歳）（男）",
              "label": "死別人口（３５～３９歳）（男）",
              "cat01": "A1603051",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603052/人/a07/死別人口（３５～３９歳）（女）",
              "label": "死別人口（３５～３９歳）（女）",
              "cat01": "A1603052",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603061/人/a07/死別人口（４０～４４歳）（男）",
              "label": "死別人口（４０～４４歳）（男）",
              "cat01": "A1603061",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603062/人/a07/死別人口（４０～４４歳）（女）",
              "label": "死別人口（４０～４４歳）（女）",
              "cat01": "A1603062",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603071/人/a07/死別人口（４５～４９歳）（男）",
              "label": "死別人口（４５～４９歳）（男）",
              "cat01": "A1603071",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603072/人/a07/死別人口（４５～４９歳）（女）",
              "label": "死別人口（４５～４９歳）（女）",
              "cat01": "A1603072",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603081/人/a07/死別人口（５０～５４歳）（男）",
              "label": "死別人口（５０～５４歳）（男）",
              "cat01": "A1603081",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603082/人/a07/死別人口（５０～５４歳）（女）",
              "label": "死別人口（５０～５４歳）（女）",
              "cat01": "A1603082",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603091/人/a07/死別人口（５５～５９歳）（男）",
              "label": "死別人口（５５～５９歳）（男）",
              "cat01": "A1603091",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603092/人/a07/死別人口（５５～５９歳）（女）",
              "label": "死別人口（５５～５９歳）（女）",
              "cat01": "A1603092",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603101/人/a07/死別人口（６０～６４歳）（男）",
              "label": "死別人口（６０～６４歳）（男）",
              "cat01": "A1603101",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603102/人/a07/死別人口（６０～６４歳）（女）",
              "label": "死別人口（６０～６４歳）（女）",
              "cat01": "A1603102",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603111/人/a07/死別人口（６５～６９歳）（男）",
              "label": "死別人口（６５～６９歳）（男）",
              "cat01": "A1603111",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603112/人/a07/死別人口（６５～６９歳）（女）",
              "label": "死別人口（６５～６９歳）（女）",
              "cat01": "A1603112",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603121/人/a07/死別人口（７０～７４歳）（男）",
              "label": "死別人口（７０～７４歳）（男）",
              "cat01": "A1603121",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603122/人/a07/死別人口（７０～７４歳）（女）",
              "label": "死別人口（７０～７４歳）（女）",
              "cat01": "A1603122",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603131/人/a07/死別人口（７５～７９歳）（男）",
              "label": "死別人口（７５～７９歳）（男）",
              "cat01": "A1603131",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603132/人/a07/死別人口（７５～７９歳）（女）",
              "label": "死別人口（７５～７９歳）（女）",
              "cat01": "A1603132",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603141/人/a07/死別人口（８０～８４歳）（男）",
              "label": "死別人口（８０～８４歳）（男）",
              "cat01": "A1603141",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603142/人/a07/死別人口（８０～８４歳）（女）",
              "label": "死別人口（８０～８４歳）（女）",
              "cat01": "A1603142",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603151/人/a07/死別人口（８５歳以上）（男）",
              "label": "死別人口（８５歳以上）（男）",
              "cat01": "A1603151",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603152/人/a07/死別人口（８５歳以上）（女）",
              "label": "死別人口（８５歳以上）（女）",
              "cat01": "A1603152",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603201/人/a07/死別人口（６０歳以上）（男）",
              "label": "死別人口（６０歳以上）（男）",
              "cat01": "A1603201",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1603202/人/a07/死別人口（６０歳以上）（女）",
              "label": "死別人口（６０歳以上）（女）",
              "cat01": "A1603202",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604001/人/a07/離別人口（１５歳以上）（男）",
              "label": "離別人口（１５歳以上）（男）",
              "cat01": "A1604001",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604002/人/a07/離別人口（１５歳以上）（女）",
              "label": "離別人口（１５歳以上）（女）",
              "cat01": "A1604002",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604011/人/a07/離別人口（１５～１９歳）（男）",
              "label": "離別人口（１５～１９歳）（男）",
              "cat01": "A1604011",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604012/人/a07/離別人口（１５～１９歳）（女）",
              "label": "離別人口（１５～１９歳）（女）",
              "cat01": "A1604012",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604021/人/a07/離別人口（２０～２４歳）（男）",
              "label": "離別人口（２０～２４歳）（男）",
              "cat01": "A1604021",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604022/人/a07/離別人口（２０～２４歳）（女）",
              "label": "離別人口（２０～２４歳）（女）",
              "cat01": "A1604022",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604031/人/a07/離別人口（２５～２９歳）（男）",
              "label": "離別人口（２５～２９歳）（男）",
              "cat01": "A1604031",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604032/人/a07/離別人口（２５～２９歳）（女）",
              "label": "離別人口（２５～２９歳）（女）",
              "cat01": "A1604032",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604041/人/a07/離別人口（３０～３４歳）（男）",
              "label": "離別人口（３０～３４歳）（男）",
              "cat01": "A1604041",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604042/人/a07/離別人口（３０～３４歳）（女）",
              "label": "離別人口（３０～３４歳）（女）",
              "cat01": "A1604042",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604051/人/a07/離別人口（３５～３９歳）（男）",
              "label": "離別人口（３５～３９歳）（男）",
              "cat01": "A1604051",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604052/人/a07/離別人口（３５～３９歳）（女）",
              "label": "離別人口（３５～３９歳）（女）",
              "cat01": "A1604052",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604061/人/a07/離別人口（４０～４４歳）（男）",
              "label": "離別人口（４０～４４歳）（男）",
              "cat01": "A1604061",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604062/人/a07/離別人口（４０～４４歳）（女）",
              "label": "離別人口（４０～４４歳）（女）",
              "cat01": "A1604062",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604071/人/a07/離別人口（４５～４９歳）（男）",
              "label": "離別人口（４５～４９歳）（男）",
              "cat01": "A1604071",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604072/人/a07/離別人口（４５～４９歳）（女）",
              "label": "離別人口（４５～４９歳）（女）",
              "cat01": "A1604072",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604081/人/a07/離別人口（５０～５４歳）（男）",
              "label": "離別人口（５０～５４歳）（男）",
              "cat01": "A1604081",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604082/人/a07/離別人口（５０～５４歳）（女）",
              "label": "離別人口（５０～５４歳）（女）",
              "cat01": "A1604082",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604091/人/a07/離別人口（５５～５９歳）（男）",
              "label": "離別人口（５５～５９歳）（男）",
              "cat01": "A1604091",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604092/人/a07/離別人口（５５～５９歳）（女）",
              "label": "離別人口（５５～５９歳）（女）",
              "cat01": "A1604092",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604101/人/a07/離別人口（６０～６４歳）（男）",
              "label": "離別人口（６０～６４歳）（男）",
              "cat01": "A1604101",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604102/人/a07/離別人口（６０～６４歳）（女）",
              "label": "離別人口（６０～６４歳）（女）",
              "cat01": "A1604102",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604111/人/a07/離別人口（６５～６９歳）（男）",
              "label": "離別人口（６５～６９歳）（男）",
              "cat01": "A1604111",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604112/人/a07/離別人口（６５～６９歳）（女）",
              "label": "離別人口（６５～６９歳）（女）",
              "cat01": "A1604112",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604121/人/a07/離別人口（７０～７４歳）（男）",
              "label": "離別人口（７０～７４歳）（男）",
              "cat01": "A1604121",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604122/人/a07/離別人口（７０～７４歳）（女）",
              "label": "離別人口（７０～７４歳）（女）",
              "cat01": "A1604122",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604131/人/a07/離別人口（７５～７９歳）（男）",
              "label": "離別人口（７５～７９歳）（男）",
              "cat01": "A1604131",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604132/人/a07/離別人口（７５～７９歳）（女）",
              "label": "離別人口（７５～７９歳）（女）",
              "cat01": "A1604132",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604141/人/a07/離別人口（８０～８４歳）（男）",
              "label": "離別人口（８０～８４歳）（男）",
              "cat01": "A1604141",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604142/人/a07/離別人口（８０～８４歳）（女）",
              "label": "離別人口（８０～８４歳）（女）",
              "cat01": "A1604142",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604151/人/a07/離別人口（８５歳以上）（男）",
              "label": "離別人口（８５歳以上）（男）",
              "cat01": "A1604151",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604152/人/a07/離別人口（８５歳以上）（女）",
              "label": "離別人口（８５歳以上）（女）",
              "cat01": "A1604152",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604201/人/a07/離別人口（４０～４９歳）（男）",
              "label": "離別人口（４０～４９歳）（男）",
              "cat01": "A1604201",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604202/人/a07/離別人口（４０～４９歳）（女）",
              "label": "離別人口（４０～４９歳）（女）",
              "cat01": "A1604202",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604301/人/a07/離別人口（５０～５９歳）（男）",
              "label": "離別人口（５０～５９歳）（男）",
              "cat01": "A1604301",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1604302/人/a07/離別人口（５０～５９歳）（女）",
              "label": "離別人口（５０～５９歳）（女）",
              "cat01": "A1604302",
              "unit": "人",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A161001/％/a07/未婚者割合（１５歳以上人口）",
              "label": "未婚者割合（１５歳以上人口）",
              "cat01": "A161001",
              "unit": "％",
              "sourceId": "a07"
            },
            {
              "statId": "0000010101/A1700/人/a08/外国人人口",
              "label": "外国人人口",
              "cat01": "A1700",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170001/人/a08/外国人人口（男）",
              "label": "外国人人口（男）",
              "cat01": "A170001",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170002/人/a08/外国人人口（女）",
              "label": "外国人人口（女）",
              "cat01": "A170002",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1701/人/a08/外国人人口（韓国・朝鮮）",
              "label": "外国人人口（韓国・朝鮮）",
              "cat01": "A1701",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170101/人/a08/外国人人口（韓国・朝鮮）（男）",
              "label": "外国人人口（韓国・朝鮮）（男）",
              "cat01": "A170101",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170102/人/a08/外国人人口（韓国・朝鮮）（女）",
              "label": "外国人人口（韓国・朝鮮）（女）",
              "cat01": "A170102",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1702/人/a08/外国人人口（中国）",
              "label": "外国人人口（中国）",
              "cat01": "A1702",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170201/人/a08/外国人人口（中国）（男）",
              "label": "外国人人口（中国）（男）",
              "cat01": "A170201",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170202/人/a08/外国人人口（中国）（女）",
              "label": "外国人人口（中国）（女）",
              "cat01": "A170202",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1703/人/a08/外国人人口（アメリカ）",
              "label": "外国人人口（アメリカ）",
              "cat01": "A1703",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170301/人/a08/外国人人口（アメリカ）（男）",
              "label": "外国人人口（アメリカ）（男）",
              "cat01": "A170301",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170302/人/a08/外国人人口（アメリカ）（女）",
              "label": "外国人人口（アメリカ）（女）",
              "cat01": "A170302",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1706/人/a08/外国人人口（フィリピン）",
              "label": "外国人人口（フィリピン）",
              "cat01": "A1706",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170601/人/a08/外国人人口（フィリピン）（男）",
              "label": "外国人人口（フィリピン）（男）",
              "cat01": "A170601",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170602/人/a08/外国人人口（フィリピン）（女）",
              "label": "外国人人口（フィリピン）（女）",
              "cat01": "A170602",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1707/人/a08/外国人人口（ブラジル）",
              "label": "外国人人口（ブラジル）",
              "cat01": "A1707",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170701/人/a08/外国人人口（ブラジル）（男）",
              "label": "外国人人口（ブラジル）（男）",
              "cat01": "A170701",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A170702/人/a08/外国人人口（ブラジル）（女）",
              "label": "外国人人口（ブラジル）（女）",
              "cat01": "A170702",
              "unit": "人",
              "sourceId": "a08"
            },
            {
              "statId": "0000010101/A1801/人/a09/人口集中地区人口",
              "label": "人口集中地区人口",
              "cat01": "A1801",
              "unit": "人",
              "sourceId": "a09"
            },
            {
              "statId": "0000010101/A180101/人/a09/人口集中地区人口（男）",
              "label": "人口集中地区人口（男）",
              "cat01": "A180101",
              "unit": "人",
              "sourceId": "a09"
            },
            {
              "statId": "0000010101/A180102/人/a09/人口集中地区人口（女）",
              "label": "人口集中地区人口（女）",
              "cat01": "A180102",
              "unit": "人",
              "sourceId": "a09"
            },
            {
              "statId": "0000010101/A1802/ｋｍ2/a09/人口集中地区面積",
              "label": "人口集中地区面積",
              "cat01": "A1802",
              "unit": "ｋｍ2",
              "sourceId": "a09"
            },
            {
              "statId": "0000010101/A191001/人/a10/将来推計人口（2020年）",
              "label": "将来推計人口（2020年）",
              "cat01": "A191001",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A191002/人/a10/将来推計人口（2025年）",
              "label": "将来推計人口（2025年）",
              "cat01": "A191002",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A191003/人/a10/将来推計人口（2030年）",
              "label": "将来推計人口（2030年）",
              "cat01": "A191003",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A191004/人/a10/将来推計人口（2035年）",
              "label": "将来推計人口（2035年）",
              "cat01": "A191004",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A191005/人/a10/将来推計人口（2040年）",
              "label": "将来推計人口（2040年）",
              "cat01": "A191005",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A191006/人/a10/将来推計人口（2045年）",
              "label": "将来推計人口（2045年）",
              "cat01": "A191006",
              "unit": "人",
              "sourceId": "a10"
            },
            {
              "statId": "0000010101/A2101/人/a11/住民基本台帳人口（日本人）",
              "label": "住民基本台帳人口（日本人）",
              "cat01": "A2101",
              "unit": "人",
              "sourceId": "a11"
            },
            {
              "statId": "0000010101/A210101/人/a11/住民基本台帳人口（日本人）（男）",
              "label": "住民基本台帳人口（日本人）（男）",
              "cat01": "A210101",
              "unit": "人",
              "sourceId": "a11"
            },
            {
              "statId": "0000010101/A210102/人/a11/住民基本台帳人口（日本人）（女）",
              "label": "住民基本台帳人口（日本人）（女）",
              "cat01": "A210102",
              "unit": "人",
              "sourceId": "a11"
            },
            {
              "statId": "0000010101/A2102/人/a12/行政区域内人口（住民基本台帳人口＋外国人登録人口）",
              "label": "行政区域内人口（住民基本台帳人口＋外国人登録人口）",
              "cat01": "A2102",
              "unit": "人",
              "sourceId": "a12"
            },
            {
              "statId": "0000010101/A2201/人/a13/住民基本台帳人口（外国人）",
              "label": "住民基本台帳人口（外国人）",
              "cat01": "A2201",
              "unit": "人",
              "sourceId": "a13"
            },
            {
              "statId": "0000010101/A2301/人/a13/住民基本台帳人口（総数）",
              "label": "住民基本台帳人口（総数）",
              "cat01": "A2301",
              "unit": "人",
              "sourceId": "a13"
            },
            {
              "statId": "0000010101/A3100/人/a14/外国人登録人口",
              "label": "外国人登録人口",
              "cat01": "A3100",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A3101/人/a14/外国人登録人口（アジア）",
              "label": "外国人登録人口（アジア）",
              "cat01": "A3101",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310101/人/a14/外国人登録人口（韓国・朝鮮）",
              "label": "外国人登録人口（韓国・朝鮮）",
              "cat01": "A310101",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310102/人/a14/外国人登録人口（中国）",
              "label": "外国人登録人口（中国）",
              "cat01": "A310102",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310103/人/a14/外国人登録人口（フィリピン）",
              "label": "外国人登録人口（フィリピン）",
              "cat01": "A310103",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310105/人/a14/外国人登録人口（タイ）",
              "label": "外国人登録人口（タイ）",
              "cat01": "A310105",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A3102/人/a14/外国人登録人口（ヨーロッパ）",
              "label": "外国人登録人口（ヨーロッパ）",
              "cat01": "A3102",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310201/人/a14/外国人登録人口（英国）",
              "label": "外国人登録人口（英国）",
              "cat01": "A310201",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A3103/人/a14/外国人登録人口（北米）",
              "label": "外国人登録人口（北米）",
              "cat01": "A3103",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310301/人/a14/外国人登録人口（米国）",
              "label": "外国人登録人口（米国）",
              "cat01": "A310301",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A3104/人/a14/外国人登録人口（南米）",
              "label": "外国人登録人口（南米）",
              "cat01": "A3104",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310401/人/a14/外国人登録人口（ブラジル）",
              "label": "外国人登録人口（ブラジル）",
              "cat01": "A310401",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A310402/人/a14/外国人登録人口（ペルー）",
              "label": "外国人登録人口（ペルー）",
              "cat01": "A310402",
              "unit": "人",
              "sourceId": "a14"
            },
            {
              "statId": "0000010101/A3200/人/a15/在留外国人数",
              "label": "在留外国人数",
              "cat01": "A3200",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A3201/人/a15/在留外国人数（アジア）",
              "label": "在留外国人数（アジア）",
              "cat01": "A3201",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A320101/人/a15/在留外国人数（韓国・朝鮮）",
              "label": "在留外国人数（韓国・朝鮮）",
              "cat01": "A320101",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A320102/人/a15/在留外国人数（中国）",
              "label": "在留外国人数（中国）",
              "cat01": "A320102",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A320103/人/a15/在留外国人数（韓国）",
              "label": "在留外国人数（韓国）",
              "cat01": "A320103",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A320104/人/a15/在留外国人数（朝鮮）",
              "label": "在留外国人数（朝鮮）",
              "cat01": "A320104",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A3202/人/a15/在留外国人数（ヨーロッパ）",
              "label": "在留外国人数（ヨーロッパ）",
              "cat01": "A3202",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A3203/人/a15/在留外国人数（北米）",
              "label": "在留外国人数（北米）",
              "cat01": "A3203",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A3204/人/a15/在留外国人数（南米）",
              "label": "在留外国人数（南米）",
              "cat01": "A3204",
              "unit": "人",
              "sourceId": "a15"
            },
            {
              "statId": "0000010101/A4101/人/a16/出生数",
              "label": "出生数",
              "cat01": "A4101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410101/人/a16/出生数（男）",
              "label": "出生数（男）",
              "cat01": "A410101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410102/人/a16/出生数（女）",
              "label": "出生数（女）",
              "cat01": "A410102",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410201/人/a16/出生数（母親の年齢１５歳未満）",
              "label": "出生数（母親の年齢１５歳未満）",
              "cat01": "A410201",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410202/人/a16/出生数（母親の年齢１５～１９歳）",
              "label": "出生数（母親の年齢１５～１９歳）",
              "cat01": "A410202",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410203/人/a16/出生数（母親の年齢２０～２４歳）",
              "label": "出生数（母親の年齢２０～２４歳）",
              "cat01": "A410203",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410204/人/a16/出生数（母親の年齢２５～２９歳）",
              "label": "出生数（母親の年齢２５～２９歳）",
              "cat01": "A410204",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410205/人/a16/出生数（母親の年齢３０～３４歳）",
              "label": "出生数（母親の年齢３０～３４歳）",
              "cat01": "A410205",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410206/人/a16/出生数（母親の年齢３５～３９歳）",
              "label": "出生数（母親の年齢３５～３９歳）",
              "cat01": "A410206",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410207/人/a16/出生数（母親の年齢４０～４４歳）",
              "label": "出生数（母親の年齢４０～４４歳）",
              "cat01": "A410207",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410208/人/a16/出生数（母親の年齢４５～４９歳）",
              "label": "出生数（母親の年齢４５～４９歳）",
              "cat01": "A410208",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A410209/人/a16/出生数（母親の年齢５０歳以上）",
              "label": "出生数（母親の年齢５０歳以上）",
              "cat01": "A410209",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4103/‐/a16/合計特殊出生率",
              "label": "合計特殊出生率",
              "cat01": "A4103",
              "unit": "‐",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4200/人/a16/死亡数",
              "label": "死亡数",
              "cat01": "A4200",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420001/人/a16/死亡数（男）",
              "label": "死亡数（男）",
              "cat01": "A420001",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420002/人/a16/死亡数（女）",
              "label": "死亡数（女）",
              "cat01": "A420002",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4201/人/a16/死亡数（０～４歳）",
              "label": "死亡数（０～４歳）",
              "cat01": "A4201",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420101/人/a16/死亡数（０～４歳）（男）",
              "label": "死亡数（０～４歳）（男）",
              "cat01": "A420101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420102/人/a16/死亡数（０～４歳）（女）",
              "label": "死亡数（０～４歳）（女）",
              "cat01": "A420102",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4202/人/a16/死亡数（５～９歳）",
              "label": "死亡数（５～９歳）",
              "cat01": "A4202",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420201/人/a16/死亡数（５～９歳）（男）",
              "label": "死亡数（５～９歳）（男）",
              "cat01": "A420201",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420202/人/a16/死亡数（５～９歳）（女）",
              "label": "死亡数（５～９歳）（女）",
              "cat01": "A420202",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4203/人/a16/死亡数（１０～１４歳）",
              "label": "死亡数（１０～１４歳）",
              "cat01": "A4203",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420301/人/a16/死亡数（１０～１４歳）（男）",
              "label": "死亡数（１０～１４歳）（男）",
              "cat01": "A420301",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420302/人/a16/死亡数（１０～１４歳）（女）",
              "label": "死亡数（１０～１４歳）（女）",
              "cat01": "A420302",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4204/人/a16/死亡数（１５～１９歳）",
              "label": "死亡数（１５～１９歳）",
              "cat01": "A4204",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420401/人/a16/死亡数（１５～１９歳）（男）",
              "label": "死亡数（１５～１９歳）（男）",
              "cat01": "A420401",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420402/人/a16/死亡数（１５～１９歳）（女）",
              "label": "死亡数（１５～１９歳）（女）",
              "cat01": "A420402",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4205/人/a16/死亡数（２０～２４歳）",
              "label": "死亡数（２０～２４歳）",
              "cat01": "A4205",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420501/人/a16/死亡数（２０～２４歳）（男）",
              "label": "死亡数（２０～２４歳）（男）",
              "cat01": "A420501",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420502/人/a16/死亡数（２０～２４歳）（女）",
              "label": "死亡数（２０～２４歳）（女）",
              "cat01": "A420502",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4207/人/a16/死亡数（３０～３４歳）",
              "label": "死亡数（３０～３４歳）",
              "cat01": "A4207",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420701/人/a16/死亡数（３０～３４歳）（男）",
              "label": "死亡数（３０～３４歳）（男）",
              "cat01": "A420701",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420702/人/a16/死亡数（３０～３４歳）（女）",
              "label": "死亡数（３０～３４歳）（女）",
              "cat01": "A420702",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4208/人/a16/死亡数（３５～３９歳）",
              "label": "死亡数（３５～３９歳）",
              "cat01": "A4208",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420801/人/a16/死亡数（３５～３９歳）（男）",
              "label": "死亡数（３５～３９歳）（男）",
              "cat01": "A420801",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420802/人/a16/死亡数（３５～３９歳）（女）",
              "label": "死亡数（３５～３９歳）（女）",
              "cat01": "A420802",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4209/人/a16/死亡数（４０～４４歳）",
              "label": "死亡数（４０～４４歳）",
              "cat01": "A4209",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420901/人/a16/死亡数（４０～４４歳）（男）",
              "label": "死亡数（４０～４４歳）（男）",
              "cat01": "A420901",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A420902/人/a16/死亡数（４０～４４歳）（女）",
              "label": "死亡数（４０～４４歳）（女）",
              "cat01": "A420902",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4210/人/a16/死亡数（４５～４９歳）",
              "label": "死亡数（４５～４９歳）",
              "cat01": "A4210",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421001/人/a16/死亡数（４５～４９歳）（男）",
              "label": "死亡数（４５～４９歳）（男）",
              "cat01": "A421001",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421002/人/a16/死亡数（４５～４９歳）（女）",
              "label": "死亡数（４５～４９歳）（女）",
              "cat01": "A421002",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4211/人/a16/死亡数（５０～５４歳）",
              "label": "死亡数（５０～５４歳）",
              "cat01": "A4211",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421101/人/a16/死亡数（５０～５４歳）（男）",
              "label": "死亡数（５０～５４歳）（男）",
              "cat01": "A421101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421102/人/a16/死亡数（５０～５４歳）（女）",
              "label": "死亡数（５０～５４歳）（女）",
              "cat01": "A421102",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4212/人/a16/死亡数（５５～５９歳）",
              "label": "死亡数（５５～５９歳）",
              "cat01": "A4212",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421201/人/a16/死亡数（５５～５９歳）（男）",
              "label": "死亡数（５５～５９歳）（男）",
              "cat01": "A421201",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421202/人/a16/死亡数（５５～５９歳）（女）",
              "label": "死亡数（５５～５９歳）（女）",
              "cat01": "A421202",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4213/人/a16/死亡数（６０～６４歳）",
              "label": "死亡数（６０～６４歳）",
              "cat01": "A4213",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421301/人/a16/死亡数（６０～６４歳）（男）",
              "label": "死亡数（６０～６４歳）（男）",
              "cat01": "A421301",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421302/人/a16/死亡数（６０～６４歳）（女）",
              "label": "死亡数（６０～６４歳）（女）",
              "cat01": "A421302",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4214/人/a16/死亡数（６５～６９歳）",
              "label": "死亡数（６５～６９歳）",
              "cat01": "A4214",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421401/人/a16/死亡数（６５～６９歳）（男）",
              "label": "死亡数（６５～６９歳）（男）",
              "cat01": "A421401",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421402/人/a16/死亡数（６５～６９歳）（女）",
              "label": "死亡数（６５～６９歳）（女）",
              "cat01": "A421402",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4215/人/a16/死亡数（７０～７４歳）",
              "label": "死亡数（７０～７４歳）",
              "cat01": "A4215",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421501/人/a16/死亡数（７０～７４歳）（男）",
              "label": "死亡数（７０～７４歳）（男）",
              "cat01": "A421501",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421502/人/a16/死亡数（７０～７４歳）（女）",
              "label": "死亡数（７０～７４歳）（女）",
              "cat01": "A421502",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4216/人/a16/死亡数（７５～７９歳）",
              "label": "死亡数（７５～７９歳）",
              "cat01": "A4216",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421601/人/a16/死亡数（７５～７９歳）（男）",
              "label": "死亡数（７５～７９歳）（男）",
              "cat01": "A421601",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421602/人/a16/死亡数（７５～７９歳）（女）",
              "label": "死亡数（７５～７９歳）（女）",
              "cat01": "A421602",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4217/人/a16/死亡数（８０～８４歳）",
              "label": "死亡数（８０～８４歳）",
              "cat01": "A4217",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421701/人/a16/死亡数（８０～８４歳）（男）",
              "label": "死亡数（８０～８４歳）（男）",
              "cat01": "A421701",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421702/人/a16/死亡数（８０～８４歳）（女）",
              "label": "死亡数（８０～８４歳）（女）",
              "cat01": "A421702",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4218/人/a16/死亡数（８５～８９歳）",
              "label": "死亡数（８５～８９歳）",
              "cat01": "A4218",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421801/人/a16/死亡数（８５～８９歳）（男）",
              "label": "死亡数（８５～８９歳）（男）",
              "cat01": "A421801",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421802/人/a16/死亡数（８５～８９歳）（女）",
              "label": "死亡数（８５～８９歳）（女）",
              "cat01": "A421802",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4219/人/a16/死亡数（９０～９４歳）",
              "label": "死亡数（９０～９４歳）",
              "cat01": "A4219",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421901/人/a16/死亡数（９０～９４歳）（男）",
              "label": "死亡数（９０～９４歳）（男）",
              "cat01": "A421901",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A421902/人/a16/死亡数（９０～９４歳）（女）",
              "label": "死亡数（９０～９４歳）（女）",
              "cat01": "A421902",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4220/人/a16/死亡数（９５～９９歳）",
              "label": "死亡数（９５～９９歳）",
              "cat01": "A4220",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A422001/人/a16/死亡数（９５～９９歳）（男）",
              "label": "死亡数（９５～９９歳）（男）",
              "cat01": "A422001",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A422002/人/a16/死亡数（９５～９９歳）（女）",
              "label": "死亡数（９５～９９歳）（女）",
              "cat01": "A422002",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4221/人/a16/死亡数（１００歳以上）",
              "label": "死亡数（１００歳以上）",
              "cat01": "A4221",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A422101/人/a16/死亡数（１００歳以上）（男）",
              "label": "死亡数（１００歳以上）（男）",
              "cat01": "A422101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A422102/人/a16/死亡数（１００歳以上）（女）",
              "label": "死亡数（１００歳以上）（女）",
              "cat01": "A422102",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A4231/人/a16/死亡数（６５歳以上）",
              "label": "死亡数（６５歳以上）",
              "cat01": "A4231",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A423101/人/a16/死亡数（６５歳以上）（男）",
              "label": "死亡数（６５歳以上）（男）",
              "cat01": "A423101",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A423102/人/a16/死亡数（６５歳以上）（女）",
              "label": "死亡数（６５歳以上）（女）",
              "cat01": "A423102",
              "unit": "人",
              "sourceId": "a16"
            },
            {
              "statId": "0000010101/A424001/‐/a17/年齢調整死亡率（男）",
              "label": "年齢調整死亡率（男）",
              "cat01": "A424001",
              "unit": "‐",
              "sourceId": "a17"
            },
            {
              "statId": "0000010101/A424002/‐/a17/年齢調整死亡率（女）",
              "label": "年齢調整死亡率（女）",
              "cat01": "A424002",
              "unit": "‐",
              "sourceId": "a17"
            },
            {
              "statId": "0000010101/A4270/胎/a18/死産数",
              "label": "死産数",
              "cat01": "A4270",
              "unit": "胎",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A427001/胎/a18/自然死産数",
              "label": "自然死産数",
              "cat01": "A427001",
              "unit": "胎",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A4271/胎/a18/死産数（妊娠満２２週以後）",
              "label": "死産数（妊娠満２２週以後）",
              "cat01": "A4271",
              "unit": "胎",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A4272/人/a18/早期新生児死亡数",
              "label": "早期新生児死亡数",
              "cat01": "A4272",
              "unit": "人",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A4280/人/a18/新生児死亡数",
              "label": "新生児死亡数",
              "cat01": "A4280",
              "unit": "人",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A4281/人/a18/乳児死亡数",
              "label": "乳児死亡数",
              "cat01": "A4281",
              "unit": "人",
              "sourceId": "a18"
            },
            {
              "statId": "0000010101/A4301/ﾊﾟｰﾐﾙ/a19/標準化死亡率〔日本人〕",
              "label": "標準化死亡率〔日本人〕",
              "cat01": "A4301",
              "unit": "ﾊﾟｰﾐﾙ",
              "sourceId": "a19"
            },
            {
              "statId": "0000010101/A5101/人/a20/転入者数",
              "label": "転入者数",
              "cat01": "A5101",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A510101/人/a20/転入者数（男）",
              "label": "転入者数（男）",
              "cat01": "A510101",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A510102/人/a20/転入者数（女）",
              "label": "転入者数（女）",
              "cat01": "A510102",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A5102/人/a20/転出者数",
              "label": "転出者数",
              "cat01": "A5102",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A510201/人/a20/転出者数（男）",
              "label": "転出者数（男）",
              "cat01": "A510201",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A510202/人/a20/転出者数（女）",
              "label": "転出者数（女）",
              "cat01": "A510202",
              "unit": "人",
              "sourceId": "a20"
            },
            {
              "statId": "0000010101/A5201/人/a21/入国者数（日本人）",
              "label": "入国者数（日本人）",
              "cat01": "A5201",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A520101/人/a21/入国者数（日本人）（男）",
              "label": "入国者数（日本人）（男）",
              "cat01": "A520101",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A520102/人/a21/入国者数（日本人）（女）",
              "label": "入国者数（日本人）（女）",
              "cat01": "A520102",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A5202/人/a21/出国者数（日本人）",
              "label": "出国者数（日本人）",
              "cat01": "A5202",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A520201/人/a21/出国者数（日本人）（男）",
              "label": "出国者数（日本人）（男）",
              "cat01": "A520201",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A520202/人/a21/出国者数（日本人）（女）",
              "label": "出国者数（日本人）（女）",
              "cat01": "A520202",
              "unit": "人",
              "sourceId": "a21"
            },
            {
              "statId": "0000010101/A6101/人/a22/従業も通学もしていない人口",
              "label": "従業も通学もしていない人口",
              "cat01": "A6101",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610101/人/a22/従業も通学もしていない人口（男）",
              "label": "従業も通学もしていない人口（男）",
              "cat01": "A610101",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610102/人/a22/従業も通学もしていない人口（女）",
              "label": "従業も通学もしていない人口（女）",
              "cat01": "A610102",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6102/人/a22/自市区町村で従業・通学している人口",
              "label": "自市区町村で従業・通学している人口",
              "cat01": "A6102",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610201/人/a22/自市区町村で従業・通学している人口（男）",
              "label": "自市区町村で従業・通学している人口（男）",
              "cat01": "A610201",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610202/人/a22/自市区町村で従業・通学している人口（女）",
              "label": "自市区町村で従業・通学している人口（女）",
              "cat01": "A610202",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6103/人/a22/流出人口（県内他市区町村で従業・通学している人口）",
              "label": "流出人口（県内他市区町村で従業・通学している人口）",
              "cat01": "A6103",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610301/人/a22/流出人口（県内他市区町村で従業・通学している人口）（男）",
              "label": "流出人口（県内他市区町村で従業・通学している人口）（男）",
              "cat01": "A610301",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610302/人/a22/流出人口（県内他市区町村で従業・通学している人口）（女）",
              "label": "流出人口（県内他市区町村で従業・通学している人口）（女）",
              "cat01": "A610302",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6104/人/a22/流出人口（従業地・通学地人口）",
              "label": "流出人口（従業地・通学地人口）",
              "cat01": "A6104",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610401/人/a22/流出人口（他県で従業・通学している人口）（男）",
              "label": "流出人口（他県で従業・通学している人口）（男）",
              "cat01": "A610401",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610402/人/a22/流出人口（他県で従業・通学している人口）（女）",
              "label": "流出人口（他県で従業・通学している人口）（女）",
              "cat01": "A610402",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6105/人/a22/流入人口（県内他市区町村に常住している人口）",
              "label": "流入人口（県内他市区町村に常住している人口）",
              "cat01": "A6105",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610501/人/a22/流入人口（県内他市区町村に常住している人口）（男）",
              "label": "流入人口（県内他市区町村に常住している人口）（男）",
              "cat01": "A610501",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610502/人/a22/流入人口（県内他市区町村に常住している人口）（女）",
              "label": "流入人口（県内他市区町村に常住している人口）（女）",
              "cat01": "A610502",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6106/人/a22/流入人口（従業地・通学地人口）",
              "label": "流入人口（従業地・通学地人口）",
              "cat01": "A6106",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610601/人/a22/流入人口（他県に常住している人口）（男）",
              "label": "流入人口（他県に常住している人口）（男）",
              "cat01": "A610601",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610602/人/a22/流入人口（他県に常住している人口）（女）",
              "label": "流入人口（他県に常住している人口）（女）",
              "cat01": "A610602",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6107/人/a22/昼間人口",
              "label": "昼間人口",
              "cat01": "A6107",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610701/人/a22/昼間人口（男）",
              "label": "昼間人口（男）",
              "cat01": "A610701",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A610702/人/a22/昼間人口（女）",
              "label": "昼間人口（女）",
              "cat01": "A610702",
              "unit": "人",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A6108/％/a22/昼夜間人口比率",
              "label": "昼夜間人口比率",
              "cat01": "A6108",
              "unit": "％",
              "sourceId": "a22"
            },
            {
              "statId": "0000010101/A7101/世帯/a23/世帯数",
              "label": "世帯数",
              "cat01": "A7101",
              "unit": "世帯",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A710101/世帯/a23/一般世帯数",
              "label": "一般世帯数",
              "cat01": "A710101",
              "unit": "世帯",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A710102/世帯/a23/施設等の世帯数",
              "label": "施設等の世帯数",
              "cat01": "A710102",
              "unit": "世帯",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A710201/人/a23/一般世帯人員数",
              "label": "一般世帯人員数",
              "cat01": "A710201",
              "unit": "人",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A710202/人/a23/施設等の世帯人員数",
              "label": "施設等の世帯人員数",
              "cat01": "A710202",
              "unit": "人",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A710211/人/a23/一般世帯平均人員数",
              "label": "一般世帯平均人員数",
              "cat01": "A710211",
              "unit": "人",
              "sourceId": "a23"
            },
            {
              "statId": "0000010101/A7103/世帯/a24/住民基本台帳世帯数（日本人）",
              "label": "住民基本台帳世帯数（日本人）",
              "cat01": "A7103",
              "unit": "世帯",
              "sourceId": "a24"
            },
            {
              "statId": "0000010101/A810101/世帯/a25/親族のみの世帯数",
              "label": "親族のみの世帯数",
              "cat01": "A810101",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A810102/世帯/a25/核家族世帯数",
              "label": "核家族世帯数",
              "cat01": "A810102",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A810103/世帯/a25/核家族以外の世帯数",
              "label": "核家族以外の世帯数",
              "cat01": "A810103",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A810104/世帯/a25/非親族を含む世帯数",
              "label": "非親族を含む世帯数",
              "cat01": "A810104",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A810105/世帯/a25/単独世帯数",
              "label": "単独世帯数",
              "cat01": "A810105",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8111/世帯/a25/６５歳以上の世帯員のいる世帯数（国勢調査結果）",
              "label": "６５歳以上の世帯員のいる世帯数（国勢調査結果）",
              "cat01": "A8111",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811101/世帯/a25/６５歳以上の世帯員のいる親族のみの世帯数",
              "label": "６５歳以上の世帯員のいる親族のみの世帯数",
              "cat01": "A811101",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811102/世帯/a25/６５歳以上の世帯員のいる核家族世帯数",
              "label": "６５歳以上の世帯員のいる核家族世帯数",
              "cat01": "A811102",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811103/世帯/a25/６５歳以上の親族のいるその他の親族世帯数",
              "label": "６５歳以上の親族のいるその他の親族世帯数",
              "cat01": "A811103",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811104/世帯/a25/６５歳以上の親族のいる非親族世帯数",
              "label": "６５歳以上の親族のいる非親族世帯数",
              "cat01": "A811104",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811105/世帯/a25/６５歳以上の世帯員のいる単独世帯数",
              "label": "６５歳以上の世帯員のいる単独世帯数",
              "cat01": "A811105",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8112/人/a25/６５歳以上の世帯員のいる世帯人員数",
              "label": "６５歳以上の世帯員のいる世帯人員数",
              "cat01": "A8112",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811201/人/a25/６５歳以上の世帯員のいる親族のみの世帯人員数",
              "label": "６５歳以上の世帯員のいる親族のみの世帯人員数",
              "cat01": "A811201",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811202/人/a25/６５歳以上の世帯員のいる核家族世帯人員数",
              "label": "６５歳以上の世帯員のいる核家族世帯人員数",
              "cat01": "A811202",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811203/人/a25/６５歳以上の親族のいるその他の親族世帯人員数",
              "label": "６５歳以上の親族のいるその他の親族世帯人員数",
              "cat01": "A811203",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811204/人/a25/６５歳以上の親族のいる非親族世帯人員数",
              "label": "６５歳以上の親族のいる非親族世帯人員数",
              "cat01": "A811204",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A811205/人/a25/６５歳以上の親族のいる単独世帯人員数",
              "label": "６５歳以上の親族のいる単独世帯人員数",
              "cat01": "A811205",
              "unit": "人",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8201/世帯/a25/高齢夫婦のみの世帯数",
              "label": "高齢夫婦のみの世帯数",
              "cat01": "A8201",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8202/世帯/a25/高齢夫婦世帯数（高齢夫婦と未婚の１８歳未満の者）",
              "label": "高齢夫婦世帯数（高齢夫婦と未婚の１８歳未満の者）",
              "cat01": "A8202",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8301/世帯/a25/高齢単身世帯数（６５歳以上の者１人）",
              "label": "高齢単身世帯数（６５歳以上の者１人）",
              "cat01": "A8301",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A830101/世帯/a25/高齢単身世帯数（６５歳以上の者１人）（男）",
              "label": "高齢単身世帯数（６５歳以上の者１人）（男）",
              "cat01": "A830101",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A830102/世帯/a25/高齢単身世帯数（６５歳以上の者１人）（女）",
              "label": "高齢単身世帯数（６５歳以上の者１人）（女）",
              "cat01": "A830102",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8303/世帯/a25/高齢単身世帯数（６０歳以上の者１人）",
              "label": "高齢単身世帯数（６０歳以上の者１人）",
              "cat01": "A8303",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A830301/世帯/a25/高齢単身世帯数（６０歳以上の者１人）（男）",
              "label": "高齢単身世帯数（６０歳以上の者１人）（男）",
              "cat01": "A830301",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A830302/世帯/a25/高齢単身世帯数（６０歳以上の者１人）（女）",
              "label": "高齢単身世帯数（６０歳以上の者１人）（女）",
              "cat01": "A830302",
              "unit": "世帯",
              "sourceId": "a25"
            },
            {
              "statId": "0000010101/A8401/世帯/a26/母子世帯数",
              "label": "母子世帯数",
              "cat01": "A8401",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840101/世帯/a26/母子世帯数（子供が１人）",
              "label": "母子世帯数（子供が１人）",
              "cat01": "A840101",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840102/世帯/a26/母子世帯数（子供が２人）",
              "label": "母子世帯数（子供が２人）",
              "cat01": "A840102",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840103/世帯/a26/母子世帯数（子供が３人以上）",
              "label": "母子世帯数（子供が３人以上）",
              "cat01": "A840103",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840201/世帯/a26/母子世帯数（１５～２４歳）",
              "label": "母子世帯数（１５～２４歳）",
              "cat01": "A840201",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840202/世帯/a26/母子世帯数（２５～３４歳）",
              "label": "母子世帯数（２５～３４歳）",
              "cat01": "A840202",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840203/世帯/a26/母子世帯数（３５～４４歳）",
              "label": "母子世帯数（３５～４４歳）",
              "cat01": "A840203",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840204/世帯/a26/母子世帯数（４５～５４歳）",
              "label": "母子世帯数（４５～５４歳）",
              "cat01": "A840204",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A840205/世帯/a26/母子世帯数（５５歳以上）",
              "label": "母子世帯数（５５歳以上）",
              "cat01": "A840205",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A8501/世帯/a26/父子世帯数",
              "label": "父子世帯数",
              "cat01": "A8501",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850101/世帯/a26/父子世帯数（子供が１人）",
              "label": "父子世帯数（子供が１人）",
              "cat01": "A850101",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850102/世帯/a26/父子世帯数（子供が２人）",
              "label": "父子世帯数（子供が２人）",
              "cat01": "A850102",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850103/世帯/a26/父子世帯数（子供が３人以上）",
              "label": "父子世帯数（子供が３人以上）",
              "cat01": "A850103",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850201/世帯/a26/父子世帯数（１５～２４歳）",
              "label": "父子世帯数（１５～２４歳）",
              "cat01": "A850201",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850202/世帯/a26/父子世帯数（２５～３４歳）",
              "label": "父子世帯数（２５～３４歳）",
              "cat01": "A850202",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850203/世帯/a26/父子世帯数（３５～４４歳）",
              "label": "父子世帯数（３５～４４歳）",
              "cat01": "A850203",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850204/世帯/a26/父子世帯数（４５～５４歳）",
              "label": "父子世帯数（４５～５４歳）",
              "cat01": "A850204",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A850205/世帯/a26/父子世帯数（５５歳以上）",
              "label": "父子世帯数（５５歳以上）",
              "cat01": "A850205",
              "unit": "世帯",
              "sourceId": "a26"
            },
            {
              "statId": "0000010101/A9101/組/a27/婚姻件数",
              "label": "婚姻件数",
              "cat01": "A9101",
              "unit": "組",
              "sourceId": "a27"
            },
            {
              "statId": "0000010101/A9111/歳/a27/平均婚姻年齢（初婚の夫）",
              "label": "平均婚姻年齢（初婚の夫）",
              "cat01": "A9111",
              "unit": "歳",
              "sourceId": "a27"
            },
            {
              "statId": "0000010101/A9112/歳/a27/平均婚姻年齢（初婚の妻）",
              "label": "平均婚姻年齢（初婚の妻）",
              "cat01": "A9112",
              "unit": "歳",
              "sourceId": "a27"
            },
            {
              "statId": "0000010101/A9201/組/a27/離婚件数",
              "label": "離婚件数",
              "cat01": "A9201",
              "unit": "組",
              "sourceId": "a27"
            }
          ]
        },
        {
          "label": "Ｂ自然環境",
          "statId": "0000010102",
          "children": [
            {
              "statId": "0000010102/B1101/ｈａ/b01/総面積（北方地域及び竹島を除く）",
              "label": "総面積（北方地域及び竹島を除く）",
              "cat01": "B1101",
              "unit": "ｈａ",
              "sourceId": "b01"
            },
            {
              "statId": "0000010102/B1102/ｈａ/b01/総面積（北方地域及び竹島を含む）",
              "label": "総面積（北方地域及び竹島を含む）",
              "cat01": "B1102",
              "unit": "ｈａ",
              "sourceId": "b01"
            },
            {
              "statId": "0000010102/B1103/ｈａ/b01/可住地面積",
              "label": "可住地面積",
              "cat01": "B1103",
              "unit": "ｈａ",
              "sourceId": "b01"
            },
            {
              "statId": "0000010102/B1104/ｈａ/b01/主要湖沼面積",
              "label": "主要湖沼面積",
              "cat01": "B1104",
              "unit": "ｈａ",
              "sourceId": "b01"
            },
            {
              "statId": "0000010102/B1105/ｈａ/b02/林野面積",
              "label": "林野面積",
              "cat01": "B1105",
              "unit": "ｈａ",
              "sourceId": "b02"
            },
            {
              "statId": "0000010102/B1106/ｈａ/b02/森林面積",
              "label": "森林面積",
              "cat01": "B1106",
              "unit": "ｈａ",
              "sourceId": "b02"
            },
            {
              "statId": "0000010102/B1107/ｈａ/b02/森林以外の草生地面積",
              "label": "森林以外の草生地面積",
              "cat01": "B1107",
              "unit": "ｈａ",
              "sourceId": "b02"
            },
            {
              "statId": "0000010102/B1108/ｈａ/b03/自然環境保全地域面積",
              "label": "自然環境保全地域面積",
              "cat01": "B1108",
              "unit": "ｈａ",
              "sourceId": "b03"
            },
            {
              "statId": "0000010102/B1201/ｍ2/b04/評価総地積（課税対象土地）",
              "label": "評価総地積（課税対象土地）",
              "cat01": "B1201",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120101/ｍ2/b04/評価総地積（田）",
              "label": "評価総地積（田）",
              "cat01": "B120101",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120102/ｍ2/b04/評価総地積（畑）",
              "label": "評価総地積（畑）",
              "cat01": "B120102",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120103/ｍ2/b04/評価総地積（宅地）",
              "label": "評価総地積（宅地）",
              "cat01": "B120103",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120104/ｍ2/b04/評価総地積（山林）",
              "label": "評価総地積（山林）",
              "cat01": "B120104",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120105/ｍ2/b04/評価総地積（牧場）",
              "label": "評価総地積（牧場）",
              "cat01": "B120105",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120106/ｍ2/b04/評価総地積（原野）",
              "label": "評価総地積（原野）",
              "cat01": "B120106",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B120107/ｍ2/b04/評価総地積（その他）",
              "label": "評価総地積（その他）",
              "cat01": "B120107",
              "unit": "ｍ2",
              "sourceId": "b04"
            },
            {
              "statId": "0000010102/B1303/ｈａ/b05/人工造林面積",
              "label": "人工造林面積",
              "cat01": "B1303",
              "unit": "ｈａ",
              "sourceId": "b05"
            },
            {
              "statId": "0000010102/B2101/ｈａ/b06/自然公園面積",
              "label": "自然公園面積",
              "cat01": "B2101",
              "unit": "ｈａ",
              "sourceId": "b06"
            },
            {
              "statId": "0000010102/B2102/箇所/b06/都道府県立自然公園数",
              "label": "都道府県立自然公園数",
              "cat01": "B2102",
              "unit": "箇所",
              "sourceId": "b06"
            },
            {
              "statId": "0000010102/B2103/ｈａ/b06/都道府県立自然公園面積",
              "label": "都道府県立自然公園面積",
              "cat01": "B2103",
              "unit": "ｈａ",
              "sourceId": "b06"
            },
            {
              "statId": "0000010102/B2104/ｈａ/b06/国立公園面積",
              "label": "国立公園面積",
              "cat01": "B2104",
              "unit": "ｈａ",
              "sourceId": "b06"
            },
            {
              "statId": "0000010102/B2105/ｈａ/b06/国定公園面積",
              "label": "国定公園面積",
              "cat01": "B2105",
              "unit": "ｈａ",
              "sourceId": "b06"
            },
            {
              "statId": "0000010102/B3101/％/b07/植生自然度１（構成比）",
              "label": "植生自然度１（構成比）",
              "cat01": "B3101",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3102/％/b07/植生自然度２（構成比）",
              "label": "植生自然度２（構成比）",
              "cat01": "B3102",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3103/％/b07/植生自然度３（構成比）",
              "label": "植生自然度３（構成比）",
              "cat01": "B3103",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3104/％/b07/植生自然度４（構成比）",
              "label": "植生自然度４（構成比）",
              "cat01": "B3104",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3105/％/b07/植生自然度５（構成比）",
              "label": "植生自然度５（構成比）",
              "cat01": "B3105",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3106/％/b07/植生自然度６（構成比）",
              "label": "植生自然度６（構成比）",
              "cat01": "B3106",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3107/％/b07/植生自然度７（構成比）",
              "label": "植生自然度７（構成比）",
              "cat01": "B3107",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3108/％/b07/植生自然度８（構成比）",
              "label": "植生自然度８（構成比）",
              "cat01": "B3108",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3109/％/b07/植生自然度９（構成比）",
              "label": "植生自然度９（構成比）",
              "cat01": "B3109",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B3110/％/b07/植生自然度１０（構成比）",
              "label": "植生自然度１０（構成比）",
              "cat01": "B3110",
              "unit": "％",
              "sourceId": "b07"
            },
            {
              "statId": "0000010102/B4101/℃/b08/年平均気温",
              "label": "年平均気温",
              "cat01": "B4101",
              "unit": "℃",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4102/℃/b08/最高気温（日最高気温の月平均の最高値）",
              "label": "最高気温（日最高気温の月平均の最高値）",
              "cat01": "B4102",
              "unit": "℃",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4103/℃/b08/最低気温（日最低気温の月平均の最低値）",
              "label": "最低気温（日最低気温の月平均の最低値）",
              "cat01": "B4103",
              "unit": "℃",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4104/日/b08/快晴日数（年間）",
              "label": "快晴日数（年間）",
              "cat01": "B4104",
              "unit": "日",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4105/日/b08/曇天日数（年間）",
              "label": "曇天日数（年間）",
              "cat01": "B4105",
              "unit": "日",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4106/日/b08/降水日数（年間）",
              "label": "降水日数（年間）",
              "cat01": "B4106",
              "unit": "日",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4107/日/b08/雪日数（年間）",
              "label": "雪日数（年間）",
              "cat01": "B4107",
              "unit": "日",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4108/時間/b08/日照時間（年間）",
              "label": "日照時間（年間）",
              "cat01": "B4108",
              "unit": "時間",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4109/ｍｍ/b08/降水量（年間）",
              "label": "降水量（年間）",
              "cat01": "B4109",
              "unit": "ｍｍ",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4110/ｃｍ/b08/最深積雪",
              "label": "最深積雪",
              "cat01": "B4110",
              "unit": "ｃｍ",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4111/％/b08/年平均相対湿度",
              "label": "年平均相対湿度",
              "cat01": "B4111",
              "unit": "％",
              "sourceId": "b08"
            },
            {
              "statId": "0000010102/B4112/％/b08/最小相対湿度（年間）",
              "label": "最小相対湿度（年間）",
              "cat01": "B4112",
              "unit": "％",
              "sourceId": "b08"
            }
          ]
        },
        {
          "label": "Ｃ経済基盤",
          "statId": "0000010103",
          "children": [
            {
              "statId": "0000010103/C1101/百万円/c01/県内総生産額（平成17年基準）",
              "label": "県内総生産額（平成17年基準）",
              "cat01": "C1101",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1102/百万円/c01/県内総生産額（産業）（平成17年基準）",
              "label": "県内総生産額（産業）（平成17年基準）",
              "cat01": "C1102",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110201/百万円/c01/県内総生産額（農林水産業）（平成17年基準）",
              "label": "県内総生産額（農林水産業）（平成17年基準）",
              "cat01": "C110201",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110202/百万円/c01/県内総生産額（農業）（平成17年基準）",
              "label": "県内総生産額（農業）（平成17年基準）",
              "cat01": "C110202",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110203/百万円/c01/県内総生産額（林業）（平成17年基準）",
              "label": "県内総生産額（林業）（平成17年基準）",
              "cat01": "C110203",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110204/百万円/c01/県内総生産額（水産業）（平成17年基準）",
              "label": "県内総生産額（水産業）（平成17年基準）",
              "cat01": "C110204",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110205/百万円/c01/県内総生産額（鉱業）（平成17年基準）",
              "label": "県内総生産額（鉱業）（平成17年基準）",
              "cat01": "C110205",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110206/百万円/c01/県内総生産額（製造業）（平成17年基準）",
              "label": "県内総生産額（製造業）（平成17年基準）",
              "cat01": "C110206",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110207/百万円/c01/県内総生産額（建設業）（平成17年基準）",
              "label": "県内総生産額（建設業）（平成17年基準）",
              "cat01": "C110207",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110208/百万円/c01/県内総生産額（電気・ガス・水道業）（平成17年基準）",
              "label": "県内総生産額（電気・ガス・水道業）（平成17年基準）",
              "cat01": "C110208",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110209/百万円/c01/県内総生産額（卸売・小売業）（平成17年基準）",
              "label": "県内総生産額（卸売・小売業）（平成17年基準）",
              "cat01": "C110209",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110210/百万円/c01/県内総生産額（金融・保険業）（平成17年基準）",
              "label": "県内総生産額（金融・保険業）（平成17年基準）",
              "cat01": "C110210",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110211/百万円/c01/県内総生産額（不動産業）（平成17年基準）",
              "label": "県内総生産額（不動産業）（平成17年基準）",
              "cat01": "C110211",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1102121/百万円/c01/県内総生産額（運輸業）（平成17年基準）",
              "label": "県内総生産額（運輸業）（平成17年基準）",
              "cat01": "C1102121",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1102122/百万円/c01/県内総生産額（情報通信業）（平成17年基準）",
              "label": "県内総生産額（情報通信業）（平成17年基準）",
              "cat01": "C1102122",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110213/百万円/c01/県内総生産額（サービス業）（平成17年基準）",
              "label": "県内総生産額（サービス業）（平成17年基準）",
              "cat01": "C110213",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1103/百万円/c01/県内総生産額（政府サービス生産者）（平成17年基準）",
              "label": "県内総生産額（政府サービス生産者）（平成17年基準）",
              "cat01": "C1103",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110301/百万円/c01/県内総生産額（政府サービス生産者）（電気・ガス・水道業）（平成17年基準）",
              "label": "県内総生産額（政府サービス生産者）（電気・ガス・水道業）（平成17年基準）",
              "cat01": "C110301",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110302/百万円/c01/県内総生産額（政府サービス生産者）（サービス業）（平成17年基準）",
              "label": "県内総生産額（政府サービス生産者）（サービス業）（平成17年基準）",
              "cat01": "C110302",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C110303/百万円/c01/県内総生産額（政府サービス生産者）（公務）（平成17年基準）",
              "label": "県内総生産額（政府サービス生産者）（公務）（平成17年基準）",
              "cat01": "C110303",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1104/百万円/c01/県内総生産額（対家計民間非営利サービス生産者）（平成17年基準）",
              "label": "県内総生産額（対家計民間非営利サービス生産者）（平成17年基準）",
              "cat01": "C1104",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1105/百万円/c01/県内総生産額（第１次産業）（平成17年基準）",
              "label": "県内総生産額（第１次産業）（平成17年基準）",
              "cat01": "C1105",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1106/百万円/c01/県内総生産額（第２次産業）（平成17年基準）",
              "label": "県内総生産額（第２次産業）（平成17年基準）",
              "cat01": "C1106",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1107/百万円/c01/県内総生産額（第３次産業）（平成17年基準）",
              "label": "県内総生産額（第３次産業）（平成17年基準）",
              "cat01": "C1107",
              "unit": "百万円",
              "sourceId": "c01"
            },
            {
              "statId": "0000010103/C1111/百万円/c02/県内総生産額（平成23年基準）",
              "label": "県内総生産額（平成23年基準）",
              "cat01": "C1111",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111201/百万円/c02/県内総生産額（農林水産業）（平成23年基準）",
              "label": "県内総生産額（農林水産業）（平成23年基準）",
              "cat01": "C111201",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111202/百万円/c02/県内総生産額（農業）（平成23年基準）",
              "label": "県内総生産額（農業）（平成23年基準）",
              "cat01": "C111202",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111203/百万円/c02/県内総生産額（林業）（平成23年基準）",
              "label": "県内総生産額（林業）（平成23年基準）",
              "cat01": "C111203",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111204/百万円/c02/県内総生産額（水産業）（平成23年基準）",
              "label": "県内総生産額（水産業）（平成23年基準）",
              "cat01": "C111204",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111205/百万円/c02/県内総生産額（鉱業）（平成23年基準）",
              "label": "県内総生産額（鉱業）（平成23年基準）",
              "cat01": "C111205",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111206/百万円/c02/県内総生産額（製造業）（平成23年基準）",
              "label": "県内総生産額（製造業）（平成23年基準）",
              "cat01": "C111206",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111207/百万円/c02/県内総生産額（建設業）（平成23年基準）",
              "label": "県内総生産額（建設業）（平成23年基準）",
              "cat01": "C111207",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111208/百万円/c02/県内総生産額（電気・ガス・水道・廃棄物処理業）（平成23年基準）",
              "label": "県内総生産額（電気・ガス・水道・廃棄物処理業）（平成23年基準）",
              "cat01": "C111208",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111209/百万円/c02/県内総生産額（卸売・小売業）（平成23年基準）",
              "label": "県内総生産額（卸売・小売業）（平成23年基準）",
              "cat01": "C111209",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111210/百万円/c02/県内総生産額（金融・保険業）（平成23年基準）",
              "label": "県内総生産額（金融・保険業）（平成23年基準）",
              "cat01": "C111210",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111211/百万円/c02/県内総生産額（不動産業）（平成23年基準）",
              "label": "県内総生産額（不動産業）（平成23年基準）",
              "cat01": "C111211",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1112121/百万円/c02/県内総生産額（運輸・郵便業）（平成23年基準）",
              "label": "県内総生産額（運輸・郵便業）（平成23年基準）",
              "cat01": "C1112121",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1112122/百万円/c02/県内総生産額（情報通信業）（平成23年基準）",
              "label": "県内総生産額（情報通信業）（平成23年基準）",
              "cat01": "C1112122",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111213/百万円/c02/県内総生産額（宿泊・飲食サービス業）（平成23年基準）",
              "label": "県内総生産額（宿泊・飲食サービス業）（平成23年基準）",
              "cat01": "C111213",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111214/百万円/c02/県内総生産額（専門・科学技術、業務支援サービス業）（平成23年基準）",
              "label": "県内総生産額（専門・科学技術、業務支援サービス業）（平成23年基準）",
              "cat01": "C111214",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111215/百万円/c02/県内総生産額（公務）（平成23年基準）",
              "label": "県内総生産額（公務）（平成23年基準）",
              "cat01": "C111215",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111216/百万円/c02/県内総生産額（教育）（平成23年基準）",
              "label": "県内総生産額（教育）（平成23年基準）",
              "cat01": "C111216",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111217/百万円/c02/県内総生産額（保健衛生・社会事業）（平成23年基準）",
              "label": "県内総生産額（保健衛生・社会事業）（平成23年基準）",
              "cat01": "C111217",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C111218/百万円/c02/県内総生産額（その他のサービス）（平成23年基準）",
              "label": "県内総生産額（その他のサービス）（平成23年基準）",
              "cat01": "C111218",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1115/百万円/c02/県内総生産額（第１次産業）（平成23年基準）",
              "label": "県内総生産額（第１次産業）（平成23年基準）",
              "cat01": "C1115",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1116/百万円/c02/県内総生産額（第２次産業）（平成23年基準）",
              "label": "県内総生産額（第２次産業）（平成23年基準）",
              "cat01": "C1116",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1117/百万円/c02/県内総生産額（第３次産業）（平成23年基準）",
              "label": "県内総生産額（第３次産業）（平成23年基準）",
              "cat01": "C1117",
              "unit": "百万円",
              "sourceId": "c02"
            },
            {
              "statId": "0000010103/C1201/百万円/c03/県民所得（平成17年基準）",
              "label": "県民所得（平成17年基準）",
              "cat01": "C1201",
              "unit": "百万円",
              "sourceId": "c03"
            },
            {
              "statId": "0000010103/C120101/千円/c03/１人当たり県民所得（平成17年基準）",
              "label": "１人当たり県民所得（平成17年基準）",
              "cat01": "C120101",
              "unit": "千円",
              "sourceId": "c03"
            },
            {
              "statId": "0000010103/C120110/千円/c04/課税対象所得",
              "label": "課税対象所得",
              "cat01": "C120110",
              "unit": "千円",
              "sourceId": "c04"
            },
            {
              "statId": "0000010103/C120120/人/c04/納税義務者数（所得割）",
              "label": "納税義務者数（所得割）",
              "cat01": "C120120",
              "unit": "人",
              "sourceId": "c04"
            },
            {
              "statId": "0000010103/C120130/人/c04/納税義務者数（均等割）",
              "label": "納税義務者数（均等割）",
              "cat01": "C120130",
              "unit": "人",
              "sourceId": "c04"
            },
            {
              "statId": "0000010103/C1202/百万円/c05/雇用者報酬（平成17年基準）",
              "label": "雇用者報酬（平成17年基準）",
              "cat01": "C1202",
              "unit": "百万円",
              "sourceId": "c05"
            },
            {
              "statId": "0000010103/C120201/百万円/c05/賃金・俸給（平成17年基準）",
              "label": "賃金・俸給（平成17年基準）",
              "cat01": "C120201",
              "unit": "百万円",
              "sourceId": "c05"
            },
            {
              "statId": "0000010103/C1203/百万円/c05/財産所得（平成17年基準）",
              "label": "財産所得（平成17年基準）",
              "cat01": "C1203",
              "unit": "百万円",
              "sourceId": "c05"
            },
            {
              "statId": "0000010103/C1204/百万円/c05/企業所得（平成17年基準）",
              "label": "企業所得（平成17年基準）",
              "cat01": "C1204",
              "unit": "百万円",
              "sourceId": "c05"
            },
            {
              "statId": "0000010103/C1211/百万円/c06/県民所得（平成23年基準）",
              "label": "県民所得（平成23年基準）",
              "cat01": "C1211",
              "unit": "百万円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C121101/千円/c06/１人当たり県民所得（平成23年基準）",
              "label": "１人当たり県民所得（平成23年基準）",
              "cat01": "C121101",
              "unit": "千円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C1212/百万円/c06/雇用者報酬（平成23年基準）",
              "label": "雇用者報酬（平成23年基準）",
              "cat01": "C1212",
              "unit": "百万円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C121201/百万円/c06/賃金・俸給（平成23年基準）",
              "label": "賃金・俸給（平成23年基準）",
              "cat01": "C121201",
              "unit": "百万円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C1213/百万円/c06/財産所得（平成23年基準）",
              "label": "財産所得（平成23年基準）",
              "cat01": "C1213",
              "unit": "百万円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C1214/百万円/c06/企業所得（平成23年基準）",
              "label": "企業所得（平成23年基準）",
              "cat01": "C1214",
              "unit": "百万円",
              "sourceId": "c06"
            },
            {
              "statId": "0000010103/C1301/百万円/c07/民間最終消費支出（名目）（平成17年基準）",
              "label": "民間最終消費支出（名目）（平成17年基準）",
              "cat01": "C1301",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1302/百万円/c07/政府最終消費支出（名目）（平成17年基準）",
              "label": "政府最終消費支出（名目）（平成17年基準）",
              "cat01": "C1302",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1303/百万円/c07/県内総資本形成（名目）（平成17年基準）",
              "label": "県内総資本形成（名目）（平成17年基準）",
              "cat01": "C1303",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C130301/百万円/c07/総固定資本形成（名目）（平成17年基準）",
              "label": "総固定資本形成（名目）（平成17年基準）",
              "cat01": "C130301",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C130302/百万円/c07/在庫品増加（名目）（平成17年基準）",
              "label": "在庫品増加（名目）（平成17年基準）",
              "cat01": "C130302",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1304/百万円/c07/財貨サービスの移出入（名目）（平成17年基準）",
              "label": "財貨サービスの移出入（名目）（平成17年基準）",
              "cat01": "C1304",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1305/百万円/c07/統計上の不突合（名目）（平成17年基準）",
              "label": "統計上の不突合（名目）（平成17年基準）",
              "cat01": "C1305",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1306/百万円/c07/県内総生産（支出側）（名目）（平成17年基準）",
              "label": "県内総生産（支出側）（名目）（平成17年基準）",
              "cat01": "C1306",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1307/百万円/c07/県外からの所得（名目）（平成17年基準）",
              "label": "県外からの所得（名目）（平成17年基準）",
              "cat01": "C1307",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1308/百万円/c07/県民総所得（名目）（平成17年基準）",
              "label": "県民総所得（名目）（平成17年基準）",
              "cat01": "C1308",
              "unit": "百万円",
              "sourceId": "c07"
            },
            {
              "statId": "0000010103/C1311/百万円/c08/民間最終消費支出（名目）（平成23年基準）",
              "label": "民間最終消費支出（名目）（平成23年基準）",
              "cat01": "C1311",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1312/百万円/c08/政府最終消費支出（名目）（平成23年基準）",
              "label": "政府最終消費支出（名目）（平成23年基準）",
              "cat01": "C1312",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1313/百万円/c08/県内総資本形成（名目）（平成23年基準）",
              "label": "県内総資本形成（名目）（平成23年基準）",
              "cat01": "C1313",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C131301/百万円/c08/総固定資本形成（名目）（平成23年基準）",
              "label": "総固定資本形成（名目）（平成23年基準）",
              "cat01": "C131301",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C131302/百万円/c08/在庫変動（名目）（平成23年基準）",
              "label": "在庫変動（名目）（平成23年基準）",
              "cat01": "C131302",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1314/百万円/c08/財貨・サービスの移出入（名目）（平成23年基準）",
              "label": "財貨・サービスの移出入（名目）（平成23年基準）",
              "cat01": "C1314",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1315/百万円/c08/統計上の不突合（名目）（平成23年基準）",
              "label": "統計上の不突合（名目）（平成23年基準）",
              "cat01": "C1315",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1316/百万円/c08/県内総生産（支出側）（名目）（平成23年基準）",
              "label": "県内総生産（支出側）（名目）（平成23年基準）",
              "cat01": "C1316",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1317/百万円/c08/県外からの所得（名目）（平成23年基準）",
              "label": "県外からの所得（名目）（平成23年基準）",
              "cat01": "C1317",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1318/百万円/c08/県民総所得（名目）（平成23年基準）",
              "label": "県民総所得（名目）（平成23年基準）",
              "cat01": "C1318",
              "unit": "百万円",
              "sourceId": "c08"
            },
            {
              "statId": "0000010103/C1401/百万円/c09/民間最終消費支出（実質）（平成17年基準）",
              "label": "民間最終消費支出（実質）（平成17年基準）",
              "cat01": "C1401",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1402/百万円/c09/政府最終消費支出（実質）（平成17年基準）",
              "label": "政府最終消費支出（実質）（平成17年基準）",
              "cat01": "C1402",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1403/百万円/c09/県内総資本形成（実質）（平成17年基準）",
              "label": "県内総資本形成（実質）（平成17年基準）",
              "cat01": "C1403",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C140301/百万円/c09/総固定資本形成（実質）（平成17年基準）",
              "label": "総固定資本形成（実質）（平成17年基準）",
              "cat01": "C140301",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C140302/百万円/c09/在庫品増加（実質）（平成17年基準）",
              "label": "在庫品増加（実質）（平成17年基準）",
              "cat01": "C140302",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1404/百万円/c09/財貨サービスの移出入（実質）（平成17年基準）",
              "label": "財貨サービスの移出入（実質）（平成17年基準）",
              "cat01": "C1404",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1405/百万円/c09/統計上の不突合（実質）（平成17年基準）",
              "label": "統計上の不突合（実質）（平成17年基準）",
              "cat01": "C1405",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1406/百万円/c09/県内総生産（支出側）（実質）（平成17年基準）",
              "label": "県内総生産（支出側）（実質）（平成17年基準）",
              "cat01": "C1406",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1407/百万円/c09/県外からの所得（実質）（平成17年基準）",
              "label": "県外からの所得（実質）（平成17年基準）",
              "cat01": "C1407",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1408/百万円/c09/県民総所得（実質）（平成17年基準）",
              "label": "県民総所得（実質）（平成17年基準）",
              "cat01": "C1408",
              "unit": "百万円",
              "sourceId": "c09"
            },
            {
              "statId": "0000010103/C1411/百万円/c10/民間最終消費支出（実質）（平成23年基準）",
              "label": "民間最終消費支出（実質）（平成23年基準）",
              "cat01": "C1411",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C1412/百万円/c10/政府最終消費支出（実質）（平成23年基準）",
              "label": "政府最終消費支出（実質）（平成23年基準）",
              "cat01": "C1412",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C1413/百万円/c10/県内総資本形成（実質）（平成23年基準）",
              "label": "県内総資本形成（実質）（平成23年基準）",
              "cat01": "C1413",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C141301/百万円/c10/総固定資本形成（実質）（平成23年基準）",
              "label": "総固定資本形成（実質）（平成23年基準）",
              "cat01": "C141301",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C141302/百万円/c10/在庫変動（実質）（平成23年基準）",
              "label": "在庫変動（実質）（平成23年基準）",
              "cat01": "C141302",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C1416/百万円/c10/県内総生産（支出側）（実質）（平成23年基準）",
              "label": "県内総生産（支出側）（実質）（平成23年基準）",
              "cat01": "C1416",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C1417/百万円/c10/財貨・サービスの移出入(純)･統計上の不突合・開差（実質）（平成23年基準）",
              "label": "財貨・サービスの移出入(純)･統計上の不突合・開差（実質）（平成23年基準）",
              "cat01": "C1417",
              "unit": "百万円",
              "sourceId": "c10"
            },
            {
              "statId": "0000010103/C2101/所/c110/事業所数（事業所・企業統計調査結果）",
              "label": "事業所数（事業所・企業統計調査結果）",
              "cat01": "C2101",
              "unit": "所",
              "sourceId": "c110"
            },
            {
              "statId": "0000010103/C2102/所/c12/事業所数（民営）（事業所・企業統計調査結果）",
              "label": "事業所数（民営）（事業所・企業統計調査結果）",
              "cat01": "C2102",
              "unit": "所",
              "sourceId": "c12"
            },
            {
              "statId": "0000010103/C210220/所/c12/事業所数（民営）（個人事業所）（事業所・企業統計調査結果）",
              "label": "事業所数（民営）（個人事業所）（事業所・企業統計調査結果）",
              "cat01": "C210220",
              "unit": "所",
              "sourceId": "c12"
            },
            {
              "statId": "0000010103/C210230/所/c12/事業所数（民営）（法人事業所）（事業所・企業統計調査結果）",
              "label": "事業所数（民営）（法人事業所）（事業所・企業統計調査結果）",
              "cat01": "C210230",
              "unit": "所",
              "sourceId": "c12"
            },
            {
              "statId": "0000010103/C210231/所/c12/事業所数（民営）（会社事業所）（事業所・企業統計調査結果）",
              "label": "事業所数（民営）（会社事業所）（事業所・企業統計調査結果）",
              "cat01": "C210231",
              "unit": "所",
              "sourceId": "c12"
            },
            {
              "statId": "0000010103/C210232/所/c12/事業所数（民営）（独立行政法人等）（事業所・企業統計調査結果）",
              "label": "事業所数（民営）（独立行政法人等）（事業所・企業統計調査結果）",
              "cat01": "C210232",
              "unit": "所",
              "sourceId": "c12"
            },
            {
              "statId": "0000010103/C2103/所/c14/事業所数（国・地方公共団体）（事業所・企業統計調査結果）",
              "label": "事業所数（国・地方公共団体）（事業所・企業統計調査結果）",
              "cat01": "C2103",
              "unit": "所",
              "sourceId": "c14"
            },
            {
              "statId": "0000010103/C210301/所/c14/事業所数（国）（事業所・企業統計調査結果）",
              "label": "事業所数（国）（事業所・企業統計調査結果）",
              "cat01": "C210301",
              "unit": "所",
              "sourceId": "c14"
            },
            {
              "statId": "0000010103/C210302/所/c14/事業所数（都道府県）（事業所・企業統計調査結果）",
              "label": "事業所数（都道府県）（事業所・企業統計調査結果）",
              "cat01": "C210302",
              "unit": "所",
              "sourceId": "c14"
            },
            {
              "statId": "0000010103/C210303/所/c14/事業所数（市区町村）（事業所・企業統計調査結果）",
              "label": "事業所数（市区町村）（事業所・企業統計調査結果）",
              "cat01": "C210303",
              "unit": "所",
              "sourceId": "c14"
            },
            {
              "statId": "0000010103/C2104/所/c16/第２次産業事業所数（事業所・企業統計調査結果）",
              "label": "第２次産業事業所数（事業所・企業統計調査結果）",
              "cat01": "C2104",
              "unit": "所",
              "sourceId": "c16"
            },
            {
              "statId": "0000010103/C2105/所/c16/第３次産業事業所数（事業所・企業統計調査結果）",
              "label": "第３次産業事業所数（事業所・企業統計調査結果）",
              "cat01": "C2105",
              "unit": "所",
              "sourceId": "c16"
            },
            {
              "statId": "0000010103/C2106/所/c16/第１次産業事業所数（事業所・企業統計調査結果）",
              "label": "第１次産業事業所数（事業所・企業統計調査結果）",
              "cat01": "C2106",
              "unit": "所",
              "sourceId": "c16"
            },
            {
              "statId": "0000010103/C2107/所/c11/事業所数（経済センサス‐基礎調査結果）",
              "label": "事業所数（経済センサス‐基礎調査結果）",
              "cat01": "C2107",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210701/所/c11/事業所数（公務を除く）",
              "label": "事業所数（公務を除く）",
              "cat01": "C210701",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210702/所/c11/事業所数（農林漁業）",
              "label": "事業所数（農林漁業）",
              "cat01": "C210702",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210703/所/c11/事業所数（農業，林業）",
              "label": "事業所数（農業，林業）",
              "cat01": "C210703",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210704/所/c11/事業所数（漁業）",
              "label": "事業所数（漁業）",
              "cat01": "C210704",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210705/所/c11/事業所数（非農林漁業）",
              "label": "事業所数（非農林漁業）",
              "cat01": "C210705",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210706/所/c11/事業所数（非農林漁業（公務を除く））",
              "label": "事業所数（非農林漁業（公務を除く））",
              "cat01": "C210706",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210707/所/c11/事業所数（鉱業，採石業，砂利採取業）",
              "label": "事業所数（鉱業，採石業，砂利採取業）",
              "cat01": "C210707",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210708/所/c11/事業所数（建設業）",
              "label": "事業所数（建設業）",
              "cat01": "C210708",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210709/所/c11/事業所数（製造業）",
              "label": "事業所数（製造業）",
              "cat01": "C210709",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210710/所/c11/事業所数（電気・ガス・熱供給・水道業）",
              "label": "事業所数（電気・ガス・熱供給・水道業）",
              "cat01": "C210710",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210711/所/c11/事業所数（情報通信業）",
              "label": "事業所数（情報通信業）",
              "cat01": "C210711",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210712/所/c11/事業所数（運輸業，郵便業）",
              "label": "事業所数（運輸業，郵便業）",
              "cat01": "C210712",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210713/所/c11/事業所数（卸売業，小売業）",
              "label": "事業所数（卸売業，小売業）",
              "cat01": "C210713",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210714/所/c11/事業所数（卸売業）",
              "label": "事業所数（卸売業）",
              "cat01": "C210714",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210715/所/c11/事業所数（小売業）",
              "label": "事業所数（小売業）",
              "cat01": "C210715",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210716/所/c11/事業所数（金融業，保険業）",
              "label": "事業所数（金融業，保険業）",
              "cat01": "C210716",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210717/所/c11/事業所数（不動産業，物品賃貸業）",
              "label": "事業所数（不動産業，物品賃貸業）",
              "cat01": "C210717",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210718/所/c11/事業所数（学術研究，専門・技術サービス業）",
              "label": "事業所数（学術研究，専門・技術サービス業）",
              "cat01": "C210718",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210719/所/c11/事業所数（宿泊業，飲食サービス業）",
              "label": "事業所数（宿泊業，飲食サービス業）",
              "cat01": "C210719",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210720/所/c11/事業所数（生活関連サービス業，娯楽業）",
              "label": "事業所数（生活関連サービス業，娯楽業）",
              "cat01": "C210720",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210721/所/c11/事業所数（教育，学習支援業）",
              "label": "事業所数（教育，学習支援業）",
              "cat01": "C210721",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210722/所/c11/事業所数（医療，福祉）",
              "label": "事業所数（医療，福祉）",
              "cat01": "C210722",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210723/所/c11/事業所数（複合サービス事業）",
              "label": "事業所数（複合サービス事業）",
              "cat01": "C210723",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210724/所/c11/事業所数（サービス業（他に分類されないもの））",
              "label": "事業所数（サービス業（他に分類されないもの））",
              "cat01": "C210724",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C210725/所/c11/事業所数（公務（他に分類されるものを除く））",
              "label": "事業所数（公務（他に分類されるものを除く））",
              "cat01": "C210725",
              "unit": "所",
              "sourceId": "c11"
            },
            {
              "statId": "0000010103/C2108/所/c13/事業所数（民営）",
              "label": "事業所数（民営）",
              "cat01": "C2108",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210801/所/c13/事業所数（民営）従業者１～４人",
              "label": "事業所数（民営）従業者１～４人",
              "cat01": "C210801",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210802/所/c13/事業所数（民営）従業者５～９人",
              "label": "事業所数（民営）従業者５～９人",
              "cat01": "C210802",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210803/所/c13/事業所数（民営）従業者１０～２９人",
              "label": "事業所数（民営）従業者１０～２９人",
              "cat01": "C210803",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210804/所/c13/事業所数（民営）従業者３０～４９人",
              "label": "事業所数（民営）従業者３０～４９人",
              "cat01": "C210804",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210805/所/c13/事業所数（民営）従業者５０～９９人",
              "label": "事業所数（民営）従業者５０～９９人",
              "cat01": "C210805",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210806/所/c13/事業所数（民営）従業者１００～２９９人",
              "label": "事業所数（民営）従業者１００～２９９人",
              "cat01": "C210806",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210807/所/c13/事業所数（民営）従業者３００人以上",
              "label": "事業所数（民営）従業者３００人以上",
              "cat01": "C210807",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210820/所/c13/事業所数（民営）（個人事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "label": "事業所数（民営）（個人事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "cat01": "C210820",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210821/所/c13/事業所数（民営）（法人事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "label": "事業所数（民営）（法人事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "cat01": "C210821",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210822/所/c13/事業所数（民営）（会社事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "label": "事業所数（民営）（会社事業所）（経済センサス‐基礎調査及び活動調査結果）",
              "cat01": "C210822",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210823/所/c13/事業所数（民営）（会社以外の法人）",
              "label": "事業所数（民営）（会社以外の法人）",
              "cat01": "C210823",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210831/所/c13/事業所数（民営）（農林漁業）",
              "label": "事業所数（民営）（農林漁業）",
              "cat01": "C210831",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210832/所/c13/事業所数（民営）（農業，林業）",
              "label": "事業所数（民営）（農業，林業）",
              "cat01": "C210832",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210833/所/c13/事業所数（民営）（漁業）",
              "label": "事業所数（民営）（漁業）",
              "cat01": "C210833",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210834/所/c13/事業所数（民営）（非農林漁業（公務を除く））",
              "label": "事業所数（民営）（非農林漁業（公務を除く））",
              "cat01": "C210834",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210835/所/c13/事業所数（民営）（鉱業，採石業，砂利採取業）",
              "label": "事業所数（民営）（鉱業，採石業，砂利採取業）",
              "cat01": "C210835",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210836/所/c13/事業所数（民営）（建設業）",
              "label": "事業所数（民営）（建設業）",
              "cat01": "C210836",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210837/所/c13/事業所数（民営）（製造業）",
              "label": "事業所数（民営）（製造業）",
              "cat01": "C210837",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210838/所/c13/事業所数（民営）（電気・ガス・熱供給・水道業）",
              "label": "事業所数（民営）（電気・ガス・熱供給・水道業）",
              "cat01": "C210838",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210839/所/c13/事業所数（民営）（情報通信業）",
              "label": "事業所数（民営）（情報通信業）",
              "cat01": "C210839",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210840/所/c13/事業所数（民営）（運輸業，郵便業）",
              "label": "事業所数（民営）（運輸業，郵便業）",
              "cat01": "C210840",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210841/所/c13/事業所数（民営）（卸売業，小売業）",
              "label": "事業所数（民営）（卸売業，小売業）",
              "cat01": "C210841",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210842/所/c13/事業所数（民営）（卸売業）",
              "label": "事業所数（民営）（卸売業）",
              "cat01": "C210842",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210843/所/c13/事業所数（民営）（小売業）",
              "label": "事業所数（民営）（小売業）",
              "cat01": "C210843",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210844/所/c13/事業所数（民営）（金融業，保険業）",
              "label": "事業所数（民営）（金融業，保険業）",
              "cat01": "C210844",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210845/所/c13/事業所数（民営）（不動産業，物品賃貸業）",
              "label": "事業所数（民営）（不動産業，物品賃貸業）",
              "cat01": "C210845",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210846/所/c13/事業所数（民営）（学術研究，専門・技術サービス業）",
              "label": "事業所数（民営）（学術研究，専門・技術サービス業）",
              "cat01": "C210846",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210847/所/c13/事業所数（民営）（宿泊業，飲食サービス業）",
              "label": "事業所数（民営）（宿泊業，飲食サービス業）",
              "cat01": "C210847",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210848/所/c13/事業所数（民営）（生活関連サービス業，娯楽業）",
              "label": "事業所数（民営）（生活関連サービス業，娯楽業）",
              "cat01": "C210848",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210849/所/c13/事業所数（民営）（教育，学習支援業）",
              "label": "事業所数（民営）（教育，学習支援業）",
              "cat01": "C210849",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210850/所/c13/事業所数（民営）（医療，福祉）",
              "label": "事業所数（民営）（医療，福祉）",
              "cat01": "C210850",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210851/所/c13/事業所数（民営）（複合サービス事業）",
              "label": "事業所数（民営）（複合サービス事業）",
              "cat01": "C210851",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C210852/所/c13/事業所数（民営）（サービス業（他に分類されないもの））",
              "label": "事業所数（民営）（サービス業（他に分類されないもの））",
              "cat01": "C210852",
              "unit": "所",
              "sourceId": "c13"
            },
            {
              "statId": "0000010103/C2109/所/c15/事業所数（国・地方公共団体）（経済センサス‐基礎調査結果）",
              "label": "事業所数（国・地方公共団体）（経済センサス‐基礎調査結果）",
              "cat01": "C2109",
              "unit": "所",
              "sourceId": "c15"
            },
            {
              "statId": "0000010103/C210901/所/c15/事業所数（国）（経済センサス‐基礎調査結果）",
              "label": "事業所数（国）（経済センサス‐基礎調査結果）",
              "cat01": "C210901",
              "unit": "所",
              "sourceId": "c15"
            },
            {
              "statId": "0000010103/C210902/所/c15/事業所数（地方公共団体）（経済センサス‐基礎調査結果）",
              "label": "事業所数（地方公共団体）（経済センサス‐基礎調査結果）",
              "cat01": "C210902",
              "unit": "所",
              "sourceId": "c15"
            },
            {
              "statId": "0000010103/C210903/所/c15/事業所数（都道府県）（経済センサス‐基礎調査結果）",
              "label": "事業所数（都道府県）（経済センサス‐基礎調査結果）",
              "cat01": "C210903",
              "unit": "所",
              "sourceId": "c15"
            },
            {
              "statId": "0000010103/C210904/所/c15/事業所数（市区町村）（経済センサス‐基礎調査結果）",
              "label": "事業所数（市区町村）（経済センサス‐基礎調査結果）",
              "cat01": "C210904",
              "unit": "所",
              "sourceId": "c15"
            },
            {
              "statId": "0000010103/C2110/所/c17/第１次産業事業所数（経済センサス‐基礎調査結果）",
              "label": "第１次産業事業所数（経済センサス‐基礎調査結果）",
              "cat01": "C2110",
              "unit": "所",
              "sourceId": "c17"
            },
            {
              "statId": "0000010103/C2111/所/c17/第２次産業事業所数（経済センサス‐基礎調査結果）",
              "label": "第２次産業事業所数（経済センサス‐基礎調査結果）",
              "cat01": "C2111",
              "unit": "所",
              "sourceId": "c17"
            },
            {
              "statId": "0000010103/C2112/所/c17/第３次産業事業所数（経済センサス‐基礎調査結果）",
              "label": "第３次産業事業所数（経済センサス‐基礎調査結果）",
              "cat01": "C2112",
              "unit": "所",
              "sourceId": "c17"
            },
            {
              "statId": "0000010103/C2201/人/c18/従業者数（事業所・企業統計調査結果）",
              "label": "従業者数（事業所・企業統計調査結果）",
              "cat01": "C2201",
              "unit": "人",
              "sourceId": "c18"
            },
            {
              "statId": "0000010103/C2202/人/c20/従業者数（民営）（事業所・企業統計調査結果）",
              "label": "従業者数（民営）（事業所・企業統計調査結果）",
              "cat01": "C2202",
              "unit": "人",
              "sourceId": "c20"
            },
            {
              "statId": "0000010103/C220220/人/c20/従業者数（民営）（個人事業所）（事業所・企業統計調査結果）",
              "label": "従業者数（民営）（個人事業所）（事業所・企業統計調査結果）",
              "cat01": "C220220",
              "unit": "人",
              "sourceId": "c20"
            },
            {
              "statId": "0000010103/C220230/人/c20/従業者数（民営）（法人事業所）（事業所・企業統計調査結果）",
              "label": "従業者数（民営）（法人事業所）（事業所・企業統計調査結果）",
              "cat01": "C220230",
              "unit": "人",
              "sourceId": "c20"
            },
            {
              "statId": "0000010103/C220231/人/c20/従業者数（民営）（会社事業所）（事業所・企業統計調査結果）",
              "label": "従業者数（民営）（会社事業所）（事業所・企業統計調査結果）",
              "cat01": "C220231",
              "unit": "人",
              "sourceId": "c20"
            },
            {
              "statId": "0000010103/C220232/人/c20/従業者数（民営）（独立行政法人等）（事業所・企業統計調査結果）",
              "label": "従業者数（民営）（独立行政法人等）（事業所・企業統計調査結果）",
              "cat01": "C220232",
              "unit": "人",
              "sourceId": "c20"
            },
            {
              "statId": "0000010103/C2203/人/c22/従業者数（国・地方公共団体）（事業所・企業統計調査結果）",
              "label": "従業者数（国・地方公共団体）（事業所・企業統計調査結果）",
              "cat01": "C2203",
              "unit": "人",
              "sourceId": "c22"
            },
            {
              "statId": "0000010103/C220301/人/c22/従業者数（国）（事業所・企業統計調査結果）",
              "label": "従業者数（国）（事業所・企業統計調査結果）",
              "cat01": "C220301",
              "unit": "人",
              "sourceId": "c22"
            },
            {
              "statId": "0000010103/C220302/人/c22/従業者数（都道府県）（事業所・企業統計調査結果）",
              "label": "従業者数（都道府県）（事業所・企業統計調査結果）",
              "cat01": "C220302",
              "unit": "人",
              "sourceId": "c22"
            },
            {
              "statId": "0000010103/C220303/人/c22/従業者数（市区町村）（事業所・企業統計調査結果）",
              "label": "従業者数（市区町村）（事業所・企業統計調査結果）",
              "cat01": "C220303",
              "unit": "人",
              "sourceId": "c22"
            },
            {
              "statId": "0000010103/C2204/人/c24/第２次産業従業者数（事業所・企業統計調査結果）",
              "label": "第２次産業従業者数（事業所・企業統計調査結果）",
              "cat01": "C2204",
              "unit": "人",
              "sourceId": "c24"
            },
            {
              "statId": "0000010103/C2205/人/c24/第３次産業従業者数（事業所・企業統計調査結果）",
              "label": "第３次産業従業者数（事業所・企業統計調査結果）",
              "cat01": "C2205",
              "unit": "人",
              "sourceId": "c24"
            },
            {
              "statId": "0000010103/C2206/人/c24/第１次産業従業者数（事業所・企業統計調査結果）",
              "label": "第１次産業従業者数（事業所・企業統計調査結果）",
              "cat01": "C2206",
              "unit": "人",
              "sourceId": "c24"
            },
            {
              "statId": "0000010103/C2207/人/c19/従業者数（経済センサス‐基礎調査結果）",
              "label": "従業者数（経済センサス‐基礎調査結果）",
              "cat01": "C2207",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220701/人/c19/従業者数（公務を除く）",
              "label": "従業者数（公務を除く）",
              "cat01": "C220701",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220702/人/c19/従業者数（農林漁業）",
              "label": "従業者数（農林漁業）",
              "cat01": "C220702",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220703/人/c19/従業者数（農業，林業）",
              "label": "従業者数（農業，林業）",
              "cat01": "C220703",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220704/人/c19/従業者数（漁業）",
              "label": "従業者数（漁業）",
              "cat01": "C220704",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220705/人/c19/従業者数（非農林漁業）",
              "label": "従業者数（非農林漁業）",
              "cat01": "C220705",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220706/人/c19/従業者数（非農林漁業（公務を除く））",
              "label": "従業者数（非農林漁業（公務を除く））",
              "cat01": "C220706",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220707/人/c19/従業者数（鉱業，採石業，砂利採取業）",
              "label": "従業者数（鉱業，採石業，砂利採取業）",
              "cat01": "C220707",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220708/人/c19/従業者数（建設業）",
              "label": "従業者数（建設業）",
              "cat01": "C220708",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220709/人/c19/従業者数（製造業）",
              "label": "従業者数（製造業）",
              "cat01": "C220709",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220710/人/c19/従業者数（電気・ガス・熱供給・水道業）",
              "label": "従業者数（電気・ガス・熱供給・水道業）",
              "cat01": "C220710",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220711/人/c19/従業者数（情報通信業）",
              "label": "従業者数（情報通信業）",
              "cat01": "C220711",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220712/人/c19/従業者数（運輸業，郵便業）",
              "label": "従業者数（運輸業，郵便業）",
              "cat01": "C220712",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220713/人/c19/従業者数（卸売業，小売業）",
              "label": "従業者数（卸売業，小売業）",
              "cat01": "C220713",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220714/人/c19/従業者数（卸売業）",
              "label": "従業者数（卸売業）",
              "cat01": "C220714",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220715/人/c19/従業者数（小売業）",
              "label": "従業者数（小売業）",
              "cat01": "C220715",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220716/人/c19/従業者数（金融業，保険業）",
              "label": "従業者数（金融業，保険業）",
              "cat01": "C220716",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220717/人/c19/従業者数（不動産業，物品賃貸業）",
              "label": "従業者数（不動産業，物品賃貸業）",
              "cat01": "C220717",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220718/人/c19/従業者数（学術研究，専門・技術サービス業）",
              "label": "従業者数（学術研究，専門・技術サービス業）",
              "cat01": "C220718",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220719/人/c19/従業者数（宿泊業，飲食サービス業）",
              "label": "従業者数（宿泊業，飲食サービス業）",
              "cat01": "C220719",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220720/人/c19/従業者数（生活関連サービス業，娯楽業）",
              "label": "従業者数（生活関連サービス業，娯楽業）",
              "cat01": "C220720",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220721/人/c19/従業者数（教育，学習支援業）",
              "label": "従業者数（教育，学習支援業）",
              "cat01": "C220721",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220722/人/c19/従業者数（医療，福祉）",
              "label": "従業者数（医療，福祉）",
              "cat01": "C220722",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220723/人/c19/従業者数（複合サービス事業）",
              "label": "従業者数（複合サービス事業）",
              "cat01": "C220723",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220724/人/c19/従業者数（サービス業（他に分類されないもの））",
              "label": "従業者数（サービス業（他に分類されないもの））",
              "cat01": "C220724",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C220725/人/c19/従業者数（公務（他に分類されるものを除く））",
              "label": "従業者数（公務（他に分類されるものを除く））",
              "cat01": "C220725",
              "unit": "人",
              "sourceId": "c19"
            },
            {
              "statId": "0000010103/C2208/人/c21/従業者数（民営）",
              "label": "従業者数（民営）",
              "cat01": "C2208",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220801/人/c21/従業者数（民営）従業者１～４人",
              "label": "従業者数（民営）従業者１～４人",
              "cat01": "C220801",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220802/人/c21/従業者数（民営）従業者５～９人",
              "label": "従業者数（民営）従業者５～９人",
              "cat01": "C220802",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220803/人/c21/従業者数（民営）従業者１０～２９人",
              "label": "従業者数（民営）従業者１０～２９人",
              "cat01": "C220803",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220804/人/c21/従業者数（民営）従業者３０～４９人",
              "label": "従業者数（民営）従業者３０～４９人",
              "cat01": "C220804",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220805/人/c21/従業者数（民営）従業者５０～９９人",
              "label": "従業者数（民営）従業者５０～９９人",
              "cat01": "C220805",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220806/人/c21/従業者数（民営）従業者１００～２９９人",
              "label": "従業者数（民営）従業者１００～２９９人",
              "cat01": "C220806",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220807/人/c21/従業者数（民営）従業者３００人以上",
              "label": "従業者数（民営）従業者３００人以上",
              "cat01": "C220807",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220820/人/c21/従業者数（民営）（個人事業所）（経済センサス‐活動調査結果）",
              "label": "従業者数（民営）（個人事業所）（経済センサス‐活動調査結果）",
              "cat01": "C220820",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220821/人/c21/従業者数（民営）（法人事業所）（経済センサス‐活動調査結果）",
              "label": "従業者数（民営）（法人事業所）（経済センサス‐活動調査結果）",
              "cat01": "C220821",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220822/人/c21/従業者数（民営）（会社事業所）（経済センサス‐活動調査結果）",
              "label": "従業者数（民営）（会社事業所）（経済センサス‐活動調査結果）",
              "cat01": "C220822",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220823/人/c21/従業者数（民営）（会社以外の法人）",
              "label": "従業者数（民営）（会社以外の法人）",
              "cat01": "C220823",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220831/人/c21/従業者数（民営）（農林漁業）",
              "label": "従業者数（民営）（農林漁業）",
              "cat01": "C220831",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220832/人/c21/従業者数（民営）（農業，林業）",
              "label": "従業者数（民営）（農業，林業）",
              "cat01": "C220832",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220833/人/c21/従業者数（民営）（漁業）",
              "label": "従業者数（民営）（漁業）",
              "cat01": "C220833",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220834/人/c21/従業者数（民営）（非農林漁業（公務を除く））",
              "label": "従業者数（民営）（非農林漁業（公務を除く））",
              "cat01": "C220834",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220835/人/c21/従業者数（民営）（鉱業，採石業，砂利採取業）",
              "label": "従業者数（民営）（鉱業，採石業，砂利採取業）",
              "cat01": "C220835",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220836/人/c21/従業者数（民営）（建設業）",
              "label": "従業者数（民営）（建設業）",
              "cat01": "C220836",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220837/人/c21/従業者数（民営）（製造業）",
              "label": "従業者数（民営）（製造業）",
              "cat01": "C220837",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220838/人/c21/従業者数（民営）（電気・ガス・熱供給・水道業）",
              "label": "従業者数（民営）（電気・ガス・熱供給・水道業）",
              "cat01": "C220838",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220839/人/c21/従業者数（民営）（情報通信業）",
              "label": "従業者数（民営）（情報通信業）",
              "cat01": "C220839",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220840/人/c21/従業者数（民営）（運輸業，郵便業）",
              "label": "従業者数（民営）（運輸業，郵便業）",
              "cat01": "C220840",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220841/人/c21/従業者数（民営）（卸売業，小売業）",
              "label": "従業者数（民営）（卸売業，小売業）",
              "cat01": "C220841",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220842/人/c21/従業者数（民営）（卸売業）",
              "label": "従業者数（民営）（卸売業）",
              "cat01": "C220842",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220843/人/c21/従業者数（民営）（小売業）",
              "label": "従業者数（民営）（小売業）",
              "cat01": "C220843",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220844/人/c21/従業者数（民営）（金融業，保険業）",
              "label": "従業者数（民営）（金融業，保険業）",
              "cat01": "C220844",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220845/人/c21/従業者数（民営）（不動産業，物品賃貸業）",
              "label": "従業者数（民営）（不動産業，物品賃貸業）",
              "cat01": "C220845",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220846/人/c21/従業者数（民営）（学術研究，専門・技術サービス業）",
              "label": "従業者数（民営）（学術研究，専門・技術サービス業）",
              "cat01": "C220846",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220847/人/c21/従業者数（民営）（宿泊業，飲食サービス業）",
              "label": "従業者数（民営）（宿泊業，飲食サービス業）",
              "cat01": "C220847",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220848/人/c21/従業者数（民営）（生活関連サービス業，娯楽業）",
              "label": "従業者数（民営）（生活関連サービス業，娯楽業）",
              "cat01": "C220848",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220849/人/c21/従業者数（民営）（教育，学習支援業）",
              "label": "従業者数（民営）（教育，学習支援業）",
              "cat01": "C220849",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220850/人/c21/従業者数（民営）（医療，福祉）",
              "label": "従業者数（民営）（医療，福祉）",
              "cat01": "C220850",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220851/人/c21/従業者数（民営）（複合サービス事業）",
              "label": "従業者数（民営）（複合サービス事業）",
              "cat01": "C220851",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C220852/人/c21/従業者数（民営）（サービス業（他に分類されないもの））",
              "label": "従業者数（民営）（サービス業（他に分類されないもの））",
              "cat01": "C220852",
              "unit": "人",
              "sourceId": "c21"
            },
            {
              "statId": "0000010103/C2209/人/c23/従業者数（国・地方公共団体）（経済センサス‐基礎調査結果）",
              "label": "従業者数（国・地方公共団体）（経済センサス‐基礎調査結果）",
              "cat01": "C2209",
              "unit": "人",
              "sourceId": "c23"
            },
            {
              "statId": "0000010103/C220901/人/c23/従業者数（国）（経済センサス‐基礎調査結果）",
              "label": "従業者数（国）（経済センサス‐基礎調査結果）",
              "cat01": "C220901",
              "unit": "人",
              "sourceId": "c23"
            },
            {
              "statId": "0000010103/C220902/人/c23/従業者数（地方公共団体）",
              "label": "従業者数（地方公共団体）",
              "cat01": "C220902",
              "unit": "人",
              "sourceId": "c23"
            },
            {
              "statId": "0000010103/C220903/人/c23/従業者数（都道府県）（経済センサス‐基礎調査結果）",
              "label": "従業者数（都道府県）（経済センサス‐基礎調査結果）",
              "cat01": "C220903",
              "unit": "人",
              "sourceId": "c23"
            },
            {
              "statId": "0000010103/C220904/人/c23/従業者数（市区町村）（経済センサス‐基礎調査結果）",
              "label": "従業者数（市区町村）（経済センサス‐基礎調査結果）",
              "cat01": "C220904",
              "unit": "人",
              "sourceId": "c23"
            },
            {
              "statId": "0000010103/C2210/人/c25/第１次産業従業者数（経済センサス‐基礎調査結果）",
              "label": "第１次産業従業者数（経済センサス‐基礎調査結果）",
              "cat01": "C2210",
              "unit": "人",
              "sourceId": "c25"
            },
            {
              "statId": "0000010103/C2211/人/c25/第２次産業従業者数（経済センサス‐基礎調査結果）",
              "label": "第２次産業従業者数（経済センサス‐基礎調査結果）",
              "cat01": "C2211",
              "unit": "人",
              "sourceId": "c25"
            },
            {
              "statId": "0000010103/C2212/人/c25/第３次産業従業者数（経済センサス‐基礎調査結果）",
              "label": "第３次産業従業者数（経済センサス‐基礎調査結果）",
              "cat01": "C2212",
              "unit": "人",
              "sourceId": "c25"
            },
            {
              "statId": "0000010103/C3101/百万円/c26/農業産出額",
              "label": "農業産出額",
              "cat01": "C3101",
              "unit": "百万円",
              "sourceId": "c26"
            },
            {
              "statId": "0000010103/C3102/戸/c27/農家数",
              "label": "農家数",
              "cat01": "C3102",
              "unit": "戸",
              "sourceId": "c27"
            },
            {
              "statId": "0000010103/C310201/戸/c27/農家数（販売農家）",
              "label": "農家数（販売農家）",
              "cat01": "C310201",
              "unit": "戸",
              "sourceId": "c27"
            },
            {
              "statId": "0000010103/C310202/戸/c27/農家数（自給的農家）",
              "label": "農家数（自給的農家）",
              "cat01": "C310202",
              "unit": "戸",
              "sourceId": "c27"
            },
            {
              "statId": "0000010103/C310211/戸/c27/専業農家数（販売農家）",
              "label": "専業農家数（販売農家）",
              "cat01": "C310211",
              "unit": "戸",
              "sourceId": "c27"
            },
            {
              "statId": "0000010103/C310212/戸/c27/兼業農家数（販売農家）",
              "label": "兼業農家数（販売農家）",
              "cat01": "C310212",
              "unit": "戸",
              "sourceId": "c27"
            },
            {
              "statId": "0000010103/C310234/戸/c28/経営耕地面積規模別農家数（販売農家）（０．３ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（０．３ｈａ未満）",
              "cat01": "C310234",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310235/戸/c28/経営耕地面積規模別農家数（販売農家）（０．３～０．５ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（０．３～０．５ｈａ未満）",
              "cat01": "C310235",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310236/戸/c28/経営耕地面積規模別農家数（販売農家）（０．５～１．０ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（０．５～１．０ｈａ未満）",
              "cat01": "C310236",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310237/戸/c28/経営耕地面積規模別農家数（販売農家）（１．０～１．５ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（１．０～１．５ｈａ未満）",
              "cat01": "C310237",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310238/戸/c28/経営耕地面積規模別農家数（販売農家）（１．５～２．０ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（１．５～２．０ｈａ未満）",
              "cat01": "C310238",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310239/戸/c28/経営耕地面積規模別農家数（販売農家）（２．０～３．０ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（２．０～３．０ｈａ未満）",
              "cat01": "C310239",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310240/戸/c28/経営耕地面積規模別農家数（販売農家）（３．０～５．０ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（３．０～５．０ｈａ未満）",
              "cat01": "C310240",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310241/戸/c28/経営耕地面積規模別農家数（販売農家）（５．０～１０．０ｈａ未満）",
              "label": "経営耕地面積規模別農家数（販売農家）（５．０～１０．０ｈａ未満）",
              "cat01": "C310241",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310242/戸/c28/経営耕地面積規模別農家数（販売農家）（１０．０ｈａ以上）",
              "label": "経営耕地面積規模別農家数（販売農家）（１０．０ｈａ以上）",
              "cat01": "C310242",
              "unit": "戸",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310410/人/c28/農業就業人口（販売農家）",
              "label": "農業就業人口（販売農家）",
              "cat01": "C310410",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310411/人/c28/農業就業人口（男）（販売農家）",
              "label": "農業就業人口（男）（販売農家）",
              "cat01": "C310411",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310412/人/c28/農業就業人口（女）（販売農家）",
              "label": "農業就業人口（女）（販売農家）",
              "cat01": "C310412",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310510/人/c28/基幹的農業従事者数（販売農家）",
              "label": "基幹的農業従事者数（販売農家）",
              "cat01": "C310510",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310610/人/c28/兼業従事者数（販売農家）",
              "label": "兼業従事者数（販売農家）",
              "cat01": "C310610",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310611/人/c28/兼業従事者数（主に恒常的勤務）（販売農家）",
              "label": "兼業従事者数（主に恒常的勤務）（販売農家）",
              "cat01": "C310611",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310612/人/c28/兼業従事者数（主に出稼）（販売農家）",
              "label": "兼業従事者数（主に出稼）（販売農家）",
              "cat01": "C310612",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C310614/人/c28/兼業従事者数（主に自営兼業）（販売農家）",
              "label": "兼業従事者数（主に自営兼業）（販売農家）",
              "cat01": "C310614",
              "unit": "人",
              "sourceId": "c28"
            },
            {
              "statId": "0000010103/C3107/ｈａ/c29/耕地面積",
              "label": "耕地面積",
              "cat01": "C3107",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C310701/ｈａ/c29/耕地面積（田）",
              "label": "耕地面積（田）",
              "cat01": "C310701",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C310702/ｈａ/c29/耕地面積（畑）",
              "label": "耕地面積（畑）",
              "cat01": "C310702",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C310703/ｈａ/c29/耕地面積（普通畑）",
              "label": "耕地面積（普通畑）",
              "cat01": "C310703",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C310704/ｈａ/c29/耕地面積（樹園地）",
              "label": "耕地面積（樹園地）",
              "cat01": "C310704",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C310705/ｈａ/c29/耕地面積（牧草地）",
              "label": "耕地面積（牧草地）",
              "cat01": "C310705",
              "unit": "ｈａ",
              "sourceId": "c29"
            },
            {
              "statId": "0000010103/C3108/ｈａ/c30/農地の転用面積",
              "label": "農地の転用面積",
              "cat01": "C3108",
              "unit": "ｈａ",
              "sourceId": "c30"
            },
            {
              "statId": "0000010103/C3109/ｈａ/c31/耕地放棄面積",
              "label": "耕地放棄面積",
              "cat01": "C3109",
              "unit": "ｈａ",
              "sourceId": "c31"
            },
            {
              "statId": "0000010103/C3110/千ｍ3/c32/素材生産量",
              "label": "素材生産量",
              "cat01": "C3110",
              "unit": "千ｍ3",
              "sourceId": "c32"
            },
            {
              "statId": "0000010103/C3111/千束/c33/竹材生産量",
              "label": "竹材生産量",
              "cat01": "C3111",
              "unit": "千束",
              "sourceId": "c33"
            },
            {
              "statId": "0000010103/C3112/トン/c33/木炭生産量",
              "label": "木炭生産量",
              "cat01": "C3112",
              "unit": "トン",
              "sourceId": "c33"
            },
            {
              "statId": "0000010103/C3114/ｋｍ/c34/林道延長",
              "label": "林道延長",
              "cat01": "C3114",
              "unit": "ｋｍ",
              "sourceId": "c34"
            },
            {
              "statId": "0000010103/C3120/百万円/c35/漁業算出額",
              "label": "漁業算出額",
              "cat01": "C3120",
              "unit": "百万円",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312001/百万円/c35/海面漁業算出額",
              "label": "海面漁業算出額",
              "cat01": "C312001",
              "unit": "百万円",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312002/百万円/c35/海面養殖業算出額",
              "label": "海面養殖業算出額",
              "cat01": "C312002",
              "unit": "百万円",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C3121/トン/c35/漁獲量",
              "label": "漁獲量",
              "cat01": "C3121",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312101/トン/c35/海面漁業漁獲量",
              "label": "海面漁業漁獲量",
              "cat01": "C312101",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312102/トン/c35/内水面漁業漁獲量",
              "label": "内水面漁業漁獲量",
              "cat01": "C312102",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C3122/トン/c35/養殖収獲量",
              "label": "養殖収獲量",
              "cat01": "C3122",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312201/トン/c35/海面養殖業収獲量",
              "label": "海面養殖業収獲量",
              "cat01": "C312201",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312202/トン/c35/内水面養殖業収獲量",
              "label": "内水面養殖業収獲量",
              "cat01": "C312202",
              "unit": "トン",
              "sourceId": "c35"
            },
            {
              "statId": "0000010103/C312301/世帯/c36/個人漁業経営体数",
              "label": "個人漁業経営体数",
              "cat01": "C312301",
              "unit": "世帯",
              "sourceId": "c36"
            },
            {
              "statId": "0000010103/C3125/人/c36/漁業就業者数",
              "label": "漁業就業者数",
              "cat01": "C3125",
              "unit": "人",
              "sourceId": "c36"
            },
            {
              "statId": "0000010103/C312601/事業体/c37/６次産業農業生産関連事業体数（農産物の加工）",
              "label": "６次産業農業生産関連事業体数（農産物の加工）",
              "cat01": "C312601",
              "unit": "事業体",
              "sourceId": "c37"
            },
            {
              "statId": "0000010103/C312602/事業体/c37/６次産業農業生産関連事業体数（農産物直売所）",
              "label": "６次産業農業生産関連事業体数（農産物直売所）",
              "cat01": "C312602",
              "unit": "事業体",
              "sourceId": "c37"
            },
            {
              "statId": "0000010103/C312701/百万円/c37/６次産業農業生産関連事業体年間販売金額（農産物の加工）",
              "label": "６次産業農業生産関連事業体年間販売金額（農産物の加工）",
              "cat01": "C312701",
              "unit": "百万円",
              "sourceId": "c37"
            },
            {
              "statId": "0000010103/C312702/百万円/c37/６次産業農業生産関連事業体年間販売金額（農産物直売所）",
              "label": "６次産業農業生産関連事業体年間販売金額（農産物直売所）",
              "cat01": "C312702",
              "unit": "百万円",
              "sourceId": "c37"
            },
            {
              "statId": "0000010103/C3301/棟/c38/着工建築物数",
              "label": "着工建築物数",
              "cat01": "C3301",
              "unit": "棟",
              "sourceId": "c38"
            },
            {
              "statId": "0000010103/C3302/ｍ2/c38/着工建築物床面積",
              "label": "着工建築物床面積",
              "cat01": "C3302",
              "unit": "ｍ2",
              "sourceId": "c38"
            },
            {
              "statId": "0000010103/C3303/万円/c38/着工建築物工事費予定額",
              "label": "着工建築物工事費予定額",
              "cat01": "C3303",
              "unit": "万円",
              "sourceId": "c38"
            },
            {
              "statId": "0000010103/C3304/百万円/c39/元請完成工事高",
              "label": "元請完成工事高",
              "cat01": "C3304",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330401/百万円/c39/元請完成工事高（土木）",
              "label": "元請完成工事高（土木）",
              "cat01": "C330401",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330402/百万円/c39/元請完成工事高（建築）",
              "label": "元請完成工事高（建築）",
              "cat01": "C330402",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330403/百万円/c39/元請完成工事高（機械）",
              "label": "元請完成工事高（機械）",
              "cat01": "C330403",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330410/百万円/c39/元請完成工事高（民間）",
              "label": "元請完成工事高（民間）",
              "cat01": "C330410",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330411/百万円/c39/元請完成工事高（民間）（土木）",
              "label": "元請完成工事高（民間）（土木）",
              "cat01": "C330411",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330412/百万円/c39/元請完成工事高（民間）（建築）",
              "label": "元請完成工事高（民間）（建築）",
              "cat01": "C330412",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330413/百万円/c39/元請完成工事高（民間）（機械）",
              "label": "元請完成工事高（民間）（機械）",
              "cat01": "C330413",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330420/百万円/c39/元請完成工事高（公共）",
              "label": "元請完成工事高（公共）",
              "cat01": "C330420",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330421/百万円/c39/元請完成工事高（公共）（土木）",
              "label": "元請完成工事高（公共）（土木）",
              "cat01": "C330421",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330422/百万円/c39/元請完成工事高（公共）（建築）",
              "label": "元請完成工事高（公共）（建築）",
              "cat01": "C330422",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330423/百万円/c39/元請完成工事高（公共）（機械）",
              "label": "元請完成工事高（公共）（機械）",
              "cat01": "C330423",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C3305/百万円/c39/下請完成工事高",
              "label": "下請完成工事高",
              "cat01": "C3305",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330501/百万円/c39/下請完成工事高（土木）",
              "label": "下請完成工事高（土木）",
              "cat01": "C330501",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330502/百万円/c39/下請完成工事高（建築）",
              "label": "下請完成工事高（建築）",
              "cat01": "C330502",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C330503/百万円/c39/下請完成工事高（機械）",
              "label": "下請完成工事高（機械）",
              "cat01": "C330503",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C3306/‐/c39/建設業者数",
              "label": "建設業者数",
              "cat01": "C3306",
              "unit": "‐",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C3307/件/c39/受注工事請負契約件数（公共）",
              "label": "受注工事請負契約件数（公共）",
              "cat01": "C3307",
              "unit": "件",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C3308/百万円/c39/受注工事請負契約額（公共）",
              "label": "受注工事請負契約額（公共）",
              "cat01": "C3308",
              "unit": "百万円",
              "sourceId": "c39"
            },
            {
              "statId": "0000010103/C3401/百万円/c40/製造品出荷額等",
              "label": "製造品出荷額等",
              "cat01": "C3401",
              "unit": "百万円",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3402/百万円/c40/製造業付加価値額",
              "label": "製造業付加価値額",
              "cat01": "C3402",
              "unit": "百万円",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3403/事業所/c40/製造業事業所数",
              "label": "製造業事業所数",
              "cat01": "C3403",
              "unit": "事業所",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3404/人/c40/製造業従業者数",
              "label": "製造業従業者数",
              "cat01": "C3404",
              "unit": "人",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3405/千ｍ2/c40/製造業事業所敷地面積",
              "label": "製造業事業所敷地面積",
              "cat01": "C3405",
              "unit": "千ｍ2",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3406/ｍ3／日/c40/工業用水量",
              "label": "工業用水量",
              "cat01": "C3406",
              "unit": "ｍ3／日",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C340601/ｍ3／日/c40/工業用水量（淡水）",
              "label": "工業用水量（淡水）",
              "cat01": "C340601",
              "unit": "ｍ3／日",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C340602/ｍ3／日/c40/工業用水量（海水）",
              "label": "工業用水量（海水）",
              "cat01": "C340602",
              "unit": "ｍ3／日",
              "sourceId": "c40"
            },
            {
              "statId": "0000010103/C3501/百万円/c41/商業年間商品販売額（卸売業＋小売業）",
              "label": "商業年間商品販売額（卸売業＋小売業）",
              "cat01": "C3501",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350101/百万円/c41/卸売業年間商品販売額",
              "label": "卸売業年間商品販売額",
              "cat01": "C350101",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350102/百万円/c41/小売業年間商品販売額",
              "label": "小売業年間商品販売額",
              "cat01": "C350102",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C3502/事業所/c41/商業事業所数（卸売業＋小売業）",
              "label": "商業事業所数（卸売業＋小売業）",
              "cat01": "C3502",
              "unit": "事業所",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350201/事業所/c41/卸売業事業所数",
              "label": "卸売業事業所数",
              "cat01": "C350201",
              "unit": "事業所",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350202/事業所/c41/小売業事業所数",
              "label": "小売業事業所数",
              "cat01": "C350202",
              "unit": "事業所",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C3503/人/c41/商業従業者数（卸売業＋小売業）",
              "label": "商業従業者数（卸売業＋小売業）",
              "cat01": "C3503",
              "unit": "人",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350301/人/c41/卸売業従業者数",
              "label": "卸売業従業者数",
              "cat01": "C350301",
              "unit": "人",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350302/人/c41/小売業従業者数",
              "label": "小売業従業者数",
              "cat01": "C350302",
              "unit": "人",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C3505/百万円/c41/商品手持額（卸売業＋小売業）",
              "label": "商品手持額（卸売業＋小売業）",
              "cat01": "C3505",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350501/百万円/c41/卸売業商品手持額",
              "label": "卸売業商品手持額",
              "cat01": "C350501",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C350502/百万円/c41/小売業商品手持額",
              "label": "小売業商品手持額",
              "cat01": "C350502",
              "unit": "百万円",
              "sourceId": "c41"
            },
            {
              "statId": "0000010103/C3601/億円/c42/預貯金残高",
              "label": "預貯金残高",
              "cat01": "C3601",
              "unit": "億円",
              "sourceId": "c42"
            },
            {
              "statId": "0000010103/C360111/億円/c42/国内銀行預金残高",
              "label": "国内銀行預金残高",
              "cat01": "C360111",
              "unit": "億円",
              "sourceId": "c42"
            },
            {
              "statId": "0000010103/C360120/億円/c42/郵便貯金残高",
              "label": "郵便貯金残高",
              "cat01": "C360120",
              "unit": "億円",
              "sourceId": "c42"
            },
            {
              "statId": "0000010103/C360211/億円/c42/国内銀行個人預金残高",
              "label": "国内銀行個人預金残高",
              "cat01": "C360211",
              "unit": "億円",
              "sourceId": "c42"
            },
            {
              "statId": "0000010103/C360311/億円/c42/国内銀行貸出残高",
              "label": "国内銀行貸出残高",
              "cat01": "C360311",
              "unit": "億円",
              "sourceId": "c42"
            },
            {
              "statId": "0000010103/C3702/トン/c43/ＪＲ貨物発送量",
              "label": "ＪＲ貨物発送量",
              "cat01": "C3702",
              "unit": "トン",
              "sourceId": "c43"
            },
            {
              "statId": "0000010103/C370201/トン/c43/ＪＲ貨物発送量（コンテナを除く）",
              "label": "ＪＲ貨物発送量（コンテナを除く）",
              "cat01": "C370201",
              "unit": "トン",
              "sourceId": "c43"
            },
            {
              "statId": "0000010103/C3704/千人/c44/ＪＲ輸送人員",
              "label": "ＪＲ輸送人員",
              "cat01": "C3704",
              "unit": "千人",
              "sourceId": "c44"
            },
            {
              "statId": "0000010103/C3705/千人/c44/民鉄輸送人員",
              "label": "民鉄輸送人員",
              "cat01": "C3705",
              "unit": "千人",
              "sourceId": "c44"
            },
            {
              "statId": "0000010103/C3706/千人/c44/航空輸送人員",
              "label": "航空輸送人員",
              "cat01": "C3706",
              "unit": "千人",
              "sourceId": "c44"
            },
            {
              "statId": "0000010103/C370601/ｋｇ/c45/航空貨物輸送量",
              "label": "航空貨物輸送量",
              "cat01": "C370601",
              "unit": "ｋｇ",
              "sourceId": "c45"
            },
            {
              "statId": "0000010103/C3707/千人/c46/旅客船輸送人員",
              "label": "旅客船輸送人員",
              "cat01": "C3707",
              "unit": "千人",
              "sourceId": "c46"
            },
            {
              "statId": "0000010103/C370701/トン/c47/海上出入貨物",
              "label": "海上出入貨物",
              "cat01": "C370701",
              "unit": "トン",
              "sourceId": "c47"
            },
            {
              "statId": "0000010103/C3708/社/c48/事業者（バス）",
              "label": "事業者（バス）",
              "cat01": "C3708",
              "unit": "社",
              "sourceId": "c48"
            },
            {
              "statId": "0000010103/C3709/社/c48/事業者（トラック）",
              "label": "事業者（トラック）",
              "cat01": "C3709",
              "unit": "社",
              "sourceId": "c48"
            },
            {
              "statId": "0000010103/C3710/社/c48/事業者（ハイヤー・タクシー）",
              "label": "事業者（ハイヤー・タクシー）",
              "cat01": "C3710",
              "unit": "社",
              "sourceId": "c48"
            },
            {
              "statId": "0000010103/C3711/社/c48/事業者（整備）",
              "label": "事業者（整備）",
              "cat01": "C3711",
              "unit": "社",
              "sourceId": "c48"
            },
            {
              "statId": "0000010103/C3712/両/c49/貨物車数",
              "label": "貨物車数",
              "cat01": "C3712",
              "unit": "両",
              "sourceId": "c49"
            },
            {
              "statId": "0000010103/C3713/千トン/c50/普通営業倉庫年間入庫量",
              "label": "普通営業倉庫年間入庫量",
              "cat01": "C3713",
              "unit": "千トン",
              "sourceId": "c50"
            },
            {
              "statId": "0000010103/C3714/千人/c51/旅客輸送人員（営業用）（バス）",
              "label": "旅客輸送人員（営業用）（バス）",
              "cat01": "C3714",
              "unit": "千人",
              "sourceId": "c51"
            },
            {
              "statId": "0000010103/C3715/千人/c51/旅客輸送人員（営業用）（乗用車）",
              "label": "旅客輸送人員（営業用）（乗用車）",
              "cat01": "C3715",
              "unit": "千人",
              "sourceId": "c51"
            },
            {
              "statId": "0000010103/C3801/施設/c52/旅館営業施設数",
              "label": "旅館営業施設数",
              "cat01": "C3801",
              "unit": "施設",
              "sourceId": "c52"
            },
            {
              "statId": "0000010103/C3802/室/c52/旅館営業施設客室数",
              "label": "旅館営業施設客室数",
              "cat01": "C3802",
              "unit": "室",
              "sourceId": "c52"
            },
            {
              "statId": "0000010103/C3803/施設/c52/ホテル営業施設数",
              "label": "ホテル営業施設数",
              "cat01": "C3803",
              "unit": "施設",
              "sourceId": "c52"
            },
            {
              "statId": "0000010103/C3804/室/c52/ホテル営業施設客室数",
              "label": "ホテル営業施設客室数",
              "cat01": "C3804",
              "unit": "室",
              "sourceId": "c52"
            },
            {
              "statId": "0000010103/C3805/施設/c52/簡易宿所営業施設数",
              "label": "簡易宿所営業施設数",
              "cat01": "C3805",
              "unit": "施設",
              "sourceId": "c52"
            },
            {
              "statId": "0000010103/C5101/‐/c53/消費者物価指数・総合",
              "label": "消費者物価指数・総合",
              "cat01": "C5101",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5102/‐/c53/消費者物価指数・持家の帰属家賃を除く総合",
              "label": "消費者物価指数・持家の帰属家賃を除く総合",
              "cat01": "C5102",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5103/‐/c53/消費者物価指数・生鮮食品を除く総合",
              "label": "消費者物価指数・生鮮食品を除く総合",
              "cat01": "C5103",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5104/‐/c53/消費者物価指数・食料",
              "label": "消費者物価指数・食料",
              "cat01": "C5104",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5105/‐/c53/消費者物価指数・住居",
              "label": "消費者物価指数・住居",
              "cat01": "C5105",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5106/‐/c53/消費者物価指数・光熱・水道",
              "label": "消費者物価指数・光熱・水道",
              "cat01": "C5106",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5107/‐/c53/消費者物価指数・家具・家事用品",
              "label": "消費者物価指数・家具・家事用品",
              "cat01": "C5107",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5108/‐/c53/消費者物価指数・被服及び履物",
              "label": "消費者物価指数・被服及び履物",
              "cat01": "C5108",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5109/‐/c53/消費者物価指数・保健医療",
              "label": "消費者物価指数・保健医療",
              "cat01": "C5109",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5110/‐/c53/消費者物価指数・交通・通信",
              "label": "消費者物価指数・交通・通信",
              "cat01": "C5110",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5111/‐/c53/消費者物価指数・教育",
              "label": "消費者物価指数・教育",
              "cat01": "C5111",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5112/‐/c53/消費者物価指数・教養娯楽",
              "label": "消費者物価指数・教養娯楽",
              "cat01": "C5112",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5113/‐/c53/消費者物価指数・諸雑費",
              "label": "消費者物価指数・諸雑費",
              "cat01": "C5113",
              "unit": "‐",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5114/％/c53/消費者物価指数変化率・総合",
              "label": "消費者物価指数変化率・総合",
              "cat01": "C5114",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5115/％/c53/消費者物価指数変化率・持家の帰属家賃を除く総合",
              "label": "消費者物価指数変化率・持家の帰属家賃を除く総合",
              "cat01": "C5115",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5116/％/c53/消費者物価指数変化率・生鮮食品を除く総合",
              "label": "消費者物価指数変化率・生鮮食品を除く総合",
              "cat01": "C5116",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5117/％/c53/消費者物価指数変化率・食料",
              "label": "消費者物価指数変化率・食料",
              "cat01": "C5117",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5118/％/c53/消費者物価指数変化率・住居",
              "label": "消費者物価指数変化率・住居",
              "cat01": "C5118",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5119/％/c53/消費者物価指数変化率・光熱・水道",
              "label": "消費者物価指数変化率・光熱・水道",
              "cat01": "C5119",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5120/％/c53/消費者物価指数変化率・家具・家事用品",
              "label": "消費者物価指数変化率・家具・家事用品",
              "cat01": "C5120",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5121/％/c53/消費者物価指数変化率・被服及び履物",
              "label": "消費者物価指数変化率・被服及び履物",
              "cat01": "C5121",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5122/％/c53/消費者物価指数変化率・保健医療",
              "label": "消費者物価指数変化率・保健医療",
              "cat01": "C5122",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5123/％/c53/消費者物価指数変化率・交通・通信",
              "label": "消費者物価指数変化率・交通・通信",
              "cat01": "C5123",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5124/％/c53/消費者物価指数変化率・教育",
              "label": "消費者物価指数変化率・教育",
              "cat01": "C5124",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5125/％/c53/消費者物価指数変化率・教養娯楽",
              "label": "消費者物価指数変化率・教養娯楽",
              "cat01": "C5125",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5126/％/c53/消費者物価指数変化率・諸雑費",
              "label": "消費者物価指数変化率・諸雑費",
              "cat01": "C5126",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5127/％/c53/消費者物価指数変化率・食料（酒類を除く）及びエネルギーを除く総合",
              "label": "消費者物価指数変化率・食料（酒類を除く）及びエネルギーを除く総合",
              "cat01": "C5127",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5128/％/c53/消費者物価指数変化率・生鮮食品及びエネルギーを除く総合",
              "label": "消費者物価指数変化率・生鮮食品及びエネルギーを除く総合",
              "cat01": "C5128",
              "unit": "％",
              "sourceId": "c53"
            },
            {
              "statId": "0000010103/C5201/‐/c54/全国物価地域差指数・総合",
              "label": "全国物価地域差指数・総合",
              "cat01": "C5201",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5202/‐/c54/全国物価地域差指数・総合（生鮮食品を除く）",
              "label": "全国物価地域差指数・総合（生鮮食品を除く）",
              "cat01": "C5202",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5203/‐/c54/全国物価地域差指数・総合（家賃を除く）",
              "label": "全国物価地域差指数・総合（家賃を除く）",
              "cat01": "C5203",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5205/‐/c54/全国物価地域差指数・食料",
              "label": "全国物価地域差指数・食料",
              "cat01": "C5205",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5206/‐/c54/全国物価地域差指数・住居",
              "label": "全国物価地域差指数・住居",
              "cat01": "C5206",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5207/‐/c54/全国物価地域差指数・光熱・水道",
              "label": "全国物価地域差指数・光熱・水道",
              "cat01": "C5207",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5208/‐/c54/全国物価地域差指数・家具・家事用品",
              "label": "全国物価地域差指数・家具・家事用品",
              "cat01": "C5208",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5209/‐/c54/全国物価地域差指数・被服及び履物",
              "label": "全国物価地域差指数・被服及び履物",
              "cat01": "C5209",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5210/‐/c54/全国物価地域差指数・保健医療",
              "label": "全国物価地域差指数・保健医療",
              "cat01": "C5210",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5211/‐/c54/全国物価地域差指数・交通・通信",
              "label": "全国物価地域差指数・交通・通信",
              "cat01": "C5211",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5212/‐/c54/全国物価地域差指数・教育",
              "label": "全国物価地域差指数・教育",
              "cat01": "C5212",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5213/‐/c54/全国物価地域差指数・教養娯楽",
              "label": "全国物価地域差指数・教養娯楽",
              "cat01": "C5213",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5214/‐/c54/全国物価地域差指数・諸雑費",
              "label": "全国物価地域差指数・諸雑費",
              "cat01": "C5214",
              "unit": "‐",
              "sourceId": "c54"
            },
            {
              "statId": "0000010103/C5301/‐/c55/消費者物価地域差指数・総合",
              "label": "消費者物価地域差指数・総合",
              "cat01": "C5301",
              "unit": "‐",
              "sourceId": "c55"
            },
            {
              "statId": "0000010103/C5302/‐/c55/消費者物価地域差指数・総合（家賃を除く）",
              "label": "消費者物価地域差指数・総合（家賃を除く）",
              "cat01": "C5302",
              "unit": "‐",
              "sourceId": "c55"
            },
            {
              "statId": "0000010103/C5303/‐/c55/消費者物価地域差指数・食料",
              "label": "消費者物価地域差指数・食料",
              "cat01": "C5303",
              "unit": "‐",
              "sourceId": "c55"
            },
            {
              "statId": "0000010103/C5401/円／ｍ2/c56/標準価格（平均価格）（住宅地）",
              "label": "標準価格（平均価格）（住宅地）",
              "cat01": "C5401",
              "unit": "円／ｍ2",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5403/円／ｍ2/c56/標準価格（平均価格）（商業地）",
              "label": "標準価格（平均価格）（商業地）",
              "cat01": "C5403",
              "unit": "円／ｍ2",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5405/円／ｍ2/c56/標準価格（平均価格）（工業地）",
              "label": "標準価格（平均価格）（工業地）",
              "cat01": "C5405",
              "unit": "円／ｍ2",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5501/％/c56/標準価格（対前年平均変動率）（住宅地）",
              "label": "標準価格（対前年平均変動率）（住宅地）",
              "cat01": "C5501",
              "unit": "％",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5503/％/c56/標準価格（対前年平均変動率）（商業地）",
              "label": "標準価格（対前年平均変動率）（商業地）",
              "cat01": "C5503",
              "unit": "％",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5505/％/c56/標準価格（対前年平均変動率）（工業地）",
              "label": "標準価格（対前年平均変動率）（工業地）",
              "cat01": "C5505",
              "unit": "％",
              "sourceId": "c56"
            },
            {
              "statId": "0000010103/C5601/‐/c57/消費者物価地域差指数・総合（５１市平均＝１００）",
              "label": "消費者物価地域差指数・総合（５１市平均＝１００）",
              "cat01": "C5601",
              "unit": "‐",
              "sourceId": "c57"
            },
            {
              "statId": "0000010103/C5602/‐/c57/消費者物価地域差指数・総合（家賃を除く）（５１市平均＝１００）",
              "label": "消費者物価地域差指数・総合（家賃を除く）（５１市平均＝１００）",
              "cat01": "C5602",
              "unit": "‐",
              "sourceId": "c57"
            },
            {
              "statId": "0000010103/C5603/‐/c57/消費者物価地域差指数・食料（５１市平均＝１００）",
              "label": "消費者物価地域差指数・食料（５１市平均＝１００）",
              "cat01": "C5603",
              "unit": "‐",
              "sourceId": "c57"
            },
            {
              "statId": "0000010103/C5701/‐/c58/消費者物価地域差指数（持家の帰属家賃を除く総合）",
              "label": "消費者物価地域差指数（持家の帰属家賃を除く総合）",
              "cat01": "C5701",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5702/‐/c58/消費者物価地域差指数（家賃を除く総合）",
              "label": "消費者物価地域差指数（家賃を除く総合）",
              "cat01": "C5702",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5703/‐/c58/消費者物価地域差指数（食料）",
              "label": "消費者物価地域差指数（食料）",
              "cat01": "C5703",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5704/‐/c58/消費者物価地域差指数（持家の帰属家賃を除く住居）",
              "label": "消費者物価地域差指数（持家の帰属家賃を除く住居）",
              "cat01": "C5704",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5705/‐/c58/消費者物価地域差指数（光熱・水道）",
              "label": "消費者物価地域差指数（光熱・水道）",
              "cat01": "C5705",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5706/‐/c58/消費者物価地域差指数（家具・家事用品）",
              "label": "消費者物価地域差指数（家具・家事用品）",
              "cat01": "C5706",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5707/‐/c58/消費者物価地域差指数（被服及び履物）",
              "label": "消費者物価地域差指数（被服及び履物）",
              "cat01": "C5707",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5708/‐/c58/消費者物価地域差指数（保健医療）",
              "label": "消費者物価地域差指数（保健医療）",
              "cat01": "C5708",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5709/‐/c58/消費者物価地域差指数（交通・通信）",
              "label": "消費者物価地域差指数（交通・通信）",
              "cat01": "C5709",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5710/‐/c58/消費者物価地域差指数（教育）",
              "label": "消費者物価地域差指数（教育）",
              "cat01": "C5710",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5711/‐/c58/消費者物価地域差指数（教養娯楽）",
              "label": "消費者物価地域差指数（教養娯楽）",
              "cat01": "C5711",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C5712/‐/c58/消費者物価地域差指数（諸雑費）",
              "label": "消費者物価地域差指数（諸雑費）",
              "cat01": "C5712",
              "unit": "‐",
              "sourceId": "c58"
            },
            {
              "statId": "0000010103/C6101/百万円/c59/売上金額（民営）",
              "label": "売上金額（民営）",
              "cat01": "C6101",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610101/百万円/c59/売上金額（民営）（農林漁業）",
              "label": "売上金額（民営）（農林漁業）",
              "cat01": "C610101",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610102/百万円/c59/売上金額（民営）（農業，林業）",
              "label": "売上金額（民営）（農業，林業）",
              "cat01": "C610102",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610103/百万円/c59/売上金額（民営）（漁業）",
              "label": "売上金額（民営）（漁業）",
              "cat01": "C610103",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610104/百万円/c59/売上金額（民営）（非農林漁業（公務を除く））",
              "label": "売上金額（民営）（非農林漁業（公務を除く））",
              "cat01": "C610104",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610105/百万円/c59/売上金額（民営）（鉱業，採石業，砂利採取業）",
              "label": "売上金額（民営）（鉱業，採石業，砂利採取業）",
              "cat01": "C610105",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610106/百万円/c59/売上金額（民営）（建設業）",
              "label": "売上金額（民営）（建設業）",
              "cat01": "C610106",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610107/百万円/c59/売上金額（民営）（製造業）",
              "label": "売上金額（民営）（製造業）",
              "cat01": "C610107",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610108/百万円/c59/売上金額（民営）（電気・ガス・熱供給・水道業）",
              "label": "売上金額（民営）（電気・ガス・熱供給・水道業）",
              "cat01": "C610108",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610109/百万円/c59/売上金額（民営）（情報通信業）",
              "label": "売上金額（民営）（情報通信業）",
              "cat01": "C610109",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610110/百万円/c59/売上金額（民営）（運輸業，郵便業）",
              "label": "売上金額（民営）（運輸業，郵便業）",
              "cat01": "C610110",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610111/百万円/c59/売上金額（民営）（卸売業，小売業）",
              "label": "売上金額（民営）（卸売業，小売業）",
              "cat01": "C610111",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610112/百万円/c59/売上金額（民営）（卸売業）",
              "label": "売上金額（民営）（卸売業）",
              "cat01": "C610112",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610113/百万円/c59/売上金額（民営）（小売業）",
              "label": "売上金額（民営）（小売業）",
              "cat01": "C610113",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610114/百万円/c59/売上金額（民営）（金融業，保険業）",
              "label": "売上金額（民営）（金融業，保険業）",
              "cat01": "C610114",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610115/百万円/c59/売上金額（民営）（不動産業，物品賃貸業）",
              "label": "売上金額（民営）（不動産業，物品賃貸業）",
              "cat01": "C610115",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610116/百万円/c59/売上金額（民営）（学術研究，専門・技術サービス業）",
              "label": "売上金額（民営）（学術研究，専門・技術サービス業）",
              "cat01": "C610116",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610117/百万円/c59/売上金額（民営）（宿泊業，飲食サービス業）",
              "label": "売上金額（民営）（宿泊業，飲食サービス業）",
              "cat01": "C610117",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610118/百万円/c59/売上金額（民営）（生活関連サービス業，娯楽業）",
              "label": "売上金額（民営）（生活関連サービス業，娯楽業）",
              "cat01": "C610118",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610119/百万円/c59/売上金額（民営）（教育，学習支援業）",
              "label": "売上金額（民営）（教育，学習支援業）",
              "cat01": "C610119",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610120/百万円/c59/売上金額（民営）（医療，福祉）",
              "label": "売上金額（民営）（医療，福祉）",
              "cat01": "C610120",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610121/百万円/c59/売上金額（民営）（複合サービス事業）",
              "label": "売上金額（民営）（複合サービス事業）",
              "cat01": "C610121",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C610122/百万円/c59/売上金額（民営）（サービス業（他に分類されないもの））",
              "label": "売上金額（民営）（サービス業（他に分類されないもの））",
              "cat01": "C610122",
              "unit": "百万円",
              "sourceId": "c59"
            },
            {
              "statId": "0000010103/C6201/百万円/c60/付加価値額（民営）",
              "label": "付加価値額（民営）",
              "cat01": "C6201",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620101/百万円/c60/付加価値額（民営）（農林漁業）",
              "label": "付加価値額（民営）（農林漁業）",
              "cat01": "C620101",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620102/百万円/c60/付加価値額（民営）（農業，林業）",
              "label": "付加価値額（民営）（農業，林業）",
              "cat01": "C620102",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620103/百万円/c60/付加価値額（民営）（漁業）",
              "label": "付加価値額（民営）（漁業）",
              "cat01": "C620103",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620104/百万円/c60/付加価値額（民営）（非農林漁業（公務を除く））",
              "label": "付加価値額（民営）（非農林漁業（公務を除く））",
              "cat01": "C620104",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620105/百万円/c60/付加価値額（民営）（鉱業，採石業，砂利採取業）",
              "label": "付加価値額（民営）（鉱業，採石業，砂利採取業）",
              "cat01": "C620105",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620106/百万円/c60/付加価値額（民営）（建設業）",
              "label": "付加価値額（民営）（建設業）",
              "cat01": "C620106",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620107/百万円/c60/付加価値額（民営）（製造業）",
              "label": "付加価値額（民営）（製造業）",
              "cat01": "C620107",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620108/百万円/c60/付加価値額（民営）（電気・ガス・熱供給・水道業）",
              "label": "付加価値額（民営）（電気・ガス・熱供給・水道業）",
              "cat01": "C620108",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620109/百万円/c60/付加価値額（民営）（情報通信業）",
              "label": "付加価値額（民営）（情報通信業）",
              "cat01": "C620109",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620110/百万円/c60/付加価値額（民営）（運輸業，郵便業）",
              "label": "付加価値額（民営）（運輸業，郵便業）",
              "cat01": "C620110",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620111/百万円/c60/付加価値額（民営）（卸売業，小売業）",
              "label": "付加価値額（民営）（卸売業，小売業）",
              "cat01": "C620111",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620112/百万円/c60/付加価値額（民営）（卸売業）",
              "label": "付加価値額（民営）（卸売業）",
              "cat01": "C620112",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620113/百万円/c60/付加価値額（民営）（小売業）",
              "label": "付加価値額（民営）（小売業）",
              "cat01": "C620113",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620114/百万円/c60/付加価値額（民営）（金融業，保険業）",
              "label": "付加価値額（民営）（金融業，保険業）",
              "cat01": "C620114",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620115/百万円/c60/付加価値額（民営）（不動産業，物品賃貸業）",
              "label": "付加価値額（民営）（不動産業，物品賃貸業）",
              "cat01": "C620115",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620116/百万円/c60/付加価値額（民営）（学術研究，専門・技術サービス業）",
              "label": "付加価値額（民営）（学術研究，専門・技術サービス業）",
              "cat01": "C620116",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620117/百万円/c60/付加価値額（民営）（宿泊業，飲食サービス業）",
              "label": "付加価値額（民営）（宿泊業，飲食サービス業）",
              "cat01": "C620117",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620118/百万円/c60/付加価値額（民営）（生活関連サービス業，娯楽業）",
              "label": "付加価値額（民営）（生活関連サービス業，娯楽業）",
              "cat01": "C620118",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620119/百万円/c60/付加価値額（民営）（教育，学習支援業）",
              "label": "付加価値額（民営）（教育，学習支援業）",
              "cat01": "C620119",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620120/百万円/c60/付加価値額（民営）（医療，福祉）",
              "label": "付加価値額（民営）（医療，福祉）",
              "cat01": "C620120",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620121/百万円/c60/付加価値額（民営）（複合サービス事業）",
              "label": "付加価値額（民営）（複合サービス事業）",
              "cat01": "C620121",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C620122/百万円/c60/付加価値額（民営）（サービス業（他に分類されないもの））",
              "label": "付加価値額（民営）（サービス業（他に分類されないもの））",
              "cat01": "C620122",
              "unit": "百万円",
              "sourceId": "c60"
            },
            {
              "statId": "0000010103/C6301/百万円/c61/売上高（サービス産業）",
              "label": "売上高（サービス産業）",
              "cat01": "C6301",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630101/百万円/c61/売上高（サービス産業）（運輸業，郵便業）",
              "label": "売上高（サービス産業）（運輸業，郵便業）",
              "cat01": "C630101",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630102/百万円/c61/売上高（サービス産業）（不動産業，物品賃貸業）",
              "label": "売上高（サービス産業）（不動産業，物品賃貸業）",
              "cat01": "C630102",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630103/百万円/c61/売上高（サービス産業）（学術研究，専門・技術サービス業）",
              "label": "売上高（サービス産業）（学術研究，専門・技術サービス業）",
              "cat01": "C630103",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630104/百万円/c61/売上高（サービス産業）（宿泊業，飲食サービス業）",
              "label": "売上高（サービス産業）（宿泊業，飲食サービス業）",
              "cat01": "C630104",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630105/百万円/c61/売上高（サービス産業）（生活関連サービス業，娯楽業）",
              "label": "売上高（サービス産業）（生活関連サービス業，娯楽業）",
              "cat01": "C630105",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630106/百万円/c61/売上高（サービス産業）（教育，学習支援業）",
              "label": "売上高（サービス産業）（教育，学習支援業）",
              "cat01": "C630106",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630107/百万円/c61/売上高（サービス産業）（医療，福祉）",
              "label": "売上高（サービス産業）（医療，福祉）",
              "cat01": "C630107",
              "unit": "百万円",
              "sourceId": "c61"
            },
            {
              "statId": "0000010103/C630108/百万円/c61/売上高（サービス業（他に分類されないもの））",
              "label": "売上高（サービス業（他に分類されないもの））",
              "cat01": "C630108",
              "unit": "百万円",
              "sourceId": "c61"
            }
          ]
        },
        {
          "label": "Ｄ行政基盤",
          "statId": "0000010104",
          "children": [
            {
              "statId": "0000010104/D110101/‐/d01/市町村数",
              "label": "市町村数",
              "cat01": "D110101",
              "unit": "‐",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D110102/‐/d01/市区数",
              "label": "市区数",
              "cat01": "D110102",
              "unit": "‐",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D110103/‐/d01/町村数",
              "label": "町村数",
              "cat01": "D110103",
              "unit": "‐",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1201/人/d01/一般行政部門職員数（都道府県）",
              "label": "一般行政部門職員数（都道府県）",
              "cat01": "D1201",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1202/人/d01/一般行政部門職員数（市区町村）",
              "label": "一般行政部門職員数（市区町村）",
              "cat01": "D1202",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1203/人/d01/消防部門職員数",
              "label": "消防部門職員数",
              "cat01": "D1203",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1204/人/d01/教育部門職員数",
              "label": "教育部門職員数",
              "cat01": "D1204",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1205/人/d01/警察部門職員数",
              "label": "警察部門職員数",
              "cat01": "D1205",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1206/人/d01/公営企業等会計部門職員数",
              "label": "公営企業等会計部門職員数",
              "cat01": "D1206",
              "unit": "人",
              "sourceId": "d01"
            },
            {
              "statId": "0000010104/D1210/人/d02/都道府県議会議員数",
              "label": "都道府県議会議員数",
              "cat01": "D1210",
              "unit": "人",
              "sourceId": "d02"
            },
            {
              "statId": "0000010104/D1211/人/d02/市議会議員数",
              "label": "市議会議員数",
              "cat01": "D1211",
              "unit": "人",
              "sourceId": "d02"
            },
            {
              "statId": "0000010104/D1212/人/d02/選挙人名簿登録者数",
              "label": "選挙人名簿登録者数",
              "cat01": "D1212",
              "unit": "人",
              "sourceId": "d02"
            },
            {
              "statId": "0000010104/D2101/‐/d03/財政力指数（都道府県財政）",
              "label": "財政力指数（都道府県財政）",
              "cat01": "D2101",
              "unit": "‐",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2102/％/d03/実質収支比率（都道府県財政）",
              "label": "実質収支比率（都道府県財政）",
              "cat01": "D2102",
              "unit": "％",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2103/％/d03/経常収支比率（都道府県財政）",
              "label": "経常収支比率（都道府県財政）",
              "cat01": "D2103",
              "unit": "％",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2105/千円/d03/基準財政収入額（都道府県財政）",
              "label": "基準財政収入額（都道府県財政）",
              "cat01": "D2105",
              "unit": "千円",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2106/千円/d03/基準財政需要額（都道府県財政）",
              "label": "基準財政需要額（都道府県財政）",
              "cat01": "D2106",
              "unit": "千円",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2109/千円/d03/一般財源（都道府県財政）",
              "label": "一般財源（都道府県財政）",
              "cat01": "D2109",
              "unit": "千円",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2110/千円/d03/投資的経費（都道府県財政）",
              "label": "投資的経費（都道府県財政）",
              "cat01": "D2110",
              "unit": "千円",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2111/％/d03/実質公債費比率（都道府県財政）",
              "label": "実質公債費比率（都道府県財政）",
              "cat01": "D2111",
              "unit": "％",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2112/％/d03/将来負担比率（都道府県財政）",
              "label": "将来負担比率（都道府県財政）",
              "cat01": "D2112",
              "unit": "％",
              "sourceId": "d03"
            },
            {
              "statId": "0000010104/D2205/千円/d04/基準財政収入額（市町村財政）",
              "label": "基準財政収入額（市町村財政）",
              "cat01": "D2205",
              "unit": "千円",
              "sourceId": "d04"
            },
            {
              "statId": "0000010104/D2206/千円/d04/基準財政需要額（市町村財政）",
              "label": "基準財政需要額（市町村財政）",
              "cat01": "D2206",
              "unit": "千円",
              "sourceId": "d04"
            },
            {
              "statId": "0000010104/D2209/千円/d04/一般財源（市町村財政）",
              "label": "一般財源（市町村財政）",
              "cat01": "D2209",
              "unit": "千円",
              "sourceId": "d04"
            },
            {
              "statId": "0000010104/D2210/千円/d04/投資的経費（市町村財政）",
              "label": "投資的経費（市町村財政）",
              "cat01": "D2210",
              "unit": "千円",
              "sourceId": "d04"
            },
            {
              "statId": "0000010104/D3101/千円/d05/歳入決算総額（都道府県財政）",
              "label": "歳入決算総額（都道府県財政）",
              "cat01": "D3101",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310101/千円/d05/地方税（都道府県財政）",
              "label": "地方税（都道府県財政）",
              "cat01": "D310101",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310102/千円/d05/地方譲与税（都道府県財政）",
              "label": "地方譲与税（都道府県財政）",
              "cat01": "D310102",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310103/千円/d05/地方交付税（都道府県財政）",
              "label": "地方交付税（都道府県財政）",
              "cat01": "D310103",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310104/千円/d05/交通安全対策特別交付金（都道府県財政）",
              "label": "交通安全対策特別交付金（都道府県財政）",
              "cat01": "D310104",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310105/千円/d05/分担金及び負担金（都道府県財政）",
              "label": "分担金及び負担金（都道府県財政）",
              "cat01": "D310105",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310106/千円/d05/使用料（都道府県財政）",
              "label": "使用料（都道府県財政）",
              "cat01": "D310106",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310107/千円/d05/手数料（都道府県財政）",
              "label": "手数料（都道府県財政）",
              "cat01": "D310107",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310108/千円/d05/国庫支出金（都道府県財政）",
              "label": "国庫支出金（都道府県財政）",
              "cat01": "D310108",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310110/千円/d05/財産収入（都道府県財政）",
              "label": "財産収入（都道府県財政）",
              "cat01": "D310110",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310111/千円/d05/寄附金（都道府県財政）",
              "label": "寄附金（都道府県財政）",
              "cat01": "D310111",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310112/千円/d05/繰入金（都道府県財政）",
              "label": "繰入金（都道府県財政）",
              "cat01": "D310112",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310113/千円/d05/繰越金（都道府県財政）",
              "label": "繰越金（都道府県財政）",
              "cat01": "D310113",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310114/千円/d05/諸収入（都道府県財政）",
              "label": "諸収入（都道府県財政）",
              "cat01": "D310114",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310115/千円/d05/地方債（都道府県財政）",
              "label": "地方債（都道府県財政）",
              "cat01": "D310115",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310116/千円/d05/地方特例交付金（都道府県財政）",
              "label": "地方特例交付金（都道府県財政）",
              "cat01": "D310116",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3102/千円/d05/自主財源額（都道府県財政）",
              "label": "自主財源額（都道府県財政）",
              "cat01": "D3102",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103/千円/d05/歳出決算総額（都道府県財政）",
              "label": "歳出決算総額（都道府県財政）",
              "cat01": "D3103",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310301/千円/d05/議会費（都道府県財政）",
              "label": "議会費（都道府県財政）",
              "cat01": "D310301",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310302/千円/d05/総務費（都道府県財政）",
              "label": "総務費（都道府県財政）",
              "cat01": "D310302",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310303/千円/d05/民生費（都道府県財政）",
              "label": "民生費（都道府県財政）",
              "cat01": "D310303",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103031/千円/d05/社会福祉費（都道府県財政）",
              "label": "社会福祉費（都道府県財政）",
              "cat01": "D3103031",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103032/千円/d05/老人福祉費（都道府県財政）",
              "label": "老人福祉費（都道府県財政）",
              "cat01": "D3103032",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103033/千円/d05/児童福祉費（都道府県財政）",
              "label": "児童福祉費（都道府県財政）",
              "cat01": "D3103033",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103034/千円/d05/生活保護費（都道府県財政）",
              "label": "生活保護費（都道府県財政）",
              "cat01": "D3103034",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103035/千円/d05/災害救助費（都道府県財政）",
              "label": "災害救助費（都道府県財政）",
              "cat01": "D3103035",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310304/千円/d05/衛生費（都道府県財政）",
              "label": "衛生費（都道府県財政）",
              "cat01": "D310304",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103041/千円/d05/公衆衛生費（都道府県財政）",
              "label": "公衆衛生費（都道府県財政）",
              "cat01": "D3103041",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103043/千円/d05/精神衛生費（都道府県財政）",
              "label": "精神衛生費（都道府県財政）",
              "cat01": "D3103043",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103044/千円/d05/環境衛生費（都道府県財政）",
              "label": "環境衛生費（都道府県財政）",
              "cat01": "D3103044",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103045/千円/d05/清掃費（都道府県財政）",
              "label": "清掃費（都道府県財政）",
              "cat01": "D3103045",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103046/千円/d05/保健所費（都道府県財政）",
              "label": "保健所費（都道府県財政）",
              "cat01": "D3103046",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310305/千円/d05/労働費（都道府県財政）",
              "label": "労働費（都道府県財政）",
              "cat01": "D310305",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103051/千円/d05/労政費（都道府県財政）",
              "label": "労政費（都道府県財政）",
              "cat01": "D3103051",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103052/千円/d05/職業訓練費（都道府県財政）",
              "label": "職業訓練費（都道府県財政）",
              "cat01": "D3103052",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103053/千円/d05/失業対策費（都道府県財政）",
              "label": "失業対策費（都道府県財政）",
              "cat01": "D3103053",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310306/千円/d05/農林水産業費（都道府県財政）",
              "label": "農林水産業費（都道府県財政）",
              "cat01": "D310306",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310307/千円/d05/商工費（都道府県財政）",
              "label": "商工費（都道府県財政）",
              "cat01": "D310307",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310308/千円/d05/土木費（都道府県財政）",
              "label": "土木費（都道府県財政）",
              "cat01": "D310308",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103082/千円/d05/道路橋りょう費（都道府県財政）",
              "label": "道路橋りょう費（都道府県財政）",
              "cat01": "D3103082",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103085/千円/d05/都市計画費（都道府県財政）",
              "label": "都市計画費（都道府県財政）",
              "cat01": "D3103085",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103086/千円/d05/住宅費（都道府県財政）",
              "label": "住宅費（都道府県財政）",
              "cat01": "D3103086",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310309/千円/d05/警察費（都道府県財政）",
              "label": "警察費（都道府県財政）",
              "cat01": "D310309",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310310/千円/d05/消防費（都道府県財政）",
              "label": "消防費（都道府県財政）",
              "cat01": "D310310",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310311/千円/d05/教育費（都道府県財政）",
              "label": "教育費（都道府県財政）",
              "cat01": "D310311",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103112/千円/d05/小学校費（都道府県財政）",
              "label": "小学校費（都道府県財政）",
              "cat01": "D3103112",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103113/千円/d05/中学校費（都道府県財政）",
              "label": "中学校費（都道府県財政）",
              "cat01": "D3103113",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103114/千円/d05/高等学校費（都道府県財政）",
              "label": "高等学校費（都道府県財政）",
              "cat01": "D3103114",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103115/千円/d05/特別支援学校費（都道府県財政）",
              "label": "特別支援学校費（都道府県財政）",
              "cat01": "D3103115",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103116/千円/d05/幼稚園費（都道府県財政）",
              "label": "幼稚園費（都道府県財政）",
              "cat01": "D3103116",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103117/千円/d05/社会教育費（都道府県財政）",
              "label": "社会教育費（都道府県財政）",
              "cat01": "D3103117",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3103118/千円/d05/保健体育費（都道府県財政）",
              "label": "保健体育費（都道府県財政）",
              "cat01": "D3103118",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310312/千円/d05/災害復旧費（都道府県財政）",
              "label": "災害復旧費（都道府県財政）",
              "cat01": "D310312",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310313/千円/d05/公債費（都道府県財政）（目的別歳出内訳）",
              "label": "公債費（都道府県財政）（目的別歳出内訳）",
              "cat01": "D310313",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310401/千円/d05/人件費（都道府県財政）",
              "label": "人件費（都道府県財政）",
              "cat01": "D310401",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310402/千円/d05/物件費（都道府県財政）",
              "label": "物件費（都道府県財政）",
              "cat01": "D310402",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310403/千円/d05/維持補修費（都道府県財政）",
              "label": "維持補修費（都道府県財政）",
              "cat01": "D310403",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310404/千円/d05/扶助費（都道府県財政）",
              "label": "扶助費（都道府県財政）",
              "cat01": "D310404",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310405/千円/d05/補助費等（都道府県財政）",
              "label": "補助費等（都道府県財政）",
              "cat01": "D310405",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310406/千円/d05/普通建設事業費（都道府県財政）",
              "label": "普通建設事業費（都道府県財政）",
              "cat01": "D310406",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310407/千円/d05/災害復旧事業費（都道府県財政）",
              "label": "災害復旧事業費（都道府県財政）",
              "cat01": "D310407",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310408/千円/d05/失業対策事業費（都道府県財政）",
              "label": "失業対策事業費（都道府県財政）",
              "cat01": "D310408",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310409/千円/d05/公債費（都道府県財政）（性質別歳出内訳）",
              "label": "公債費（都道府県財政）（性質別歳出内訳）",
              "cat01": "D310409",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310410/千円/d05/積立金（都道府県財政）",
              "label": "積立金（都道府県財政）",
              "cat01": "D310410",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310411/千円/d05/投資及び出資金（都道府県財政）",
              "label": "投資及び出資金（都道府県財政）",
              "cat01": "D310411",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D310412/千円/d05/貸付金（都道府県財政）",
              "label": "貸付金（都道府県財政）",
              "cat01": "D310412",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3105/千円/d05/地方債現在高（都道府県財政）",
              "label": "地方債現在高（都道府県財政）",
              "cat01": "D3105",
              "unit": "千円",
              "sourceId": "d05"
            },
            {
              "statId": "0000010104/D3201/千円/d06/歳入決算総額（市町村財政）",
              "label": "歳入決算総額（市町村財政）",
              "cat01": "D3201",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320101/千円/d06/地方税（市町村財政）",
              "label": "地方税（市町村財政）",
              "cat01": "D320101",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320102/千円/d06/地方譲与税（市町村財政）",
              "label": "地方譲与税（市町村財政）",
              "cat01": "D320102",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320103/千円/d06/利子割交付金（市町村財政）",
              "label": "利子割交付金（市町村財政）",
              "cat01": "D320103",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320104/千円/d06/ゴルフ場利用税交付金（市町村財政）",
              "label": "ゴルフ場利用税交付金（市町村財政）",
              "cat01": "D320104",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320105/千円/d06/特別地方消費税交付金（市町村財政）",
              "label": "特別地方消費税交付金（市町村財政）",
              "cat01": "D320105",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320106/千円/d06/自動車取得税交付金（市町村財政）",
              "label": "自動車取得税交付金（市町村財政）",
              "cat01": "D320106",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320107/千円/d06/軽油引取税交付金（市町村財政）",
              "label": "軽油引取税交付金（市町村財政）",
              "cat01": "D320107",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320108/千円/d06/地方交付税（市町村財政）",
              "label": "地方交付税（市町村財政）",
              "cat01": "D320108",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320109/千円/d06/交通安全対策特別交付金（市町村財政）",
              "label": "交通安全対策特別交付金（市町村財政）",
              "cat01": "D320109",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320110/千円/d06/分担金及び負担金（市町村財政）",
              "label": "分担金及び負担金（市町村財政）",
              "cat01": "D320110",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320111/千円/d06/使用料（市町村財政）",
              "label": "使用料（市町村財政）",
              "cat01": "D320111",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320113/千円/d06/国庫支出金（市町村財政）",
              "label": "国庫支出金（市町村財政）",
              "cat01": "D320113",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320115/千円/d06/県支出金（市町村財政）",
              "label": "県支出金（市町村財政）",
              "cat01": "D320115",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320116/千円/d06/財産収入（市町村財政）",
              "label": "財産収入（市町村財政）",
              "cat01": "D320116",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320117/千円/d06/寄附金（市町村財政）",
              "label": "寄附金（市町村財政）",
              "cat01": "D320117",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320118/千円/d06/繰入金（市町村財政）",
              "label": "繰入金（市町村財政）",
              "cat01": "D320118",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320119/千円/d06/繰越金（市町村財政）",
              "label": "繰越金（市町村財政）",
              "cat01": "D320119",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320120/千円/d06/諸収入（市町村財政）",
              "label": "諸収入（市町村財政）",
              "cat01": "D320120",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320121/千円/d06/地方債（市町村財政）",
              "label": "地方債（市町村財政）",
              "cat01": "D320121",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320122/千円/d06/地方特例交付金（市町村財政）",
              "label": "地方特例交付金（市町村財政）",
              "cat01": "D320122",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3202/千円/d06/自主財源額（市町村財政）",
              "label": "自主財源額（市町村財政）",
              "cat01": "D3202",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203/千円/d06/歳出決算総額（市町村財政）",
              "label": "歳出決算総額（市町村財政）",
              "cat01": "D3203",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203001/千円/d06/歳出決算総額（市町村財政・都分含む）",
              "label": "歳出決算総額（市町村財政・都分含む）",
              "cat01": "D3203001",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320301/千円/d06/議会費（市町村財政）",
              "label": "議会費（市町村財政）",
              "cat01": "D320301",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320302/千円/d06/総務費（市町村財政）",
              "label": "総務費（市町村財政）",
              "cat01": "D320302",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320303/千円/d06/民生費（市町村財政）",
              "label": "民生費（市町村財政）",
              "cat01": "D320303",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203031/千円/d06/社会福祉費（市町村財政）",
              "label": "社会福祉費（市町村財政）",
              "cat01": "D3203031",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203032/千円/d06/老人福祉費（市町村財政）",
              "label": "老人福祉費（市町村財政）",
              "cat01": "D3203032",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203033/千円/d06/児童福祉費（市町村財政）",
              "label": "児童福祉費（市町村財政）",
              "cat01": "D3203033",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203034/千円/d06/生活保護費（市町村財政）",
              "label": "生活保護費（市町村財政）",
              "cat01": "D3203034",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203035/千円/d06/災害救助費（市町村財政）",
              "label": "災害救助費（市町村財政）",
              "cat01": "D3203035",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320304/千円/d06/衛生費（市町村財政）",
              "label": "衛生費（市町村財政）",
              "cat01": "D320304",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203042/千円/d06/保健衛生費（市町村財政）",
              "label": "保健衛生費（市町村財政）",
              "cat01": "D3203042",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203043/千円/d06/保健所費（市町村財政）",
              "label": "保健所費（市町村財政）",
              "cat01": "D3203043",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203044/千円/d06/清掃費（市町村財政）",
              "label": "清掃費（市町村財政）",
              "cat01": "D3203044",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320305/千円/d06/労働費（市町村財政）",
              "label": "労働費（市町村財政）",
              "cat01": "D320305",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203051/千円/d06/失業対策費（市町村財政）",
              "label": "失業対策費（市町村財政）",
              "cat01": "D3203051",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320306/千円/d06/農林水産業費（市町村財政）",
              "label": "農林水産業費（市町村財政）",
              "cat01": "D320306",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320307/千円/d06/商工費（市町村財政）",
              "label": "商工費（市町村財政）",
              "cat01": "D320307",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320308/千円/d06/土木費（市町村財政）",
              "label": "土木費（市町村財政）",
              "cat01": "D320308",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203082/千円/d06/道路橋りょう費（市町村財政）",
              "label": "道路橋りょう費（市町村財政）",
              "cat01": "D3203082",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203085/千円/d06/都市計画費（市町村財政）",
              "label": "都市計画費（市町村財政）",
              "cat01": "D3203085",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203086/千円/d06/住宅費（市町村財政）",
              "label": "住宅費（市町村財政）",
              "cat01": "D3203086",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320309/千円/d06/消防費（市町村財政）",
              "label": "消防費（市町村財政）",
              "cat01": "D320309",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203099/千円/d06/消防費（都・市町村合計）",
              "label": "消防費（都・市町村合計）",
              "cat01": "D3203099",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320310/千円/d06/教育費（市町村財政）",
              "label": "教育費（市町村財政）",
              "cat01": "D320310",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203102/千円/d06/小学校費（市町村財政）",
              "label": "小学校費（市町村財政）",
              "cat01": "D3203102",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203103/千円/d06/中学校費（市町村財政）",
              "label": "中学校費（市町村財政）",
              "cat01": "D3203103",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203104/千円/d06/高等学校費（市町村財政）",
              "label": "高等学校費（市町村財政）",
              "cat01": "D3203104",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203105/千円/d06/特別支援学校費（市町村財政）",
              "label": "特別支援学校費（市町村財政）",
              "cat01": "D3203105",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203106/千円/d06/幼稚園費（市町村財政）",
              "label": "幼稚園費（市町村財政）",
              "cat01": "D3203106",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203107/千円/d06/社会教育費（市町村財政）",
              "label": "社会教育費（市町村財政）",
              "cat01": "D3203107",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3203108/千円/d06/保健体育費（市町村財政）",
              "label": "保健体育費（市町村財政）",
              "cat01": "D3203108",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320311/千円/d06/災害復旧費（市町村財政）",
              "label": "災害復旧費（市町村財政）",
              "cat01": "D320311",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320312/千円/d06/公債費（市町村財政）（目的別歳出内訳）",
              "label": "公債費（市町村財政）（目的別歳出内訳）",
              "cat01": "D320312",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320401/千円/d06/人件費（市町村財政）",
              "label": "人件費（市町村財政）",
              "cat01": "D320401",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320402/千円/d06/物件費（市町村財政）",
              "label": "物件費（市町村財政）",
              "cat01": "D320402",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320403/千円/d06/維持補修費（市町村財政）",
              "label": "維持補修費（市町村財政）",
              "cat01": "D320403",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320404/千円/d06/扶助費（市町村財政）",
              "label": "扶助費（市町村財政）",
              "cat01": "D320404",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320405/千円/d06/補助費等（市町村財政）",
              "label": "補助費等（市町村財政）",
              "cat01": "D320405",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320406/千円/d06/普通建設事業費（市町村財政）",
              "label": "普通建設事業費（市町村財政）",
              "cat01": "D320406",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320407/千円/d06/災害復旧事業費（市町村財政）",
              "label": "災害復旧事業費（市町村財政）",
              "cat01": "D320407",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320408/千円/d06/失業対策事業費（市町村財政）",
              "label": "失業対策事業費（市町村財政）",
              "cat01": "D320408",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320409/千円/d06/公債費（市町村財政）（性質別歳出内訳）",
              "label": "公債費（市町村財政）（性質別歳出内訳）",
              "cat01": "D320409",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320410/千円/d06/積立金（市町村財政）",
              "label": "積立金（市町村財政）",
              "cat01": "D320410",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320411/千円/d06/投資及び出資金（市町村財政）",
              "label": "投資及び出資金（市町村財政）",
              "cat01": "D320411",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D320412/千円/d06/貸付金（市町村財政）",
              "label": "貸付金（市町村財政）",
              "cat01": "D320412",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D3205/千円/d06/地方債現在高（市町村財政）",
              "label": "地方債現在高（市町村財政）",
              "cat01": "D3205",
              "unit": "千円",
              "sourceId": "d06"
            },
            {
              "statId": "0000010104/D4101/千円/d07/普通税（地方税）",
              "label": "普通税（地方税）",
              "cat01": "D4101",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D410101/千円/d07/普通税（都道府県税）",
              "label": "普通税（都道府県税）",
              "cat01": "D410101",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D410102/千円/d07/普通税（市町村税）",
              "label": "普通税（市町村税）",
              "cat01": "D410102",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D4102/千円/d07/目的税（地方税）",
              "label": "目的税（地方税）",
              "cat01": "D4102",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D410201/千円/d07/目的税（都道府県税）",
              "label": "目的税（都道府県税）",
              "cat01": "D410201",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D410202/千円/d07/目的税（市町村税）",
              "label": "目的税（市町村税）",
              "cat01": "D410202",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D4201/千円/d07/住民税（県，市町村財政合計）",
              "label": "住民税（県，市町村財政合計）",
              "cat01": "D4201",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D420101/千円/d07/都道府県民税",
              "label": "都道府県民税",
              "cat01": "D420101",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D420102/千円/d07/市町村民税",
              "label": "市町村民税",
              "cat01": "D420102",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D4202/千円/d07/固定資産税（県，市町村財政合計）",
              "label": "固定資産税（県，市町村財政合計）",
              "cat01": "D4202",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D420201/千円/d07/固定資産税（都道府県税）",
              "label": "固定資産税（都道府県税）",
              "cat01": "D420201",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D420202/千円/d07/固定資産税（市町村税）",
              "label": "固定資産税（市町村税）",
              "cat01": "D420202",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D4203/千円/d07/事業税",
              "label": "事業税",
              "cat01": "D4203",
              "unit": "千円",
              "sourceId": "d07"
            },
            {
              "statId": "0000010104/D430101/百万円/d08/国税徴収決定済額",
              "label": "国税徴収決定済額",
              "cat01": "D430101",
              "unit": "百万円",
              "sourceId": "d08"
            },
            {
              "statId": "0000010104/D430102/千円/d09/都道府県税徴収決定済額",
              "label": "都道府県税徴収決定済額",
              "cat01": "D430102",
              "unit": "千円",
              "sourceId": "d09"
            },
            {
              "statId": "0000010104/D430103/千円/d09/市町村税徴収決定済額",
              "label": "市町村税徴収決定済額",
              "cat01": "D430103",
              "unit": "千円",
              "sourceId": "d09"
            },
            {
              "statId": "0000010104/D4302/百万円/d10/収納済額",
              "label": "収納済額",
              "cat01": "D4302",
              "unit": "百万円",
              "sourceId": "d10"
            },
            {
              "statId": "0000010104/D430201/百万円/d10/国税収納済額",
              "label": "国税収納済額",
              "cat01": "D430201",
              "unit": "百万円",
              "sourceId": "d10"
            },
            {
              "statId": "0000010104/D430202/千円/d11/都道府県税収納済額",
              "label": "都道府県税収納済額",
              "cat01": "D430202",
              "unit": "千円",
              "sourceId": "d11"
            },
            {
              "statId": "0000010104/D430203/千円/d11/市町村税収納済額",
              "label": "市町村税収納済額",
              "cat01": "D430203",
              "unit": "千円",
              "sourceId": "d11"
            },
            {
              "statId": "0000010104/D5100/千円/d12/行政投資総額",
              "label": "行政投資総額",
              "cat01": "D5100",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5200/千円/d12/一般事業投資総額",
              "label": "一般事業投資総額",
              "cat01": "D5200",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5201/千円/d12/一般事業投資額（道路）",
              "label": "一般事業投資額（道路）",
              "cat01": "D5201",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5202/千円/d12/一般事業投資額（農林水産）",
              "label": "一般事業投資額（農林水産）",
              "cat01": "D5202",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5203/千円/d12/一般事業投資額（住宅）",
              "label": "一般事業投資額（住宅）",
              "cat01": "D5203",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5204/千円/d12/一般事業投資額（環境衛生）",
              "label": "一般事業投資額（環境衛生）",
              "cat01": "D5204",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5205/千円/d12/一般事業投資額（厚生福祉）",
              "label": "一般事業投資額（厚生福祉）",
              "cat01": "D5205",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5206/千円/d12/一般事業投資額（治山治水）",
              "label": "一般事業投資額（治山治水）",
              "cat01": "D5206",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5207/千円/d12/一般事業投資額（都市計画）",
              "label": "一般事業投資額（都市計画）",
              "cat01": "D5207",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5208/千円/d12/一般事業投資額（文教施設）",
              "label": "一般事業投資額（文教施設）",
              "cat01": "D5208",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5210/千円/d12/一般事業投資額（災害復旧）",
              "label": "一般事業投資額（災害復旧）",
              "cat01": "D5210",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5211/千円/d12/一般事業投資額（鉄道）",
              "label": "一般事業投資額（鉄道）",
              "cat01": "D5211",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D5300/千円/d12/公営企業投資総額",
              "label": "公営企業投資総額",
              "cat01": "D5300",
              "unit": "千円",
              "sourceId": "d12"
            },
            {
              "statId": "0000010104/D620201/件/d13/情報公開条例開示請求件数（都道府県）",
              "label": "情報公開条例開示請求件数（都道府県）",
              "cat01": "D620201",
              "unit": "件",
              "sourceId": "d13"
            }
          ]
        },
        {
          "label": "Ｅ教育",
          "statId": "0000010105",
          "children": [
            {
              "statId": "0000010105/E1101/園/e01/幼稚園数",
              "label": "幼稚園数",
              "cat01": "E1101",
              "unit": "園",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E110102/園/e01/幼稚園数（公立）",
              "label": "幼稚園数（公立）",
              "cat01": "E110102",
              "unit": "園",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1201/学級/e01/幼稚園学級数",
              "label": "幼稚園学級数",
              "cat01": "E1201",
              "unit": "学級",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E120101/学級/e01/幼稚園学級数（国立）",
              "label": "幼稚園学級数（国立）",
              "cat01": "E120101",
              "unit": "学級",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E120102/学級/e01/幼稚園学級数（公立）",
              "label": "幼稚園学級数（公立）",
              "cat01": "E120102",
              "unit": "学級",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E120103/学級/e01/幼稚園学級数（私立）",
              "label": "幼稚園学級数（私立）",
              "cat01": "E120103",
              "unit": "学級",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1301/人/e01/幼稚園教員数",
              "label": "幼稚園教員数",
              "cat01": "E1301",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130101/人/e01/幼稚園教員数（男）",
              "label": "幼稚園教員数（男）",
              "cat01": "E130101",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130102/人/e01/幼稚園教員数（女）",
              "label": "幼稚園教員数（女）",
              "cat01": "E130102",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1302/人/e01/幼稚園教員数（養護教諭・養護助教諭）",
              "label": "幼稚園教員数（養護教諭・養護助教諭）",
              "cat01": "E1302",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130201/人/e01/幼稚園教員数（養護教諭・養護助教諭）（男）",
              "label": "幼稚園教員数（養護教諭・養護助教諭）（男）",
              "cat01": "E130201",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130202/人/e01/幼稚園教員数（養護教諭・養護助教諭）（女）",
              "label": "幼稚園教員数（養護教諭・養護助教諭）（女）",
              "cat01": "E130202",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1303/人/e01/幼稚園教員数（教育補助員）",
              "label": "幼稚園教員数（教育補助員）",
              "cat01": "E1303",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130301/人/e01/幼稚園教員数（教育補助員）（男）",
              "label": "幼稚園教員数（教育補助員）（男）",
              "cat01": "E130301",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E130302/人/e01/幼稚園教員数（教育補助員）（女）",
              "label": "幼稚園教員数（教育補助員）（女）",
              "cat01": "E130302",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1401/人/e01/幼稚園定員数",
              "label": "幼稚園定員数",
              "cat01": "E1401",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E140101/人/e01/幼稚園定員数（国立）",
              "label": "幼稚園定員数（国立）",
              "cat01": "E140101",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E140102/人/e01/幼稚園定員数（公立）",
              "label": "幼稚園定員数（公立）",
              "cat01": "E140102",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E140103/人/e01/幼稚園定員数（私立）",
              "label": "幼稚園定員数（私立）",
              "cat01": "E140103",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1501/人/e01/幼稚園在園者数",
              "label": "幼稚園在園者数",
              "cat01": "E1501",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150101/人/e01/幼稚園在園者数（３歳児）",
              "label": "幼稚園在園者数（３歳児）",
              "cat01": "E150101",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150102/人/e01/幼稚園在園者数（４歳児）",
              "label": "幼稚園在園者数（４歳児）",
              "cat01": "E150102",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150103/人/e01/幼稚園在園者数（５歳児）",
              "label": "幼稚園在園者数（５歳児）",
              "cat01": "E150103",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150104/人/e01/幼稚園在園者数（男）",
              "label": "幼稚園在園者数（男）",
              "cat01": "E150104",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150105/人/e01/幼稚園在園者数（女）",
              "label": "幼稚園在園者数（女）",
              "cat01": "E150105",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1502/人/e01/幼稚園在園者数（公立）",
              "label": "幼稚園在園者数（公立）",
              "cat01": "E1502",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150201/人/e01/幼稚園在園者数（公立）（３歳児）",
              "label": "幼稚園在園者数（公立）（３歳児）",
              "cat01": "E150201",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150202/人/e01/幼稚園在園者数（公立）（４歳児）",
              "label": "幼稚園在園者数（公立）（４歳児）",
              "cat01": "E150202",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150203/人/e01/幼稚園在園者数（公立）（５歳児）",
              "label": "幼稚園在園者数（公立）（５歳児）",
              "cat01": "E150203",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150204/人/e01/幼稚園在園者数（公立）（男）",
              "label": "幼稚園在園者数（公立）（男）",
              "cat01": "E150204",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E150205/人/e01/幼稚園在園者数（公立）（女）",
              "label": "幼稚園在園者数（公立）（女）",
              "cat01": "E150205",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E1601/人/e01/幼稚園修了者数",
              "label": "幼稚園修了者数",
              "cat01": "E1601",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E160101/人/e01/幼稚園修了者数（男）",
              "label": "幼稚園修了者数（男）",
              "cat01": "E160101",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E160102/人/e01/幼稚園修了者数（女）",
              "label": "幼稚園修了者数（女）",
              "cat01": "E160102",
              "unit": "人",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E2101/校/e01/小学校数",
              "label": "小学校数",
              "cat01": "E2101",
              "unit": "校",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E210101/校/e01/小学校数（国立）",
              "label": "小学校数（国立）",
              "cat01": "E210101",
              "unit": "校",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E210102/校/e01/小学校数（公立）",
              "label": "小学校数（公立）",
              "cat01": "E210102",
              "unit": "校",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E210103/校/e01/小学校数（私立）",
              "label": "小学校数（私立）",
              "cat01": "E210103",
              "unit": "校",
              "sourceId": "e01"
            },
            {
              "statId": "0000010105/E2201/千ｍ2/e02/小学校校地面積（公立）",
              "label": "小学校校地面積（公立）",
              "cat01": "E2201",
              "unit": "千ｍ2",
              "sourceId": "e02"
            },
            {
              "statId": "0000010105/E2202/ｍ2/e03/小学校校舎面積（公立）",
              "label": "小学校校舎面積（公立）",
              "cat01": "E2202",
              "unit": "ｍ2",
              "sourceId": "e03"
            },
            {
              "statId": "0000010105/E2203/ｍ2/e03/小学校木造校舎面積（公立）",
              "label": "小学校木造校舎面積（公立）",
              "cat01": "E2203",
              "unit": "ｍ2",
              "sourceId": "e03"
            },
            {
              "statId": "0000010105/E2204/千ｍ2/e04/小学校屋外運動場面積（公立）",
              "label": "小学校屋外運動場面積（公立）",
              "cat01": "E2204",
              "unit": "千ｍ2",
              "sourceId": "e04"
            },
            {
              "statId": "0000010105/E2205/ｍ2/e05/小学校屋内運動場面積（公立）",
              "label": "小学校屋内運動場面積（公立）",
              "cat01": "E2205",
              "unit": "ｍ2",
              "sourceId": "e05"
            },
            {
              "statId": "0000010105/E2206/校/e05/小学校屋内運動場保有校数（公立）",
              "label": "小学校屋内運動場保有校数（公立）",
              "cat01": "E2206",
              "unit": "校",
              "sourceId": "e05"
            },
            {
              "statId": "0000010105/E2207/校/e05/小学校プール保有校数（公立）",
              "label": "小学校プール保有校数（公立）",
              "cat01": "E2207",
              "unit": "校",
              "sourceId": "e05"
            },
            {
              "statId": "0000010105/E2301/学級/e06/小学校学級数",
              "label": "小学校学級数",
              "cat01": "E2301",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E230101/学級/e06/小学校学級数（国立）",
              "label": "小学校学級数（国立）",
              "cat01": "E230101",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E230102/学級/e06/小学校学級数（公立）",
              "label": "小学校学級数（公立）",
              "cat01": "E230102",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2301021/学級/e06/小学校学級数（単式学級）（公立）",
              "label": "小学校学級数（単式学級）（公立）",
              "cat01": "E2301021",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2301022/学級/e06/小学校学級数（複式学級）（公立）",
              "label": "小学校学級数（複式学級）（公立）",
              "cat01": "E2301022",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2301023/学級/e06/小学校学級数（特別支援学級）（公立）",
              "label": "小学校学級数（特別支援学級）（公立）",
              "cat01": "E2301023",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E230103/学級/e06/小学校学級数（私立）",
              "label": "小学校学級数（私立）",
              "cat01": "E230103",
              "unit": "学級",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2401/人/e06/小学校教員数",
              "label": "小学校教員数",
              "cat01": "E2401",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E240101/人/e06/小学校教員数（男）",
              "label": "小学校教員数（男）",
              "cat01": "E240101",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E240102/人/e06/小学校教員数（女）",
              "label": "小学校教員数（女）",
              "cat01": "E240102",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2402/人/e06/小学校教員数（養護教諭・養護助教諭）",
              "label": "小学校教員数（養護教諭・養護助教諭）",
              "cat01": "E2402",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E240201/人/e06/小学校教員数（養護教諭・養護助教諭）（男）",
              "label": "小学校教員数（養護教諭・養護助教諭）（男）",
              "cat01": "E240201",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E240202/人/e06/小学校教員数（養護教諭・養護助教諭）（女）",
              "label": "小学校教員数（養護教諭・養護助教諭）（女）",
              "cat01": "E240202",
              "unit": "人",
              "sourceId": "e06"
            },
            {
              "statId": "0000010105/E2501/人/e07/小学校児童数",
              "label": "小学校児童数",
              "cat01": "E2501",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250101/人/e07/小学校児童数（国立）",
              "label": "小学校児童数（国立）",
              "cat01": "E250101",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250102/人/e07/小学校児童数（公立）",
              "label": "小学校児童数（公立）",
              "cat01": "E250102",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2501021/人/e07/小学校児童数（単式学級）（公立）",
              "label": "小学校児童数（単式学級）（公立）",
              "cat01": "E2501021",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2501022/人/e07/小学校児童数（複式学級）（公立）",
              "label": "小学校児童数（複式学級）（公立）",
              "cat01": "E2501022",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2501023/人/e07/小学校児童数（特別支援学級）（公立）",
              "label": "小学校児童数（特別支援学級）（公立）",
              "cat01": "E2501023",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2501024/人/e07/小学校児童数（公立）（男）",
              "label": "小学校児童数（公立）（男）",
              "cat01": "E2501024",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2501025/人/e07/小学校児童数（公立）（女）",
              "label": "小学校児童数（公立）（女）",
              "cat01": "E2501025",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250103/人/e07/小学校児童数（私立）",
              "label": "小学校児童数（私立）",
              "cat01": "E250103",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250104/人/e07/小学校児童数（男）",
              "label": "小学校児童数（男）",
              "cat01": "E250104",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250105/人/e07/小学校児童数（女）",
              "label": "小学校児童数（女）",
              "cat01": "E250105",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2502/人/e07/小学校児童数（第１学年児童数）",
              "label": "小学校児童数（第１学年児童数）",
              "cat01": "E2502",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250401/人/e07/小学校就学免除者数",
              "label": "小学校就学免除者数",
              "cat01": "E250401",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250402/人/e07/小学校就学猶予者数",
              "label": "小学校就学猶予者数",
              "cat01": "E250402",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2508/人/e07/小学校長期欠席児童数（年度間３０日以上）",
              "label": "小学校長期欠席児童数（年度間３０日以上）",
              "cat01": "E2508",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250801/人/e07/小学校長期欠席児童数（病気）（年度間３０日以上）",
              "label": "小学校長期欠席児童数（病気）（年度間３０日以上）",
              "cat01": "E250801",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E250802/人/e07/小学校長期欠席児童数（不登校）（年度間３０日以上）",
              "label": "小学校長期欠席児童数（不登校）（年度間３０日以上）",
              "cat01": "E250802",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E2601/人/e07/小学校帰国児童数",
              "label": "小学校帰国児童数",
              "cat01": "E2601",
              "unit": "人",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E3101/校/e07/中学校数",
              "label": "中学校数",
              "cat01": "E3101",
              "unit": "校",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E310101/校/e07/中学校数（国立）",
              "label": "中学校数（国立）",
              "cat01": "E310101",
              "unit": "校",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E310102/校/e07/中学校数（公立）",
              "label": "中学校数（公立）",
              "cat01": "E310102",
              "unit": "校",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E310103/校/e07/中学校数（私立）",
              "label": "中学校数（私立）",
              "cat01": "E310103",
              "unit": "校",
              "sourceId": "e07"
            },
            {
              "statId": "0000010105/E3201/千ｍ2/e08/中学校校地面積（公立）",
              "label": "中学校校地面積（公立）",
              "cat01": "E3201",
              "unit": "千ｍ2",
              "sourceId": "e08"
            },
            {
              "statId": "0000010105/E3202/ｍ2/e09/中学校校舎面積（公立）",
              "label": "中学校校舎面積（公立）",
              "cat01": "E3202",
              "unit": "ｍ2",
              "sourceId": "e09"
            },
            {
              "statId": "0000010105/E3203/ｍ2/e09/中学校木造校舎面積（公立）",
              "label": "中学校木造校舎面積（公立）",
              "cat01": "E3203",
              "unit": "ｍ2",
              "sourceId": "e09"
            },
            {
              "statId": "0000010105/E3204/千ｍ2/e10/中学校屋外運動場面積（公立）",
              "label": "中学校屋外運動場面積（公立）",
              "cat01": "E3204",
              "unit": "千ｍ2",
              "sourceId": "e10"
            },
            {
              "statId": "0000010105/E3205/ｍ2/e11/中学校屋内運動場面積（公立）",
              "label": "中学校屋内運動場面積（公立）",
              "cat01": "E3205",
              "unit": "ｍ2",
              "sourceId": "e11"
            },
            {
              "statId": "0000010105/E3206/校/e11/中学校屋内運動場保有校数（公立）",
              "label": "中学校屋内運動場保有校数（公立）",
              "cat01": "E3206",
              "unit": "校",
              "sourceId": "e11"
            },
            {
              "statId": "0000010105/E3207/校/e11/中学校プール保有校数（公立）",
              "label": "中学校プール保有校数（公立）",
              "cat01": "E3207",
              "unit": "校",
              "sourceId": "e11"
            },
            {
              "statId": "0000010105/E3301/学級/e12/中学校学級数",
              "label": "中学校学級数",
              "cat01": "E3301",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E330101/学級/e12/中学校学級数（国立）",
              "label": "中学校学級数（国立）",
              "cat01": "E330101",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E330102/学級/e12/中学校学級数（公立）",
              "label": "中学校学級数（公立）",
              "cat01": "E330102",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3301021/学級/e12/中学校学級数（単式学級）（公立）",
              "label": "中学校学級数（単式学級）（公立）",
              "cat01": "E3301021",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3301022/学級/e12/中学校学級数（複式学級）（公立）",
              "label": "中学校学級数（複式学級）（公立）",
              "cat01": "E3301022",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3301023/学級/e12/中学校学級数（特別支援学級）（公立）",
              "label": "中学校学級数（特別支援学級）（公立）",
              "cat01": "E3301023",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E330103/学級/e12/中学校学級数（私立）",
              "label": "中学校学級数（私立）",
              "cat01": "E330103",
              "unit": "学級",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3401/人/e12/中学校教員数",
              "label": "中学校教員数",
              "cat01": "E3401",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E340101/人/e12/中学校教員数（男）",
              "label": "中学校教員数（男）",
              "cat01": "E340101",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E340102/人/e12/中学校教員数（女）",
              "label": "中学校教員数（女）",
              "cat01": "E340102",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3402/人/e12/中学校教員数（養護教諭・養護助教諭）",
              "label": "中学校教員数（養護教諭・養護助教諭）",
              "cat01": "E3402",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E340201/人/e12/中学校教員数（養護教諭・養護助教諭）（男）",
              "label": "中学校教員数（養護教諭・養護助教諭）（男）",
              "cat01": "E340201",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E340202/人/e12/中学校教員数（養護教諭・養護助教諭）（女）",
              "label": "中学校教員数（養護教諭・養護助教諭）（女）",
              "cat01": "E340202",
              "unit": "人",
              "sourceId": "e12"
            },
            {
              "statId": "0000010105/E3501/人/e13/中学校生徒数",
              "label": "中学校生徒数",
              "cat01": "E3501",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350101/人/e13/中学校生徒数（公立）",
              "label": "中学校生徒数（公立）",
              "cat01": "E350101",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3501011/人/e13/中学校生徒数（単式学級）（公立）",
              "label": "中学校生徒数（単式学級）（公立）",
              "cat01": "E3501011",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3501012/人/e13/中学校生徒数（複式学級）（公立）",
              "label": "中学校生徒数（複式学級）（公立）",
              "cat01": "E3501012",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3501013/人/e13/中学校生徒数（特別支援学級）（公立）",
              "label": "中学校生徒数（特別支援学級）（公立）",
              "cat01": "E3501013",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3501014/人/e13/中学校生徒数（公立）（男）",
              "label": "中学校生徒数（公立）（男）",
              "cat01": "E3501014",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3501015/人/e13/中学校生徒数（公立）（女）",
              "label": "中学校生徒数（公立）（女）",
              "cat01": "E3501015",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350102/人/e13/中学校生徒数（男）",
              "label": "中学校生徒数（男）",
              "cat01": "E350102",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350103/人/e13/中学校生徒数（女）",
              "label": "中学校生徒数（女）",
              "cat01": "E350103",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350201/人/e13/中学校就学免除者数",
              "label": "中学校就学免除者数",
              "cat01": "E350201",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350202/人/e13/中学校就学猶予者数",
              "label": "中学校就学猶予者数",
              "cat01": "E350202",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3505/人/e13/中学校長期欠席生徒数（年度間３０日以上）",
              "label": "中学校長期欠席生徒数（年度間３０日以上）",
              "cat01": "E3505",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350501/人/e13/中学校長期欠席生徒数（病気）（年度間３０日以上）",
              "label": "中学校長期欠席生徒数（病気）（年度間３０日以上）",
              "cat01": "E350501",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E350502/人/e13/中学校長期欠席生徒数（不登校）（年度間３０日以上）",
              "label": "中学校長期欠席生徒数（不登校）（年度間３０日以上）",
              "cat01": "E350502",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3601/人/e13/中学校帰国生徒数",
              "label": "中学校帰国生徒数",
              "cat01": "E3601",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3701/人/e13/中学校卒業者数",
              "label": "中学校卒業者数",
              "cat01": "E3701",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370101/人/e13/中学校卒業者数（男）",
              "label": "中学校卒業者数（男）",
              "cat01": "E370101",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370102/人/e13/中学校卒業者数（女）",
              "label": "中学校卒業者数（女）",
              "cat01": "E370102",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3702/人/e13/中学校卒業者のうち進学者数",
              "label": "中学校卒業者のうち進学者数",
              "cat01": "E3702",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370201/人/e13/中学校卒業者のうち進学者数（男）",
              "label": "中学校卒業者のうち進学者数（男）",
              "cat01": "E370201",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370202/人/e13/中学校卒業者のうち進学者数（女）",
              "label": "中学校卒業者のうち進学者数（女）",
              "cat01": "E370202",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3703/人/e13/中学校卒業者のうち専修学校等入学者数",
              "label": "中学校卒業者のうち専修学校等入学者数",
              "cat01": "E3703",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370301/人/e13/中学校卒業者のうち専修学校等入学者数（男）",
              "label": "中学校卒業者のうち専修学校等入学者数（男）",
              "cat01": "E370301",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370302/人/e13/中学校卒業者のうち専修学校等入学者数（女）",
              "label": "中学校卒業者のうち専修学校等入学者数（女）",
              "cat01": "E370302",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3704/人/e13/中学校卒業者のうち就職者数",
              "label": "中学校卒業者のうち就職者数",
              "cat01": "E3704",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370401/人/e13/中学校卒業者のうち就職者数（男）",
              "label": "中学校卒業者のうち就職者数（男）",
              "cat01": "E370401",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E370402/人/e13/中学校卒業者のうち就職者数（女）",
              "label": "中学校卒業者のうち就職者数（女）",
              "cat01": "E370402",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3801/％/e13/中学生の進学率",
              "label": "中学生の進学率",
              "cat01": "E3801",
              "unit": "％",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E380101/％/e13/中学生の進学率（男）",
              "label": "中学生の進学率（男）",
              "cat01": "E380101",
              "unit": "％",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E380102/％/e13/中学生の進学率（女）",
              "label": "中学生の進学率（女）",
              "cat01": "E380102",
              "unit": "％",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E3802/人/e13/中学校卒業者の進学希望者数",
              "label": "中学校卒業者の進学希望者数",
              "cat01": "E3802",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E380201/人/e13/中学校卒業者の進学希望者数（男）",
              "label": "中学校卒業者の進学希望者数（男）",
              "cat01": "E380201",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E380202/人/e13/中学校卒業者の進学希望者数（女）",
              "label": "中学校卒業者の進学希望者数（女）",
              "cat01": "E380202",
              "unit": "人",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E4101/校/e13/高等学校数",
              "label": "高等学校数",
              "cat01": "E4101",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410101/校/e13/高等学校数（国立）",
              "label": "高等学校数（国立）",
              "cat01": "E410101",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410102/校/e13/高等学校数（公立）",
              "label": "高等学校数（公立）",
              "cat01": "E410102",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410103/校/e13/高等学校数（私立）",
              "label": "高等学校数（私立）",
              "cat01": "E410103",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410201/校/e13/高等学校数（全日制）",
              "label": "高等学校数（全日制）",
              "cat01": "E410201",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410202/校/e13/高等学校数（定時制）",
              "label": "高等学校数（定時制）",
              "cat01": "E410202",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E410203/校/e13/高等学校数（併置）",
              "label": "高等学校数（併置）",
              "cat01": "E410203",
              "unit": "校",
              "sourceId": "e13"
            },
            {
              "statId": "0000010105/E4201/千ｍ2/e14/高等学校校地面積（公立）",
              "label": "高等学校校地面積（公立）",
              "cat01": "E4201",
              "unit": "千ｍ2",
              "sourceId": "e14"
            },
            {
              "statId": "0000010105/E4202/ｍ2/e15/高等学校校舎面積（公立）",
              "label": "高等学校校舎面積（公立）",
              "cat01": "E4202",
              "unit": "ｍ2",
              "sourceId": "e15"
            },
            {
              "statId": "0000010105/E4206/校/e16/高等学校屋内運動場保有校数（公立）",
              "label": "高等学校屋内運動場保有校数（公立）",
              "cat01": "E4206",
              "unit": "校",
              "sourceId": "e16"
            },
            {
              "statId": "0000010105/E4207/校/e17/高等学校プール保有校数（公立）",
              "label": "高等学校プール保有校数（公立）",
              "cat01": "E4207",
              "unit": "校",
              "sourceId": "e17"
            },
            {
              "statId": "0000010105/E4301/学級/e18/高等学校学級数（公立）",
              "label": "高等学校学級数（公立）",
              "cat01": "E4301",
              "unit": "学級",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E4401/人/e18/高等学校教員数",
              "label": "高等学校教員数",
              "cat01": "E4401",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E440101/人/e18/高等学校教員数（男）",
              "label": "高等学校教員数（男）",
              "cat01": "E440101",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E440102/人/e18/高等学校教員数（女）",
              "label": "高等学校教員数（女）",
              "cat01": "E440102",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E4402/人/e18/高等学校教員数（養護教諭・養護助教諭）",
              "label": "高等学校教員数（養護教諭・養護助教諭）",
              "cat01": "E4402",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E440201/人/e18/高等学校教員数（養護教諭・養護助教諭）（男）",
              "label": "高等学校教員数（養護教諭・養護助教諭）（男）",
              "cat01": "E440201",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E440202/人/e18/高等学校教員数（養護教諭・養護助教諭）（女）",
              "label": "高等学校教員数（養護教諭・養護助教諭）（女）",
              "cat01": "E440202",
              "unit": "人",
              "sourceId": "e18"
            },
            {
              "statId": "0000010105/E4501/人/e19/高等学校生徒数",
              "label": "高等学校生徒数",
              "cat01": "E4501",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450101/人/e19/高等学校生徒数（男）",
              "label": "高等学校生徒数（男）",
              "cat01": "E450101",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450102/人/e19/高等学校生徒数（女）",
              "label": "高等学校生徒数（女）",
              "cat01": "E450102",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450110/人/e19/高等学校生徒数（全日制）",
              "label": "高等学校生徒数（全日制）",
              "cat01": "E450110",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450111/人/e19/高等学校生徒数（全日制）（男）",
              "label": "高等学校生徒数（全日制）（男）",
              "cat01": "E450111",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450112/人/e19/高等学校生徒数（全日制）（女）",
              "label": "高等学校生徒数（全日制）（女）",
              "cat01": "E450112",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450120/人/e19/高等学校生徒数（定時制）",
              "label": "高等学校生徒数（定時制）",
              "cat01": "E450120",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450121/人/e19/高等学校生徒数（定時制）（男）",
              "label": "高等学校生徒数（定時制）（男）",
              "cat01": "E450121",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E450122/人/e19/高等学校生徒数（定時制）（女）",
              "label": "高等学校生徒数（定時制）（女）",
              "cat01": "E450122",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4511/人/e19/高等学校生徒数（国立）",
              "label": "高等学校生徒数（国立）",
              "cat01": "E4511",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451101/人/e19/高等学校生徒数（国立）（男）",
              "label": "高等学校生徒数（国立）（男）",
              "cat01": "E451101",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451102/人/e19/高等学校生徒数（国立）（女）",
              "label": "高等学校生徒数（国立）（女）",
              "cat01": "E451102",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4512/人/e19/高等学校生徒数（公立）",
              "label": "高等学校生徒数（公立）",
              "cat01": "E4512",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451201/人/e19/高等学校生徒数（公立）（男）",
              "label": "高等学校生徒数（公立）（男）",
              "cat01": "E451201",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451202/人/e19/高等学校生徒数（公立）（女）",
              "label": "高等学校生徒数（公立）（女）",
              "cat01": "E451202",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4513/人/e19/高等学校生徒数（私立）",
              "label": "高等学校生徒数（私立）",
              "cat01": "E4513",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451301/人/e19/高等学校生徒数（私立）（男）",
              "label": "高等学校生徒数（私立）（男）",
              "cat01": "E451301",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E451302/人/e19/高等学校生徒数（私立）（女）",
              "label": "高等学校生徒数（私立）（女）",
              "cat01": "E451302",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4520/人/e19/高等学校生徒数（通信制）",
              "label": "高等学校生徒数（通信制）",
              "cat01": "E4520",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E452001/人/e19/高等学校生徒数（通信制）（男）",
              "label": "高等学校生徒数（通信制）（男）",
              "cat01": "E452001",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E452002/人/e19/高等学校生徒数（通信制）（女）",
              "label": "高等学校生徒数（通信制）（女）",
              "cat01": "E452002",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4601/人/e19/高等学校卒業者数",
              "label": "高等学校卒業者数",
              "cat01": "E4601",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460101/人/e19/高等学校卒業者数（男）",
              "label": "高等学校卒業者数（男）",
              "cat01": "E460101",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460102/人/e19/高等学校卒業者数（女）",
              "label": "高等学校卒業者数（女）",
              "cat01": "E460102",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4602/人/e19/高等学校卒業者のうち進学者数",
              "label": "高等学校卒業者のうち進学者数",
              "cat01": "E4602",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460201/人/e19/高等学校卒業者のうち進学者数（男）",
              "label": "高等学校卒業者のうち進学者数（男）",
              "cat01": "E460201",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460202/人/e19/高等学校卒業者のうち進学者数（女）",
              "label": "高等学校卒業者のうち進学者数（女）",
              "cat01": "E460202",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460210/人/e19/高等学校卒業者のうち短期大学進学者数",
              "label": "高等学校卒業者のうち短期大学進学者数",
              "cat01": "E460210",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460220/人/e19/高等学校卒業者のうち大学進学者数",
              "label": "高等学校卒業者のうち大学進学者数",
              "cat01": "E460220",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4603/人/e19/高等学校卒業者のうち専修学校等入学者数",
              "label": "高等学校卒業者のうち専修学校等入学者数",
              "cat01": "E4603",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460301/人/e19/高等学校卒業者のうち専修学校等入学者数（男）",
              "label": "高等学校卒業者のうち専修学校等入学者数（男）",
              "cat01": "E460301",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460302/人/e19/高等学校卒業者のうち専修学校等入学者数（女）",
              "label": "高等学校卒業者のうち専修学校等入学者数（女）",
              "cat01": "E460302",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4604/人/e19/高等学校卒業者のうち就職者数",
              "label": "高等学校卒業者のうち就職者数",
              "cat01": "E4604",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460401/人/e19/高等学校卒業者のうち就職者数（男）",
              "label": "高等学校卒業者のうち就職者数（男）",
              "cat01": "E460401",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460402/人/e19/高等学校卒業者のうち就職者数（女）",
              "label": "高等学校卒業者のうち就職者数（女）",
              "cat01": "E460402",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460410/人/e19/高等学校卒業者の就職者のうち県内就職者数",
              "label": "高等学校卒業者の就職者のうち県内就職者数",
              "cat01": "E460410",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460411/人/e19/高等学校卒業者の就職者のうち県内就職者数（男）",
              "label": "高等学校卒業者の就職者のうち県内就職者数（男）",
              "cat01": "E460411",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460412/人/e19/高等学校卒業者の就職者のうち県内就職者数（女）",
              "label": "高等学校卒業者の就職者のうち県内就職者数（女）",
              "cat01": "E460412",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4605/人/e19/高等学校卒業者のうち進路未定者数",
              "label": "高等学校卒業者のうち進路未定者数",
              "cat01": "E4605",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460501/人/e19/高等学校卒業者のうち進路未定者数（男）",
              "label": "高等学校卒業者のうち進路未定者数（男）",
              "cat01": "E460501",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E460502/人/e19/高等学校卒業者のうち進路未定者数（女）",
              "label": "高等学校卒業者のうち進路未定者数（女）",
              "cat01": "E460502",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4701/％/e19/高校生の進学率",
              "label": "高校生の進学率",
              "cat01": "E4701",
              "unit": "％",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470101/％/e19/高校生の進学率（男）",
              "label": "高校生の進学率（男）",
              "cat01": "E470101",
              "unit": "％",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470102/％/e19/高校生の進学率（女）",
              "label": "高校生の進学率（女）",
              "cat01": "E470102",
              "unit": "％",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470201/人/e19/当該県の高校出身者で当該県の大学入学者数",
              "label": "当該県の高校出身者で当該県の大学入学者数",
              "cat01": "E470201",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470202/人/e19/当該県の高校出身者で他県の大学入学者数",
              "label": "当該県の高校出身者で他県の大学入学者数",
              "cat01": "E470202",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470203/人/e19/当該県の高校出身者で当該県の短期大学入学者数",
              "label": "当該県の高校出身者で当該県の短期大学入学者数",
              "cat01": "E470203",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470204/人/e19/当該県の高校出身者で他県の短期大学入学者数",
              "label": "当該県の高校出身者で他県の短期大学入学者数",
              "cat01": "E470204",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470205/人/e19/当該県の高校出身者である大学入学者数",
              "label": "当該県の高校出身者である大学入学者数",
              "cat01": "E470205",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470206/人/e19/当該県の高校出身者である短期大学入学者数",
              "label": "当該県の高校出身者である短期大学入学者数",
              "cat01": "E470206",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4703/人/e19/高等学校卒業者の進学希望者数（新規高卒者）",
              "label": "高等学校卒業者の進学希望者数（新規高卒者）",
              "cat01": "E4703",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470301/人/e19/高等学校卒業者の進学希望者数（新規高卒者）（男）",
              "label": "高等学校卒業者の進学希望者数（新規高卒者）（男）",
              "cat01": "E470301",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E470302/人/e19/高等学校卒業者の進学希望者数（新規高卒者）（女）",
              "label": "高等学校卒業者の進学希望者数（新規高卒者）（女）",
              "cat01": "E470302",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4801/校/e19/中等教育学校数",
              "label": "中等教育学校数",
              "cat01": "E4801",
              "unit": "校",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4802/学級/e19/中等教育学校前期課程学級数（公立）",
              "label": "中等教育学校前期課程学級数（公立）",
              "cat01": "E4802",
              "unit": "学級",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4803/学級/e19/中等教育学校後期課程学級数（公立）",
              "label": "中等教育学校後期課程学級数（公立）",
              "cat01": "E4803",
              "unit": "学級",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4804/人/e19/中等教育学校教員数",
              "label": "中等教育学校教員数",
              "cat01": "E4804",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4805/人/e19/中等教育学校前期課程生徒数",
              "label": "中等教育学校前期課程生徒数",
              "cat01": "E4805",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4806/人/e19/中等教育学校後期課程生徒数",
              "label": "中等教育学校後期課程生徒数",
              "cat01": "E4806",
              "unit": "人",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E4807/％/e19/中等教育学校後期課程生の進学率",
              "label": "中等教育学校後期課程生の進学率",
              "cat01": "E4807",
              "unit": "％",
              "sourceId": "e19"
            },
            {
              "statId": "0000010105/E5501/人/e20/特別支援学校数",
              "label": "特別支援学校数",
              "cat01": "E5501",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E550101/校/e20/特別支援学校数（公立）",
              "label": "特別支援学校数（公立）",
              "cat01": "E550101",
              "unit": "校",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5601/人/e20/特別支援学校学級数（公立）",
              "label": "特別支援学校学級数（公立）",
              "cat01": "E5601",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E560101/人/e20/特別支援学校学級数（幼稚部）（公立）",
              "label": "特別支援学校学級数（幼稚部）（公立）",
              "cat01": "E560101",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E560102/人/e20/特別支援学校学級数（小学部）（公立）",
              "label": "特別支援学校学級数（小学部）（公立）",
              "cat01": "E560102",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E560103/人/e20/特別支援学校学級数（中学部）（公立）",
              "label": "特別支援学校学級数（中学部）（公立）",
              "cat01": "E560103",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E560104/人/e20/特別支援学校学級数（高等部）（公立）",
              "label": "特別支援学校学級数（高等部）（公立）",
              "cat01": "E560104",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5701/人/e20/特別支援学校教員数（公立）",
              "label": "特別支援学校教員数（公立）",
              "cat01": "E5701",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E570101/人/e20/特別支援学校教員数（男）（公立）",
              "label": "特別支援学校教員数（男）（公立）",
              "cat01": "E570101",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E570102/人/e20/特別支援学校教員数（女）（公立）",
              "label": "特別支援学校教員数（女）（公立）",
              "cat01": "E570102",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5702/人/e20/視覚障害担当教員数（公立）",
              "label": "視覚障害担当教員数（公立）",
              "cat01": "E5702",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5703/人/e20/聴覚障害担当教員数（公立）",
              "label": "聴覚障害担当教員数（公立）",
              "cat01": "E5703",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5704/人/e20/知的障害担当教員数（公立）",
              "label": "知的障害担当教員数（公立）",
              "cat01": "E5704",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5705/人/e20/肢体不自由担当教員数（公立）",
              "label": "肢体不自由担当教員数（公立）",
              "cat01": "E5705",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5706/人/e20/病弱・身体虚弱担当教員数（公立）",
              "label": "病弱・身体虚弱担当教員数（公立）",
              "cat01": "E5706",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E5801/人/e20/特別支援学校生徒数（公立）",
              "label": "特別支援学校生徒数（公立）",
              "cat01": "E5801",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E580101/人/e20/特別支援学校生徒数（幼稚部）（公立）",
              "label": "特別支援学校生徒数（幼稚部）（公立）",
              "cat01": "E580101",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E580102/人/e20/特別支援学校生徒数（小学部）（公立）",
              "label": "特別支援学校生徒数（小学部）（公立）",
              "cat01": "E580102",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E580103/人/e20/特別支援学校生徒数（中学部）（公立）",
              "label": "特別支援学校生徒数（中学部）（公立）",
              "cat01": "E580103",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E580104/人/e20/特別支援学校生徒数（高等部）（公立）",
              "label": "特別支援学校生徒数（高等部）（公立）",
              "cat01": "E580104",
              "unit": "人",
              "sourceId": "e20"
            },
            {
              "statId": "0000010105/E6101/校/e22/短期大学数",
              "label": "短期大学数",
              "cat01": "E6101",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610101/校/e22/短期大学数（国立）",
              "label": "短期大学数（国立）",
              "cat01": "E610101",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610102/校/e22/短期大学数（公立）",
              "label": "短期大学数（公立）",
              "cat01": "E610102",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610103/校/e22/短期大学数（私立）",
              "label": "短期大学数（私立）",
              "cat01": "E610103",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6102/校/e22/大学数",
              "label": "大学数",
              "cat01": "E6102",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610201/校/e22/大学数（国立）",
              "label": "大学数（国立）",
              "cat01": "E610201",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610202/校/e22/大学数（公立）",
              "label": "大学数（公立）",
              "cat01": "E610202",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E610203/校/e22/大学数（私立）",
              "label": "大学数（私立）",
              "cat01": "E610203",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6201/人/e22/短期大学教員数",
              "label": "短期大学教員数",
              "cat01": "E6201",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620101/人/e22/短期大学教員数（男）",
              "label": "短期大学教員数（男）",
              "cat01": "E620101",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620102/人/e22/短期大学教員数（女）",
              "label": "短期大学教員数（女）",
              "cat01": "E620102",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620110/人/e22/短期大学教員数（国立）",
              "label": "短期大学教員数（国立）",
              "cat01": "E620110",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620120/人/e22/短期大学教員数（公立）",
              "label": "短期大学教員数（公立）",
              "cat01": "E620120",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620130/人/e22/短期大学教員数（私立）",
              "label": "短期大学教員数（私立）",
              "cat01": "E620130",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6202/人/e22/大学教員数",
              "label": "大学教員数",
              "cat01": "E6202",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620201/人/e22/大学教員数（男）",
              "label": "大学教員数（男）",
              "cat01": "E620201",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620202/人/e22/大学教員数（女）",
              "label": "大学教員数（女）",
              "cat01": "E620202",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620210/人/e22/大学教員数（国立）",
              "label": "大学教員数（国立）",
              "cat01": "E620210",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620220/人/e22/大学教員数（公立）",
              "label": "大学教員数（公立）",
              "cat01": "E620220",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E620230/人/e22/大学教員数（私立）",
              "label": "大学教員数（私立）",
              "cat01": "E620230",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6301/人/e22/短期大学学生数",
              "label": "短期大学学生数",
              "cat01": "E6301",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630101/人/e22/短期大学学生数（男）",
              "label": "短期大学学生数（男）",
              "cat01": "E630101",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630102/人/e22/短期大学学生数（女）",
              "label": "短期大学学生数（女）",
              "cat01": "E630102",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630110/人/e22/短期大学学生数（国立）",
              "label": "短期大学学生数（国立）",
              "cat01": "E630110",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630111/人/e22/短期大学学生数（国立）（男）",
              "label": "短期大学学生数（国立）（男）",
              "cat01": "E630111",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630112/人/e22/短期大学学生数（国立）（女）",
              "label": "短期大学学生数（国立）（女）",
              "cat01": "E630112",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630120/人/e22/短期大学学生数（公立）",
              "label": "短期大学学生数（公立）",
              "cat01": "E630120",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630121/人/e22/短期大学学生数（公立）（男）",
              "label": "短期大学学生数（公立）（男）",
              "cat01": "E630121",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630122/人/e22/短期大学学生数（公立）（女）",
              "label": "短期大学学生数（公立）（女）",
              "cat01": "E630122",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630130/人/e22/短期大学学生数（私立）",
              "label": "短期大学学生数（私立）",
              "cat01": "E630130",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630131/人/e22/短期大学学生数（私立）（男）",
              "label": "短期大学学生数（私立）（男）",
              "cat01": "E630131",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630132/人/e22/短期大学学生数（私立）（女）",
              "label": "短期大学学生数（私立）（女）",
              "cat01": "E630132",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6302/人/e22/大学学生数",
              "label": "大学学生数",
              "cat01": "E6302",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630201/人/e22/大学学生数（男）",
              "label": "大学学生数（男）",
              "cat01": "E630201",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630202/人/e22/大学学生数（女）",
              "label": "大学学生数（女）",
              "cat01": "E630202",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630210/人/e22/大学学生数（国立）",
              "label": "大学学生数（国立）",
              "cat01": "E630210",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630211/人/e22/大学学生数（国立）（男）",
              "label": "大学学生数（国立）（男）",
              "cat01": "E630211",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630212/人/e22/大学学生数（国立）（女）",
              "label": "大学学生数（国立）（女）",
              "cat01": "E630212",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630220/人/e22/大学学生数（公立）",
              "label": "大学学生数（公立）",
              "cat01": "E630220",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630221/人/e22/大学学生数（公立）（男）",
              "label": "大学学生数（公立）（男）",
              "cat01": "E630221",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630222/人/e22/大学学生数（公立）（女）",
              "label": "大学学生数（公立）（女）",
              "cat01": "E630222",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630230/人/e22/大学学生数（私立）",
              "label": "大学学生数（私立）",
              "cat01": "E630230",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630231/人/e22/大学学生数（私立）（男）",
              "label": "大学学生数（私立）（男）",
              "cat01": "E630231",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E630232/人/e22/大学学生数（私立）（女）",
              "label": "大学学生数（私立）（女）",
              "cat01": "E630232",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6401/人/e22/短期大学・大学入学者数",
              "label": "短期大学・大学入学者数",
              "cat01": "E6401",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640101/人/e22/短期大学・大学入学者数（男）",
              "label": "短期大学・大学入学者数（男）",
              "cat01": "E640101",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640102/人/e22/短期大学・大学入学者数（女）",
              "label": "短期大学・大学入学者数（女）",
              "cat01": "E640102",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6402/人/e22/短期大学入学者数",
              "label": "短期大学入学者数",
              "cat01": "E6402",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640201/人/e22/短期大学入学者数（男）",
              "label": "短期大学入学者数（男）",
              "cat01": "E640201",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640202/人/e22/短期大学入学者数（女）",
              "label": "短期大学入学者数（女）",
              "cat01": "E640202",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6403/人/e22/大学入学者数",
              "label": "大学入学者数",
              "cat01": "E6403",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640301/人/e22/大学入学者数（男）",
              "label": "大学入学者数（男）",
              "cat01": "E640301",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E640302/人/e22/大学入学者数（女）",
              "label": "大学入学者数（女）",
              "cat01": "E640302",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6501/人/e22/短期大学卒業者数",
              "label": "短期大学卒業者数",
              "cat01": "E6501",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650101/人/e22/短期大学卒業者数（男）",
              "label": "短期大学卒業者数（男）",
              "cat01": "E650101",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650102/人/e22/短期大学卒業者数（女）",
              "label": "短期大学卒業者数（女）",
              "cat01": "E650102",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650110/人/e22/短期大学卒業者のうち進学者数",
              "label": "短期大学卒業者のうち進学者数",
              "cat01": "E650110",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650111/人/e22/短期大学卒業者のうち進学者数（男）",
              "label": "短期大学卒業者のうち進学者数（男）",
              "cat01": "E650111",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650112/人/e22/短期大学卒業者のうち進学者数（女）",
              "label": "短期大学卒業者のうち進学者数（女）",
              "cat01": "E650112",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650120/人/e22/短期大学卒業者のうち就職者数",
              "label": "短期大学卒業者のうち就職者数",
              "cat01": "E650120",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650121/人/e22/短期大学卒業者のうち就職者数（男）",
              "label": "短期大学卒業者のうち就職者数（男）",
              "cat01": "E650121",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650122/人/e22/短期大学卒業者のうち就職者数（女）",
              "label": "短期大学卒業者のうち就職者数（女）",
              "cat01": "E650122",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650130/人/e22/短期大学卒業者のうち進路未定者数",
              "label": "短期大学卒業者のうち進路未定者数",
              "cat01": "E650130",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650131/人/e22/短期大学卒業者のうち進路未定者数（男）",
              "label": "短期大学卒業者のうち進路未定者数（男）",
              "cat01": "E650131",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650132/人/e22/短期大学卒業者のうち進路未定者数（女）",
              "label": "短期大学卒業者のうち進路未定者数（女）",
              "cat01": "E650132",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E6502/人/e22/大学卒業者数",
              "label": "大学卒業者数",
              "cat01": "E6502",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650201/人/e22/大学卒業者数（男）",
              "label": "大学卒業者数（男）",
              "cat01": "E650201",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650202/人/e22/大学卒業者数（女）",
              "label": "大学卒業者数（女）",
              "cat01": "E650202",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650210/人/e22/大学卒業者のうち進学者数",
              "label": "大学卒業者のうち進学者数",
              "cat01": "E650210",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650211/人/e22/大学卒業者のうち進学者数（男）",
              "label": "大学卒業者のうち進学者数（男）",
              "cat01": "E650211",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650212/人/e22/大学卒業者のうち進学者数（女）",
              "label": "大学卒業者のうち進学者数（女）",
              "cat01": "E650212",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650220/人/e22/大学卒業者のうち就職者数",
              "label": "大学卒業者のうち就職者数",
              "cat01": "E650220",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650221/人/e22/大学卒業者のうち就職者数（男）",
              "label": "大学卒業者のうち就職者数（男）",
              "cat01": "E650221",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650222/人/e22/大学卒業者のうち就職者数（女）",
              "label": "大学卒業者のうち就職者数（女）",
              "cat01": "E650222",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650230/人/e22/大学卒業者のうち進路未定者数",
              "label": "大学卒業者のうち進路未定者数",
              "cat01": "E650230",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650231/人/e22/大学卒業者のうち進路未定者数（男）",
              "label": "大学卒業者のうち進路未定者数（男）",
              "cat01": "E650231",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E650232/人/e22/大学卒業者のうち進路未定者数（女）",
              "label": "大学卒業者のうち進路未定者数（女）",
              "cat01": "E650232",
              "unit": "人",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E7101/校/e22/専修学校数",
              "label": "専修学校数",
              "cat01": "E7101",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E7102/校/e22/各種学校数",
              "label": "各種学校数",
              "cat01": "E7102",
              "unit": "校",
              "sourceId": "e22"
            },
            {
              "statId": "0000010105/E7201/人/e23/専修学校生徒数",
              "label": "専修学校生徒数",
              "cat01": "E7201",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720101/人/e23/専修学校生徒数（工業関係）",
              "label": "専修学校生徒数（工業関係）",
              "cat01": "E720101",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720102/人/e23/専修学校生徒数（農業関係）",
              "label": "専修学校生徒数（農業関係）",
              "cat01": "E720102",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720103/人/e23/専修学校生徒数（医療関係）",
              "label": "専修学校生徒数（医療関係）",
              "cat01": "E720103",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720104/人/e23/専修学校生徒数（衛生関係）",
              "label": "専修学校生徒数（衛生関係）",
              "cat01": "E720104",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720105/人/e23/専修学校生徒数（教育・社会福祉関係）",
              "label": "専修学校生徒数（教育・社会福祉関係）",
              "cat01": "E720105",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720106/人/e23/専修学校生徒数（商業実務関係）",
              "label": "専修学校生徒数（商業実務関係）",
              "cat01": "E720106",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720107/人/e23/専修学校生徒数（服飾・家政関係）",
              "label": "専修学校生徒数（服飾・家政関係）",
              "cat01": "E720107",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720108/人/e23/専修学校生徒数（文化・教養関係）",
              "label": "専修学校生徒数（文化・教養関係）",
              "cat01": "E720108",
              "unit": "人",
              "sourceId": "e23"
            },
            {
              "statId": "0000010105/E720110/人/e24/専修学校生徒数（高等課程）",
              "label": "専修学校生徒数（高等課程）",
              "cat01": "E720110",
              "unit": "人",
              "sourceId": "e24"
            },
            {
              "statId": "0000010105/E720111/人/e24/専修学校生徒数（専門課程）",
              "label": "専修学校生徒数（専門課程）",
              "cat01": "E720111",
              "unit": "人",
              "sourceId": "e24"
            },
            {
              "statId": "0000010105/E720112/人/e24/専修学校生徒数（一般課程）",
              "label": "専修学校生徒数（一般課程）",
              "cat01": "E720112",
              "unit": "人",
              "sourceId": "e24"
            },
            {
              "statId": "0000010105/E7202/人/e24/各種学校生徒数",
              "label": "各種学校生徒数",
              "cat01": "E7202",
              "unit": "人",
              "sourceId": "e24"
            },
            {
              "statId": "0000010105/E720201/人/e25/各種学校生徒数（工業関係）",
              "label": "各種学校生徒数（工業関係）",
              "cat01": "E720201",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720202/人/e25/各種学校生徒数（農業関係）",
              "label": "各種学校生徒数（農業関係）",
              "cat01": "E720202",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720203/人/e25/各種学校生徒数（医療関係）",
              "label": "各種学校生徒数（医療関係）",
              "cat01": "E720203",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720204/人/e25/各種学校生徒数（衛生関係）",
              "label": "各種学校生徒数（衛生関係）",
              "cat01": "E720204",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720205/人/e25/各種学校生徒数（教育・社会福祉関係）",
              "label": "各種学校生徒数（教育・社会福祉関係）",
              "cat01": "E720205",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720206/人/e25/各種学校生徒数（商業実務関係）",
              "label": "各種学校生徒数（商業実務関係）",
              "cat01": "E720206",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720207/人/e25/各種学校生徒数（家政関係）",
              "label": "各種学校生徒数（家政関係）",
              "cat01": "E720207",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E720208/人/e25/各種学校生徒数（文化・教養関係）",
              "label": "各種学校生徒数（文化・教養関係）",
              "cat01": "E720208",
              "unit": "人",
              "sourceId": "e25"
            },
            {
              "statId": "0000010105/E8101/円/e26/在学者１人当たり学校教育費（幼稚園）",
              "label": "在学者１人当たり学校教育費（幼稚園）",
              "cat01": "E8101",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E810101/円/e26/在学者１人当たり学校教育費（幼保連携型認定こども園）",
              "label": "在学者１人当たり学校教育費（幼保連携型認定こども園）",
              "cat01": "E810101",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8102/円/e26/在学者１人当たり学校教育費（小学校）",
              "label": "在学者１人当たり学校教育費（小学校）",
              "cat01": "E8102",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8103/円/e26/在学者１人当たり学校教育費（中学校）",
              "label": "在学者１人当たり学校教育費（中学校）",
              "cat01": "E8103",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8104/円/e26/在学者１人当たり学校教育費（高等学校・全日制）",
              "label": "在学者１人当たり学校教育費（高等学校・全日制）",
              "cat01": "E8104",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8105/円/e26/在学者１人当たり学校教育費（高等学校・定時制）",
              "label": "在学者１人当たり学校教育費（高等学校・定時制）",
              "cat01": "E8105",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8106/円/e26/在学者１人当たり学校教育費（特別支援学校）",
              "label": "在学者１人当たり学校教育費（特別支援学校）",
              "cat01": "E8106",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8107/円/e26/在学者１人当たり学校教育費（高等学校・通信制）",
              "label": "在学者１人当たり学校教育費（高等学校・通信制）",
              "cat01": "E8107",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8108/円/e26/在学者１人当たり学校教育費（専修学校）",
              "label": "在学者１人当たり学校教育費（専修学校）",
              "cat01": "E8108",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8109/円/e26/在学者１人当たり学校教育費（各種学校）",
              "label": "在学者１人当たり学校教育費（各種学校）",
              "cat01": "E8109",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E8110/円/e26/在学者１人当たり学校教育費（高等専門学校）",
              "label": "在学者１人当たり学校教育費（高等専門学校）",
              "cat01": "E8110",
              "unit": "円",
              "sourceId": "e26"
            },
            {
              "statId": "0000010105/E9101/人/e27/最終学歴人口（卒業者総数）",
              "label": "最終学歴人口（卒業者総数）",
              "cat01": "E9101",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910101/人/e27/最終学歴人口（卒業者総数）（男）",
              "label": "最終学歴人口（卒業者総数）（男）",
              "cat01": "E910101",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910102/人/e27/最終学歴人口（卒業者総数）（女）",
              "label": "最終学歴人口（卒業者総数）（女）",
              "cat01": "E910102",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910110/人/e27/最終学歴人口（卒業者総数）（１５～１９歳）",
              "label": "最終学歴人口（卒業者総数）（１５～１９歳）",
              "cat01": "E910110",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910111/人/e27/最終学歴人口（卒業者総数）（１５～１９歳）（男）",
              "label": "最終学歴人口（卒業者総数）（１５～１９歳）（男）",
              "cat01": "E910111",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910112/人/e27/最終学歴人口（卒業者総数）（１５～１９歳）（女）",
              "label": "最終学歴人口（卒業者総数）（１５～１９歳）（女）",
              "cat01": "E910112",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910120/人/e27/最終学歴人口（卒業者総数）（２０～２９歳）",
              "label": "最終学歴人口（卒業者総数）（２０～２９歳）",
              "cat01": "E910120",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910121/人/e27/最終学歴人口（卒業者総数）（２０～２９歳）（男）",
              "label": "最終学歴人口（卒業者総数）（２０～２９歳）（男）",
              "cat01": "E910121",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910122/人/e27/最終学歴人口（卒業者総数）（２０～２９歳）（女）",
              "label": "最終学歴人口（卒業者総数）（２０～２９歳）（女）",
              "cat01": "E910122",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910130/人/e27/最終学歴人口（卒業者総数）（３０～３９歳）",
              "label": "最終学歴人口（卒業者総数）（３０～３９歳）",
              "cat01": "E910130",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910131/人/e27/最終学歴人口（卒業者総数）（３０～３９歳）（男）",
              "label": "最終学歴人口（卒業者総数）（３０～３９歳）（男）",
              "cat01": "E910131",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910133/人/e27/最終学歴人口（卒業者総数）（３０～３９歳）（女）",
              "label": "最終学歴人口（卒業者総数）（３０～３９歳）（女）",
              "cat01": "E910133",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910140/人/e27/最終学歴人口（卒業者総数）（４０～４９歳）",
              "label": "最終学歴人口（卒業者総数）（４０～４９歳）",
              "cat01": "E910140",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910141/人/e27/最終学歴人口（卒業者総数）（４０～４９歳）（男）",
              "label": "最終学歴人口（卒業者総数）（４０～４９歳）（男）",
              "cat01": "E910141",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910142/人/e27/最終学歴人口（卒業者総数）（４０～４９歳）（女）",
              "label": "最終学歴人口（卒業者総数）（４０～４９歳）（女）",
              "cat01": "E910142",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910150/人/e27/最終学歴人口（卒業者総数）（５０～５９歳）",
              "label": "最終学歴人口（卒業者総数）（５０～５９歳）",
              "cat01": "E910150",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910151/人/e27/最終学歴人口（卒業者総数）（５０～５９歳）（男）",
              "label": "最終学歴人口（卒業者総数）（５０～５９歳）（男）",
              "cat01": "E910151",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910153/人/e27/最終学歴人口（卒業者総数）（５０～５９歳）（女）",
              "label": "最終学歴人口（卒業者総数）（５０～５９歳）（女）",
              "cat01": "E910153",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910160/人/e27/最終学歴人口（卒業者総数）（６０歳以上）",
              "label": "最終学歴人口（卒業者総数）（６０歳以上）",
              "cat01": "E910160",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910161/人/e27/最終学歴人口（卒業者総数）（６０歳以上）（男）",
              "label": "最終学歴人口（卒業者総数）（６０歳以上）（男）",
              "cat01": "E910161",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910162/人/e27/最終学歴人口（卒業者総数）（６０歳以上）（女）",
              "label": "最終学歴人口（卒業者総数）（６０歳以上）（女）",
              "cat01": "E910162",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9102/人/e27/最終学歴人口（小学校・中学校）",
              "label": "最終学歴人口（小学校・中学校）",
              "cat01": "E9102",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910201/人/e27/最終学歴人口（小学校・中学校・高小）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（男）",
              "cat01": "E910201",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910202/人/e27/最終学歴人口（小学校・中学校・高小）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（女）",
              "cat01": "E910202",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910210/人/e27/最終学歴人口（小学校・中学校・高小）（１５～１９歳）",
              "label": "最終学歴人口（小学校・中学校・高小）（１５～１９歳）",
              "cat01": "E910210",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910211/人/e27/最終学歴人口（小学校・中学校・高小）（１５～１９歳）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（１５～１９歳）（男）",
              "cat01": "E910211",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910212/人/e27/最終学歴人口（小学校・中学校・高小）（１５～１９歳）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（１５～１９歳）（女）",
              "cat01": "E910212",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910220/人/e27/最終学歴人口（小学校・中学校・高小）（２０～２９歳）",
              "label": "最終学歴人口（小学校・中学校・高小）（２０～２９歳）",
              "cat01": "E910220",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910221/人/e27/最終学歴人口（小学校・中学校・高小）（２０～２９歳）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（２０～２９歳）（男）",
              "cat01": "E910221",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910222/人/e27/最終学歴人口（小学校・中学校・高小）（２０～２９歳）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（２０～２９歳）（女）",
              "cat01": "E910222",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910230/人/e27/最終学歴人口（小学校・中学校・高小）（３０～３９歳）",
              "label": "最終学歴人口（小学校・中学校・高小）（３０～３９歳）",
              "cat01": "E910230",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910231/人/e27/最終学歴人口（小学校・中学校・高小）（３０～３９歳）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（３０～３９歳）（男）",
              "cat01": "E910231",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910233/人/e27/最終学歴人口（小学校・中学校・高小）（３０～３９歳）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（３０～３９歳）（女）",
              "cat01": "E910233",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910240/人/e27/最終学歴人口（小学校・中学校・高小）（４０～４９歳）",
              "label": "最終学歴人口（小学校・中学校・高小）（４０～４９歳）",
              "cat01": "E910240",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910241/人/e27/最終学歴人口（小学校・中学校・高小）（４０～４９歳）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（４０～４９歳）（男）",
              "cat01": "E910241",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910242/人/e27/最終学歴人口（小学校・中学校・高小）（４０～４９歳）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（４０～４９歳）（女）",
              "cat01": "E910242",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910250/人/e27/最終学歴人口（小学校・中学校・高小）（５０～５９歳）",
              "label": "最終学歴人口（小学校・中学校・高小）（５０～５９歳）",
              "cat01": "E910250",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910251/人/e27/最終学歴人口（小学校・中学校・高小）（５０～５９歳）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（５０～５９歳）（男）",
              "cat01": "E910251",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910253/人/e27/最終学歴人口（小学校・中学校・高小）（５０～５９歳）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（５０～５９歳）（女）",
              "cat01": "E910253",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910260/人/e27/最終学歴人口（小学校・中学校・高小）（６０歳以上）",
              "label": "最終学歴人口（小学校・中学校・高小）（６０歳以上）",
              "cat01": "E910260",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910261/人/e27/最終学歴人口（小学校・中学校・高小）（６０歳以上）（男）",
              "label": "最終学歴人口（小学校・中学校・高小）（６０歳以上）（男）",
              "cat01": "E910261",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910262/人/e27/最終学歴人口（小学校・中学校・高小）（６０歳以上）（女）",
              "label": "最終学歴人口（小学校・中学校・高小）（６０歳以上）（女）",
              "cat01": "E910262",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9103/人/e27/最終学歴人口（高校・旧中）",
              "label": "最終学歴人口（高校・旧中）",
              "cat01": "E9103",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910301/人/e27/最終学歴人口（高校・旧中）（男）",
              "label": "最終学歴人口（高校・旧中）（男）",
              "cat01": "E910301",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910302/人/e27/最終学歴人口（高校・旧中）（女）",
              "label": "最終学歴人口（高校・旧中）（女）",
              "cat01": "E910302",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910310/人/e27/最終学歴人口（高校・旧中）（１５～１９歳）",
              "label": "最終学歴人口（高校・旧中）（１５～１９歳）",
              "cat01": "E910310",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910311/人/e27/最終学歴人口（高校・旧中）（１５～１９歳）（男）",
              "label": "最終学歴人口（高校・旧中）（１５～１９歳）（男）",
              "cat01": "E910311",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910312/人/e27/最終学歴人口（高校・旧中）（１５～１９歳）（女）",
              "label": "最終学歴人口（高校・旧中）（１５～１９歳）（女）",
              "cat01": "E910312",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910320/人/e27/最終学歴人口（高校・旧中）（２０～２９歳）",
              "label": "最終学歴人口（高校・旧中）（２０～２９歳）",
              "cat01": "E910320",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910321/人/e27/最終学歴人口（高校・旧中）（２０～２９歳）（男）",
              "label": "最終学歴人口（高校・旧中）（２０～２９歳）（男）",
              "cat01": "E910321",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910322/人/e27/最終学歴人口（高校・旧中）（２０～２９歳）（女）",
              "label": "最終学歴人口（高校・旧中）（２０～２９歳）（女）",
              "cat01": "E910322",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910330/人/e27/最終学歴人口（高校・旧中）（３０～３９歳）",
              "label": "最終学歴人口（高校・旧中）（３０～３９歳）",
              "cat01": "E910330",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910331/人/e27/最終学歴人口（高校・旧中）（３０～３９歳）（男）",
              "label": "最終学歴人口（高校・旧中）（３０～３９歳）（男）",
              "cat01": "E910331",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910333/人/e27/最終学歴人口（高校・旧中）（３０～３９歳）（女）",
              "label": "最終学歴人口（高校・旧中）（３０～３９歳）（女）",
              "cat01": "E910333",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910340/人/e27/最終学歴人口（高校・旧中）（４０～４９歳）",
              "label": "最終学歴人口（高校・旧中）（４０～４９歳）",
              "cat01": "E910340",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910341/人/e27/最終学歴人口（高校・旧中）（４０～４９歳）（男）",
              "label": "最終学歴人口（高校・旧中）（４０～４９歳）（男）",
              "cat01": "E910341",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910342/人/e27/最終学歴人口（高校・旧中）（４０～４９歳）（女）",
              "label": "最終学歴人口（高校・旧中）（４０～４９歳）（女）",
              "cat01": "E910342",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910350/人/e27/最終学歴人口（高校・旧中）（５０～５９歳）",
              "label": "最終学歴人口（高校・旧中）（５０～５９歳）",
              "cat01": "E910350",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910351/人/e27/最終学歴人口（高校・旧中）（５０～５９歳）（男）",
              "label": "最終学歴人口（高校・旧中）（５０～５９歳）（男）",
              "cat01": "E910351",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910353/人/e27/最終学歴人口（高校・旧中）（５０～５９歳）（女）",
              "label": "最終学歴人口（高校・旧中）（５０～５９歳）（女）",
              "cat01": "E910353",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910460/人/e27/最終学歴人口（高校・旧中）（６０歳以上）",
              "label": "最終学歴人口（高校・旧中）（６０歳以上）",
              "cat01": "E910460",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910461/人/e27/最終学歴人口（高校・旧中）（６０歳以上）（男）",
              "label": "最終学歴人口（高校・旧中）（６０歳以上）（男）",
              "cat01": "E910461",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910462/人/e27/最終学歴人口（高校・旧中）（６０歳以上）（女）",
              "label": "最終学歴人口（高校・旧中）（６０歳以上）（女）",
              "cat01": "E910462",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9105/人/e27/最終学歴人口（短大・高専）",
              "label": "最終学歴人口（短大・高専）",
              "cat01": "E9105",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910501/人/e27/最終学歴人口（短大・高専）（男）",
              "label": "最終学歴人口（短大・高専）（男）",
              "cat01": "E910501",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910502/人/e27/最終学歴人口（短大・高専）（女）",
              "label": "最終学歴人口（短大・高専）（女）",
              "cat01": "E910502",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910520/人/e27/最終学歴人口（短大・高専）（２０～２９歳）",
              "label": "最終学歴人口（短大・高専）（２０～２９歳）",
              "cat01": "E910520",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910521/人/e27/最終学歴人口（短大・高専）（２０～２９歳）（男）",
              "label": "最終学歴人口（短大・高専）（２０～２９歳）（男）",
              "cat01": "E910521",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910522/人/e27/最終学歴人口（短大・高専）（２０～２９歳）（女）",
              "label": "最終学歴人口（短大・高専）（２０～２９歳）（女）",
              "cat01": "E910522",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910530/人/e27/最終学歴人口（短大・高専）（３０～３９歳）",
              "label": "最終学歴人口（短大・高専）（３０～３９歳）",
              "cat01": "E910530",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910531/人/e27/最終学歴人口（短大・高専）（３０～３９歳）（男）",
              "label": "最終学歴人口（短大・高専）（３０～３９歳）（男）",
              "cat01": "E910531",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910533/人/e27/最終学歴人口（短大・高専）（３０～３９歳）（女）",
              "label": "最終学歴人口（短大・高専）（３０～３９歳）（女）",
              "cat01": "E910533",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910540/人/e27/最終学歴人口（短大・高専）（４０～４９歳）",
              "label": "最終学歴人口（短大・高専）（４０～４９歳）",
              "cat01": "E910540",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910541/人/e27/最終学歴人口（短大・高専）（４０～４９歳）（男）",
              "label": "最終学歴人口（短大・高専）（４０～４９歳）（男）",
              "cat01": "E910541",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910542/人/e27/最終学歴人口（短大・高専）（４０～４９歳）（女）",
              "label": "最終学歴人口（短大・高専）（４０～４９歳）（女）",
              "cat01": "E910542",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910550/人/e27/最終学歴人口（短大・高専）（５０～５９歳）",
              "label": "最終学歴人口（短大・高専）（５０～５９歳）",
              "cat01": "E910550",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910551/人/e27/最終学歴人口（短大・高専）（５０～５９歳）（男）",
              "label": "最終学歴人口（短大・高専）（５０～５９歳）（男）",
              "cat01": "E910551",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910553/人/e27/最終学歴人口（短大・高専）（５０～５９歳）（女）",
              "label": "最終学歴人口（短大・高専）（５０～５９歳）（女）",
              "cat01": "E910553",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910560/人/e27/最終学歴人口（短大・高専）（６０歳以上）",
              "label": "最終学歴人口（短大・高専）（６０歳以上）",
              "cat01": "E910560",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910561/人/e27/最終学歴人口（短大・高専）（６０歳以上）（男）",
              "label": "最終学歴人口（短大・高専）（６０歳以上）（男）",
              "cat01": "E910561",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910562/人/e27/最終学歴人口（短大・高専）（６０歳以上）（女）",
              "label": "最終学歴人口（短大・高専）（６０歳以上）（女）",
              "cat01": "E910562",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9106/人/e27/最終学歴人口（大学・大学院）",
              "label": "最終学歴人口（大学・大学院）",
              "cat01": "E9106",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910601/人/e27/最終学歴人口（大学・大学院）（男）",
              "label": "最終学歴人口（大学・大学院）（男）",
              "cat01": "E910601",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910602/人/e27/最終学歴人口（大学・大学院）（女）",
              "label": "最終学歴人口（大学・大学院）（女）",
              "cat01": "E910602",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910620/人/e27/最終学歴人口（大学・大学院）（２０～２９歳）",
              "label": "最終学歴人口（大学・大学院）（２０～２９歳）",
              "cat01": "E910620",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910621/人/e27/最終学歴人口（大学・大学院）（２０～２９歳）（男）",
              "label": "最終学歴人口（大学・大学院）（２０～２９歳）（男）",
              "cat01": "E910621",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910622/人/e27/最終学歴人口（大学・大学院）（２０～２９歳）（女）",
              "label": "最終学歴人口（大学・大学院）（２０～２９歳）（女）",
              "cat01": "E910622",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910630/人/e27/最終学歴人口（大学・大学院）（３０～３９歳）",
              "label": "最終学歴人口（大学・大学院）（３０～３９歳）",
              "cat01": "E910630",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910631/人/e27/最終学歴人口（大学・大学院）（３０～３９歳）（男）",
              "label": "最終学歴人口（大学・大学院）（３０～３９歳）（男）",
              "cat01": "E910631",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910633/人/e27/最終学歴人口（大学・大学院）（３０～３９歳）（女）",
              "label": "最終学歴人口（大学・大学院）（３０～３９歳）（女）",
              "cat01": "E910633",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910640/人/e27/最終学歴人口（大学・大学院）（４０～４９歳）",
              "label": "最終学歴人口（大学・大学院）（４０～４９歳）",
              "cat01": "E910640",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910641/人/e27/最終学歴人口（大学・大学院）（４０～４９歳）（男）",
              "label": "最終学歴人口（大学・大学院）（４０～４９歳）（男）",
              "cat01": "E910641",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910642/人/e27/最終学歴人口（大学・大学院）（４０～４９歳）（女）",
              "label": "最終学歴人口（大学・大学院）（４０～４９歳）（女）",
              "cat01": "E910642",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910650/人/e27/最終学歴人口（大学・大学院）（５０～５９歳）",
              "label": "最終学歴人口（大学・大学院）（５０～５９歳）",
              "cat01": "E910650",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910651/人/e27/最終学歴人口（大学・大学院）（５０～５９歳）（男）",
              "label": "最終学歴人口（大学・大学院）（５０～５９歳）（男）",
              "cat01": "E910651",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910653/人/e27/最終学歴人口（大学・大学院）（５０～５９歳）（女）",
              "label": "最終学歴人口（大学・大学院）（５０～５９歳）（女）",
              "cat01": "E910653",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910660/人/e27/最終学歴人口（大学・大学院）（６０歳以上）",
              "label": "最終学歴人口（大学・大学院）（６０歳以上）",
              "cat01": "E910660",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910661/人/e27/最終学歴人口（大学・大学院）（６０歳以上）（男）",
              "label": "最終学歴人口（大学・大学院）（６０歳以上）（男）",
              "cat01": "E910661",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E910662/人/e27/最終学歴人口（大学・大学院）（６０歳以上）（女）",
              "label": "最終学歴人口（大学・大学院）（６０歳以上）（女）",
              "cat01": "E910662",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9201/人/e27/在学者数",
              "label": "在学者数",
              "cat01": "E9201",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920101/人/e27/在学者数（男）",
              "label": "在学者数（男）",
              "cat01": "E920101",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920102/人/e27/在学者数（女）",
              "label": "在学者数（女）",
              "cat01": "E920102",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9202/人/e27/在学者数（小学校・中学校）",
              "label": "在学者数（小学校・中学校）",
              "cat01": "E9202",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920201/人/e27/在学者数（小学校・中学校）（男）",
              "label": "在学者数（小学校・中学校）（男）",
              "cat01": "E920201",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920202/人/e27/在学者数（小学校・中学校）（女）",
              "label": "在学者数（小学校・中学校）（女）",
              "cat01": "E920202",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9203/人/e27/在学者数（高等学校）",
              "label": "在学者数（高等学校）",
              "cat01": "E9203",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920301/人/e27/在学者数（高等学校）（男）",
              "label": "在学者数（高等学校）（男）",
              "cat01": "E920301",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920302/人/e27/在学者数（高等学校）（女）",
              "label": "在学者数（高等学校）（女）",
              "cat01": "E920302",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9204/人/e27/在学者数（短大・高専）",
              "label": "在学者数（短大・高専）",
              "cat01": "E9204",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920401/人/e27/在学者数（短大・高専）（男）",
              "label": "在学者数（短大・高専）（男）",
              "cat01": "E920401",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920402/人/e27/在学者数（短大・高専）（女）",
              "label": "在学者数（短大・高専）（女）",
              "cat01": "E920402",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9205/人/e27/在学者数（大学・大学院）",
              "label": "在学者数（大学・大学院）",
              "cat01": "E9205",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920501/人/e27/在学者数（大学・大学院）（男）",
              "label": "在学者数（大学・大学院）（男）",
              "cat01": "E920501",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E920502/人/e27/在学者数（大学・大学院）（女）",
              "label": "在学者数（大学・大学院）（女）",
              "cat01": "E920502",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9301/人/e27/未就学者数",
              "label": "未就学者数",
              "cat01": "E9301",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930101/人/e27/未就学者数（男）",
              "label": "未就学者数（男）",
              "cat01": "E930101",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930102/人/e27/未就学者数（女）",
              "label": "未就学者数（女）",
              "cat01": "E930102",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9302/人/e27/未就学者数（幼稚園）",
              "label": "未就学者数（幼稚園）",
              "cat01": "E9302",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930201/人/e27/未就学者数（幼稚園）（男）",
              "label": "未就学者数（幼稚園）（男）",
              "cat01": "E930201",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930202/人/e27/未就学者数（幼稚園）（女）",
              "label": "未就学者数（幼稚園）（女）",
              "cat01": "E930202",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9303/人/e27/未就学者数（保育園・保育所）",
              "label": "未就学者数（保育園・保育所）",
              "cat01": "E9303",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930301/人/e27/未就学者数（保育園・保育所）（男）",
              "label": "未就学者数（保育園・保育所）（男）",
              "cat01": "E930301",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930302/人/e27/未就学者数（保育園・保育所）（女）",
              "label": "未就学者数（保育園・保育所）（女）",
              "cat01": "E930302",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9304/人/e27/未就学者数（その他）",
              "label": "未就学者数（その他）",
              "cat01": "E9304",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930401/人/e27/未就学者数（その他）（男）",
              "label": "未就学者数（その他）（男）",
              "cat01": "E930401",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E930402/人/e27/未就学者数（その他）（女）",
              "label": "未就学者数（その他）（女）",
              "cat01": "E930402",
              "unit": "人",
              "sourceId": "e27"
            },
            {
              "statId": "0000010105/E9401/人/e28/教育用コンピュータ１台当たりの児童数（小学校）",
              "label": "教育用コンピュータ１台当たりの児童数（小学校）",
              "cat01": "E9401",
              "unit": "人",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9402/人/e28/教育用コンピュータ１台当たりの生徒数（中学校）",
              "label": "教育用コンピュータ１台当たりの生徒数（中学校）",
              "cat01": "E9402",
              "unit": "人",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9403/人/e28/教育用コンピュータ１台当たりの生徒数（高等学校）",
              "label": "教育用コンピュータ１台当たりの生徒数（高等学校）",
              "cat01": "E9403",
              "unit": "人",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9411/台/e28/１学校当たりの電子黒板の整備台数（小学校）",
              "label": "１学校当たりの電子黒板の整備台数（小学校）",
              "cat01": "E9411",
              "unit": "台",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9412/台/e28/１学校当たりの電子黒板の整備台数（中学校）",
              "label": "１学校当たりの電子黒板の整備台数（中学校）",
              "cat01": "E9412",
              "unit": "台",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9413/台/e28/１学校当たりの電子黒板の整備台数（高等学校）",
              "label": "１学校当たりの電子黒板の整備台数（高等学校）",
              "cat01": "E9413",
              "unit": "台",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9421/％/e28/デジタル教科書の整備率（小学校）",
              "label": "デジタル教科書の整備率（小学校）",
              "cat01": "E9421",
              "unit": "％",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9422/％/e28/デジタル教科書の整備率（中学校）",
              "label": "デジタル教科書の整備率（中学校）",
              "cat01": "E9422",
              "unit": "％",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9423/％/e28/デジタル教科書の整備率（高等学校）",
              "label": "デジタル教科書の整備率（高等学校）",
              "cat01": "E9423",
              "unit": "％",
              "sourceId": "e28"
            },
            {
              "statId": "0000010105/E9501/件/e29/都道府県別暴力行為発生件数",
              "label": "都道府県別暴力行為発生件数",
              "cat01": "E9501",
              "unit": "件",
              "sourceId": "e29"
            },
            {
              "statId": "0000010105/E9502/件/e29/都道府県別いじめ認知件数等",
              "label": "都道府県別いじめ認知件数等",
              "cat01": "E9502",
              "unit": "件",
              "sourceId": "e29"
            },
            {
              "statId": "0000010105/E9503/件/e29/都道府県別いじめの現在の状況（解消件数）",
              "label": "都道府県別いじめの現在の状況（解消件数）",
              "cat01": "E9503",
              "unit": "件",
              "sourceId": "e29"
            }
          ]
        },
        {
          "label": "Ｆ労働",
          "statId": "0000010106",
          "children": [
            {
              "statId": "0000010106/F1101/人/f01/労働力人口",
              "label": "労働力人口",
              "cat01": "F1101",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110101/人/f01/労働力人口（男）",
              "label": "労働力人口（男）",
              "cat01": "F110101",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110102/人/f01/労働力人口（女）",
              "label": "労働力人口（女）",
              "cat01": "F110102",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1102/人/f01/就業者数",
              "label": "就業者数",
              "cat01": "F1102",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110201/人/f01/就業者数（男）",
              "label": "就業者数（男）",
              "cat01": "F110201",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110202/人/f01/就業者数（女）",
              "label": "就業者数（女）",
              "cat01": "F110202",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1103/人/f01/就業者数・主に仕事",
              "label": "就業者数・主に仕事",
              "cat01": "F1103",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110301/人/f01/就業者数・主に仕事（男）",
              "label": "就業者数・主に仕事（男）",
              "cat01": "F110301",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110302/人/f01/就業者数・主に仕事（女）",
              "label": "就業者数・主に仕事（女）",
              "cat01": "F110302",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1104/人/f01/就業者数・家事のほか仕事",
              "label": "就業者数・家事のほか仕事",
              "cat01": "F1104",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110401/人/f01/就業者数・家事のほか仕事（男）",
              "label": "就業者数・家事のほか仕事（男）",
              "cat01": "F110401",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110402/人/f01/就業者数・家事のほか仕事（女）",
              "label": "就業者数・家事のほか仕事（女）",
              "cat01": "F110402",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1105/人/f01/就業者数・通学のかたわら仕事",
              "label": "就業者数・通学のかたわら仕事",
              "cat01": "F1105",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110501/人/f01/就業者数・通学のかたわら仕事（男）",
              "label": "就業者数・通学のかたわら仕事（男）",
              "cat01": "F110501",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110502/人/f01/就業者数・通学のかたわら仕事（女）",
              "label": "就業者数・通学のかたわら仕事（女）",
              "cat01": "F110502",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1106/人/f01/就業者数・休業者",
              "label": "就業者数・休業者",
              "cat01": "F1106",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110601/人/f01/就業者数・休業者（男）",
              "label": "就業者数・休業者（男）",
              "cat01": "F110601",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110602/人/f01/就業者数・休業者（女）",
              "label": "就業者数・休業者（女）",
              "cat01": "F110602",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1107/人/f01/完全失業者数",
              "label": "完全失業者数",
              "cat01": "F1107",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110701/人/f01/完全失業者数（男）",
              "label": "完全失業者数（男）",
              "cat01": "F110701",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110702/人/f01/完全失業者数（女）",
              "label": "完全失業者数（女）",
              "cat01": "F110702",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1108/人/f01/非労働力人口",
              "label": "非労働力人口",
              "cat01": "F1108",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110801/人/f01/非労働力人口（男）",
              "label": "非労働力人口（男）",
              "cat01": "F110801",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110802/人/f01/非労働力人口（女）",
              "label": "非労働力人口（女）",
              "cat01": "F110802",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1109/人/f01/非労働力人口・家事",
              "label": "非労働力人口・家事",
              "cat01": "F1109",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110901/人/f01/非労働力人口・家事（男）",
              "label": "非労働力人口・家事（男）",
              "cat01": "F110901",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F110902/人/f01/非労働力人口・家事（女）",
              "label": "非労働力人口・家事（女）",
              "cat01": "F110902",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1110/人/f01/非労働力人口・通学",
              "label": "非労働力人口・通学",
              "cat01": "F1110",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F111001/人/f01/非労働力人口・通学（男）",
              "label": "非労働力人口・通学（男）",
              "cat01": "F111001",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F111002/人/f01/非労働力人口・通学（女）",
              "label": "非労働力人口・通学（女）",
              "cat01": "F111002",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1111/人/f01/非労働力人口・その他",
              "label": "非労働力人口・その他",
              "cat01": "F1111",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F111101/人/f01/非労働力人口・その他（男）",
              "label": "非労働力人口・その他（男）",
              "cat01": "F111101",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F111102/人/f01/非労働力人口・その他（女）",
              "label": "非労働力人口・その他（女）",
              "cat01": "F111102",
              "unit": "人",
              "sourceId": "f01"
            },
            {
              "statId": "0000010106/F1201/千人/f02/１５歳以上人口（就業構造基本調査結果）",
              "label": "１５歳以上人口（就業構造基本調査結果）",
              "cat01": "F1201",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120101/千人/f02/１５歳以上人口（男）（就業構造基本調査結果）",
              "label": "１５歳以上人口（男）（就業構造基本調査結果）",
              "cat01": "F120101",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120102/千人/f02/１５歳以上人口（女）（就業構造基本調査結果）",
              "label": "１５歳以上人口（女）（就業構造基本調査結果）",
              "cat01": "F120102",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1202/千人/f02/有業者数",
              "label": "有業者数",
              "cat01": "F1202",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120201/千人/f02/有業者数（男）",
              "label": "有業者数（男）",
              "cat01": "F120201",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120202/千人/f02/有業者数（女）",
              "label": "有業者数（女）",
              "cat01": "F120202",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1203/千人/f02/有業者数・仕事が主な者",
              "label": "有業者数・仕事が主な者",
              "cat01": "F1203",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120301/千人/f02/有業者数・仕事が主な者（男）",
              "label": "有業者数・仕事が主な者（男）",
              "cat01": "F120301",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120302/千人/f02/有業者数・仕事が主な者（女）",
              "label": "有業者数・仕事が主な者（女）",
              "cat01": "F120302",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1204/千人/f02/有業者数・仕事は従な者",
              "label": "有業者数・仕事は従な者",
              "cat01": "F1204",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120401/千人/f02/有業者数・仕事は従な者（男）",
              "label": "有業者数・仕事は従な者（男）",
              "cat01": "F120401",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120402/千人/f02/有業者数・仕事は従な者（女）",
              "label": "有業者数・仕事は従な者（女）",
              "cat01": "F120402",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1205/千人/f02/無業者数",
              "label": "無業者数",
              "cat01": "F1205",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120501/千人/f02/無業者数（男）",
              "label": "無業者数（男）",
              "cat01": "F120501",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120502/千人/f02/無業者数（女）",
              "label": "無業者数（女）",
              "cat01": "F120502",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1206/千人/f02/無業者数・家事をしている者",
              "label": "無業者数・家事をしている者",
              "cat01": "F1206",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120601/千人/f02/無業者数・家事をしている者（男）",
              "label": "無業者数・家事をしている者（男）",
              "cat01": "F120601",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120602/千人/f02/無業者数・家事をしている者（女）",
              "label": "無業者数・家事をしている者（女）",
              "cat01": "F120602",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1207/千人/f02/無業者数・通学している者",
              "label": "無業者数・通学している者",
              "cat01": "F1207",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120701/千人/f02/無業者数・通学している者（男）",
              "label": "無業者数・通学している者（男）",
              "cat01": "F120701",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120702/千人/f02/無業者数・通学している者（女）",
              "label": "無業者数・通学している者（女）",
              "cat01": "F120702",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1208/千人/f02/無業者数・その他",
              "label": "無業者数・その他",
              "cat01": "F1208",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120801/千人/f02/無業者数・その他（男）",
              "label": "無業者数・その他（男）",
              "cat01": "F120801",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F120802/千人/f02/無業者数・その他（女）",
              "label": "無業者数・その他（女）",
              "cat01": "F120802",
              "unit": "千人",
              "sourceId": "f02"
            },
            {
              "statId": "0000010106/F1301/人/f03/農林漁業者",
              "label": "農林漁業者",
              "cat01": "F1301",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130101/人/f03/農林漁業者（男）",
              "label": "農林漁業者（男）",
              "cat01": "F130101",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130102/人/f03/農林漁業者（女）",
              "label": "農林漁業者（女）",
              "cat01": "F130102",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1302/人/f03/農林漁業雇用者",
              "label": "農林漁業雇用者",
              "cat01": "F1302",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130201/人/f03/農林漁業雇用者（男）",
              "label": "農林漁業雇用者（男）",
              "cat01": "F130201",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130202/人/f03/農林漁業雇用者（女）",
              "label": "農林漁業雇用者（女）",
              "cat01": "F130202",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1303/人/f03/会社団体役員",
              "label": "会社団体役員",
              "cat01": "F1303",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130301/人/f03/会社団体役員（男）",
              "label": "会社団体役員（男）",
              "cat01": "F130301",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130302/人/f03/会社団体役員（女）",
              "label": "会社団体役員（女）",
              "cat01": "F130302",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1304/人/f03/商店主",
              "label": "商店主",
              "cat01": "F1304",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130401/人/f03/商店主（男）",
              "label": "商店主（男）",
              "cat01": "F130401",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130402/人/f03/商店主（女）",
              "label": "商店主（女）",
              "cat01": "F130402",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1305/人/f03/工場主",
              "label": "工場主",
              "cat01": "F1305",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130501/人/f03/工場主（男）",
              "label": "工場主（男）",
              "cat01": "F130501",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130502/人/f03/工場主（女）",
              "label": "工場主（女）",
              "cat01": "F130502",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1306/人/f03/サービス・その他の事業主",
              "label": "サービス・その他の事業主",
              "cat01": "F1306",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130601/人/f03/サービス・その他の事業主（男）",
              "label": "サービス・その他の事業主（男）",
              "cat01": "F130601",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130602/人/f03/サービス・その他の事業主（女）",
              "label": "サービス・その他の事業主（女）",
              "cat01": "F130602",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1307/人/f03/専門職業者",
              "label": "専門職業者",
              "cat01": "F1307",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130701/人/f03/専門職業者（男）",
              "label": "専門職業者（男）",
              "cat01": "F130701",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130702/人/f03/専門職業者（女）",
              "label": "専門職業者（女）",
              "cat01": "F130702",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1308/人/f03/技術者",
              "label": "技術者",
              "cat01": "F1308",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130801/人/f03/技術者（男）",
              "label": "技術者（男）",
              "cat01": "F130801",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130802/人/f03/技術者（女）",
              "label": "技術者（女）",
              "cat01": "F130802",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1309/人/f03/教員・宗教家",
              "label": "教員・宗教家",
              "cat01": "F1309",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130901/人/f03/教員・宗教家（男）",
              "label": "教員・宗教家（男）",
              "cat01": "F130901",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F130902/人/f03/教員・宗教家（女）",
              "label": "教員・宗教家（女）",
              "cat01": "F130902",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1310/人/f03/文筆家・芸術家・芸能家",
              "label": "文筆家・芸術家・芸能家",
              "cat01": "F1310",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131001/人/f03/文筆家・芸術家・芸能家（男）",
              "label": "文筆家・芸術家・芸能家（男）",
              "cat01": "F131001",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131002/人/f03/文筆家・芸術家・芸能家（女）",
              "label": "文筆家・芸術家・芸能家（女）",
              "cat01": "F131002",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1311/人/f03/管理職",
              "label": "管理職",
              "cat01": "F1311",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131101/人/f03/管理職（男）",
              "label": "管理職（男）",
              "cat01": "F131101",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131102/人/f03/管理職（女）",
              "label": "管理職（女）",
              "cat01": "F131102",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1312/人/f03/事務職",
              "label": "事務職",
              "cat01": "F1312",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131201/人/f03/事務職（男）",
              "label": "事務職（男）",
              "cat01": "F131201",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131202/人/f03/事務職（女）",
              "label": "事務職（女）",
              "cat01": "F131202",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1313/人/f03/販売人",
              "label": "販売人",
              "cat01": "F1313",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131301/人/f03/販売人（男）",
              "label": "販売人（男）",
              "cat01": "F131301",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131302/人/f03/販売人（女）",
              "label": "販売人（女）",
              "cat01": "F131302",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1314/人/f03/技能者",
              "label": "技能者",
              "cat01": "F1314",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131401/人/f03/技能者（男）",
              "label": "技能者（男）",
              "cat01": "F131401",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131402/人/f03/技能者（女）",
              "label": "技能者（女）",
              "cat01": "F131402",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1315/人/f03/労務作業者",
              "label": "労務作業者",
              "cat01": "F1315",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131501/人/f03/労務作業者（男）",
              "label": "労務作業者（男）",
              "cat01": "F131501",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131502/人/f03/労務作業者（女）",
              "label": "労務作業者（女）",
              "cat01": "F131502",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1316/人/f03/個人サービス人",
              "label": "個人サービス人",
              "cat01": "F1316",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131601/人/f03/個人サービス人（男）",
              "label": "個人サービス人（男）",
              "cat01": "F131601",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131602/人/f03/個人サービス人（女）",
              "label": "個人サービス人（女）",
              "cat01": "F131602",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1317/人/f03/保安職",
              "label": "保安職",
              "cat01": "F1317",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131701/人/f03/保安職（男）",
              "label": "保安職（男）",
              "cat01": "F131701",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F131702/人/f03/保安職（女）",
              "label": "保安職（女）",
              "cat01": "F131702",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F1318/人/f03/内職者",
              "label": "内職者",
              "cat01": "F1318",
              "unit": "人",
              "sourceId": "f03"
            },
            {
              "statId": "0000010106/F140111/世帯/f04/６５歳以上の単身者世帯（完全失業者数(男)）",
              "label": "６５歳以上の単身者世帯（完全失業者数(男)）",
              "cat01": "F140111",
              "unit": "世帯",
              "sourceId": "f04"
            },
            {
              "statId": "0000010106/F140112/世帯/f04/６５歳以上の単身者世帯（完全失業者数(女)）",
              "label": "６５歳以上の単身者世帯（完全失業者数(女)）",
              "cat01": "F140112",
              "unit": "世帯",
              "sourceId": "f04"
            },
            {
              "statId": "0000010106/F140121/世帯/f04/６５歳以上の単身者世帯（非労動力人口(男)）",
              "label": "６５歳以上の単身者世帯（非労動力人口(男)）",
              "cat01": "F140121",
              "unit": "世帯",
              "sourceId": "f04"
            },
            {
              "statId": "0000010106/F140122/世帯/f04/６５歳以上の単身者世帯（非労動力人口(女)）",
              "label": "６５歳以上の単身者世帯（非労動力人口(女)）",
              "cat01": "F140122",
              "unit": "世帯",
              "sourceId": "f04"
            },
            {
              "statId": "0000010106/F140301/世帯/f05/母子世帯・完全失業者数",
              "label": "母子世帯・完全失業者数",
              "cat01": "F140301",
              "unit": "世帯",
              "sourceId": "f05"
            },
            {
              "statId": "0000010106/F140302/世帯/f05/母子世帯・非労働力人口",
              "label": "母子世帯・非労働力人口",
              "cat01": "F140302",
              "unit": "世帯",
              "sourceId": "f05"
            },
            {
              "statId": "0000010106/F1501/世帯/f06/共働き世帯数",
              "label": "共働き世帯数",
              "cat01": "F1501",
              "unit": "世帯",
              "sourceId": "f06"
            },
            {
              "statId": "0000010106/F150101/世帯/f06/共働き世帯数（子供なし）",
              "label": "共働き世帯数（子供なし）",
              "cat01": "F150101",
              "unit": "世帯",
              "sourceId": "f06"
            },
            {
              "statId": "0000010106/F150102/世帯/f06/共働き世帯数（６歳未満の子供あり）",
              "label": "共働き世帯数（６歳未満の子供あり）",
              "cat01": "F150102",
              "unit": "世帯",
              "sourceId": "f06"
            },
            {
              "statId": "0000010106/F150103/世帯/f06/共働き世帯数（１８歳未満の子供あり）",
              "label": "共働き世帯数（１８歳未満の子供あり）",
              "cat01": "F150103",
              "unit": "世帯",
              "sourceId": "f06"
            },
            {
              "statId": "0000010106/F2101/人/f07/就業者数（１５～１９歳）",
              "label": "就業者数（１５～１９歳）",
              "cat01": "F2101",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210101/人/f07/就業者数（１５～１９歳）（男）",
              "label": "就業者数（１５～１９歳）（男）",
              "cat01": "F210101",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210102/人/f07/就業者数（１５～１９歳）（女）",
              "label": "就業者数（１５～１９歳）（女）",
              "cat01": "F210102",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2102/人/f07/就業者数（２０～２４歳）",
              "label": "就業者数（２０～２４歳）",
              "cat01": "F2102",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210201/人/f07/就業者数（２０～２４歳）（男）",
              "label": "就業者数（２０～２４歳）（男）",
              "cat01": "F210201",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210202/人/f07/就業者数（２０～２４歳）（女）",
              "label": "就業者数（２０～２４歳）（女）",
              "cat01": "F210202",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2103/人/f07/就業者数（２５～２９歳）",
              "label": "就業者数（２５～２９歳）",
              "cat01": "F2103",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210301/人/f07/就業者数（２５～２９歳）（男）",
              "label": "就業者数（２５～２９歳）（男）",
              "cat01": "F210301",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210302/人/f07/就業者数（２５～２９歳）（女）",
              "label": "就業者数（２５～２９歳）（女）",
              "cat01": "F210302",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2104/人/f07/就業者数（３０～３４歳）",
              "label": "就業者数（３０～３４歳）",
              "cat01": "F2104",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210401/人/f07/就業者数（３０～３４歳）（男）",
              "label": "就業者数（３０～３４歳）（男）",
              "cat01": "F210401",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210402/人/f07/就業者数（３０～３４歳）（女）",
              "label": "就業者数（３０～３４歳）（女）",
              "cat01": "F210402",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2105/人/f07/就業者数（３５～３９歳）",
              "label": "就業者数（３５～３９歳）",
              "cat01": "F2105",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210501/人/f07/就業者数（３５～３９歳）（男）",
              "label": "就業者数（３５～３９歳）（男）",
              "cat01": "F210501",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210502/人/f07/就業者数（３５～３９歳）（女）",
              "label": "就業者数（３５～３９歳）（女）",
              "cat01": "F210502",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2106/人/f07/就業者数（４０～４４歳）",
              "label": "就業者数（４０～４４歳）",
              "cat01": "F2106",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210601/人/f07/就業者数（４０～４４歳）（男）",
              "label": "就業者数（４０～４４歳）（男）",
              "cat01": "F210601",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210602/人/f07/就業者数（４０～４４歳）（女）",
              "label": "就業者数（４０～４４歳）（女）",
              "cat01": "F210602",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2107/人/f07/就業者数（４５～４９歳）",
              "label": "就業者数（４５～４９歳）",
              "cat01": "F2107",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210701/人/f07/就業者数（４５～４９歳）（男）",
              "label": "就業者数（４５～４９歳）（男）",
              "cat01": "F210701",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210702/人/f07/就業者数（４５～４９歳）（女）",
              "label": "就業者数（４５～４９歳）（女）",
              "cat01": "F210702",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2108/人/f07/就業者数（５０～５４歳）",
              "label": "就業者数（５０～５４歳）",
              "cat01": "F2108",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210801/人/f07/就業者数（５０～５４歳）（男）",
              "label": "就業者数（５０～５４歳）（男）",
              "cat01": "F210801",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210802/人/f07/就業者数（５０～５４歳）（女）",
              "label": "就業者数（５０～５４歳）（女）",
              "cat01": "F210802",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2109/人/f07/就業者数（５５～５９歳）",
              "label": "就業者数（５５～５９歳）",
              "cat01": "F2109",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210901/人/f07/就業者数（５５～５９歳）（男）",
              "label": "就業者数（５５～５９歳）（男）",
              "cat01": "F210901",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F210902/人/f07/就業者数（５５～５９歳）（女）",
              "label": "就業者数（５５～５９歳）（女）",
              "cat01": "F210902",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2110/人/f07/就業者数（６０～６４歳）",
              "label": "就業者数（６０～６４歳）",
              "cat01": "F2110",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211001/人/f07/就業者数（６０～６４歳）（男）",
              "label": "就業者数（６０～６４歳）（男）",
              "cat01": "F211001",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211002/人/f07/就業者数（６０～６４歳）（女）",
              "label": "就業者数（６０～６４歳）（女）",
              "cat01": "F211002",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2111/人/f07/就業者数（６５～６９歳）",
              "label": "就業者数（６５～６９歳）",
              "cat01": "F2111",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211101/人/f07/就業者数（６５～６９歳）（男）",
              "label": "就業者数（６５～６９歳）（男）",
              "cat01": "F211101",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211102/人/f07/就業者数（６５～６９歳）（女）",
              "label": "就業者数（６５～６９歳）（女）",
              "cat01": "F211102",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2112/人/f07/就業者数（７０～７４歳）",
              "label": "就業者数（７０～７４歳）",
              "cat01": "F2112",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211201/人/f07/就業者数（７０～７４歳）（男）",
              "label": "就業者数（７０～７４歳）（男）",
              "cat01": "F211201",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211202/人/f07/就業者数（７０～７４歳）（女）",
              "label": "就業者数（７０～７４歳）（女）",
              "cat01": "F211202",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2113/人/f07/就業者数（７５～７９歳）",
              "label": "就業者数（７５～７９歳）",
              "cat01": "F2113",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211301/人/f07/就業者数（７５～７９歳）（男）",
              "label": "就業者数（７５～７９歳）（男）",
              "cat01": "F211301",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211302/人/f07/就業者数（７５～７９歳）（女）",
              "label": "就業者数（７５～７９歳）（女）",
              "cat01": "F211302",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2114/人/f07/就業者数（８０～８４歳）",
              "label": "就業者数（８０～８４歳）",
              "cat01": "F2114",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211401/人/f07/就業者数（８０～８４歳）（男）",
              "label": "就業者数（８０～８４歳）（男）",
              "cat01": "F211401",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211402/人/f07/就業者数（８０～８４歳）（女）",
              "label": "就業者数（８０～８４歳）（女）",
              "cat01": "F211402",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2115/人/f07/就業者数（８５歳以上）",
              "label": "就業者数（８５歳以上）",
              "cat01": "F2115",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211501/人/f07/就業者数（８５歳以上）（男）",
              "label": "就業者数（８５歳以上）（男）",
              "cat01": "F211501",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211502/人/f07/就業者数（８５歳以上）（女）",
              "label": "就業者数（８５歳以上）（女）",
              "cat01": "F211502",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2116/人/f07/就業者数（６５歳以上）",
              "label": "就業者数（６５歳以上）",
              "cat01": "F2116",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211601/人/f07/就業者数（６５歳以上）（男）",
              "label": "就業者数（６５歳以上）（男）",
              "cat01": "F211601",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F211602/人/f07/就業者数（６５歳以上）（女）",
              "label": "就業者数（６５歳以上）（女）",
              "cat01": "F211602",
              "unit": "人",
              "sourceId": "f07"
            },
            {
              "statId": "0000010106/F2201/人/f08/第１次産業就業者数",
              "label": "第１次産業就業者数",
              "cat01": "F2201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220101/人/f08/第１次産業就業者数（男）",
              "label": "第１次産業就業者数（男）",
              "cat01": "F220101",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220102/人/f08/第１次産業就業者数（女）",
              "label": "第１次産業就業者数（女）",
              "cat01": "F220102",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2202/人/f08/第１次産業就業者数（１５～６４歳）",
              "label": "第１次産業就業者数（１５～６４歳）",
              "cat01": "F2202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220201/人/f08/第１次産業就業者数（１５～６４歳）（男）",
              "label": "第１次産業就業者数（１５～６４歳）（男）",
              "cat01": "F220201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220202/人/f08/第１次産業就業者数（１５～６４歳）（女）",
              "label": "第１次産業就業者数（１５～６４歳）（女）",
              "cat01": "F220202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2203/人/f08/第１次産業就業者数（６５歳以上）",
              "label": "第１次産業就業者数（６５歳以上）",
              "cat01": "F2203",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220301/人/f08/第１次産業就業者数（６５歳以上）（男）",
              "label": "第１次産業就業者数（６５歳以上）（男）",
              "cat01": "F220301",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F220302/人/f08/第１次産業就業者数（６５歳以上）（女）",
              "label": "第１次産業就業者数（６５歳以上）（女）",
              "cat01": "F220302",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2211/人/f08/第２次産業就業者数",
              "label": "第２次産業就業者数",
              "cat01": "F2211",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221101/人/f08/第２次産業就業者数（男）",
              "label": "第２次産業就業者数（男）",
              "cat01": "F221101",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221102/人/f08/第２次産業就業者数（女）",
              "label": "第２次産業就業者数（女）",
              "cat01": "F221102",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2212/人/f08/第２次産業就業者数（１５～６４歳）",
              "label": "第２次産業就業者数（１５～６４歳）",
              "cat01": "F2212",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221201/人/f08/第２次産業就業者数（１５～６４歳）（男）",
              "label": "第２次産業就業者数（１５～６４歳）（男）",
              "cat01": "F221201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221202/人/f08/第２次産業就業者数（１５～６４歳）（女）",
              "label": "第２次産業就業者数（１５～６４歳）（女）",
              "cat01": "F221202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2213/人/f08/第２次産業就業者数（６５歳以上）",
              "label": "第２次産業就業者数（６５歳以上）",
              "cat01": "F2213",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221301/人/f08/第２次産業就業者数（６５歳以上）（男）",
              "label": "第２次産業就業者数（６５歳以上）（男）",
              "cat01": "F221301",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F221302/人/f08/第２次産業就業者数（６５歳以上）（女）",
              "label": "第２次産業就業者数（６５歳以上）（女）",
              "cat01": "F221302",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2221/人/f08/第３次産業就業者数",
              "label": "第３次産業就業者数",
              "cat01": "F2221",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222101/人/f08/第３次産業就業者数（男）",
              "label": "第３次産業就業者数（男）",
              "cat01": "F222101",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222102/人/f08/第３次産業就業者数（女）",
              "label": "第３次産業就業者数（女）",
              "cat01": "F222102",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2222/人/f08/第３次産業就業者数（１５～６４歳）",
              "label": "第３次産業就業者数（１５～６４歳）",
              "cat01": "F2222",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222201/人/f08/第３次産業就業者数（１５～６４歳）（男）",
              "label": "第３次産業就業者数（１５～６４歳）（男）",
              "cat01": "F222201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222202/人/f08/第３次産業就業者数（１５～６４歳）（女）",
              "label": "第３次産業就業者数（１５～６４歳）（女）",
              "cat01": "F222202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2223/人/f08/第３次産業就業者数（６５歳以上）",
              "label": "第３次産業就業者数（６５歳以上）",
              "cat01": "F2223",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222301/人/f08/第３次産業就業者数（６５歳以上）（男）",
              "label": "第３次産業就業者数（６５歳以上）（男）",
              "cat01": "F222301",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F222302/人/f08/第３次産業就業者数（６５歳以上）（女）",
              "label": "第３次産業就業者数（６５歳以上）（女）",
              "cat01": "F222302",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2315/人/f08/就業者数（農業）（‐２００５）",
              "label": "就業者数（農業）（‐２００５）",
              "cat01": "F2315",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231501/人/f08/就業者数（農業）（男）（‐２００５）",
              "label": "就業者数（農業）（男）（‐２００５）",
              "cat01": "F231501",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231502/人/f08/就業者数（農業）（女）（‐２００５）",
              "label": "就業者数（農業）（女）（‐２００５）",
              "cat01": "F231502",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2316/人/f08/就業者数（林業）（‐２００５）",
              "label": "就業者数（林業）（‐２００５）",
              "cat01": "F2316",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231601/人/f08/就業者数（林業）（男）（‐２００５）",
              "label": "就業者数（林業）（男）（‐２００５）",
              "cat01": "F231601",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231602/人/f08/就業者数（林業）（女）（‐２００５）",
              "label": "就業者数（林業）（女）（‐２００５）",
              "cat01": "F231602",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2317/人/f08/就業者数（漁業）（‐２００５）",
              "label": "就業者数（漁業）（‐２００５）",
              "cat01": "F2317",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231701/人/f08/就業者数（漁業）（男）（‐２００５）",
              "label": "就業者数（漁業）（男）（‐２００５）",
              "cat01": "F231701",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231702/人/f08/就業者数（漁業）（女）（‐２００５）",
              "label": "就業者数（漁業）（女）（‐２００５）",
              "cat01": "F231702",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2318/人/f08/就業者数（鉱業）（‐２００５）",
              "label": "就業者数（鉱業）（‐２００５）",
              "cat01": "F2318",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231801/人/f08/就業者数（鉱業）（男）（‐２００５）",
              "label": "就業者数（鉱業）（男）（‐２００５）",
              "cat01": "F231801",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231802/人/f08/就業者数（鉱業）（女）（‐２００５）",
              "label": "就業者数（鉱業）（女）（‐２００５）",
              "cat01": "F231802",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2319/人/f08/就業者数（建設業）（‐２００５）",
              "label": "就業者数（建設業）（‐２００５）",
              "cat01": "F2319",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231901/人/f08/就業者数（建設業）（男）（‐２００５）",
              "label": "就業者数（建設業）（男）（‐２００５）",
              "cat01": "F231901",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F231902/人/f08/就業者数（建設業）（女）（‐２００５）",
              "label": "就業者数（建設業）（女）（‐２００５）",
              "cat01": "F231902",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2320/人/f08/就業者数（製造業）（‐２００５）",
              "label": "就業者数（製造業）（‐２００５）",
              "cat01": "F2320",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232001/人/f08/就業者数（製造業）（男）（‐２００５）",
              "label": "就業者数（製造業）（男）（‐２００５）",
              "cat01": "F232001",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232002/人/f08/就業者数（製造業）（女）（‐２００５）",
              "label": "就業者数（製造業）（女）（‐２００５）",
              "cat01": "F232002",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2321/人/f08/就業者数（電気・ガス・熱供給・水道業）（‐２００５）",
              "label": "就業者数（電気・ガス・熱供給・水道業）（‐２００５）",
              "cat01": "F2321",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232101/人/f08/就業者数（電気・ガス・熱供給・水道業）（男）（‐２００５）",
              "label": "就業者数（電気・ガス・熱供給・水道業）（男）（‐２００５）",
              "cat01": "F232101",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232102/人/f08/就業者数（電気・ガス・熱供給・水道業）（女）（‐２００５）",
              "label": "就業者数（電気・ガス・熱供給・水道業）（女）（‐２００５）",
              "cat01": "F232102",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2322/人/f08/就業者数（情報通信業）（‐２００５）",
              "label": "就業者数（情報通信業）（‐２００５）",
              "cat01": "F2322",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232201/人/f08/就業者数（情報通信業）（男）（‐２００５）",
              "label": "就業者数（情報通信業）（男）（‐２００５）",
              "cat01": "F232201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232202/人/f08/就業者数（情報通信業）（女）（‐２００５）",
              "label": "就業者数（情報通信業）（女）（‐２００５）",
              "cat01": "F232202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2323/人/f08/就業者数（運輸業）（‐２００５）",
              "label": "就業者数（運輸業）（‐２００５）",
              "cat01": "F2323",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232301/人/f08/就業者数（運輸業）（男）（‐２００５）",
              "label": "就業者数（運輸業）（男）（‐２００５）",
              "cat01": "F232301",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232302/人/f08/就業者数（運輸業）（女）（‐２００５）",
              "label": "就業者数（運輸業）（女）（‐２００５）",
              "cat01": "F232302",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2324/人/f08/就業者数（卸売・小売業）（‐２００５）",
              "label": "就業者数（卸売・小売業）（‐２００５）",
              "cat01": "F2324",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232401/人/f08/就業者数（卸売・小売業）（男）（‐２００５）",
              "label": "就業者数（卸売・小売業）（男）（‐２００５）",
              "cat01": "F232401",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232402/人/f08/就業者数（卸売・小売業）（女）（‐２００５）",
              "label": "就業者数（卸売・小売業）（女）（‐２００５）",
              "cat01": "F232402",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2325/人/f08/就業者数（金融・保険業）（‐２００５）",
              "label": "就業者数（金融・保険業）（‐２００５）",
              "cat01": "F2325",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232501/人/f08/就業者数（金融・保険業）（男）（‐２００５）",
              "label": "就業者数（金融・保険業）（男）（‐２００５）",
              "cat01": "F232501",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232502/人/f08/就業者数（金融・保険業）（女）（‐２００５）",
              "label": "就業者数（金融・保険業）（女）（‐２００５）",
              "cat01": "F232502",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2326/人/f08/就業者数（不動産業）（‐２００５）",
              "label": "就業者数（不動産業）（‐２００５）",
              "cat01": "F2326",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232601/人/f08/就業者数（不動産業）（男）（‐２００５）",
              "label": "就業者数（不動産業）（男）（‐２００５）",
              "cat01": "F232601",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232602/人/f08/就業者数（不動産業）（女）（‐２００５）",
              "label": "就業者数（不動産業）（女）（‐２００５）",
              "cat01": "F232602",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2327/人/f08/就業者数（飲食店，宿泊業）（‐２００５）",
              "label": "就業者数（飲食店，宿泊業）（‐２００５）",
              "cat01": "F2327",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232701/人/f08/就業者数（飲食店，宿泊業）（男）（‐２００５）",
              "label": "就業者数（飲食店，宿泊業）（男）（‐２００５）",
              "cat01": "F232701",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232702/人/f08/就業者数（飲食店，宿泊業）（女）（‐２００５）",
              "label": "就業者数（飲食店，宿泊業）（女）（‐２００５）",
              "cat01": "F232702",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2328/人/f08/就業者数（医療，福祉）（‐２００５）",
              "label": "就業者数（医療，福祉）（‐２００５）",
              "cat01": "F2328",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232801/人/f08/就業者数（医療，福祉）（男）（‐２００５）",
              "label": "就業者数（医療，福祉）（男）（‐２００５）",
              "cat01": "F232801",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232802/人/f08/就業者数（医療，福祉）（女）（‐２００５）",
              "label": "就業者数（医療，福祉）（女）（‐２００５）",
              "cat01": "F232802",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2329/人/f08/就業者数（教育，学習支援業）（‐２００５）",
              "label": "就業者数（教育，学習支援業）（‐２００５）",
              "cat01": "F2329",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232901/人/f08/就業者数（教育，学習支援業）（男）（‐２００５）",
              "label": "就業者数（教育，学習支援業）（男）（‐２００５）",
              "cat01": "F232901",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F232902/人/f08/就業者数（教育，学習支援業）（女）（‐２００５）",
              "label": "就業者数（教育，学習支援業）（女）（‐２００５）",
              "cat01": "F232902",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2330/人/f08/就業者数（サービス事業）（‐２００５）",
              "label": "就業者数（サービス事業）（‐２００５）",
              "cat01": "F2330",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233001/人/f08/就業者数（サービス事業）（男）（‐２００５）",
              "label": "就業者数（サービス事業）（男）（‐２００５）",
              "cat01": "F233001",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233002/人/f08/就業者数（サービス事業）（女）（‐２００５）",
              "label": "就業者数（サービス事業）（女）（‐２００５）",
              "cat01": "F233002",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2331/人/f08/就業者数（サービス業（他に分類されない））（‐２００５）",
              "label": "就業者数（サービス業（他に分類されない））（‐２００５）",
              "cat01": "F2331",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233101/人/f08/就業者数（サービス業（他に分類されない））（男）（‐２００５）",
              "label": "就業者数（サービス業（他に分類されない））（男）（‐２００５）",
              "cat01": "F233101",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233102/人/f08/就業者数（サービス業（他に分類されない））（女）（‐２００５）",
              "label": "就業者数（サービス業（他に分類されない））（女）（‐２００５）",
              "cat01": "F233102",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2332/人/f08/就業者数（公務（他に分類されない））（‐２００５）",
              "label": "就業者数（公務（他に分類されない））（‐２００５）",
              "cat01": "F2332",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233201/人/f08/就業者数（公務（他に分類されない））（男）（‐２００５）",
              "label": "就業者数（公務（他に分類されない））（男）（‐２００５）",
              "cat01": "F233201",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233202/人/f08/就業者数（公務（他に分類されない））（女）（‐２００５）",
              "label": "就業者数（公務（他に分類されない））（女）（‐２００５）",
              "cat01": "F233202",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2333/人/f08/就業者数（分類不能の産業）（‐２００５）",
              "label": "就業者数（分類不能の産業）（‐２００５）",
              "cat01": "F2333",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233301/人/f08/就業者数（分類不能の産業）（男）（‐２００５）",
              "label": "就業者数（分類不能の産業）（男）（‐２００５）",
              "cat01": "F233301",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F233302/人/f08/就業者数（分類不能の産業）（女）（‐２００５）",
              "label": "就業者数（分類不能の産業）（女）（‐２００５）",
              "cat01": "F233302",
              "unit": "人",
              "sourceId": "f08"
            },
            {
              "statId": "0000010106/F2334/人/f09/就業者数（農業，林業）（２０１０‐）",
              "label": "就業者数（農業，林業）（２０１０‐）",
              "cat01": "F2334",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2335/人/f09/就業者数（漁業）（２０１０‐）",
              "label": "就業者数（漁業）（２０１０‐）",
              "cat01": "F2335",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2336/人/f09/就業者数（鉱業，採石業，砂利採取業）（２０１０‐）",
              "label": "就業者数（鉱業，採石業，砂利採取業）（２０１０‐）",
              "cat01": "F2336",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2337/人/f09/就業者数（建設業）（２０１０‐）",
              "label": "就業者数（建設業）（２０１０‐）",
              "cat01": "F2337",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2338/人/f09/就業者数（製造業）（２０１０‐）",
              "label": "就業者数（製造業）（２０１０‐）",
              "cat01": "F2338",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2339/人/f09/就業者数（電気・ガス・熱供給・水道業）（２０１０‐）",
              "label": "就業者数（電気・ガス・熱供給・水道業）（２０１０‐）",
              "cat01": "F2339",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2340/人/f09/就業者数（情報通信業）（２０１０‐）",
              "label": "就業者数（情報通信業）（２０１０‐）",
              "cat01": "F2340",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2341/人/f09/就業者数（運輸業，郵便業）（２０１０‐）",
              "label": "就業者数（運輸業，郵便業）（２０１０‐）",
              "cat01": "F2341",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2342/人/f09/就業者数（卸売業，小売業）（２０１０‐）",
              "label": "就業者数（卸売業，小売業）（２０１０‐）",
              "cat01": "F2342",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2343/人/f09/就業者数（金融業，保険業）（２０１０‐）",
              "label": "就業者数（金融業，保険業）（２０１０‐）",
              "cat01": "F2343",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2344/人/f09/就業者数（不動産業，物品賃貸業）（２０１０‐）",
              "label": "就業者数（不動産業，物品賃貸業）（２０１０‐）",
              "cat01": "F2344",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2345/人/f09/就業者数（学術研究，専門・技術サービス業）（２０１０‐）",
              "label": "就業者数（学術研究，専門・技術サービス業）（２０１０‐）",
              "cat01": "F2345",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2346/人/f09/就業者数（宿泊業，飲食サービス業）（２０１０‐）",
              "label": "就業者数（宿泊業，飲食サービス業）（２０１０‐）",
              "cat01": "F2346",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2347/人/f09/就業者数（生活関連サービス業，娯楽業）（２０１０‐）",
              "label": "就業者数（生活関連サービス業，娯楽業）（２０１０‐）",
              "cat01": "F2347",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2348/人/f09/就業者数（教育，学習支援業）（２０１０‐）",
              "label": "就業者数（教育，学習支援業）（２０１０‐）",
              "cat01": "F2348",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2349/人/f09/就業者数（医療，福祉）（２０１０‐）",
              "label": "就業者数（医療，福祉）（２０１０‐）",
              "cat01": "F2349",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2350/人/f09/就業者数（複合サービス事業）（２０１０‐）",
              "label": "就業者数（複合サービス事業）（２０１０‐）",
              "cat01": "F2350",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2351/人/f09/就業者数（サービス業（他に分類されないもの））（２０１０‐）",
              "label": "就業者数（サービス業（他に分類されないもの））（２０１０‐）",
              "cat01": "F2351",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2352/人/f09/就業者数（公務（他に分類されるものを除く））（２０１０‐）",
              "label": "就業者数（公務（他に分類されるものを除く））（２０１０‐）",
              "cat01": "F2352",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2353/人/f09/就業者数（分類不能の産業）（２０１０‐）",
              "label": "就業者数（分類不能の産業）（２０１０‐）",
              "cat01": "F2353",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2401/人/f09/雇用者数（国勢調査結果）",
              "label": "雇用者数（国勢調査結果）",
              "cat01": "F2401",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240101/人/f09/雇用者数（男）（国勢調査）（‐２００５）",
              "label": "雇用者数（男）（国勢調査）（‐２００５）",
              "cat01": "F240101",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240102/人/f09/雇用者数（女）（国勢調査）（‐２００５）",
              "label": "雇用者数（女）（国勢調査）（‐２００５）",
              "cat01": "F240102",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2402/人/f09/役員数",
              "label": "役員数",
              "cat01": "F2402",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240201/人/f09/役員数（男）",
              "label": "役員数（男）",
              "cat01": "F240201",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240202/人/f09/役員数（女）",
              "label": "役員数（女）",
              "cat01": "F240202",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2403/人/f09/雇人のある業主数",
              "label": "雇人のある業主数",
              "cat01": "F2403",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240301/人/f09/雇人のある業主数（男）",
              "label": "雇人のある業主数（男）",
              "cat01": "F240301",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240302/人/f09/雇人のある業主数（女）",
              "label": "雇人のある業主数（女）",
              "cat01": "F240302",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2404/人/f09/雇人のない業主数",
              "label": "雇人のない業主数",
              "cat01": "F2404",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240401/人/f09/雇人のない業主数（男）",
              "label": "雇人のない業主数（男）",
              "cat01": "F240401",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240402/人/f09/雇人のない業主数（女）",
              "label": "雇人のない業主数（女）",
              "cat01": "F240402",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2405/人/f09/家族従業者数（国勢調査結果）",
              "label": "家族従業者数（国勢調査結果）",
              "cat01": "F2405",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240501/人/f09/家族従業者数（男）",
              "label": "家族従業者数（男）",
              "cat01": "F240501",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240502/人/f09/家族従業者数（女）",
              "label": "家族従業者数（女）",
              "cat01": "F240502",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2406/人/f09/自営業主及び家族従業者数",
              "label": "自営業主及び家族従業者数",
              "cat01": "F2406",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240601/人/f09/自営業主及び家族従業者数（男）",
              "label": "自営業主及び家族従業者数（男）",
              "cat01": "F240601",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240602/人/f09/自営業主及び家族従業者数（女）",
              "label": "自営業主及び家族従業者数（女）",
              "cat01": "F240602",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2407/人/f09/雇用者数（常雇）",
              "label": "雇用者数（常雇）",
              "cat01": "F2407",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240701/人/f09/雇用者数（常雇）（男）",
              "label": "雇用者数（常雇）（男）",
              "cat01": "F240701",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240702/人/f09/雇用者数（常雇）（女）",
              "label": "雇用者数（常雇）（女）",
              "cat01": "F240702",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2408/人/f09/雇用者数（臨時雇）",
              "label": "雇用者数（臨時雇）",
              "cat01": "F2408",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240801/人/f09/雇用者数（臨時雇）（男）",
              "label": "雇用者数（臨時雇）（男）",
              "cat01": "F240801",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F240802/人/f09/雇用者数（臨時雇）（女）",
              "label": "雇用者数（臨時雇）（女）",
              "cat01": "F240802",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2409/人/f09/雇用者数（正規の職員・従業員）",
              "label": "雇用者数（正規の職員・従業員）",
              "cat01": "F2409",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2410/人/f09/雇用者数（労働者派遣事業所の派遣社員）",
              "label": "雇用者数（労働者派遣事業所の派遣社員）",
              "cat01": "F2410",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2411/人/f09/雇用者数（パート・アルバイト・その他）",
              "label": "雇用者数（パート・アルバイト・その他）",
              "cat01": "F2411",
              "unit": "人",
              "sourceId": "f09"
            },
            {
              "statId": "0000010106/F2501/千人/f10/雇用者数（就業構造基本調査）",
              "label": "雇用者数（就業構造基本調査）",
              "cat01": "F2501",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F250101/千人/f10/雇用者数（男）（就業構造基本調査）",
              "label": "雇用者数（男）（就業構造基本調査）",
              "cat01": "F250101",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F250102/千人/f10/雇用者数（女）（就業構造基本調査）",
              "label": "雇用者数（女）（就業構造基本調査）",
              "cat01": "F250102",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F2502/千人/f10/自営業主数",
              "label": "自営業主数",
              "cat01": "F2502",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F250201/千人/f10/自営業主数（男）",
              "label": "自営業主数（男）",
              "cat01": "F250201",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F250202/千人/f10/自営業主数（女）",
              "label": "自営業主数（女）",
              "cat01": "F250202",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F2503/千人/f10/家族従業者数（就業構造基本調査結果）",
              "label": "家族従業者数（就業構造基本調査結果）",
              "cat01": "F2503",
              "unit": "千人",
              "sourceId": "f10"
            },
            {
              "statId": "0000010106/F2601/人/f11/専門的・技術的職業従事者数（‐２００５）",
              "label": "専門的・技術的職業従事者数（‐２００５）",
              "cat01": "F2601",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260101/人/f11/専門的・技術的職業従事者数（男）（‐２００５）",
              "label": "専門的・技術的職業従事者数（男）（‐２００５）",
              "cat01": "F260101",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260102/人/f11/専門的・技術的職業従事者数（女）（‐２００５）",
              "label": "専門的・技術的職業従事者数（女）（‐２００５）",
              "cat01": "F260102",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2602/人/f11/管理的職業従事者数（‐２００５）",
              "label": "管理的職業従事者数（‐２００５）",
              "cat01": "F2602",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260201/人/f11/管理的職業従事者数（男）（‐２００５）",
              "label": "管理的職業従事者数（男）（‐２００５）",
              "cat01": "F260201",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260202/人/f11/管理的職業従事者数（女）（‐２００５）",
              "label": "管理的職業従事者数（女）（‐２００５）",
              "cat01": "F260202",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2603/人/f11/事務従事者数（‐２００５）",
              "label": "事務従事者数（‐２００５）",
              "cat01": "F2603",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260301/人/f11/事務従事者数（男）（‐２００５）",
              "label": "事務従事者数（男）（‐２００５）",
              "cat01": "F260301",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260302/人/f11/事務従事者数（女）（‐２００５）",
              "label": "事務従事者数（女）（‐２００５）",
              "cat01": "F260302",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2604/人/f11/販売従事者数（‐２００５）",
              "label": "販売従事者数（‐２００５）",
              "cat01": "F2604",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260401/人/f11/販売従事者数（男）（‐２００５）",
              "label": "販売従事者数（男）（‐２００５）",
              "cat01": "F260401",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260402/人/f11/販売従事者数（女）（‐２００５）",
              "label": "販売従事者数（女）（‐２００５）",
              "cat01": "F260402",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2605/人/f11/農林漁業作業者数（‐２００５）",
              "label": "農林漁業作業者数（‐２００５）",
              "cat01": "F2605",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260501/人/f11/農林漁業作業者数（男）（‐２００５）",
              "label": "農林漁業作業者数（男）（‐２００５）",
              "cat01": "F260501",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260502/人/f11/農林漁業作業者数（女）（‐２００５）",
              "label": "農林漁業作業者数（女）（‐２００５）",
              "cat01": "F260502",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2607/人/f11/運輸・通信従事者数（‐２００５）",
              "label": "運輸・通信従事者数（‐２００５）",
              "cat01": "F2607",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260701/人/f11/運輸・通信従事者数（男）（‐２００５）",
              "label": "運輸・通信従事者数（男）（‐２００５）",
              "cat01": "F260701",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260702/人/f11/運輸・通信従事者数（女）（‐２００５）",
              "label": "運輸・通信従事者数（女）（‐２００５）",
              "cat01": "F260702",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2609/人/f11/保安職業従事者数（‐２００５）",
              "label": "保安職業従事者数（‐２００５）",
              "cat01": "F2609",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260901/人/f11/保安職業従事者数（男）（‐２００５）",
              "label": "保安職業従事者数（男）（‐２００５）",
              "cat01": "F260901",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F260902/人/f11/保安職業従事者数（女）（‐２００５）",
              "label": "保安職業従事者数（女）（‐２００５）",
              "cat01": "F260902",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2610/人/f11/サービス職業従事者数（‐２００５）",
              "label": "サービス職業従事者数（‐２００５）",
              "cat01": "F2610",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261001/人/f11/サービス職業従事者数（男）（‐２００５）",
              "label": "サービス職業従事者数（男）（‐２００５）",
              "cat01": "F261001",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261002/人/f11/サービス職業従事者数（女）（‐２００５）",
              "label": "サービス職業従事者数（女）（‐２００５）",
              "cat01": "F261002",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2611/人/f11/分類不能の職業従事者数（‐２００５）",
              "label": "分類不能の職業従事者数（‐２００５）",
              "cat01": "F2611",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261101/人/f11/分類不能の職業従事者数（男）（‐２００５）",
              "label": "分類不能の職業従事者数（男）（‐２００５）",
              "cat01": "F261101",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261102/人/f11/分類不能の職業従事者数（女）（‐２００５）",
              "label": "分類不能の職業従事者数（女）（‐２００５）",
              "cat01": "F261102",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2612/人/f11/生産工程・労務作業者数（‐２００５）",
              "label": "生産工程・労務作業者数（‐２００５）",
              "cat01": "F2612",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261201/人/f11/生産工程・労務作業者数（男）（‐２００５）",
              "label": "生産工程・労務作業者数（男）（‐２００５）",
              "cat01": "F261201",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F261202/人/f11/生産工程・労務作業者数（女）（‐２００５）",
              "label": "生産工程・労務作業者数（女）（‐２００５）",
              "cat01": "F261202",
              "unit": "人",
              "sourceId": "f11"
            },
            {
              "statId": "0000010106/F2613/人/f12/管理的職業従事者数（２０１０‐）",
              "label": "管理的職業従事者数（２０１０‐）",
              "cat01": "F2613",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2614/人/f12/専門的・技術的職業従事者数（２０１０‐）",
              "label": "専門的・技術的職業従事者数（２０１０‐）",
              "cat01": "F2614",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2615/人/f12/事務従事者数（２０１０‐）",
              "label": "事務従事者数（２０１０‐）",
              "cat01": "F2615",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2616/人/f12/販売従事者数（２０１０‐）",
              "label": "販売従事者数（２０１０‐）",
              "cat01": "F2616",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2617/人/f12/サービス職業従事者数（２０１０‐）",
              "label": "サービス職業従事者数（２０１０‐）",
              "cat01": "F2617",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2618/人/f12/保安職業従事者数（２０１０‐）",
              "label": "保安職業従事者数（２０１０‐）",
              "cat01": "F2618",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2619/人/f12/農林漁業従事者数（２０１０‐）",
              "label": "農林漁業従事者数（２０１０‐）",
              "cat01": "F2619",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2620/人/f12/生産工程従事者数（２０１０‐）",
              "label": "生産工程従事者数（２０１０‐）",
              "cat01": "F2620",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2621/人/f12/輸送・機械運転従事者数（２０１０‐）",
              "label": "輸送・機械運転従事者数（２０１０‐）",
              "cat01": "F2621",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2622/人/f12/建設・採掘従事者数（２０１０‐）",
              "label": "建設・採掘従事者数（２０１０‐）",
              "cat01": "F2622",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2623/人/f12/運搬・清掃・包装等従事者数（２０１０‐）",
              "label": "運搬・清掃・包装等従事者数（２０１０‐）",
              "cat01": "F2623",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2624/人/f12/分類不能の職業従事者数（２０１０‐）",
              "label": "分類不能の職業従事者数（２０１０‐）",
              "cat01": "F2624",
              "unit": "人",
              "sourceId": "f12"
            },
            {
              "statId": "0000010106/F2701/人/f13/自市区町村で従業している就業者数",
              "label": "自市区町村で従業している就業者数",
              "cat01": "F2701",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270101/人/f13/自市区町村で従業している就業者数（男）",
              "label": "自市区町村で従業している就業者数（男）",
              "cat01": "F270101",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270102/人/f13/自市区町村で従業している就業者数（女）",
              "label": "自市区町村で従業している就業者数（女）",
              "cat01": "F270102",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2702/人/f13/県内他市区町村で従業している就業者数",
              "label": "県内他市区町村で従業している就業者数",
              "cat01": "F2702",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270201/人/f13/県内他市区町村で従業している就業者数（男）",
              "label": "県内他市区町村で従業している就業者数（男）",
              "cat01": "F270201",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270202/人/f13/県内他市区町村で従業している就業者数（女）",
              "label": "県内他市区町村で従業している就業者数（女）",
              "cat01": "F270202",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2703/人/f13/他県で従業している就業者数",
              "label": "他県で従業している就業者数",
              "cat01": "F2703",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270301/人/f13/他県で従業している就業者数（男）",
              "label": "他県で従業している就業者数（男）",
              "cat01": "F270301",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270302/人/f13/他県で従業している就業者数（女）",
              "label": "他県で従業している就業者数（女）",
              "cat01": "F270302",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2704/人/f13/県内就業者数",
              "label": "県内就業者数",
              "cat01": "F2704",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270401/人/f13/県内就業者数（男）",
              "label": "県内就業者数（男）",
              "cat01": "F270401",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270402/人/f13/県内就業者数（女）",
              "label": "県内就業者数（女）",
              "cat01": "F270402",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2705/人/f13/他市区町村への通勤者数",
              "label": "他市区町村への通勤者数",
              "cat01": "F2705",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270501/人/f13/他市区町村への通勤者数（男）",
              "label": "他市区町村への通勤者数（男）",
              "cat01": "F270501",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F270502/人/f13/他市区町村への通勤者数（女）",
              "label": "他市区町村への通勤者数（女）",
              "cat01": "F270502",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2801/人/f13/従業地による就業者数",
              "label": "従業地による就業者数",
              "cat01": "F2801",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280115/人/f13/従業地による就業者数（農業）（‐２００５）",
              "label": "従業地による就業者数（農業）（‐２００５）",
              "cat01": "F280115",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280116/人/f13/従業地による就業者数（林業）（‐２００５）",
              "label": "従業地による就業者数（林業）（‐２００５）",
              "cat01": "F280116",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280117/人/f13/従業地による就業者数（漁業）（‐２００５）",
              "label": "従業地による就業者数（漁業）（‐２００５）",
              "cat01": "F280117",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280118/人/f13/従業地による就業者数（鉱業）（‐２００５）",
              "label": "従業地による就業者数（鉱業）（‐２００５）",
              "cat01": "F280118",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280119/人/f13/従業地による就業者数（建設業）（‐２００５）",
              "label": "従業地による就業者数（建設業）（‐２００５）",
              "cat01": "F280119",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280120/人/f13/従業地による就業者数（製造業）（‐２００５）",
              "label": "従業地による就業者数（製造業）（‐２００５）",
              "cat01": "F280120",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280121/人/f13/従業地による就業者数（電気・ガス・熱供給・水道業）（‐２００５）",
              "label": "従業地による就業者数（電気・ガス・熱供給・水道業）（‐２００５）",
              "cat01": "F280121",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280122/人/f13/従業地による就業者数（情報通信業）（‐２００５）",
              "label": "従業地による就業者数（情報通信業）（‐２００５）",
              "cat01": "F280122",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280123/人/f13/従業地による就業者数（運輸業）（‐２００５）",
              "label": "従業地による就業者数（運輸業）（‐２００５）",
              "cat01": "F280123",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280124/人/f13/従業地による就業者数（卸売・小売業）（‐２００５）",
              "label": "従業地による就業者数（卸売・小売業）（‐２００５）",
              "cat01": "F280124",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280125/人/f13/従業地による就業者数（金融・保険業）（‐２００５）",
              "label": "従業地による就業者数（金融・保険業）（‐２００５）",
              "cat01": "F280125",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280126/人/f13/従業地による就業者数（不動産業）（‐２００５）",
              "label": "従業地による就業者数（不動産業）（‐２００５）",
              "cat01": "F280126",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280127/人/f13/従業地による就業者数（飲食店，宿泊業）（‐２００５）",
              "label": "従業地による就業者数（飲食店，宿泊業）（‐２００５）",
              "cat01": "F280127",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280128/人/f13/従業地による就業者数（医療・福祉）（‐２００５）",
              "label": "従業地による就業者数（医療・福祉）（‐２００５）",
              "cat01": "F280128",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280129/人/f13/従業地による就業者数（教育，学習支援業）（‐２００５）",
              "label": "従業地による就業者数（教育，学習支援業）（‐２００５）",
              "cat01": "F280129",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280130/人/f13/従業地による就業者数（複合サービス事業）（‐２００５）",
              "label": "従業地による就業者数（複合サービス事業）（‐２００５）",
              "cat01": "F280130",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280131/人/f13/従業地による就業者数（サービス業（他に分類されないもの））（‐２００５）",
              "label": "従業地による就業者数（サービス業（他に分類されないもの））（‐２００５）",
              "cat01": "F280131",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280132/人/f13/従業地による就業者数（公務（他に分類されないもの））（‐２００５）",
              "label": "従業地による就業者数（公務（他に分類されないもの））（‐２００５）",
              "cat01": "F280132",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280133/人/f13/従業地による就業者数（分類不能の産業）（‐２００５）",
              "label": "従業地による就業者数（分類不能の産業）（‐２００５）",
              "cat01": "F280133",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2802/人/f13/他県に常住している就業者数",
              "label": "他県に常住している就業者数",
              "cat01": "F2802",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280201/人/f13/他県に常住している就業者数（男）",
              "label": "他県に常住している就業者数（男）",
              "cat01": "F280201",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280202/人/f13/他県に常住している就業者数（女）",
              "label": "他県に常住している就業者数（女）",
              "cat01": "F280202",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F2803/人/f13/他市区町村からの通勤者数",
              "label": "他市区町村からの通勤者数",
              "cat01": "F2803",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280301/人/f13/他市区町村からの通勤者数（男）",
              "label": "他市区町村からの通勤者数（男）",
              "cat01": "F280301",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F280302/人/f13/他市区町村からの通勤者数（女）",
              "label": "他市区町村からの通勤者数（女）",
              "cat01": "F280302",
              "unit": "人",
              "sourceId": "f13"
            },
            {
              "statId": "0000010106/F3101/件/f14/新規求職申込件数（一般）",
              "label": "新規求職申込件数（一般）",
              "cat01": "F3101",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310101/件/f14/新規求職申込件数（一般）（男）",
              "label": "新規求職申込件数（一般）（男）",
              "cat01": "F310101",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310102/件/f14/新規求職申込件数（一般）（女）",
              "label": "新規求職申込件数（一般）（女）",
              "cat01": "F310102",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3102/人/f14/月間有効求職者数（一般）（年度計）",
              "label": "月間有効求職者数（一般）（年度計）",
              "cat01": "F3102",
              "unit": "人",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310201/人/f14/月間有効求職者数（一般）（男）",
              "label": "月間有効求職者数（一般）（男）",
              "cat01": "F310201",
              "unit": "人",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310202/人/f14/月間有効求職者数（一般）（女）",
              "label": "月間有効求職者数（一般）（女）",
              "cat01": "F310202",
              "unit": "人",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3103/人/f14/月間有効求人数（一般）（年度計）",
              "label": "月間有効求人数（一般）（年度計）",
              "cat01": "F3103",
              "unit": "人",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3104/人/f14/充足数（一般）",
              "label": "充足数（一般）",
              "cat01": "F3104",
              "unit": "人",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3105/件/f14/就職件数（一般）（年度計）",
              "label": "就職件数（一般）（年度計）",
              "cat01": "F3105",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310501/件/f14/就職件数（一般）（男）",
              "label": "就職件数（一般）（男）",
              "cat01": "F310501",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F310502/件/f14/就職件数（一般）（女）",
              "label": "就職件数（一般）（女）",
              "cat01": "F310502",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3106/件/f14/県内就職件数（一般）（年度計）",
              "label": "県内就職件数（一般）（年度計）",
              "cat01": "F3106",
              "unit": "件",
              "sourceId": "f14"
            },
            {
              "statId": "0000010106/F3107/１０人/f15/労働者数（一般）",
              "label": "労働者数（一般）",
              "cat01": "F3107",
              "unit": "１０人",
              "sourceId": "f15"
            },
            {
              "statId": "0000010106/F3201/件/f16/パートタイム新規求職申込件数（常用）",
              "label": "パートタイム新規求職申込件数（常用）",
              "cat01": "F3201",
              "unit": "件",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3202/件/f16/パートタイム新規求職申込件数（臨時）",
              "label": "パートタイム新規求職申込件数（臨時）",
              "cat01": "F3202",
              "unit": "件",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3211/人/f16/パートタイム月間有効求職者数（常用）（年度計）",
              "label": "パートタイム月間有効求職者数（常用）（年度計）",
              "cat01": "F3211",
              "unit": "人",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3212/人/f16/パートタイム月間有効求職者数（臨時）（年度計）",
              "label": "パートタイム月間有効求職者数（臨時）（年度計）",
              "cat01": "F3212",
              "unit": "人",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3221/件/f16/パートタイム就職件数（常用）",
              "label": "パートタイム就職件数（常用）",
              "cat01": "F3221",
              "unit": "件",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3222/件/f16/パートタイム就職件数（臨時）",
              "label": "パートタイム就職件数（臨時）",
              "cat01": "F3222",
              "unit": "件",
              "sourceId": "f16"
            },
            {
              "statId": "0000010106/F3230/１０人/f17/女性パートタイム労働者数",
              "label": "女性パートタイム労働者数",
              "cat01": "F3230",
              "unit": "１０人",
              "sourceId": "f17"
            },
            {
              "statId": "0000010106/F3240/１０人/f17/男性パートタイム労働者数",
              "label": "男性パートタイム労働者数",
              "cat01": "F3240",
              "unit": "１０人",
              "sourceId": "f17"
            },
            {
              "statId": "0000010106/F3301/人/f18/新規学卒者求職者数（中学）",
              "label": "新規学卒者求職者数（中学）",
              "cat01": "F3301",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F3302/人/f18/新規学卒者求職者数（高校）",
              "label": "新規学卒者求職者数（高校）",
              "cat01": "F3302",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F3311/人/f18/新規学卒者求人数（中学）",
              "label": "新規学卒者求人数（中学）",
              "cat01": "F3311",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F3312/人/f18/新規学卒者求人数（高校）",
              "label": "新規学卒者求人数（高校）",
              "cat01": "F3312",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F3321/人/f18/新規学卒者就職者数（中学）",
              "label": "新規学卒者就職者数（中学）",
              "cat01": "F3321",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F3322/人/f18/新規学卒者就職者数（高校）",
              "label": "新規学卒者就職者数（高校）",
              "cat01": "F3322",
              "unit": "人",
              "sourceId": "f18"
            },
            {
              "statId": "0000010106/F340101/件/f19/中高年齢者新規求職申込件数（４５歳以上）",
              "label": "中高年齢者新規求職申込件数（４５歳以上）",
              "cat01": "F340101",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F340102/件/f19/中高年齢者新規求職申込件数（５５歳以上）",
              "label": "中高年齢者新規求職申込件数（５５歳以上）",
              "cat01": "F340102",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F340103/件/f19/中高年齢者新規求職申込件数（６５歳以上）",
              "label": "中高年齢者新規求職申込件数（６５歳以上）",
              "cat01": "F340103",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F340201/人/f19/中高年齢者有効求職者数（４５歳以上）（月平均）",
              "label": "中高年齢者有効求職者数（４５歳以上）（月平均）",
              "cat01": "F340201",
              "unit": "人",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F340202/人/f19/中高年齢者有効求職者数（５５歳以上）（月平均）",
              "label": "中高年齢者有効求職者数（５５歳以上）（月平均）",
              "cat01": "F340202",
              "unit": "人",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F340203/人/f19/中高年齢者有効求職者数（６５歳以上）（月平均）",
              "label": "中高年齢者有効求職者数（６５歳以上）（月平均）",
              "cat01": "F340203",
              "unit": "人",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F341101/件/f19/中高年齢者就職件数（４５歳以上）",
              "label": "中高年齢者就職件数（４５歳以上）",
              "cat01": "F341101",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F341102/件/f19/中高年齢者就職件数（５５歳以上）",
              "label": "中高年齢者就職件数（５５歳以上）",
              "cat01": "F341102",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F341103/件/f19/中高年齢者就職件数（６５歳以上）",
              "label": "中高年齢者就職件数（６５歳以上）",
              "cat01": "F341103",
              "unit": "件",
              "sourceId": "f19"
            },
            {
              "statId": "0000010106/F341201/１０人/f20/一般労働者数（４５歳以上）（企業規模１０人以上の事業所）",
              "label": "一般労働者数（４５歳以上）（企業規模１０人以上の事業所）",
              "cat01": "F341201",
              "unit": "１０人",
              "sourceId": "f20"
            },
            {
              "statId": "0000010106/F341202/１０人/f20/一般労働者数（５５歳以上）（企業規模１０人以上の事業所）",
              "label": "一般労働者数（５５歳以上）（企業規模１０人以上の事業所）",
              "cat01": "F341202",
              "unit": "１０人",
              "sourceId": "f20"
            },
            {
              "statId": "0000010106/F341203/１０人/f20/一般労働者数（６５歳以上）（企業規模１０人以上の事業所）",
              "label": "一般労働者数（６５歳以上）（企業規模１０人以上の事業所）",
              "cat01": "F341203",
              "unit": "１０人",
              "sourceId": "f20"
            },
            {
              "statId": "0000010106/F3502/件/f21/障害者就職件数",
              "label": "障害者就職件数",
              "cat01": "F3502",
              "unit": "件",
              "sourceId": "f21"
            },
            {
              "statId": "0000010106/F350210/件/f21/身体障害者就職件数",
              "label": "身体障害者就職件数",
              "cat01": "F350210",
              "unit": "件",
              "sourceId": "f21"
            },
            {
              "statId": "0000010106/F350220/件/f21/知的障害者等就職件数",
              "label": "知的障害者等就職件数",
              "cat01": "F350220",
              "unit": "件",
              "sourceId": "f21"
            },
            {
              "statId": "0000010106/F350221/件/f21/知的障害者就職件数",
              "label": "知的障害者就職件数",
              "cat01": "F350221",
              "unit": "件",
              "sourceId": "f21"
            },
            {
              "statId": "0000010106/F4101/千人/f22/継続就業希望者数",
              "label": "継続就業希望者数",
              "cat01": "F4101",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410101/千人/f22/継続就業希望者数（男）",
              "label": "継続就業希望者数（男）",
              "cat01": "F410101",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410102/千人/f22/継続就業希望者数（女）",
              "label": "継続就業希望者数（女）",
              "cat01": "F410102",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4102/千人/f22/追加就業希望者数",
              "label": "追加就業希望者数",
              "cat01": "F4102",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410201/千人/f22/追加就業希望者数（男）",
              "label": "追加就業希望者数（男）",
              "cat01": "F410201",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410202/千人/f22/追加就業希望者数（女）",
              "label": "追加就業希望者数（女）",
              "cat01": "F410202",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4103/千人/f22/追加就業希望者数（求職者）",
              "label": "追加就業希望者数（求職者）",
              "cat01": "F4103",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410301/千人/f22/追加就業希望者数（求職者）（男）",
              "label": "追加就業希望者数（求職者）（男）",
              "cat01": "F410301",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410302/千人/f22/追加就業希望者数（求職者）（女）",
              "label": "追加就業希望者数（求職者）（女）",
              "cat01": "F410302",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4104/千人/f22/転職希望者数",
              "label": "転職希望者数",
              "cat01": "F4104",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410401/千人/f22/転職希望者数（男）",
              "label": "転職希望者数（男）",
              "cat01": "F410401",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410402/千人/f22/転職希望者数（女）",
              "label": "転職希望者数（女）",
              "cat01": "F410402",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4105/千人/f22/転職希望者数（求職者）",
              "label": "転職希望者数（求職者）",
              "cat01": "F4105",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410501/千人/f22/転職希望者数（求職者）（男）",
              "label": "転職希望者数（求職者）（男）",
              "cat01": "F410501",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410502/千人/f22/転職希望者数（求職者）（女）",
              "label": "転職希望者数（求職者）（女）",
              "cat01": "F410502",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4106/千人/f22/就業休止希望者数",
              "label": "就業休止希望者数",
              "cat01": "F4106",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410601/千人/f22/就業休止希望者数（男）",
              "label": "就業休止希望者数（男）",
              "cat01": "F410601",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410602/千人/f22/就業休止希望者数（女）",
              "label": "就業休止希望者数（女）",
              "cat01": "F410602",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4107/千人/f22/就業希望者数",
              "label": "就業希望者数",
              "cat01": "F4107",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410701/千人/f22/就業希望者数（男）",
              "label": "就業希望者数（男）",
              "cat01": "F410701",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410702/千人/f22/就業希望者数（女）",
              "label": "就業希望者数（女）",
              "cat01": "F410702",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4108/千人/f22/非就業希望者数",
              "label": "非就業希望者数",
              "cat01": "F4108",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410801/千人/f22/非就業希望者数（男）",
              "label": "非就業希望者数（男）",
              "cat01": "F410801",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F410802/千人/f22/非就業希望者数（女）",
              "label": "非就業希望者数（女）",
              "cat01": "F410802",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4201/千人/f22/継続就業者数",
              "label": "継続就業者数",
              "cat01": "F4201",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420101/千人/f22/継続就業者数（男）",
              "label": "継続就業者数（男）",
              "cat01": "F420101",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420102/千人/f22/継続就業者数（女）",
              "label": "継続就業者数（女）",
              "cat01": "F420102",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4202/千人/f22/転職者数",
              "label": "転職者数",
              "cat01": "F4202",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420201/千人/f22/転職者数（男）",
              "label": "転職者数（男）",
              "cat01": "F420201",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420202/千人/f22/転職者数（女）",
              "label": "転職者数（女）",
              "cat01": "F420202",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4203/千人/f22/離職者数",
              "label": "離職者数",
              "cat01": "F4203",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420301/千人/f22/離職者数（男）",
              "label": "離職者数（男）",
              "cat01": "F420301",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420302/千人/f22/離職者数（女）",
              "label": "離職者数（女）",
              "cat01": "F420302",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4204/千人/f22/新規就業者数",
              "label": "新規就業者数",
              "cat01": "F4204",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420401/千人/f22/新規就業者数（男）",
              "label": "新規就業者数（男）",
              "cat01": "F420401",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420402/千人/f22/新規就業者数（女）",
              "label": "新規就業者数（女）",
              "cat01": "F420402",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F4205/千人/f22/継続非就業者数",
              "label": "継続非就業者数",
              "cat01": "F4205",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420501/千人/f22/継続非就業者数（男）",
              "label": "継続非就業者数（男）",
              "cat01": "F420501",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F420502/千人/f22/継続非就業者数（女）",
              "label": "継続非就業者数（女）",
              "cat01": "F420502",
              "unit": "千人",
              "sourceId": "f22"
            },
            {
              "statId": "0000010106/F5103/校/f23/公共職業能力開発施設数",
              "label": "公共職業能力開発施設数",
              "cat01": "F5103",
              "unit": "校",
              "sourceId": "f23"
            },
            {
              "statId": "0000010106/F610101/時間/f24/所定内実労働時間数（男）",
              "label": "所定内実労働時間数（男）",
              "cat01": "F610101",
              "unit": "時間",
              "sourceId": "f24"
            },
            {
              "statId": "0000010106/F610102/時間/f24/所定内実労働時間数（女）",
              "label": "所定内実労働時間数（女）",
              "cat01": "F610102",
              "unit": "時間",
              "sourceId": "f24"
            },
            {
              "statId": "0000010106/F610201/時間/f24/超過実労働時間数（男）",
              "label": "超過実労働時間数（男）",
              "cat01": "F610201",
              "unit": "時間",
              "sourceId": "f24"
            },
            {
              "statId": "0000010106/F610202/時間/f24/超過実労働時間数（女）",
              "label": "超過実労働時間数（女）",
              "cat01": "F610202",
              "unit": "時間",
              "sourceId": "f24"
            },
            {
              "statId": "0000010106/F620101/千円/f25/きまって支給する現金給与額（男）",
              "label": "きまって支給する現金給与額（男）",
              "cat01": "F620101",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620102/千円/f25/きまって支給する現金給与額（女）",
              "label": "きまって支給する現金給与額（女）",
              "cat01": "F620102",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620201/千円/f25/所定内給与額（男）",
              "label": "所定内給与額（男）",
              "cat01": "F620201",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620202/千円/f25/所定内給与額（女）",
              "label": "所定内給与額（女）",
              "cat01": "F620202",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620203/千円/f25/所定内給与額（１０～９９人規模）（男）",
              "label": "所定内給与額（１０～９９人規模）（男）",
              "cat01": "F620203",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620204/千円/f25/所定内給与額（１０～９９人規模）（女）",
              "label": "所定内給与額（１０～９９人規模）（女）",
              "cat01": "F620204",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620205/千円/f25/所定内給与額（１００～９９９人規模）（男）",
              "label": "所定内給与額（１００～９９９人規模）（男）",
              "cat01": "F620205",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620206/千円/f25/所定内給与額（１００～９９９人規模）（女）",
              "label": "所定内給与額（１００～９９９人規模）（女）",
              "cat01": "F620206",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620209/千円/f25/所定内給与額（２５～２９歳）（男）",
              "label": "所定内給与額（２５～２９歳）（男）",
              "cat01": "F620209",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620210/千円/f25/所定内給与額（２５～２９歳）（女）",
              "label": "所定内給与額（２５～２９歳）（女）",
              "cat01": "F620210",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620211/千円/f25/所定内給与額（３５～３９歳）（男）",
              "label": "所定内給与額（３５～３９歳）（男）",
              "cat01": "F620211",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620212/千円/f25/所定内給与額（３５～３９歳）（女）",
              "label": "所定内給与額（３５～３９歳）（女）",
              "cat01": "F620212",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F620213/千円/f25/所定内給与額（５５～５９歳）（男）",
              "label": "所定内給与額（５５～５９歳）（男）",
              "cat01": "F620213",
              "unit": "千円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F6204/円/f25/女性パートタイムの給与",
              "label": "女性パートタイムの給与",
              "cat01": "F6204",
              "unit": "円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F6205/円/f25/男性パートタイムの給与",
              "label": "男性パートタイムの給与",
              "cat01": "F6205",
              "unit": "円",
              "sourceId": "f25"
            },
            {
              "statId": "0000010106/F6301/日/f26/労働日数",
              "label": "労働日数",
              "cat01": "F6301",
              "unit": "日",
              "sourceId": "f26"
            },
            {
              "statId": "0000010106/F6302/日/f26/労働日数（男）",
              "label": "労働日数（男）",
              "cat01": "F6302",
              "unit": "日",
              "sourceId": "f26"
            },
            {
              "statId": "0000010106/F6303/日/f26/労働日数（女）",
              "label": "労働日数（女）",
              "cat01": "F6303",
              "unit": "日",
              "sourceId": "f26"
            },
            {
              "statId": "0000010106/F6401/千円/f27/新規学卒者初任給（高校）（男）",
              "label": "新規学卒者初任給（高校）（男）",
              "cat01": "F6401",
              "unit": "千円",
              "sourceId": "f27"
            },
            {
              "statId": "0000010106/F6402/千円/f27/新規学卒者初任給（高校）（女）",
              "label": "新規学卒者初任給（高校）（女）",
              "cat01": "F6402",
              "unit": "千円",
              "sourceId": "f27"
            },
            {
              "statId": "0000010106/F6403/千円/f27/新規学卒者初任給（大学）（男）",
              "label": "新規学卒者初任給（大学）（男）",
              "cat01": "F6403",
              "unit": "千円",
              "sourceId": "f27"
            },
            {
              "statId": "0000010106/F6404/千円/f27/新規学卒者初任給（高専・短大）（女）",
              "label": "新規学卒者初任給（高専・短大）（女）",
              "cat01": "F6404",
              "unit": "千円",
              "sourceId": "f27"
            },
            {
              "statId": "0000010106/F6501/円/f28/地域別最低賃金",
              "label": "地域別最低賃金",
              "cat01": "F6501",
              "unit": "円",
              "sourceId": "f28"
            },
            {
              "statId": "0000010106/F8101/‐/f29/労働災害度数率",
              "label": "労働災害度数率",
              "cat01": "F8101",
              "unit": "‐",
              "sourceId": "f29"
            },
            {
              "statId": "0000010106/F8102/‐/f29/労働災害強度率",
              "label": "労働災害強度率",
              "cat01": "F8102",
              "unit": "‐",
              "sourceId": "f29"
            },
            {
              "statId": "0000010106/F9101/‐/f30/労働組合数",
              "label": "労働組合数",
              "cat01": "F9101",
              "unit": "‐",
              "sourceId": "f30"
            },
            {
              "statId": "0000010106/F9102/人/f30/労働組合員数",
              "label": "労働組合員数",
              "cat01": "F9102",
              "unit": "人",
              "sourceId": "f30"
            },
            {
              "statId": "0000010106/F9201/件/f31/労働争議件数",
              "label": "労働争議件数",
              "cat01": "F9201",
              "unit": "件",
              "sourceId": "f31"
            },
            {
              "statId": "0000010106/F9202/人/f31/争議行為参加人員",
              "label": "争議行為参加人員",
              "cat01": "F9202",
              "unit": "人",
              "sourceId": "f31"
            },
            {
              "statId": "0000010106/F9203/日/f31/労働損失日数",
              "label": "労働損失日数",
              "cat01": "F9203",
              "unit": "日",
              "sourceId": "f31"
            }
          ]
        },
        {
          "label": "Ｇ文化・スポーツ",
          "statId": "0000010107",
          "children": [
            {
              "statId": "0000010107/G1101/人/g01/社会教育関係職員数",
              "label": "社会教育関係職員数",
              "cat01": "G1101",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G110101/人/g01/社会教育関係職員数（専任）",
              "label": "社会教育関係職員数（専任）",
              "cat01": "G110101",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G1102/人/g01/社会体育担当職員数",
              "label": "社会体育担当職員数",
              "cat01": "G1102",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G110201/人/g01/社会体育担当職員数（専任）",
              "label": "社会体育担当職員数（専任）",
              "cat01": "G110201",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G1103/人/g01/社会教育主事数",
              "label": "社会教育主事数",
              "cat01": "G1103",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G1104/人/g01/社会教育主事数（専任）",
              "label": "社会教育主事数（専任）",
              "cat01": "G1104",
              "unit": "人",
              "sourceId": "g01"
            },
            {
              "statId": "0000010107/G1201/館/g02/公民館数",
              "label": "公民館数",
              "cat01": "G1201",
              "unit": "館",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1202/人/g02/公民館職員数",
              "label": "公民館職員数",
              "cat01": "G1202",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120201/人/g02/公民館職員数（専任）",
              "label": "公民館職員数（専任）",
              "cat01": "G120201",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1203/館/g02/公民館諸集会実施館数",
              "label": "公民館諸集会実施館数",
              "cat01": "G1203",
              "unit": "館",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1204/件/g02/公民館諸集会実施件数",
              "label": "公民館諸集会実施件数",
              "cat01": "G1204",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120401/件/g02/公民館講習会・講演会・実習会実施件数",
              "label": "公民館講習会・講演会・実習会実施件数",
              "cat01": "G120401",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120402/件/g02/公民館体育事業実施件数",
              "label": "公民館体育事業実施件数",
              "cat01": "G120402",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120403/件/g02/公民館文化事業実施件数",
              "label": "公民館文化事業実施件数",
              "cat01": "G120403",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1205/人/g02/公民館諸集会実施参加者数",
              "label": "公民館諸集会実施参加者数",
              "cat01": "G1205",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120501/人/g02/公民館講習会・講演会・実習会実施参加者数",
              "label": "公民館講習会・講演会・実習会実施参加者数",
              "cat01": "G120501",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120502/人/g02/公民館体育事業実施参加者数",
              "label": "公民館体育事業実施参加者数",
              "cat01": "G120502",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G120503/人/g02/公民館文化事業実施参加者数",
              "label": "公民館文化事業実施参加者数",
              "cat01": "G120503",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1301/館/g02/公民館類似施設数",
              "label": "公民館類似施設数",
              "cat01": "G1301",
              "unit": "館",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1302/人/g02/公民館類似施設職員数（専任）",
              "label": "公民館類似施設職員数（専任）",
              "cat01": "G1302",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1303/館/g02/公民館類似施設諸集会実施施設数",
              "label": "公民館類似施設諸集会実施施設数",
              "cat01": "G1303",
              "unit": "館",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1304/件/g02/公民館類似施設諸集会実施件数",
              "label": "公民館類似施設諸集会実施件数",
              "cat01": "G1304",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130401/件/g02/公民館類似施設講習会・講演会・実習会実施件数",
              "label": "公民館類似施設講習会・講演会・実習会実施件数",
              "cat01": "G130401",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130402/件/g02/公民館類似施設体育事業実施件数",
              "label": "公民館類似施設体育事業実施件数",
              "cat01": "G130402",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130403/件/g02/公民館類似施設文化事業実施件数",
              "label": "公民館類似施設文化事業実施件数",
              "cat01": "G130403",
              "unit": "件",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1305/人/g02/公民館類似施設諸集会実施参加者数",
              "label": "公民館類似施設諸集会実施参加者数",
              "cat01": "G1305",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130501/人/g02/公民館類似施設講習会・講演会・実習会実施参加者数",
              "label": "公民館類似施設講習会・講演会・実習会実施参加者数",
              "cat01": "G130501",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130502/人/g02/公民館類似施設体育事業実施参加者数",
              "label": "公民館類似施設体育事業実施参加者数",
              "cat01": "G130502",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G130503/人/g02/公民館類似施設文化事業実施参加者数",
              "label": "公民館類似施設文化事業実施参加者数",
              "cat01": "G130503",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1401/館/g02/図書館数",
              "label": "図書館数",
              "cat01": "G1401",
              "unit": "館",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1402/人/g02/図書館職員数",
              "label": "図書館職員数",
              "cat01": "G1402",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G140201/人/g02/図書館職員数（専任）",
              "label": "図書館職員数（専任）",
              "cat01": "G140201",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1403/冊/g02/図書館蔵書数",
              "label": "図書館蔵書数",
              "cat01": "G1403",
              "unit": "冊",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1404/人/g02/図書館登録者数",
              "label": "図書館登録者数",
              "cat01": "G1404",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1405/人/g02/図書館帯出者数",
              "label": "図書館帯出者数",
              "cat01": "G1405",
              "unit": "人",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1406/冊/g02/図書館館外貸出冊数",
              "label": "図書館館外貸出冊数",
              "cat01": "G1406",
              "unit": "冊",
              "sourceId": "g02"
            },
            {
              "statId": "0000010107/G1501/館/g03/博物館数",
              "label": "博物館数",
              "cat01": "G1501",
              "unit": "館",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G150101/館/g03/公立博物館数",
              "label": "公立博物館数",
              "cat01": "G150101",
              "unit": "館",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1502/人/g03/博物館職員数",
              "label": "博物館職員数",
              "cat01": "G1502",
              "unit": "人",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G150201/人/g03/博物館職員数（専任）",
              "label": "博物館職員数（専任）",
              "cat01": "G150201",
              "unit": "人",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1601/施設/g03/博物館類似施設数",
              "label": "博物館類似施設数",
              "cat01": "G1601",
              "unit": "施設",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1602/施設/g03/青少年教育施設数",
              "label": "青少年教育施設数",
              "cat01": "G1602",
              "unit": "施設",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1603/施設/g03/女性教育施設数",
              "label": "女性教育施設数",
              "cat01": "G1603",
              "unit": "施設",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1604/施設/g03/劇場，音楽堂等数",
              "label": "劇場，音楽堂等数",
              "cat01": "G1604",
              "unit": "施設",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1605/法人/g03/生涯学習・社会教育関係法人数",
              "label": "生涯学習・社会教育関係法人数",
              "cat01": "G1605",
              "unit": "法人",
              "sourceId": "g03"
            },
            {
              "statId": "0000010107/G1606/箇所/g04/勤労青少年・婦人福祉施設数",
              "label": "勤労青少年・婦人福祉施設数",
              "cat01": "G1606",
              "unit": "箇所",
              "sourceId": "g04"
            },
            {
              "statId": "0000010107/G2101/学級・講座/g05/青少年学級・講座数",
              "label": "青少年学級・講座数",
              "cat01": "G2101",
              "unit": "学級・講座",
              "sourceId": "g05"
            },
            {
              "statId": "0000010107/G2102/学級・講座/g05/成人一般学級・講座数",
              "label": "成人一般学級・講座数",
              "cat01": "G2102",
              "unit": "学級・講座",
              "sourceId": "g05"
            },
            {
              "statId": "0000010107/G2103/学級・講座/g05/女性学級・講座数",
              "label": "女性学級・講座数",
              "cat01": "G2103",
              "unit": "学級・講座",
              "sourceId": "g05"
            },
            {
              "statId": "0000010107/G2104/学級・講座/g05/高齢者学級・講座数",
              "label": "高齢者学級・講座数",
              "cat01": "G2104",
              "unit": "学級・講座",
              "sourceId": "g05"
            },
            {
              "statId": "0000010107/G3102/施設/g06/社会体育施設数",
              "label": "社会体育施設数",
              "cat01": "G3102",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310201/施設/g06/陸上競技場数",
              "label": "陸上競技場数",
              "cat01": "G310201",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310202/施設/g06/野球場・ソフトボール場数",
              "label": "野球場・ソフトボール場数",
              "cat01": "G310202",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310203/施設/g06/多目的運動広場数",
              "label": "多目的運動広場数",
              "cat01": "G310203",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310204/施設/g06/水泳プール数（屋内，屋外）",
              "label": "水泳プール数（屋内，屋外）",
              "cat01": "G310204",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310205/施設/g06/レジャープール数",
              "label": "レジャープール数",
              "cat01": "G310205",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310206/施設/g06/体育館数",
              "label": "体育館数",
              "cat01": "G310206",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310207/施設/g06/柔道・剣道・柔剣道場数",
              "label": "柔道・剣道・柔剣道場数",
              "cat01": "G310207",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310208/施設/g06/庭球場数（屋内、屋外）",
              "label": "庭球場数（屋内、屋外）",
              "cat01": "G310208",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310209/施設/g06/トレーニング場数",
              "label": "トレーニング場数",
              "cat01": "G310209",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310210/施設/g06/ダンス場数",
              "label": "ダンス場数",
              "cat01": "G310210",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310211/施設/g06/ゴルフ場数",
              "label": "ゴルフ場数",
              "cat01": "G310211",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310212/施設/g06/ゴルフ練習場数",
              "label": "ゴルフ練習場数",
              "cat01": "G310212",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310213/施設/g06/ボウリング場数",
              "label": "ボウリング場数",
              "cat01": "G310213",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310214/施設/g06/ゲートボール・クロッケー場数",
              "label": "ゲートボール・クロッケー場数",
              "cat01": "G310214",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G310215/施設/g06/キャンプ場数",
              "label": "キャンプ場数",
              "cat01": "G310215",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G3201/施設/g06/民間体育施設数",
              "label": "民間体育施設数",
              "cat01": "G3201",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320101/施設/g06/民間陸上競技場数",
              "label": "民間陸上競技場数",
              "cat01": "G320101",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320102/施設/g06/民間野球場・ソフトボール場数",
              "label": "民間野球場・ソフトボール場数",
              "cat01": "G320102",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320103/施設/g06/民間多目的運動広場数",
              "label": "民間多目的運動広場数",
              "cat01": "G320103",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320104/施設/g06/民間水泳プール数（屋内、屋外）",
              "label": "民間水泳プール数（屋内、屋外）",
              "cat01": "G320104",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320105/施設/g06/民間レジャープール数",
              "label": "民間レジャープール数",
              "cat01": "G320105",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320106/施設/g06/民間体育館数",
              "label": "民間体育館数",
              "cat01": "G320106",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320107/施設/g06/民間柔道・剣道・柔剣道場数",
              "label": "民間柔道・剣道・柔剣道場数",
              "cat01": "G320107",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320108/施設/g06/民間庭球場数（屋内、屋外）",
              "label": "民間庭球場数（屋内、屋外）",
              "cat01": "G320108",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320109/施設/g06/民間トレーニング場数",
              "label": "民間トレーニング場数",
              "cat01": "G320109",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320110/施設/g06/民間ダンス場数",
              "label": "民間ダンス場数",
              "cat01": "G320110",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320111/施設/g06/民間ゴルフ場数",
              "label": "民間ゴルフ場数",
              "cat01": "G320111",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320112/施設/g06/民間ゴルフ練習場数",
              "label": "民間ゴルフ練習場数",
              "cat01": "G320112",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320113/施設/g06/民間ボウリング場数",
              "label": "民間ボウリング場数",
              "cat01": "G320113",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320114/施設/g06/民間ゲートボール・クロッケー場数",
              "label": "民間ゲートボール・クロッケー場数",
              "cat01": "G320114",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G320115/施設/g06/民間キャンプ場数",
              "label": "民間キャンプ場数",
              "cat01": "G320115",
              "unit": "施設",
              "sourceId": "g06"
            },
            {
              "statId": "0000010107/G4101/件/g07/重要文化財指定件数",
              "label": "重要文化財指定件数",
              "cat01": "G4101",
              "unit": "件",
              "sourceId": "g07"
            },
            {
              "statId": "0000010107/G4102/件/g07/史跡名勝天然記念物指定件数",
              "label": "史跡名勝天然記念物指定件数",
              "cat01": "G4102",
              "unit": "件",
              "sourceId": "g07"
            },
            {
              "statId": "0000010107/G4201/団体/g08/宗教団体数",
              "label": "宗教団体数",
              "cat01": "G4201",
              "unit": "団体",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G4202/人/g08/信者数",
              "label": "信者数",
              "cat01": "G4202",
              "unit": "人",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G420201/人/g08/神道系信者数",
              "label": "神道系信者数",
              "cat01": "G420201",
              "unit": "人",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G420202/人/g08/仏教系信者数",
              "label": "仏教系信者数",
              "cat01": "G420202",
              "unit": "人",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G420203/人/g08/キリスト教系信者数",
              "label": "キリスト教系信者数",
              "cat01": "G420203",
              "unit": "人",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G420204/人/g08/諸教信者数",
              "label": "諸教信者数",
              "cat01": "G420204",
              "unit": "人",
              "sourceId": "g08"
            },
            {
              "statId": "0000010107/G5101/館/g09/常設映画館数",
              "label": "常設映画館数",
              "cat01": "G5101",
              "unit": "館",
              "sourceId": "g09"
            },
            {
              "statId": "0000010107/G5104/箇所/g10/劇場，音楽会場等の数",
              "label": "劇場，音楽会場等の数",
              "cat01": "G5104",
              "unit": "箇所",
              "sourceId": "g10"
            },
            {
              "statId": "0000010107/G5105/件/g11/一般旅券発行件数",
              "label": "一般旅券発行件数",
              "cat01": "G5105",
              "unit": "件",
              "sourceId": "g11"
            },
            {
              "statId": "0000010107/G5106/事業所/g12/書籍・文房具小売業事業所数",
              "label": "書籍・文房具小売業事業所数",
              "cat01": "G5106",
              "unit": "事業所",
              "sourceId": "g12"
            },
            {
              "statId": "0000010107/G5107/百万円/g12/書籍・文房具小売業年間商品販売額",
              "label": "書籍・文房具小売業年間商品販売額",
              "cat01": "G5107",
              "unit": "百万円",
              "sourceId": "g12"
            },
            {
              "statId": "0000010107/G5108/事業所/g12/書籍・雑誌小売業事業所数",
              "label": "書籍・雑誌小売業事業所数",
              "cat01": "G5108",
              "unit": "事業所",
              "sourceId": "g12"
            },
            {
              "statId": "0000010107/G5109/百万円/g12/書籍・雑誌小売業年間商品販売額",
              "label": "書籍・雑誌小売業年間商品販売額",
              "cat01": "G5109",
              "unit": "百万円",
              "sourceId": "g12"
            },
            {
              "statId": "0000010107/G5201/クラブ/g13/老人クラブ数",
              "label": "老人クラブ数",
              "cat01": "G5201",
              "unit": "クラブ",
              "sourceId": "g13"
            },
            {
              "statId": "0000010107/G5202/人/g13/老人クラブ会員数",
              "label": "老人クラブ会員数",
              "cat01": "G5202",
              "unit": "人",
              "sourceId": "g13"
            },
            {
              "statId": "0000010107/G6120/法人/g14/ＮＰＯ法人認証数",
              "label": "ＮＰＯ法人認証数",
              "cat01": "G6120",
              "unit": "法人",
              "sourceId": "g14"
            },
            {
              "statId": "0000010107/G6230/人/g15/献血者数",
              "label": "献血者数",
              "cat01": "G6230",
              "unit": "人",
              "sourceId": "g15"
            },
            {
              "statId": "0000010107/G6301/％/g16/衆議院議員選挙投票率（小選挙区）",
              "label": "衆議院議員選挙投票率（小選挙区）",
              "cat01": "G6301",
              "unit": "％",
              "sourceId": "g16"
            },
            {
              "statId": "0000010107/G6302/％/g16/衆議院議員選挙投票率（比例代表）",
              "label": "衆議院議員選挙投票率（比例代表）",
              "cat01": "G6302",
              "unit": "％",
              "sourceId": "g16"
            },
            {
              "statId": "0000010107/G6303/％/g17/参議院議員選挙投票率（比例代表）",
              "label": "参議院議員選挙投票率（比例代表）",
              "cat01": "G6303",
              "unit": "％",
              "sourceId": "g17"
            },
            {
              "statId": "0000010107/G6304/％/g17/参議院議員選挙投票率（選挙区）",
              "label": "参議院議員選挙投票率（選挙区）",
              "cat01": "G6304",
              "unit": "％",
              "sourceId": "g17"
            },
            {
              "statId": "0000010107/G6305/％/g18/都道府県議会議員選挙投票率",
              "label": "都道府県議会議員選挙投票率",
              "cat01": "G6305",
              "unit": "％",
              "sourceId": "g18"
            },
            {
              "statId": "0000010107/G6306/％/g18/都道府県知事選挙投票率",
              "label": "都道府県知事選挙投票率",
              "cat01": "G6306",
              "unit": "％",
              "sourceId": "g18"
            },
            {
              "statId": "0000010107/G6307/％/g18/市区町村議会議員選挙投票率",
              "label": "市区町村議会議員選挙投票率",
              "cat01": "G6307",
              "unit": "％",
              "sourceId": "g18"
            },
            {
              "statId": "0000010107/G6308/％/g18/市区町村長選挙投票率",
              "label": "市区町村長選挙投票率",
              "cat01": "G6308",
              "unit": "％",
              "sourceId": "g18"
            },
            {
              "statId": "0000010107/G6417/％/g19/ボランティア活動行動者率（１０歳以上）",
              "label": "ボランティア活動行動者率（１０歳以上）",
              "cat01": "G6417",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641701/％/g19/ボランティア活動行動者率（１０歳以上）（男）",
              "label": "ボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G641701",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641702/％/g19/ボランティア活動行動者率（１０歳以上）（女）",
              "label": "ボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G641702",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6418/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）",
              "cat01": "G6418",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641801/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）（男）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G641801",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641802/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）（女）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G641802",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6419/％/g19/高齢者を対象としたボランティア活動行動者率（１０歳以上）",
              "label": "高齢者を対象としたボランティア活動行動者率（１０歳以上）",
              "cat01": "G6419",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641901/％/g19/高齢者を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "label": "高齢者を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G641901",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G641902/％/g19/高齢者を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "label": "高齢者を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G641902",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6420/％/g19/障害者を対象としたボランティア活動行動者率（１０歳以上）",
              "label": "障害者を対象としたボランティア活動行動者率（１０歳以上）",
              "cat01": "G6420",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642001/％/g19/障害者を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "label": "障害者を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642001",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642002/％/g19/障害者を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "label": "障害者を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642002",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6421/％/g19/子供を対象としたボランティア活動行動者率（１０歳以上）",
              "label": "子供を対象としたボランティア活動行動者率（１０歳以上）",
              "cat01": "G6421",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642101/％/g19/子供を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "label": "子供を対象としたボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642101",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642102/％/g19/子供を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "label": "子供を対象としたボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642102",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6422/％/g19/スポーツ・文化・芸術・学術に関係したボランティア活動行動者率（１０歳以上）",
              "label": "スポーツ・文化・芸術・学術に関係したボランティア活動行動者率（１０歳以上）",
              "cat01": "G6422",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642201/％/g19/スポーツ・文化・芸術に関係したボランティア活動行動者率（１０歳以上）（男）",
              "label": "スポーツ・文化・芸術に関係したボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642201",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642202/％/g19/スポーツ・文化・芸術に関係したボランティア活動行動者率（１０歳以上）（女）",
              "label": "スポーツ・文化・芸術に関係したボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642202",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6423/％/g19/まちづくりのためのボランティア活動行動者率（１０歳以上）",
              "label": "まちづくりのためのボランティア活動行動者率（１０歳以上）",
              "cat01": "G6423",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642301/％/g19/まちづくりのためのボランティア活動行動者率（１０歳以上）（男）",
              "label": "まちづくりのためのボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642301",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642302/％/g19/まちづくりのためのボランティア活動行動者率（１０歳以上）（女）",
              "label": "まちづくりのためのボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642302",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6424/％/g19/安全な生活のためのボランティア活動行動者率（１０歳以上）",
              "label": "安全な生活のためのボランティア活動行動者率（１０歳以上）",
              "cat01": "G6424",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642401/％/g19/安全な生活のためのボランティア活動行動者率（１０歳以上）（男）",
              "label": "安全な生活のためのボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642401",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642402/％/g19/安全な生活のためのボランティア活動行動者率（１０歳以上）（女）",
              "label": "安全な生活のためのボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642402",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6425/％/g19/自然や環境を守るためのボランティア活動行動者率（１０歳以上）",
              "label": "自然や環境を守るためのボランティア活動行動者率（１０歳以上）",
              "cat01": "G6425",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642501/％/g19/自然や環境をまもるためのボランティア活動行動者率（１０歳以上）（男）",
              "label": "自然や環境をまもるためのボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642501",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642502/％/g19/自然や環境をまもるためのボランティア活動行動者率（１０歳以上）（女）",
              "label": "自然や環境をまもるためのボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642502",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6426/％/g19/災害に関係したボランティア活動行動者率（１０歳以上）",
              "label": "災害に関係したボランティア活動行動者率（１０歳以上）",
              "cat01": "G6426",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642601/％/g19/災害に関係したボランティア活動行動者率（１０歳以上）（男）",
              "label": "災害に関係したボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642601",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642602/％/g19/災害に関係したボランティア活動行動者率（１０歳以上）（女）",
              "label": "災害に関係したボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642602",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6427/％/g19/その他のボランティア活動行動者率（１０歳以上）",
              "label": "その他のボランティア活動行動者率（１０歳以上）",
              "cat01": "G6427",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642701/％/g19/その他のボランティア活動行動者率（１０歳以上）（男）",
              "label": "その他のボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642701",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642702/％/g19/その他のボランティア活動行動者率（１０歳以上）（女）",
              "label": "その他のボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642702",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6428/％/g19/国際協力に関係したボランティア活動行動者率（１０歳以上）",
              "label": "国際協力に関係したボランティア活動行動者率（１０歳以上）",
              "cat01": "G6428",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642801/％/g19/国際協力に関係したボランティア活動行動者率（１０歳以上）（男）",
              "label": "国際協力に関係したボランティア活動行動者率（１０歳以上）（男）",
              "cat01": "G642801",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G642802/％/g19/国際協力に関係したボランティア活動行動者率（１０歳以上）（女）",
              "label": "国際協力に関係したボランティア活動行動者率（１０歳以上）（女）",
              "cat01": "G642802",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6430/％/g19/ボランティア活動行動者率（１５歳以上）",
              "label": "ボランティア活動行動者率（１５歳以上）",
              "cat01": "G6430",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643001/％/g19/ボランティア活動行動者率（１５歳以上）（男）",
              "label": "ボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643001",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643002/％/g19/ボランティア活動行動者率（１５歳以上）（女）",
              "label": "ボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643002",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6431/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）",
              "cat01": "G6431",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643101/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）（男）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643101",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643102/％/g19/健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）（女）",
              "label": "健康や医療サービスに関係したボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643102",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6432/％/g19/高齢者を対象としたボランティア活動行動者率（１５歳以上）",
              "label": "高齢者を対象としたボランティア活動行動者率（１５歳以上）",
              "cat01": "G6432",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643201/％/g19/高齢者を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "label": "高齢者を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643201",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643202/％/g19/高齢者を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "label": "高齢者を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643202",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6433/％/g19/障害者を対象としたボランティア活動行動者率（１５歳以上）",
              "label": "障害者を対象としたボランティア活動行動者率（１５歳以上）",
              "cat01": "G6433",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643301/％/g19/障害者を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "label": "障害者を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643301",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643302/％/g19/障害者を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "label": "障害者を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643302",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6434/％/g19/子供を対象としたボランティア活動行動者率（１５歳以上）",
              "label": "子供を対象としたボランティア活動行動者率（１５歳以上）",
              "cat01": "G6434",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643401/％/g19/子供を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "label": "子供を対象としたボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643401",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643402/％/g19/子供を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "label": "子供を対象としたボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643402",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6435/％/g19/スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）",
              "label": "スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）",
              "cat01": "G6435",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643501/％/g19/スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）（男）",
              "label": "スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643501",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643502/％/g19/スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）（女）",
              "label": "スポーツ・文化・芸術に関係したボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643502",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6436/％/g19/まちづくりのためのボランティア活動行動者率（１５歳以上）",
              "label": "まちづくりのためのボランティア活動行動者率（１５歳以上）",
              "cat01": "G6436",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643601/％/g19/まちづくりのためのボランティア活動行動者率（１５歳以上）（男）",
              "label": "まちづくりのためのボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643601",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643602/％/g19/まちづくりのためのボランティア活動行動者率（１５歳以上）（女）",
              "label": "まちづくりのためのボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643602",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6437/％/g19/安全な生活のためのボランティア活動行動者率（１５歳以上）",
              "label": "安全な生活のためのボランティア活動行動者率（１５歳以上）",
              "cat01": "G6437",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643701/％/g19/安全な生活のためのボランティア活動行動者率（１５歳以上）（男）",
              "label": "安全な生活のためのボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643701",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643702/％/g19/安全な生活のためのボランティア活動行動者率（１５歳以上）（女）",
              "label": "安全な生活のためのボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643702",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6438/％/g19/自然や環境をまもるためのボランティア活動行動者率（１５歳以上）",
              "label": "自然や環境をまもるためのボランティア活動行動者率（１５歳以上）",
              "cat01": "G6438",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643801/％/g19/自然や環境をまもるためのボランティア活動行動者率（１５歳以上）（男）",
              "label": "自然や環境をまもるためのボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643801",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643802/％/g19/自然や環境をまもるためのボランティア活動行動者率（１５歳以上）（女）",
              "label": "自然や環境をまもるためのボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643802",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6439/％/g19/災害に関係したボランティア活動行動者率（１５歳以上）",
              "label": "災害に関係したボランティア活動行動者率（１５歳以上）",
              "cat01": "G6439",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643901/％/g19/災害に関係したボランティア活動行動者率（１５歳以上）（男）",
              "label": "災害に関係したボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G643901",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G643902/％/g19/災害に関係したボランティア活動行動者率（１５歳以上）（女）",
              "label": "災害に関係したボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G643902",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6440/％/g19/その他のボランティア活動行動者率（１５歳以上）",
              "label": "その他のボランティア活動行動者率（１５歳以上）",
              "cat01": "G6440",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G644001/％/g19/その他のボランティア活動行動者率（１５歳以上）（男）",
              "label": "その他のボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G644001",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G644002/％/g19/その他のボランティア活動行動者率（１５歳以上）（女）",
              "label": "その他のボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G644002",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6450/％/g19/国際協力に関係したボランティア活動行動者率（１５歳以上）",
              "label": "国際協力に関係したボランティア活動行動者率（１５歳以上）",
              "cat01": "G6450",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G645001/％/g19/国際協力に関係したボランティア活動行動者率（１５歳以上）（男）",
              "label": "国際協力に関係したボランティア活動行動者率（１５歳以上）（男）",
              "cat01": "G645001",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G645002/％/g19/国際協力に関係したボランティア活動行動者率（１５歳以上）（女）",
              "label": "国際協力に関係したボランティア活動行動者率（１５歳以上）（女）",
              "cat01": "G645002",
              "unit": "％",
              "sourceId": "g19"
            },
            {
              "statId": "0000010107/G6500/％/g20/スポーツ行動者率（１０歳以上）",
              "label": "スポーツ行動者率（１０歳以上）",
              "cat01": "G6500",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G650001/％/g20/スポーツ行動者率（１０歳以上）（男）",
              "label": "スポーツ行動者率（１０歳以上）（男）",
              "cat01": "G650001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G650002/％/g20/スポーツ行動者率（１０歳以上）（女）",
              "label": "スポーツ行動者率（１０歳以上）（女）",
              "cat01": "G650002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6600/％/g20/旅行・行楽行動者率（１０歳以上）",
              "label": "旅行・行楽行動者率（１０歳以上）",
              "cat01": "G6600",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660001/％/g20/旅行・行楽行動者率（１０歳以上）（男）",
              "label": "旅行・行楽行動者率（１０歳以上）（男）",
              "cat01": "G660001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660002/％/g20/旅行・行楽行動者率（１０歳以上）（女）",
              "label": "旅行・行楽行動者率（１０歳以上）（女）",
              "cat01": "G660002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6601/％/g20/旅行行動者率（１０歳以上）",
              "label": "旅行行動者率（１０歳以上）",
              "cat01": "G6601",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660101/％/g20/旅行行動者率（１０歳以上）（男）",
              "label": "旅行行動者率（１０歳以上）（男）",
              "cat01": "G660101",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660102/％/g20/旅行行動者率（１０歳以上）（女）",
              "label": "旅行行動者率（１０歳以上）（女）",
              "cat01": "G660102",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6605/％/g20/海外旅行行動者率（１０歳以上）",
              "label": "海外旅行行動者率（１０歳以上）",
              "cat01": "G6605",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660501/％/g20/海外旅行行動者率（１０歳以上）（男）",
              "label": "海外旅行行動者率（１０歳以上）（男）",
              "cat01": "G660501",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660502/％/g20/海外旅行行動者率（１０歳以上）（女）",
              "label": "海外旅行行動者率（１０歳以上）（女）",
              "cat01": "G660502",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6606/％/g20/国内旅行行動者率（１０歳以上）",
              "label": "国内旅行行動者率（１０歳以上）",
              "cat01": "G6606",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660601/％/g20/国内旅行行動者率（１０歳以上）（男）",
              "label": "国内旅行行動者率（１０歳以上）（男）",
              "cat01": "G660601",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660602/％/g20/国内旅行行動者率（１０歳以上）（女）",
              "label": "国内旅行行動者率（１０歳以上）（女）",
              "cat01": "G660602",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6607/％/g20/行楽行動者率（１０歳以上）",
              "label": "行楽行動者率（１０歳以上）",
              "cat01": "G6607",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660701/％/g20/行楽行動者率（１０歳以上）（男）",
              "label": "行楽行動者率（１０歳以上）（男）",
              "cat01": "G660701",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G660702/％/g20/行楽行動者率（１０歳以上）（女）",
              "label": "行楽行動者率（１０歳以上）（女）",
              "cat01": "G660702",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6610/％/g20/旅行・行楽行動者率（１５歳以上）",
              "label": "旅行・行楽行動者率（１５歳以上）",
              "cat01": "G6610",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661001/％/g20/旅行・行楽行動者率（１５歳以上）（男）",
              "label": "旅行・行楽行動者率（１５歳以上）（男）",
              "cat01": "G661001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661002/％/g20/旅行・行楽行動者率（１５歳以上）（女）",
              "label": "旅行・行楽行動者率（１５歳以上）（女）",
              "cat01": "G661002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6611/％/g20/旅行行動者率（１５歳以上）",
              "label": "旅行行動者率（１５歳以上）",
              "cat01": "G6611",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661101/％/g20/旅行行動者率（１５歳以上）（男）",
              "label": "旅行行動者率（１５歳以上）（男）",
              "cat01": "G661101",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661102/％/g20/旅行行動者率（１５歳以上）（女）",
              "label": "旅行行動者率（１５歳以上）（女）",
              "cat01": "G661102",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6615/％/g20/海外旅行行動者率（１５歳以上）",
              "label": "海外旅行行動者率（１５歳以上）",
              "cat01": "G6615",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661501/％/g20/海外旅行行動者率（１５歳以上）（男）",
              "label": "海外旅行行動者率（１５歳以上）（男）",
              "cat01": "G661501",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661502/％/g20/海外旅行行動者率（１５歳以上）（女）",
              "label": "海外旅行行動者率（１５歳以上）（女）",
              "cat01": "G661502",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6616/％/g20/国内旅行行動者率（１５歳以上）",
              "label": "国内旅行行動者率（１５歳以上）",
              "cat01": "G6616",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661601/％/g20/国内旅行行動者率（１５歳以上）（男）",
              "label": "国内旅行行動者率（１５歳以上）（男）",
              "cat01": "G661601",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661602/％/g20/国内旅行行動者率（１５歳以上）（女）",
              "label": "国内旅行行動者率（１５歳以上）（女）",
              "cat01": "G661602",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6617/％/g20/行楽行動者率（１５歳以上）",
              "label": "行楽行動者率（１５歳以上）",
              "cat01": "G6617",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661701/％/g20/行楽行動者率（１５歳以上）（男）",
              "label": "行楽行動者率（１５歳以上）（男）",
              "cat01": "G661701",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G661702/％/g20/行楽行動者率（１５歳以上）（女）",
              "label": "行楽行動者率（１５歳以上）（女）",
              "cat01": "G661702",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6700/％/g20/学習・自己啓発・訓練行動者率（１０歳以上）",
              "label": "学習・自己啓発・訓練行動者率（１０歳以上）",
              "cat01": "G6700",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G670001/％/g20/学習・自己啓発・訓練行動者率（１０歳以上）（男）",
              "label": "学習・自己啓発・訓練行動者率（１０歳以上）（男）",
              "cat01": "G670001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G670002/％/g20/学習・自己啓発・訓練行動者率（１０歳以上）（女）",
              "label": "学習・自己啓発・訓練行動者率（１０歳以上）（女）",
              "cat01": "G670002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6701/％/g20/学習・研究行動者率（１５歳以上）",
              "label": "学習・研究行動者率（１５歳以上）",
              "cat01": "G6701",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G670101/％/g20/学習・研究行動者率（１５歳以上）（男）",
              "label": "学習・研究行動者率（１５歳以上）（男）",
              "cat01": "G670101",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G670102/％/g20/学習・研究行動者率（１５歳以上）（女）",
              "label": "学習・研究行動者率（１５歳以上）（女）",
              "cat01": "G670102",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6800/％/g20/趣味・娯楽行動者率（１０歳以上）",
              "label": "趣味・娯楽行動者率（１０歳以上）",
              "cat01": "G6800",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G680001/％/g20/趣味・娯楽行動者率（１０歳以上）（男）",
              "label": "趣味・娯楽行動者率（１０歳以上）（男）",
              "cat01": "G680001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G680002/％/g20/趣味・娯楽行動者率（１０歳以上）（女）",
              "label": "趣味・娯楽行動者率（１０歳以上）（女）",
              "cat01": "G680002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6801/％/g20/趣味・娯楽行動者率（１５歳以上）",
              "label": "趣味・娯楽行動者率（１５歳以上）",
              "cat01": "G6801",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G680101/％/g20/趣味・娯楽行動者率（１５歳以上）（男）",
              "label": "趣味・娯楽行動者率（１５歳以上）（男）",
              "cat01": "G680101",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G680102/％/g20/趣味・娯楽行動者率（１５歳以上）（女）",
              "label": "趣味・娯楽行動者率（１５歳以上）（女）",
              "cat01": "G680102",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6900/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）",
              "cat01": "G6900",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G690001/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）（男）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）（男）",
              "cat01": "G690001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G690002/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）（女）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１０歳以上）（女）",
              "cat01": "G690002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G6901/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）",
              "cat01": "G6901",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G690101/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）（男）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）（男）",
              "cat01": "G690101",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G690102/％/g20/テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）（女）",
              "label": "テレビ・ラジオ・新聞・雑誌行動者率（１５歳以上）（女）",
              "cat01": "G690102",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G7000/％/g20/インターネットの利用行動者率（１０歳以上）",
              "label": "インターネットの利用行動者率（１０歳以上）",
              "cat01": "G7000",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G700001/％/g20/インターネットの利用行動者率（１０歳以上）（男）",
              "label": "インターネットの利用行動者率（１０歳以上）（男）",
              "cat01": "G700001",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G700002/％/g20/インターネットの利用行動者率（１０歳以上）（女）",
              "label": "インターネットの利用行動者率（１０歳以上）（女）",
              "cat01": "G700002",
              "unit": "％",
              "sourceId": "g20"
            },
            {
              "statId": "0000010107/G7101/人/g21/延べ宿泊者数",
              "label": "延べ宿泊者数",
              "cat01": "G7101",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710101/人/g21/延べ宿泊者数（県内）",
              "label": "延べ宿泊者数（県内）",
              "cat01": "G710101",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710102/人/g21/延べ宿泊者数（県外）",
              "label": "延べ宿泊者数（県外）",
              "cat01": "G710102",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710103/人/g21/延べ宿泊者数（旅館）",
              "label": "延べ宿泊者数（旅館）",
              "cat01": "G710103",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710104/人/g21/延べ宿泊者数（リゾートホテル）",
              "label": "延べ宿泊者数（リゾートホテル）",
              "cat01": "G710104",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710105/人/g21/延べ宿泊者数（ビジネスホテル）",
              "label": "延べ宿泊者数（ビジネスホテル）",
              "cat01": "G710105",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710106/人/g21/延べ宿泊者数（シティーホテル）",
              "label": "延べ宿泊者数（シティーホテル）",
              "cat01": "G710106",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G7102/人/g21/外国人延べ宿泊者数",
              "label": "外国人延べ宿泊者数",
              "cat01": "G7102",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710201/人/g21/外国人延べ宿泊者数（韓国）",
              "label": "外国人延べ宿泊者数（韓国）",
              "cat01": "G710201",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710202/人/g21/外国人延べ宿泊者数（中国）",
              "label": "外国人延べ宿泊者数（中国）",
              "cat01": "G710202",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710203/人/g21/外国人延べ宿泊者数（台湾）",
              "label": "外国人延べ宿泊者数（台湾）",
              "cat01": "G710203",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710204/人/g21/外国人延べ宿泊者数（アメリカ）",
              "label": "外国人延べ宿泊者数（アメリカ）",
              "cat01": "G710204",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G7103/人/g21/実宿泊者数",
              "label": "実宿泊者数",
              "cat01": "G7103",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G710301/人/g21/実宿泊者数（外国人実宿泊者数）",
              "label": "実宿泊者数（外国人実宿泊者数）",
              "cat01": "G710301",
              "unit": "人",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G7104/％/g21/定員稼働率",
              "label": "定員稼働率",
              "cat01": "G7104",
              "unit": "％",
              "sourceId": "g21"
            },
            {
              "statId": "0000010107/G7105/％/g21/客室稼働率",
              "label": "客室稼働率",
              "cat01": "G7105",
              "unit": "％",
              "sourceId": "g21"
            }
          ]
        },
        {
          "label": "Ｈ居住",
          "statId": "0000010108",
          "children": [
            {
              "statId": "0000010108/H1100/住宅/h01/総住宅数",
              "label": "総住宅数",
              "cat01": "H1100",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1101/住宅/h01/居住世帯あり住宅数",
              "label": "居住世帯あり住宅数",
              "cat01": "H1101",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1102/住宅/h01/居住世帯なし住宅数",
              "label": "居住世帯なし住宅数",
              "cat01": "H1102",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H110201/住宅/h01/一時現在者のみ住宅数",
              "label": "一時現在者のみ住宅数",
              "cat01": "H110201",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H110202/住宅/h01/空き家数",
              "label": "空き家数",
              "cat01": "H110202",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H110203/住宅/h01/建築中住宅数",
              "label": "建築中住宅数",
              "cat01": "H110203",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1201/住宅/h01/専用住宅数",
              "label": "専用住宅数",
              "cat01": "H1201",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1203/住宅/h01/店舗その他の併用住宅数",
              "label": "店舗その他の併用住宅数",
              "cat01": "H1203",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1310/住宅/h01/持ち家数",
              "label": "持ち家数",
              "cat01": "H1310",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1320/住宅/h01/借家数",
              "label": "借家数",
              "cat01": "H1320",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1321/住宅/h01/公営・都市再生機構（ＵＲ）・公社の借家数",
              "label": "公営・都市再生機構（ＵＲ）・公社の借家数",
              "cat01": "H1321",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H132101/住宅/h01/公営の借家数",
              "label": "公営の借家数",
              "cat01": "H132101",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H132102/住宅/h01/都市再生機構（ＵＲ）・公社の借家数",
              "label": "都市再生機構（ＵＲ）・公社の借家数",
              "cat01": "H132102",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1322/住宅/h01/民営借家数",
              "label": "民営借家数",
              "cat01": "H1322",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1323/住宅/h01/給与住宅数",
              "label": "給与住宅数",
              "cat01": "H1323",
              "unit": "住宅",
              "sourceId": "h01"
            },
            {
              "statId": "0000010108/H1401/住宅/h02/一戸建住宅数",
              "label": "一戸建住宅数",
              "cat01": "H1401",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140101/住宅/h02/一戸建住宅数（木造）",
              "label": "一戸建住宅数（木造）",
              "cat01": "H140101",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140102/住宅/h02/一戸建住宅数（非木造）",
              "label": "一戸建住宅数（非木造）",
              "cat01": "H140102",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1402/住宅/h02/長屋建住宅数",
              "label": "長屋建住宅数",
              "cat01": "H1402",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140201/住宅/h02/長屋建住宅数（木造）",
              "label": "長屋建住宅数（木造）",
              "cat01": "H140201",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140202/住宅/h02/長屋建住宅数（非木造）",
              "label": "長屋建住宅数（非木造）",
              "cat01": "H140202",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1403/住宅/h02/共同住宅数",
              "label": "共同住宅数",
              "cat01": "H1403",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140301/住宅/h02/共同住宅数（木造）",
              "label": "共同住宅数（木造）",
              "cat01": "H140301",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140302/住宅/h02/共同住宅数（非木造）",
              "label": "共同住宅数（非木造）",
              "cat01": "H140302",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140310/住宅/h02/エレベーター付き共同住宅数（非木造）",
              "label": "エレベーター付き共同住宅数（非木造）",
              "cat01": "H140310",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H140320/住宅/h02/高齢者対応型共同住宅数",
              "label": "高齢者対応型共同住宅数",
              "cat01": "H140320",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1404/住宅/h02/その他の建て方住宅数",
              "label": "その他の建て方住宅数",
              "cat01": "H1404",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1501/住宅/h02/木造（防火木造を除く）・防火木造住宅数",
              "label": "木造（防火木造を除く）・防火木造住宅数",
              "cat01": "H1501",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H150101/住宅/h02/木造（防火木造を除く）住宅数",
              "label": "木造（防火木造を除く）住宅数",
              "cat01": "H150101",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H150102/住宅/h02/防火木造住宅数",
              "label": "防火木造住宅数",
              "cat01": "H150102",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1502/住宅/h02/非木造住宅数",
              "label": "非木造住宅数",
              "cat01": "H1502",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1504/住宅/h02/鉄筋・鉄骨コンクリ－ト造住宅数",
              "label": "鉄筋・鉄骨コンクリ－ト造住宅数",
              "cat01": "H1504",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1505/住宅/h02/その他の構造住宅数",
              "label": "その他の構造住宅数",
              "cat01": "H1505",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1506/住宅/h02/鉄骨造住宅数",
              "label": "鉄骨造住宅数",
              "cat01": "H1506",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1604/住宅/h02/昭和２６～３５年建築住宅数",
              "label": "昭和２６～３５年建築住宅数",
              "cat01": "H1604",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1605/住宅/h02/昭和３６～４５年建築住宅数",
              "label": "昭和３６～４５年建築住宅数",
              "cat01": "H1605",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1609/住宅/h02/平成３～５年９月建築住宅数",
              "label": "平成３～５年９月建築住宅数",
              "cat01": "H1609",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1610/住宅/h02/平成３～７年建築住宅数",
              "label": "平成３～７年建築住宅数",
              "cat01": "H1610",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1612/住宅/h02/昭和４６～５５年建築住宅数",
              "label": "昭和４６～５５年建築住宅数",
              "cat01": "H1612",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1613/住宅/h02/昭和５６～平成２年建築住宅数",
              "label": "昭和５６～平成２年建築住宅数",
              "cat01": "H1613",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1615/住宅/h02/昭和３５年以前建築住宅数",
              "label": "昭和３５年以前建築住宅数",
              "cat01": "H1615",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1616/住宅/h02/昭和４５年以前建築住宅数",
              "label": "昭和４５年以前建築住宅数",
              "cat01": "H1616",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1617/住宅/h02/平成８～１２年建築住宅数",
              "label": "平成８～１２年建築住宅数",
              "cat01": "H1617",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1618/住宅/h02/平成１３～１５年９月建築住宅数",
              "label": "平成１３～１５年９月建築住宅数",
              "cat01": "H1618",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1619/住宅/h02/平成３～１２年建築住宅数",
              "label": "平成３～１２年建築住宅数",
              "cat01": "H1619",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1620/住宅/h02/平成１３～１７年建築住宅数",
              "label": "平成１３～１７年建築住宅数",
              "cat01": "H1620",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1621/住宅/h02/平成１８～２０年９月建築住宅数",
              "label": "平成１８～２０年９月建築住宅数",
              "cat01": "H1621",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1622/住宅/h02/平成１８～２２年建築住宅数",
              "label": "平成１８～２２年建築住宅数",
              "cat01": "H1622",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1623/住宅/h02/平成２３～２５年９月建築住宅数",
              "label": "平成２３～２５年９月建築住宅数",
              "cat01": "H1623",
              "unit": "住宅",
              "sourceId": "h02"
            },
            {
              "statId": "0000010108/H1700/棟/h03/着工居住用建築物数",
              "label": "着工居住用建築物数",
              "cat01": "H1700",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1701/棟/h03/着工居住用建築物数（木造）",
              "label": "着工居住用建築物数（木造）",
              "cat01": "H1701",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1702/棟/h03/着工居住用建築物数（鉄骨鉄筋コンクリート造）",
              "label": "着工居住用建築物数（鉄骨鉄筋コンクリート造）",
              "cat01": "H1702",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1703/棟/h03/着工居住用建築物数（鉄筋コンクリート造）",
              "label": "着工居住用建築物数（鉄筋コンクリート造）",
              "cat01": "H1703",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1704/棟/h03/着工居住用建築物数（鉄骨造）",
              "label": "着工居住用建築物数（鉄骨造）",
              "cat01": "H1704",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1705/棟/h03/着工居住用建築物数（コンクリートブロック造）",
              "label": "着工居住用建築物数（コンクリートブロック造）",
              "cat01": "H1705",
              "unit": "棟",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1800/戸/h03/着工新設住宅戸数",
              "label": "着工新設住宅戸数",
              "cat01": "H1800",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1801/戸/h03/着工新設持家数",
              "label": "着工新設持家数",
              "cat01": "H1801",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1802/戸/h03/着工新設貸家数",
              "label": "着工新設貸家数",
              "cat01": "H1802",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H180201/戸/h03/着工新設貸家数（公営）",
              "label": "着工新設貸家数（公営）",
              "cat01": "H180201",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H180202/戸/h03/着工新設貸家数（都市再生機構）",
              "label": "着工新設貸家数（都市再生機構）",
              "cat01": "H180202",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1803/戸/h03/着工新設分譲住宅数",
              "label": "着工新設分譲住宅数",
              "cat01": "H1803",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H180302/戸/h03/着工新設分譲住宅数（都市再生機構）",
              "label": "着工新設分譲住宅数（都市再生機構）",
              "cat01": "H180302",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1804/戸/h03/着工新設給与住宅数",
              "label": "着工新設給与住宅数",
              "cat01": "H1804",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1810/戸/h03/着工新設持家・分譲住宅数",
              "label": "着工新設持家・分譲住宅数",
              "cat01": "H1810",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1900/戸/h03/滅失住宅戸数",
              "label": "滅失住宅戸数",
              "cat01": "H1900",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1901/戸/h03/除却住宅戸数",
              "label": "除却住宅戸数",
              "cat01": "H1901",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H1902/戸/h03/災害住宅戸数",
              "label": "災害住宅戸数",
              "cat01": "H1902",
              "unit": "戸",
              "sourceId": "h03"
            },
            {
              "statId": "0000010108/H2101/住宅/h04/居住室の畳数５．９畳以下住宅数",
              "label": "居住室の畳数５．９畳以下住宅数",
              "cat01": "H2101",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2102/住宅/h04/居住室の畳数６．０～１１．９畳住宅数",
              "label": "居住室の畳数６．０～１１．９畳住宅数",
              "cat01": "H2102",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2103/住宅/h04/居住室の畳数１２．０～１７．９畳住宅数",
              "label": "居住室の畳数１２．０～１７．９畳住宅数",
              "cat01": "H2103",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2104/住宅/h04/居住室の畳数１８．０～２３．９畳住宅数",
              "label": "居住室の畳数１８．０～２３．９畳住宅数",
              "cat01": "H2104",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2105/住宅/h04/居住室の畳数２４．０～２９．９畳住宅数",
              "label": "居住室の畳数２４．０～２９．９畳住宅数",
              "cat01": "H2105",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2106/住宅/h04/居住室の畳数３０．０～３５．９畳住宅数",
              "label": "居住室の畳数３０．０～３５．９畳住宅数",
              "cat01": "H2106",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2107/住宅/h04/居住室の畳数３６．０～４７．９畳住宅数",
              "label": "居住室の畳数３６．０～４７．９畳住宅数",
              "cat01": "H2107",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2108/住宅/h04/居住室の畳数４８．０畳以上住宅数",
              "label": "居住室の畳数４８．０畳以上住宅数",
              "cat01": "H2108",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2110/室/h04/１住宅当たり居住室数",
              "label": "１住宅当たり居住室数",
              "cat01": "H2110",
              "unit": "室",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H211010/室/h04/１住宅当たり居住室数（持ち家）",
              "label": "１住宅当たり居住室数（持ち家）",
              "cat01": "H211010",
              "unit": "室",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H211020/室/h04/１住宅当たり居住室数（借家）",
              "label": "１住宅当たり居住室数（借家）",
              "cat01": "H211020",
              "unit": "室",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2120/畳/h04/１住宅当たり居住室の畳数",
              "label": "１住宅当たり居住室の畳数",
              "cat01": "H2120",
              "unit": "畳",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H212010/畳/h04/１住宅当たり居住室の畳数（持ち家）",
              "label": "１住宅当たり居住室の畳数（持ち家）",
              "cat01": "H212010",
              "unit": "畳",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H212020/畳/h04/１住宅当たり居住室の畳数（借家）",
              "label": "１住宅当たり居住室の畳数（借家）",
              "cat01": "H212020",
              "unit": "畳",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2130/ｍ2/h04/１住宅当たり延べ面積",
              "label": "１住宅当たり延べ面積",
              "cat01": "H2130",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H213010/ｍ2/h04/１住宅当たり延べ面積（持ち家）",
              "label": "１住宅当たり延べ面積（持ち家）",
              "cat01": "H213010",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H213020/ｍ2/h04/１住宅当たり延べ面積（借家）",
              "label": "１住宅当たり延べ面積（借家）",
              "cat01": "H213020",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2140/ｍ2/h04/１住宅当たり敷地面積",
              "label": "１住宅当たり敷地面積",
              "cat01": "H2140",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H214010/ｍ2/h04/１住宅当たり敷地面積（一戸建）",
              "label": "１住宅当たり敷地面積（一戸建）",
              "cat01": "H214010",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H214011/ｍ2/h04/１住宅当たり敷地面積（一戸建・持ち家）",
              "label": "１住宅当たり敷地面積（一戸建・持ち家）",
              "cat01": "H214011",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H214020/ｍ2/h04/１住宅当たり敷地面積（長屋建）",
              "label": "１住宅当たり敷地面積（長屋建）",
              "cat01": "H214020",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H214021/ｍ2/h04/１住宅当たり敷地面積（長屋建・持ち家）",
              "label": "１住宅当たり敷地面積（長屋建・持ち家）",
              "cat01": "H214021",
              "unit": "ｍ2",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2201/住宅/h04/水洗トイレのある住宅数",
              "label": "水洗トイレのある住宅数",
              "cat01": "H2201",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2202/住宅/h04/浴室のある住宅数",
              "label": "浴室のある住宅数",
              "cat01": "H2202",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2230/住宅/h04/高齢者等用設備住宅数",
              "label": "高齢者等用設備住宅数",
              "cat01": "H2230",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H223001/住宅/h04/高齢者等用設備住宅数（手すりがある）",
              "label": "高齢者等用設備住宅数（手すりがある）",
              "cat01": "H223001",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H223002/住宅/h04/高齢者等用設備住宅数（またぎやすい高さの浴槽）",
              "label": "高齢者等用設備住宅数（またぎやすい高さの浴槽）",
              "cat01": "H223002",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H223003/住宅/h04/高齢者等用設備住宅数（廊下など車いすで通行可能な幅）",
              "label": "高齢者等用設備住宅数（廊下など車いすで通行可能な幅）",
              "cat01": "H223003",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H223004/住宅/h04/高齢者等用設備住宅数（段差のない屋内）",
              "label": "高齢者等用設備住宅数（段差のない屋内）",
              "cat01": "H223004",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H223005/住宅/h04/高齢者等用設備住宅数（道路から玄関まで車いすで通行可能）",
              "label": "高齢者等用設備住宅数（道路から玄関まで車いすで通行可能）",
              "cat01": "H223005",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2250/住宅/h04/自動火災感知設備あり住宅数",
              "label": "自動火災感知設備あり住宅数",
              "cat01": "H2250",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H225001/住宅/h04/自動火災感知設備あり住宅数（木造）",
              "label": "自動火災感知設備あり住宅数（木造）",
              "cat01": "H225001",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H225002/住宅/h04/自動火災感知設備あり住宅数（非木造）",
              "label": "自動火災感知設備あり住宅数（非木造）",
              "cat01": "H225002",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H225003/住宅/h04/自動火災感知設備あり住宅数（持ち家）",
              "label": "自動火災感知設備あり住宅数（持ち家）",
              "cat01": "H225003",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H225004/住宅/h04/自動火災感知設備あり住宅数（借家）",
              "label": "自動火災感知設備あり住宅数（借家）",
              "cat01": "H225004",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2260/住宅/h04/自動消火設備あり住宅数",
              "label": "自動消火設備あり住宅数",
              "cat01": "H2260",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H226001/住宅/h04/自動消火設備あり住宅数（木造）",
              "label": "自動消火設備あり住宅数（木造）",
              "cat01": "H226001",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H226002/住宅/h04/自動消火設備あり住宅数（非木造）",
              "label": "自動消火設備あり住宅数（非木造）",
              "cat01": "H226002",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H226003/住宅/h04/自動消火設備あり住宅数（持ち家）",
              "label": "自動消火設備あり住宅数（持ち家）",
              "cat01": "H226003",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H226004/住宅/h04/自動消火設備あり住宅数（借家）",
              "label": "自動消火設備あり住宅数（借家）",
              "cat01": "H226004",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2270/住宅/h04/耐震工事をした住宅数（持ち家）",
              "label": "耐震工事をした住宅数（持ち家）",
              "cat01": "H2270",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H227001/住宅/h04/耐震工事をした住宅数（持ち家・木造）",
              "label": "耐震工事をした住宅数（持ち家・木造）",
              "cat01": "H227001",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H227002/住宅/h04/耐震工事をした住宅数（持ち家・防火木造）",
              "label": "耐震工事をした住宅数（持ち家・防火木造）",
              "cat01": "H227002",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H227003/住宅/h04/耐震工事をした住宅数（持ち家・非木造）",
              "label": "耐震工事をした住宅数（持ち家・非木造）",
              "cat01": "H227003",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H227004/住宅/h04/平成２１年以降における住宅の耐震改修工事をした持ち家総数",
              "label": "平成２１年以降における住宅の耐震改修工事をした持ち家総数",
              "cat01": "H227004",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2280/住宅/h04/太陽熱を利用した温水機器等のある住宅数",
              "label": "太陽熱を利用した温水機器等のある住宅数",
              "cat01": "H2280",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2281/住宅/h04/太陽光を利用した発電機器のある住宅数",
              "label": "太陽光を利用した発電機器のある住宅数",
              "cat01": "H2281",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2282/住宅/h04/二重サッシ又は複層ガラスの窓のある住宅数",
              "label": "二重サッシ又は複層ガラスの窓のある住宅数",
              "cat01": "H2282",
              "unit": "住宅",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2283/世帯/h04/オートロック式の共同住宅に住む普通世帯数",
              "label": "オートロック式の共同住宅に住む普通世帯数",
              "cat01": "H2283",
              "unit": "世帯",
              "sourceId": "h04"
            },
            {
              "statId": "0000010108/H2500/ｍ2/h05/着工居住用建築物床面積",
              "label": "着工居住用建築物床面積",
              "cat01": "H2500",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2501/ｍ2/h05/着工居住用建築物床面積（木造）",
              "label": "着工居住用建築物床面積（木造）",
              "cat01": "H2501",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2502/ｍ2/h05/着工居住用建築物床面積（鉄骨鉄筋コンクリート造）",
              "label": "着工居住用建築物床面積（鉄骨鉄筋コンクリート造）",
              "cat01": "H2502",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2503/ｍ2/h05/着工居住用建築物床面積（鉄筋コンクリート造）",
              "label": "着工居住用建築物床面積（鉄筋コンクリート造）",
              "cat01": "H2503",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2504/ｍ2/h05/着工居住用建築物床面積（鉄骨造）",
              "label": "着工居住用建築物床面積（鉄骨造）",
              "cat01": "H2504",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2505/ｍ2/h05/着工居住用建築物床面積（コンクリートブロック造）",
              "label": "着工居住用建築物床面積（コンクリートブロック造）",
              "cat01": "H2505",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2600/ｍ2/h05/着工新設住宅床面積",
              "label": "着工新設住宅床面積",
              "cat01": "H2600",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2601/ｍ2/h05/着工新設持家床面積",
              "label": "着工新設持家床面積",
              "cat01": "H2601",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2602/ｍ2/h05/着工新設分譲住宅床面積",
              "label": "着工新設分譲住宅床面積",
              "cat01": "H2602",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2603/ｍ2/h05/着工新設貸家床面積",
              "label": "着工新設貸家床面積",
              "cat01": "H2603",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2604/ｍ2/h05/着工新設給与住宅床面積",
              "label": "着工新設給与住宅床面積",
              "cat01": "H2604",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2610/ｍ2/h05/着工新設持家・分譲住宅床面積",
              "label": "着工新設持家・分譲住宅床面積",
              "cat01": "H2610",
              "unit": "ｍ2",
              "sourceId": "h05"
            },
            {
              "statId": "0000010108/H2700/住宅/h06/要修理住宅割合別住宅数（割合（０％））",
              "label": "要修理住宅割合別住宅数（割合（０％））",
              "cat01": "H2700",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2701/住宅/h06/要修理住宅割合別住宅数（割合（１０％未満））",
              "label": "要修理住宅割合別住宅数（割合（１０％未満））",
              "cat01": "H2701",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2702/住宅/h06/要修理住宅割合別住宅数（割合（１０～２０％未満））",
              "label": "要修理住宅割合別住宅数（割合（１０～２０％未満））",
              "cat01": "H2702",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2703/住宅/h06/要修理住宅割合別住宅数（割合（２０％以上））",
              "label": "要修理住宅割合別住宅数（割合（２０％以上））",
              "cat01": "H2703",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2800/住宅/h06/敷地が幅員２ｍ未満の道路に接している住宅数",
              "label": "敷地が幅員２ｍ未満の道路に接している住宅数",
              "cat01": "H2800",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2801/住宅/h06/敷地が幅員２～４ｍ未満の道路に接している住宅数",
              "label": "敷地が幅員２～４ｍ未満の道路に接している住宅数",
              "cat01": "H2801",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2802/住宅/h06/敷地が幅員４～６ｍ未満の道路に接している住宅数",
              "label": "敷地が幅員４～６ｍ未満の道路に接している住宅数",
              "cat01": "H2802",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2803/住宅/h06/敷地が幅員６～１０ｍ未満の道路に接している住宅数",
              "label": "敷地が幅員６～１０ｍ未満の道路に接している住宅数",
              "cat01": "H2803",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2804/住宅/h06/敷地が幅員１０ｍ以上の道路に接している住宅数",
              "label": "敷地が幅員１０ｍ以上の道路に接している住宅数",
              "cat01": "H2804",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2805/住宅/h06/敷地が道路に接していない住宅数",
              "label": "敷地が道路に接していない住宅数",
              "cat01": "H2805",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2900/住宅/h06/最寄りの保育所までの距離が１００ｍ未満の住宅数",
              "label": "最寄りの保育所までの距離が１００ｍ未満の住宅数",
              "cat01": "H2900",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2901/住宅/h06/最寄りの保育所までの距離が１００～２００ｍ未満の住宅数",
              "label": "最寄りの保育所までの距離が１００～２００ｍ未満の住宅数",
              "cat01": "H2901",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2902/住宅/h06/最寄りの保育所までの距離が２００～５００ｍ未満の住宅数",
              "label": "最寄りの保育所までの距離が２００～５００ｍ未満の住宅数",
              "cat01": "H2902",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2903/住宅/h06/最寄りの保育所までの距離が５００～１０００ｍ未満の住宅数",
              "label": "最寄りの保育所までの距離が５００～１０００ｍ未満の住宅数",
              "cat01": "H2903",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2904/住宅/h06/最寄りの保育所までの距離が１０００ｍ以上の住宅数",
              "label": "最寄りの保育所までの距離が１０００ｍ以上の住宅数",
              "cat01": "H2904",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2910/住宅/h06/最寄りの老人デイサービスセンターまでの距離が２５０ｍ未満の住宅数",
              "label": "最寄りの老人デイサービスセンターまでの距離が２５０ｍ未満の住宅数",
              "cat01": "H2910",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2911/住宅/h06/最寄りの老人デイサービスセンターまでの距離が２５０～５００ｍ未満の住宅数",
              "label": "最寄りの老人デイサービスセンターまでの距離が２５０～５００ｍ未満の住宅数",
              "cat01": "H2911",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2912/住宅/h06/最寄りの老人デイサービスセンターまでの距離が５００～１０００ｍ未満の住宅数",
              "label": "最寄りの老人デイサービスセンターまでの距離が５００～１０００ｍ未満の住宅数",
              "cat01": "H2912",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2913/住宅/h06/最寄りの老人デイサービスセンターまでの距離が１０００～２０００ｍ未満の住宅数",
              "label": "最寄りの老人デイサービスセンターまでの距離が１０００～２０００ｍ未満の住宅数",
              "cat01": "H2913",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H2914/住宅/h06/最寄りの老人デイサービスセンターまでの距離が２０００ｍ以上の住宅数",
              "label": "最寄りの老人デイサービスセンターまでの距離が２０００ｍ以上の住宅数",
              "cat01": "H2914",
              "unit": "住宅",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3100/世帯/h06/総世帯数",
              "label": "総世帯数",
              "cat01": "H3100",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3110/世帯/h06/普通世帯数",
              "label": "普通世帯数",
              "cat01": "H3110",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3111/世帯/h06/主世帯数（住宅・土地統計調査結果）",
              "label": "主世帯数（住宅・土地統計調査結果）",
              "cat01": "H3111",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H311110/世帯/h06/６５歳以上の世帯員のいる世帯数（住宅・土地統計調査結果）",
              "label": "６５歳以上の世帯員のいる世帯数（住宅・土地統計調査結果）",
              "cat01": "H311110",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3112/世帯/h06/住宅に同居の普通世帯数",
              "label": "住宅に同居の普通世帯数",
              "cat01": "H3112",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3113/世帯/h06/住宅以外の建物に居住の普通世帯数",
              "label": "住宅以外の建物に居住の普通世帯数",
              "cat01": "H3113",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3120/世帯/h06/準世帯数",
              "label": "準世帯数",
              "cat01": "H3120",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3121/世帯/h06/住宅に同居の準世帯数",
              "label": "住宅に同居の準世帯数",
              "cat01": "H3121",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3122/世帯/h06/住宅以外の建物に居住の準世帯数",
              "label": "住宅以外の建物に居住の準世帯数",
              "cat01": "H3122",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3130/世帯/h06/同居世帯数",
              "label": "同居世帯数",
              "cat01": "H3130",
              "unit": "世帯",
              "sourceId": "h06"
            },
            {
              "statId": "0000010108/H3210/世帯/h07/住宅に住む一般世帯数",
              "label": "住宅に住む一般世帯数",
              "cat01": "H3210",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3211/世帯/h07/主世帯数（一般世帯）（国勢調査結果）",
              "label": "主世帯数（一般世帯）（国勢調査結果）",
              "cat01": "H3211",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3220/世帯/h07/住宅以外に住む一般世帯数",
              "label": "住宅以外に住む一般世帯数",
              "cat01": "H3220",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3230/世帯/h07/住宅に住む母子世帯数",
              "label": "住宅に住む母子世帯数",
              "cat01": "H3230",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3241/世帯/h07/住宅に住む高齢単身世帯数（６０歳以上の者のみ）",
              "label": "住宅に住む高齢単身世帯数（６０歳以上の者のみ）",
              "cat01": "H3241",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3251/世帯/h07/住宅に住む高齢夫婦世帯数（６０歳以上の夫婦のみ）",
              "label": "住宅に住む高齢夫婦世帯数（６０歳以上の夫婦のみ）",
              "cat01": "H3251",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3261/世帯/h07/住宅に住む高齢単身世帯数（６５歳以上の者のみ）",
              "label": "住宅に住む高齢単身世帯数（６５歳以上の者のみ）",
              "cat01": "H3261",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3271/世帯/h07/住宅に住む高齢夫婦世帯数（高齢夫婦のみ）",
              "label": "住宅に住む高齢夫婦世帯数（高齢夫婦のみ）",
              "cat01": "H3271",
              "unit": "世帯",
              "sourceId": "h07"
            },
            {
              "statId": "0000010108/H3300/人/h08/総世帯人員",
              "label": "総世帯人員",
              "cat01": "H3300",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3310/人/h08/普通世帯人員",
              "label": "普通世帯人員",
              "cat01": "H3310",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3311/人/h08/主世帯人員（住宅・土地統計調査結果）",
              "label": "主世帯人員（住宅・土地統計調査結果）",
              "cat01": "H3311",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3312/人/h08/住宅に同居の普通世帯人員",
              "label": "住宅に同居の普通世帯人員",
              "cat01": "H3312",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3313/人/h08/住宅以外の建物に居住の普通世帯人員",
              "label": "住宅以外の建物に居住の普通世帯人員",
              "cat01": "H3313",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3320/人/h08/準世帯人員",
              "label": "準世帯人員",
              "cat01": "H3320",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3321/人/h08/住宅に同居の準世帯人員",
              "label": "住宅に同居の準世帯人員",
              "cat01": "H3321",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3322/人/h08/住宅以外の建物に居住の準世帯人員",
              "label": "住宅以外の建物に居住の準世帯人員",
              "cat01": "H3322",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3330/人/h08/同居世帯人員",
              "label": "同居世帯人員",
              "cat01": "H3330",
              "unit": "人",
              "sourceId": "h08"
            },
            {
              "statId": "0000010108/H3410/人/h09/住宅に住む一般世帯人員",
              "label": "住宅に住む一般世帯人員",
              "cat01": "H3410",
              "unit": "人",
              "sourceId": "h09"
            },
            {
              "statId": "0000010108/H3411/人/h09/主世帯人員（一般世帯）（国勢調査結果）",
              "label": "主世帯人員（一般世帯）（国勢調査結果）",
              "cat01": "H3411",
              "unit": "人",
              "sourceId": "h09"
            },
            {
              "statId": "0000010108/H3420/人/h09/住宅以外に住む一般世帯人員",
              "label": "住宅以外に住む一般世帯人員",
              "cat01": "H3420",
              "unit": "人",
              "sourceId": "h09"
            },
            {
              "statId": "0000010108/H3510/室/h10/１世帯当たり居住室数（普通世帯）",
              "label": "１世帯当たり居住室数（普通世帯）",
              "cat01": "H3510",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3511/室/h10/１世帯当たり居住室数（主世帯）",
              "label": "１世帯当たり居住室数（主世帯）",
              "cat01": "H3511",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H351101/室/h10/１世帯当たり居住室数（持ち家・主世帯）",
              "label": "１世帯当たり居住室数（持ち家・主世帯）",
              "cat01": "H351101",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H351102/室/h10/１世帯当たり居住室数（借家・主世帯）",
              "label": "１世帯当たり居住室数（借家・主世帯）",
              "cat01": "H351102",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3512/室/h10/１世帯当たり居住室数（同居の普通世帯）",
              "label": "１世帯当たり居住室数（同居の普通世帯）",
              "cat01": "H3512",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3513/室/h10/１世帯当たり居住室数（住宅以外の建物に居住の普通世帯）",
              "label": "１世帯当たり居住室数（住宅以外の建物に居住の普通世帯）",
              "cat01": "H3513",
              "unit": "室",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3520/畳/h10/１世帯当たり畳数（普通世帯）",
              "label": "１世帯当たり畳数（普通世帯）",
              "cat01": "H3520",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3521/畳/h10/１世帯当たり畳数（主世帯）",
              "label": "１世帯当たり畳数（主世帯）",
              "cat01": "H3521",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H352101/畳/h10/１世帯当たり畳数（持ち家・主世帯）",
              "label": "１世帯当たり畳数（持ち家・主世帯）",
              "cat01": "H352101",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H352102/畳/h10/１世帯当たり畳数（借家・主世帯）",
              "label": "１世帯当たり畳数（借家・主世帯）",
              "cat01": "H352102",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3522/畳/h10/１世帯当たり畳数（同居の普通世帯）",
              "label": "１世帯当たり畳数（同居の普通世帯）",
              "cat01": "H3522",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3523/畳/h10/１世帯当たり畳数（住宅以外の建物に居住の普通世帯）",
              "label": "１世帯当たり畳数（住宅以外の建物に居住の普通世帯）",
              "cat01": "H3523",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3524/畳/h10/１人当たり畳数（主世帯）",
              "label": "１人当たり畳数（主世帯）",
              "cat01": "H3524",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H352401/畳/h10/１人当たり畳数（持ち家・主世帯）",
              "label": "１人当たり畳数（持ち家・主世帯）",
              "cat01": "H352401",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H352402/畳/h10/１人当たり畳数（借家・主世帯）",
              "label": "１人当たり畳数（借家・主世帯）",
              "cat01": "H352402",
              "unit": "畳",
              "sourceId": "h10"
            },
            {
              "statId": "0000010108/H3660/ｍ2/h11/１世帯当たり延べ面積（住宅に住む一般世帯）",
              "label": "１世帯当たり延べ面積（住宅に住む一般世帯）",
              "cat01": "H3660",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3661/ｍ2/h11/１世帯当たり延べ面積（主世帯）",
              "label": "１世帯当たり延べ面積（主世帯）",
              "cat01": "H3661",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H366101/ｍ2/h11/１世帯当たり延べ面積（持ち家）",
              "label": "１世帯当たり延べ面積（持ち家）",
              "cat01": "H366101",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3661021/ｍ2/h11/１世帯当たり延べ面積（公営の借家）",
              "label": "１世帯当たり延べ面積（公営の借家）",
              "cat01": "H3661021",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3661022/ｍ2/h11/１世帯当たり延べ面積（公団・公社の借家）",
              "label": "１世帯当たり延べ面積（公団・公社の借家）",
              "cat01": "H3661022",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H366103/ｍ2/h11/１世帯当たり延べ面積（民営の借家）",
              "label": "１世帯当たり延べ面積（民営の借家）",
              "cat01": "H366103",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H366104/ｍ2/h11/１世帯当たり延べ面積（給与住宅）",
              "label": "１世帯当たり延べ面積（給与住宅）",
              "cat01": "H366104",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3662/ｍ2/h11/１世帯当たり延べ面積（住宅に住む母子世帯）",
              "label": "１世帯当たり延べ面積（住宅に住む母子世帯）",
              "cat01": "H3662",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3670/ｍ2/h11/１人当たり延べ面積（住宅に住む一般世帯）",
              "label": "１人当たり延べ面積（住宅に住む一般世帯）",
              "cat01": "H3670",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3671/ｍ2/h11/１人当たり延べ面積（主世帯）",
              "label": "１人当たり延べ面積（主世帯）",
              "cat01": "H3671",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H367101/ｍ2/h11/１人当たり延べ面積（持ち家）",
              "label": "１人当たり延べ面積（持ち家）",
              "cat01": "H367101",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3671021/ｍ2/h11/１人当たり延べ面積（公営の借家）",
              "label": "１人当たり延べ面積（公営の借家）",
              "cat01": "H3671021",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3671022/ｍ2/h11/１人当たり延べ面積（公団・公社の借家）",
              "label": "１人当たり延べ面積（公団・公社の借家）",
              "cat01": "H3671022",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H367103/ｍ2/h11/１人当たり延べ面積（民営の借家）",
              "label": "１人当たり延べ面積（民営の借家）",
              "cat01": "H367103",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H367104/ｍ2/h11/１人当たり延べ面積（給与住宅）",
              "label": "１人当たり延べ面積（給与住宅）",
              "cat01": "H367104",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3672/ｍ2/h11/１人当たり延べ面積（住宅に住む母子世帯）",
              "label": "１人当たり延べ面積（住宅に住む母子世帯）",
              "cat01": "H3672",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3673/ｍ2/h11/１人当たり延べ面積（住宅に住む高齢単身世帯）",
              "label": "１人当たり延べ面積（住宅に住む高齢単身世帯）",
              "cat01": "H3673",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3675/ｍ2/h11/１人当たり延べ面積（住宅に住む高齢夫婦世帯）",
              "label": "１人当たり延べ面積（住宅に住む高齢夫婦世帯）",
              "cat01": "H3675",
              "unit": "ｍ2",
              "sourceId": "h11"
            },
            {
              "statId": "0000010108/H3710/世帯/h12/最低居住水準以上の主世帯数",
              "label": "最低居住水準以上の主世帯数",
              "cat01": "H3710",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H371001/世帯/h12/最低居住水準以上の主世帯数（持ち家）",
              "label": "最低居住水準以上の主世帯数（持ち家）",
              "cat01": "H371001",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H371002/世帯/h12/最低居住水準以上の主世帯数（借家）",
              "label": "最低居住水準以上の主世帯数（借家）",
              "cat01": "H371002",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3711/世帯/h12/最低居住水準以上の主世帯数（６５歳未満の単身）",
              "label": "最低居住水準以上の主世帯数（６５歳未満の単身）",
              "cat01": "H3711",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3712/世帯/h12/最低居住水準以上の主世帯数（６５歳以上の単身）",
              "label": "最低居住水準以上の主世帯数（６５歳以上の単身）",
              "cat01": "H3712",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3713/世帯/h12/最低居住水準以上の主世帯数（夫婦のみ）",
              "label": "最低居住水準以上の主世帯数（夫婦のみ）",
              "cat01": "H3713",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3717/世帯/h12/最低居住水準以上の主世帯数（夫婦と１８歳未満及び６５歳以上の者）",
              "label": "最低居住水準以上の主世帯数（夫婦と１８歳未満及び６５歳以上の者）",
              "cat01": "H3717",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3720/世帯/h12/誘導居住水準以上の主世帯数",
              "label": "誘導居住水準以上の主世帯数",
              "cat01": "H3720",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H372001/世帯/h12/誘導居住水準以上の主世帯数（持ち家）",
              "label": "誘導居住水準以上の主世帯数（持ち家）",
              "cat01": "H372001",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H372002/世帯/h12/誘導居住水準以上の主世帯数（借家）",
              "label": "誘導居住水準以上の主世帯数（借家）",
              "cat01": "H372002",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3721/世帯/h12/誘導居住水準以上の主世帯数（６５歳未満の単身）",
              "label": "誘導居住水準以上の主世帯数（６５歳未満の単身）",
              "cat01": "H3721",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3722/世帯/h12/誘導居住水準以上の主世帯数（６５歳以上の単身）",
              "label": "誘導居住水準以上の主世帯数（６５歳以上の単身）",
              "cat01": "H3722",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3723/世帯/h12/誘導居住水準以上の主世帯数（夫婦のみ）",
              "label": "誘導居住水準以上の主世帯数（夫婦のみ）",
              "cat01": "H3723",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3727/世帯/h12/誘導居住水準以上の主世帯数（夫婦と１８歳未満及び６５歳以上の者）",
              "label": "誘導居住水準以上の主世帯数（夫婦と１８歳未満及び６５歳以上の者）",
              "cat01": "H3727",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3730/世帯/h12/最低居住面積水準以上の主世帯数",
              "label": "最低居住面積水準以上の主世帯数",
              "cat01": "H3730",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3740/世帯/h12/誘導居住面積水準以上の主世帯数",
              "label": "誘導居住面積水準以上の主世帯数",
              "cat01": "H3740",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3801/世帯/h12/現住居敷地所有普通世帯数",
              "label": "現住居敷地所有普通世帯数",
              "cat01": "H3801",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3802/世帯/h12/現住居敷地以外の宅地など所有普通世帯数",
              "label": "現住居敷地以外の宅地など所有普通世帯数",
              "cat01": "H3802",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380201/世帯/h12/現住居敷地以外の宅地など所有普通世帯数（持ち家）",
              "label": "現住居敷地以外の宅地など所有普通世帯数（持ち家）",
              "cat01": "H380201",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380202/世帯/h12/現住居敷地以外の宅地など所有普通世帯数（持ち家以外）",
              "label": "現住居敷地以外の宅地など所有普通世帯数（持ち家以外）",
              "cat01": "H380202",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3803/件/h12/現住居敷地以外の宅地など所有件数",
              "label": "現住居敷地以外の宅地など所有件数",
              "cat01": "H3803",
              "unit": "件",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380301/件/h12/現住居敷地以外の宅地など所有件数（持ち家）",
              "label": "現住居敷地以外の宅地など所有件数（持ち家）",
              "cat01": "H380301",
              "unit": "件",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380302/件/h12/現住居敷地以外の宅地など所有件数（持ち家以外）",
              "label": "現住居敷地以外の宅地など所有件数（持ち家以外）",
              "cat01": "H380302",
              "unit": "件",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H3804/世帯/h12/現住居以外の住宅所有普通世帯数",
              "label": "現住居以外の住宅所有普通世帯数",
              "cat01": "H3804",
              "unit": "世帯",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380410/住宅/h12/現住居以外の所有住宅数",
              "label": "現住居以外の所有住宅数",
              "cat01": "H380410",
              "unit": "住宅",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380411/住宅/h12/現住居以外の所有住宅数（親族居住用）",
              "label": "現住居以外の所有住宅数（親族居住用）",
              "cat01": "H380411",
              "unit": "住宅",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380412/住宅/h12/現住居以外の所有住宅数（二次的住宅・別荘用）",
              "label": "現住居以外の所有住宅数（二次的住宅・別荘用）",
              "cat01": "H380412",
              "unit": "住宅",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H380413/住宅/h12/現住居以外の所有住宅数（貸家用）",
              "label": "現住居以外の所有住宅数（貸家用）",
              "cat01": "H380413",
              "unit": "住宅",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H4101/円/h12/専用住宅の１畳当たり家賃・間代",
              "label": "専用住宅の１畳当たり家賃・間代",
              "cat01": "H4101",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410110/円/h12/専用住宅の１畳当たり家賃・間代（公営の借家）",
              "label": "専用住宅の１畳当たり家賃・間代（公営の借家）",
              "cat01": "H410110",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410133/円/h12/専用住宅の１畳当たり家賃・間代（民営借家・非木造）",
              "label": "専用住宅の１畳当たり家賃・間代（民営借家・非木造）",
              "cat01": "H410133",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410134/円/h12/専用住宅の１畳当たり家賃・間代（民営借家・木造）",
              "label": "専用住宅の１畳当たり家賃・間代（民営借家・木造）",
              "cat01": "H410134",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410301/円/h13/３．３m2当たり家賃（公営賃貸住宅）",
              "label": "３．３m2当たり家賃（公営賃貸住宅）",
              "cat01": "H410301",
              "unit": "円",
              "sourceId": "h13"
            },
            {
              "statId": "0000010108/H410302/円/h13/３．３m2当たり家賃（民営賃貸住宅）",
              "label": "３．３m2当たり家賃（民営賃貸住宅）",
              "cat01": "H410302",
              "unit": "円",
              "sourceId": "h13"
            },
            {
              "statId": "0000010108/H4104/円/h12/専用住宅の１畳当たり家賃",
              "label": "専用住宅の１畳当たり家賃",
              "cat01": "H4104",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410410/円/h12/専用住宅の１畳当たり家賃（公営の借家）",
              "label": "専用住宅の１畳当たり家賃（公営の借家）",
              "cat01": "H410410",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410420/円/h12/専用住宅の１畳当たり家賃（都市再生機構（ＵＲ）・公社の借家）",
              "label": "専用住宅の１畳当たり家賃（都市再生機構（ＵＲ）・公社の借家）",
              "cat01": "H410420",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410431/円/h12/専用住宅の１畳当たり家賃（民営借家）",
              "label": "専用住宅の１畳当たり家賃（民営借家）",
              "cat01": "H410431",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H410432/円/h12/専用住宅の１畳当たり家賃（給与住宅）",
              "label": "専用住宅の１畳当たり家賃（給与住宅）",
              "cat01": "H410432",
              "unit": "円",
              "sourceId": "h12"
            },
            {
              "statId": "0000010108/H4210/百円/h14/３．３m2当たり住宅敷地価額",
              "label": "３．３m2当たり住宅敷地価額",
              "cat01": "H4210",
              "unit": "百円",
              "sourceId": "h14"
            },
            {
              "statId": "0000010108/H4320/万円/h15/着工居住用建築物工事費予定額",
              "label": "着工居住用建築物工事費予定額",
              "cat01": "H4320",
              "unit": "万円",
              "sourceId": "h15"
            },
            {
              "statId": "0000010108/H510101/百万ｋｗｈ/h16/電灯使用電力量",
              "label": "電灯使用電力量",
              "cat01": "H510101",
              "unit": "百万ｋｗｈ",
              "sourceId": "h16"
            },
            {
              "statId": "0000010108/H5102/ｋｗ/h16/風力発電導入量（設備容量）",
              "label": "風力発電導入量（設備容量）",
              "cat01": "H5102",
              "unit": "ｋｗ",
              "sourceId": "h16"
            },
            {
              "statId": "0000010108/H5103/基/h16/風力発電導入量（設置基数）",
              "label": "風力発電導入量（設置基数）",
              "cat01": "H5103",
              "unit": "基",
              "sourceId": "h16"
            },
            {
              "statId": "0000010108/H5104/ＭＷｈ/h17/発電電力量",
              "label": "発電電力量",
              "cat01": "H5104",
              "unit": "ＭＷｈ",
              "sourceId": "h17"
            },
            {
              "statId": "0000010108/H5105/ＭＷｈ/h17/電力需要量",
              "label": "電力需要量",
              "cat01": "H5105",
              "unit": "ＭＷｈ",
              "sourceId": "h17"
            },
            {
              "statId": "0000010108/H5201/個/h18/都市ガスメーター取付数",
              "label": "都市ガスメーター取付数",
              "cat01": "H5201",
              "unit": "個",
              "sourceId": "h18"
            },
            {
              "statId": "0000010108/H5202/個/h18/都市ガスメーター調定数",
              "label": "都市ガスメーター調定数",
              "cat01": "H5202",
              "unit": "個",
              "sourceId": "h18"
            },
            {
              "statId": "0000010108/H5203/戸/h18/都市ガス供給区域内世帯数",
              "label": "都市ガス供給区域内世帯数",
              "cat01": "H5203",
              "unit": "戸",
              "sourceId": "h18"
            },
            {
              "statId": "0000010108/H5205/ｋｌ/h19/ガソリン販売量",
              "label": "ガソリン販売量",
              "cat01": "H5205",
              "unit": "ｋｌ",
              "sourceId": "h19"
            },
            {
              "statId": "0000010108/H5206/千ＭＪ/h20/都市ガス販売量",
              "label": "都市ガス販売量",
              "cat01": "H5206",
              "unit": "千ＭＪ",
              "sourceId": "h20"
            },
            {
              "statId": "0000010108/H530101/人/h21/上水道給水人口",
              "label": "上水道給水人口",
              "cat01": "H530101",
              "unit": "人",
              "sourceId": "h21"
            },
            {
              "statId": "0000010108/H530102/人/h21/簡易水道給水人口",
              "label": "簡易水道給水人口",
              "cat01": "H530102",
              "unit": "人",
              "sourceId": "h21"
            },
            {
              "statId": "0000010108/H530103/人/h21/専用水道給水人口",
              "label": "専用水道給水人口",
              "cat01": "H530103",
              "unit": "人",
              "sourceId": "h21"
            },
            {
              "statId": "0000010108/H530201/ｍ3／日/h22/上水道施設能力",
              "label": "上水道施設能力",
              "cat01": "H530201",
              "unit": "ｍ3／日",
              "sourceId": "h22"
            },
            {
              "statId": "0000010108/H530301/千ｍ3/h22/上水道年間給水量",
              "label": "上水道年間給水量",
              "cat01": "H530301",
              "unit": "千ｍ3",
              "sourceId": "h22"
            },
            {
              "statId": "0000010108/H540301/人/h23/下水道排水区域人口",
              "label": "下水道排水区域人口",
              "cat01": "H540301",
              "unit": "人",
              "sourceId": "h23"
            },
            {
              "statId": "0000010108/H540302/人/h23/下水道処理区域人口",
              "label": "下水道処理区域人口",
              "cat01": "H540302",
              "unit": "人",
              "sourceId": "h23"
            },
            {
              "statId": "0000010108/H5404/人/h23/下水道によるトイレ水洗化人口",
              "label": "下水道によるトイレ水洗化人口",
              "cat01": "H5404",
              "unit": "人",
              "sourceId": "h23"
            },
            {
              "statId": "0000010108/H5507/人/h24/総人口（非水洗化人口＋水洗化人口）",
              "label": "総人口（非水洗化人口＋水洗化人口）",
              "cat01": "H5507",
              "unit": "人",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H550701/人/h24/非水洗化人口",
              "label": "非水洗化人口",
              "cat01": "H550701",
              "unit": "人",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5508/％/h24/水洗化率（浄化槽人口）",
              "label": "水洗化率（浄化槽人口）",
              "cat01": "H5508",
              "unit": "％",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5509/ｋｌ/h24/し尿処理量（し尿＋浄化槽汚泥＋自家処理量）",
              "label": "し尿処理量（し尿＋浄化槽汚泥＋自家処理量）",
              "cat01": "H5509",
              "unit": "ｋｌ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5608/人/h24/ごみ計画収集人口",
              "label": "ごみ計画収集人口",
              "cat01": "H5608",
              "unit": "人",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5609/ｔ/h24/ごみ総排出量（総量）",
              "label": "ごみ総排出量（総量）",
              "cat01": "H5609",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H560901/ｔ/h24/ごみ総排出量（計画収集量）",
              "label": "ごみ総排出量（計画収集量）",
              "cat01": "H560901",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H560902/ｔ/h24/ごみ総排出量（直接搬入量）",
              "label": "ごみ総排出量（直接搬入量）",
              "cat01": "H560902",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H560903/ｔ/h24/ごみ総排出量（自家処理量）",
              "label": "ごみ総排出量（自家処理量）",
              "cat01": "H560903",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H560904/ｔ/h24/ごみ総排出量（集団回収量）",
              "label": "ごみ総排出量（集団回収量）",
              "cat01": "H560904",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5610/ｇ/人日/h24/１人１日当たりの排出量",
              "label": "１人１日当たりの排出量",
              "cat01": "H5610",
              "unit": "ｇ/人日",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5612/ｔ/h24/ごみ処理量（総量）",
              "label": "ごみ処理量（総量）",
              "cat01": "H5612",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H561201/ｔ/h24/ごみ処理量（直接資源化）",
              "label": "ごみ処理量（直接資源化）",
              "cat01": "H561201",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5613/ｔ/h24/中間処理後再生利用量",
              "label": "中間処理後再生利用量",
              "cat01": "H5613",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5614/％/h24/ごみのリサイクル率",
              "label": "ごみのリサイクル率",
              "cat01": "H5614",
              "unit": "％",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5615/ｔ/h24/ごみ最終処分量",
              "label": "ごみ最終処分量",
              "cat01": "H5615",
              "unit": "ｔ",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5616/ｍ3／年度/h24/最終処分場埋立容量",
              "label": "最終処分場埋立容量",
              "cat01": "H5616",
              "unit": "ｍ3／年度",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5617/ｍ3/h24/最終処分場残余容量",
              "label": "最終処分場残余容量",
              "cat01": "H5617",
              "unit": "ｍ3",
              "sourceId": "h24"
            },
            {
              "statId": "0000010108/H5701/TJ/h25/最終エネルギー消費量",
              "label": "最終エネルギー消費量",
              "cat01": "H5701",
              "unit": "TJ",
              "sourceId": "h25"
            },
            {
              "statId": "0000010108/H5702/GJ/h25/１人当たり最終エネルギー消費量",
              "label": "１人当たり最終エネルギー消費量",
              "cat01": "H5702",
              "unit": "GJ",
              "sourceId": "h25"
            },
            {
              "statId": "0000010108/H6101/事業所/h26/小売店数（事業所・企業統計調査結果）",
              "label": "小売店数（事業所・企業統計調査結果）",
              "cat01": "H6101",
              "unit": "事業所",
              "sourceId": "h26"
            },
            {
              "statId": "0000010108/H610102/事業所/h26/織物・衣服・身の回り品小売店数（事業所・企業統計調査結果）",
              "label": "織物・衣服・身の回り品小売店数（事業所・企業統計調査結果）",
              "cat01": "H610102",
              "unit": "事業所",
              "sourceId": "h26"
            },
            {
              "statId": "0000010108/H610103/事業所/h26/飲食料品小売店数（事業所・企業統計調査結果）",
              "label": "飲食料品小売店数（事業所・企業統計調査結果）",
              "cat01": "H610103",
              "unit": "事業所",
              "sourceId": "h26"
            },
            {
              "statId": "0000010108/H6102/事業所/h28/飲食店数（事業所・企業統計調査結果）",
              "label": "飲食店数（事業所・企業統計調査結果）",
              "cat01": "H6102",
              "unit": "事業所",
              "sourceId": "h28"
            },
            {
              "statId": "0000010108/H6103/事業所/h28/大型小売店数（事業所・企業統計調査結果）",
              "label": "大型小売店数（事業所・企業統計調査結果）",
              "cat01": "H6103",
              "unit": "事業所",
              "sourceId": "h28"
            },
            {
              "statId": "0000010108/H6104/事業所/h28/百貨店数（事業所・企業統計調査結果）",
              "label": "百貨店数（事業所・企業統計調査結果）",
              "cat01": "H6104",
              "unit": "事業所",
              "sourceId": "h28"
            },
            {
              "statId": "0000010108/H6105/事業所/h30/セルフサービス事業所数",
              "label": "セルフサービス事業所数",
              "cat01": "H6105",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H610501/事業所/h30/総合スーパー数",
              "label": "総合スーパー数",
              "cat01": "H610501",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H610503/事業所/h30/専門スーパー数",
              "label": "専門スーパー数",
              "cat01": "H610503",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H610504/事業所/h30/コンビニエンスストア数",
              "label": "コンビニエンスストア数",
              "cat01": "H610504",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H610505/事業所/h30/その他のスーパー数",
              "label": "その他のスーパー数",
              "cat01": "H610505",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H610506/事業所/h30/広義ドラッグストア数",
              "label": "広義ドラッグストア数",
              "cat01": "H610506",
              "unit": "事業所",
              "sourceId": "h30"
            },
            {
              "statId": "0000010108/H6107/所/h31/理容・美容所数",
              "label": "理容・美容所数",
              "cat01": "H6107",
              "unit": "所",
              "sourceId": "h31"
            },
            {
              "statId": "0000010108/H610701/所/h31/理容所数",
              "label": "理容所数",
              "cat01": "H610701",
              "unit": "所",
              "sourceId": "h31"
            },
            {
              "statId": "0000010108/H610702/所/h31/美容所数",
              "label": "美容所数",
              "cat01": "H610702",
              "unit": "所",
              "sourceId": "h31"
            },
            {
              "statId": "0000010108/H6108/所/h31/クリーニング所数",
              "label": "クリーニング所数",
              "cat01": "H6108",
              "unit": "所",
              "sourceId": "h31"
            },
            {
              "statId": "0000010108/H6109/所/h31/公衆浴場数",
              "label": "公衆浴場数",
              "cat01": "H6109",
              "unit": "所",
              "sourceId": "h31"
            },
            {
              "statId": "0000010108/H6120/箇所/h32/給油所数",
              "label": "給油所数",
              "cat01": "H6120",
              "unit": "箇所",
              "sourceId": "h32"
            },
            {
              "statId": "0000010108/H6130/店/h27/小売店数",
              "label": "小売店数",
              "cat01": "H6130",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613001/店/h27/各種商品小売店数",
              "label": "各種商品小売店数",
              "cat01": "H613001",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613002/店/h27/織物・衣服・身の回り品小売店数（経済センサス‐基礎調査及び活動調査結果）",
              "label": "織物・衣服・身の回り品小売店数（経済センサス‐基礎調査及び活動調査結果）",
              "cat01": "H613002",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613003/店/h27/飲食料品小売店数（経済センサス-基礎調査結果）",
              "label": "飲食料品小売店数（経済センサス-基礎調査結果）",
              "cat01": "H613003",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613004/店/h27/機械器具小売店数",
              "label": "機械器具小売店数",
              "cat01": "H613004",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613005/店/h27/その他の小売店数",
              "label": "その他の小売店数",
              "cat01": "H613005",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H613006/店/h27/無店舗小売店数",
              "label": "無店舗小売店数",
              "cat01": "H613006",
              "unit": "店",
              "sourceId": "h27"
            },
            {
              "statId": "0000010108/H6131/店/h29/飲食店数（経済センサス-基礎調査結果）",
              "label": "飲食店数（経済センサス-基礎調査結果）",
              "cat01": "H6131",
              "unit": "店",
              "sourceId": "h29"
            },
            {
              "statId": "0000010108/H6132/店/h29/大型小売店数（経済センサス‐基礎調査及び活動調査結果）",
              "label": "大型小売店数（経済センサス‐基礎調査及び活動調査結果）",
              "cat01": "H6132",
              "unit": "店",
              "sourceId": "h29"
            },
            {
              "statId": "0000010108/H6133/店/h29/百貨店，総合スーパー数",
              "label": "百貨店，総合スーパー数",
              "cat01": "H6133",
              "unit": "店",
              "sourceId": "h29"
            },
            {
              "statId": "0000010108/H6201/ｍ2/h33/小売業売場面積",
              "label": "小売業売場面積",
              "cat01": "H6201",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620101/ｍ2/h33/各種商品小売業売場面積",
              "label": "各種商品小売業売場面積",
              "cat01": "H620101",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620102/ｍ2/h33/織物・衣服・身の回り品小売業売場面積",
              "label": "織物・衣服・身の回り品小売業売場面積",
              "cat01": "H620102",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620103/ｍ2/h33/飲食料品小売業売場面積",
              "label": "飲食料品小売業売場面積",
              "cat01": "H620103",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620104/ｍ2/h33/自動車・自転車小売業売場面積",
              "label": "自動車・自転車小売業売場面積",
              "cat01": "H620104",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620105/ｍ2/h33/家具・じゅう器・家庭用機械器具小売業売場面積",
              "label": "家具・じゅう器・家庭用機械器具小売業売場面積",
              "cat01": "H620105",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H620106/ｍ2/h33/その他の小売業売場面積",
              "label": "その他の小売業売場面積",
              "cat01": "H620106",
              "unit": "ｍ2",
              "sourceId": "h33"
            },
            {
              "statId": "0000010108/H7110/ｋｍ/h34/道路実延長",
              "label": "道路実延長",
              "cat01": "H7110",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H711001/ｋｍ/h34/道路実延長（高速道路を含む）",
              "label": "道路実延長（高速道路を含む）",
              "cat01": "H711001",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7111/ｋｍ/h34/道路実延長（主要道路）",
              "label": "道路実延長（主要道路）",
              "cat01": "H7111",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H711101/ｋｍ/h34/道路実延長（一般国道）",
              "label": "道路実延長（一般国道）",
              "cat01": "H711101",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H711102/ｋｍ/h34/道路実延長（主要地方道）",
              "label": "道路実延長（主要地方道）",
              "cat01": "H711102",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H711103/ｋｍ/h34/道路実延長（一般都道府県道）",
              "label": "道路実延長（一般都道府県道）",
              "cat01": "H711103",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7112/ｋｍ/h34/道路実延長（市町村道）",
              "label": "道路実延長（市町村道）",
              "cat01": "H7112",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7113/ｋｍ/h34/道路実延長（高速道路）",
              "label": "道路実延長（高速道路）",
              "cat01": "H7113",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7120/ｋｍ/h34/舗装道路実延長",
              "label": "舗装道路実延長",
              "cat01": "H7120",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7121/ｋｍ/h34/舗装道路実延長（主要道路）",
              "label": "舗装道路実延長（主要道路）",
              "cat01": "H7121",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H712101/ｋｍ/h34/舗装道路実延長（一般国道）",
              "label": "舗装道路実延長（一般国道）",
              "cat01": "H712101",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H712102/ｋｍ/h34/舗装道路実延長（主要地方道）",
              "label": "舗装道路実延長（主要地方道）",
              "cat01": "H712102",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H712103/ｋｍ/h34/舗装道路実延長（一般都道府県道）",
              "label": "舗装道路実延長（一般都道府県道）",
              "cat01": "H712103",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7122/ｋｍ/h34/舗装道路実延長（市町村道）",
              "label": "舗装道路実延長（市町村道）",
              "cat01": "H7122",
              "unit": "ｋｍ",
              "sourceId": "h34"
            },
            {
              "statId": "0000010108/H7150/千台ｷﾛ/12ｈ//自動車走行台キロ",
              "label": "自動車走行台キロ",
              "cat01": "H7150",
              "unit": "千台ｷﾛ/12ｈ",
              "sourceId": ""
            },
            {
              "statId": "0000010108/H7160/台/12ｈ/h35/道路平均交通量",
              "label": "道路平均交通量",
              "cat01": "H7160",
              "unit": "台/12ｈ",
              "sourceId": "h35"
            },
            {
              "statId": "0000010108/H7207/台/h36/軽自動車等の賦課期日現在台数",
              "label": "軽自動車等の賦課期日現在台数",
              "cat01": "H7207",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H7208/台/h36/二輪の小型自動車台数",
              "label": "二輪の小型自動車台数",
              "cat01": "H7208",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H7209/台/h36/原動機付き自転車台数",
              "label": "原動機付き自転車台数",
              "cat01": "H7209",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H720901/台/h36/原動機付き自転車台数（５０ｃｃ以下）",
              "label": "原動機付き自転車台数（５０ｃｃ以下）",
              "cat01": "H720901",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H720902/台/h36/原動機付き自転車台数（５０ｃｃ～９０ｃｃ）",
              "label": "原動機付き自転車台数（５０ｃｃ～９０ｃｃ）",
              "cat01": "H720902",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H720903/台/h36/原動機付き自転車台数（９０ｃｃ～）",
              "label": "原動機付き自転車台数（９０ｃｃ～）",
              "cat01": "H720903",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H720904/台/h36/原動機付き自転車台数（ミニカー）",
              "label": "原動機付き自転車台数（ミニカー）",
              "cat01": "H720904",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H7210/台/h36/軽自動車及び小型特殊自動車台数",
              "label": "軽自動車及び小型特殊自動車台数",
              "cat01": "H7210",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H721001/台/h36/二輪車台数（側車付のものを含む）",
              "label": "二輪車台数（側車付のものを含む）",
              "cat01": "H721001",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H721002/台/h36/三輪車台数",
              "label": "三輪車台数",
              "cat01": "H721002",
              "unit": "台",
              "sourceId": "h36"
            },
            {
              "statId": "0000010108/H7301/人/h37/自宅外通勤・通学者数",
              "label": "自宅外通勤・通学者数",
              "cat01": "H7301",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730101/人/h37/自宅外通勤・通学者数（徒歩だけ）",
              "label": "自宅外通勤・通学者数（徒歩だけ）",
              "cat01": "H730101",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730102/人/h37/自宅外通勤・通学者数（鉄道・電車）",
              "label": "自宅外通勤・通学者数（鉄道・電車）",
              "cat01": "H730102",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730103/人/h37/自宅外通勤・通学者数（乗合バス）",
              "label": "自宅外通勤・通学者数（乗合バス）",
              "cat01": "H730103",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730104/人/h37/自宅外通勤・通学者数（勤め先・学校のバス）",
              "label": "自宅外通勤・通学者数（勤め先・学校のバス）",
              "cat01": "H730104",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730105/人/h37/自宅外通勤・通学者数（自家用車）",
              "label": "自宅外通勤・通学者数（自家用車）",
              "cat01": "H730105",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730108/人/h37/自宅外通勤・通学者数（利用交通手段が２種類）",
              "label": "自宅外通勤・通学者数（利用交通手段が２種類）",
              "cat01": "H730108",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730109/人/h37/自宅外通勤・通学者数（利用交通手段が３種類以上）",
              "label": "自宅外通勤・通学者数（利用交通手段が３種類以上）",
              "cat01": "H730109",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730110/人/h37/自宅外通勤・通学者数（オートバイ）",
              "label": "自宅外通勤・通学者数（オートバイ）",
              "cat01": "H730110",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730111/人/h37/自宅外通勤・通学者数（自転車）",
              "label": "自宅外通勤・通学者数（自転車）",
              "cat01": "H730111",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730112/人/h37/自宅外通勤・通学者数（ハイヤー・タクシー）",
              "label": "自宅外通勤・通学者数（ハイヤー・タクシー）",
              "cat01": "H730112",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730113/人/h37/自宅外通勤・通学者数（その他）",
              "label": "自宅外通勤・通学者数（その他）",
              "cat01": "H730113",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H7302/人/h37/自市区町村内通勤・通学者数",
              "label": "自市区町村内通勤・通学者数",
              "cat01": "H7302",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730208/人/h37/自市区町村内通勤・通学者数（利用交通手段が２種類）",
              "label": "自市区町村内通勤・通学者数（利用交通手段が２種類）",
              "cat01": "H730208",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730209/人/h37/自市区町村内通勤・通学者数（利用交通手段が３種類以上）",
              "label": "自市区町村内通勤・通学者数（利用交通手段が３種類以上）",
              "cat01": "H730209",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730210/人/h37/自市区町村内通勤・通学者数（オートバイ）",
              "label": "自市区町村内通勤・通学者数（オートバイ）",
              "cat01": "H730210",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730211/人/h37/自市区町村内通勤・通学者数（自転車）",
              "label": "自市区町村内通勤・通学者数（自転車）",
              "cat01": "H730211",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730212/人/h37/自市区町村内通勤・通学者数（ハイヤー・タクシー）",
              "label": "自市区町村内通勤・通学者数（ハイヤー・タクシー）",
              "cat01": "H730212",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730213/人/h37/自市区町村内通勤・通学者数（その他）",
              "label": "自市区町村内通勤・通学者数（その他）",
              "cat01": "H730213",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H7303/人/h37/県内他市区町村への通勤・通学者数",
              "label": "県内他市区町村への通勤・通学者数",
              "cat01": "H7303",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730301/人/h37/県内他市区町村への通勤・通学者数（徒歩だけ）",
              "label": "県内他市区町村への通勤・通学者数（徒歩だけ）",
              "cat01": "H730301",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730302/人/h37/県内他市区町村への通勤・通学者数（鉄道・電車）",
              "label": "県内他市区町村への通勤・通学者数（鉄道・電車）",
              "cat01": "H730302",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730303/人/h37/県内他市区町村への通勤・通学者数（乗合バス）",
              "label": "県内他市区町村への通勤・通学者数（乗合バス）",
              "cat01": "H730303",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730304/人/h37/県内他市区町村への通勤・通学者数（勤め先・学校のバス）",
              "label": "県内他市区町村への通勤・通学者数（勤め先・学校のバス）",
              "cat01": "H730304",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730305/人/h37/県内他市区町村への通勤・通学者数（自家用車）",
              "label": "県内他市区町村への通勤・通学者数（自家用車）",
              "cat01": "H730305",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730308/人/h37/県内他市区町村への通勤・通学者数（利用交通手段が２種類）",
              "label": "県内他市区町村への通勤・通学者数（利用交通手段が２種類）",
              "cat01": "H730308",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730309/人/h37/県内他市区町村への通勤・通学者数（利用交通手段が３種類以上）",
              "label": "県内他市区町村への通勤・通学者数（利用交通手段が３種類以上）",
              "cat01": "H730309",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730310/人/h37/県内他市区町村への通勤・通学者数（オートバイ）",
              "label": "県内他市区町村への通勤・通学者数（オートバイ）",
              "cat01": "H730310",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730311/人/h37/県内他市区町村への通勤・通学者数（自転車）",
              "label": "県内他市区町村への通勤・通学者数（自転車）",
              "cat01": "H730311",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730312/人/h37/県内他市区町村への通勤・通学者数（ハイヤー・タクシー）",
              "label": "県内他市区町村への通勤・通学者数（ハイヤー・タクシー）",
              "cat01": "H730312",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730313/人/h37/県内他市区町村への通勤・通学者数（その他）",
              "label": "県内他市区町村への通勤・通学者数（その他）",
              "cat01": "H730313",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H7304/人/h37/他県への通勤・通学者数",
              "label": "他県への通勤・通学者数",
              "cat01": "H7304",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730402/人/h37/他県への通勤・通学者数（鉄道・電車）",
              "label": "他県への通勤・通学者数（鉄道・電車）",
              "cat01": "H730402",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730403/人/h37/他県への通勤・通学者数（乗合バス）",
              "label": "他県への通勤・通学者数（乗合バス）",
              "cat01": "H730403",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730404/人/h37/他県への通勤・通学者数（勤め先・学校のバス）",
              "label": "他県への通勤・通学者数（勤め先・学校のバス）",
              "cat01": "H730404",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730408/人/h37/他県への通勤・通学者数（利用交通手段が２種類）",
              "label": "他県への通勤・通学者数（利用交通手段が２種類）",
              "cat01": "H730408",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730409/人/h37/他県への通勤・通学者数（利用交通手段が３種類以上）",
              "label": "他県への通勤・通学者数（利用交通手段が３種類以上）",
              "cat01": "H730409",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730410/人/h37/他県への通勤・通学者数（オートバイ）",
              "label": "他県への通勤・通学者数（オートバイ）",
              "cat01": "H730410",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730411/人/h37/他県への通勤・通学者数（自転車）",
              "label": "他県への通勤・通学者数（自転車）",
              "cat01": "H730411",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730412/人/h37/他県への通勤・通学者数（ハイヤー・タクシー）",
              "label": "他県への通勤・通学者数（ハイヤー・タクシー）",
              "cat01": "H730412",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H730413/人/h37/他県への通勤・通学者数（その他）",
              "label": "他県への通勤・通学者数（その他）",
              "cat01": "H730413",
              "unit": "人",
              "sourceId": "h37"
            },
            {
              "statId": "0000010108/H7401/世帯/h38/家計を主に支える者が雇用者である普通世帯数",
              "label": "家計を主に支える者が雇用者である普通世帯数",
              "cat01": "H7401",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740101/世帯/h38/家計を主に支える者が雇用者である普通世帯数（通勤時間３０分未満）",
              "label": "家計を主に支える者が雇用者である普通世帯数（通勤時間３０分未満）",
              "cat01": "H740101",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740102/世帯/h38/家計を主に支える者が雇用者である普通世帯数（通勤時間３０分～１時間）",
              "label": "家計を主に支える者が雇用者である普通世帯数（通勤時間３０分～１時間）",
              "cat01": "H740102",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740103/世帯/h38/家計を主に支える者が雇用者である普通世帯数（通勤時間１時間～１時間３０分）",
              "label": "家計を主に支える者が雇用者である普通世帯数（通勤時間１時間～１時間３０分）",
              "cat01": "H740103",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740104/世帯/h38/家計を主に支える者が雇用者である普通世帯数（通勤時間１時間３０分以上）",
              "label": "家計を主に支える者が雇用者である普通世帯数（通勤時間１時間３０分以上）",
              "cat01": "H740104",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H7402/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家）",
              "cat01": "H7402",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740201/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間３０分未満）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間３０分未満）",
              "cat01": "H740201",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740202/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間３０～５９分）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間３０～５９分）",
              "cat01": "H740202",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740203/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間６０～８９分）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間６０～８９分）",
              "cat01": "H740203",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740204/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間９０分以上）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家・通勤時間９０分以上）",
              "cat01": "H740204",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H7403/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家以外）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家以外）",
              "cat01": "H7403",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740301/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間３０分未満）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間３０分未満）",
              "cat01": "H740301",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740302/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間３０～５９分）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間３０～５９分）",
              "cat01": "H740302",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740303/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間６０～８９分）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間６０～８９分）",
              "cat01": "H740303",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H740304/世帯/h38/家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間９０分以上）",
              "label": "家計を主に支える者が雇用者である普通世帯数（持ち家以外・通勤時間９０分以上）",
              "cat01": "H740304",
              "unit": "世帯",
              "sourceId": "h38"
            },
            {
              "statId": "0000010108/H7501/局/h39/郵便局数",
              "label": "郵便局数",
              "cat01": "H7501",
              "unit": "局",
              "sourceId": "h39"
            },
            {
              "statId": "0000010108/H7503/‐/h39/郵便物引受数",
              "label": "郵便物引受数",
              "cat01": "H7503",
              "unit": "‐",
              "sourceId": "h39"
            },
            {
              "statId": "0000010108/H7601/加入/h40/電話加入数",
              "label": "電話加入数",
              "cat01": "H7601",
              "unit": "加入",
              "sourceId": "h40"
            },
            {
              "statId": "0000010108/H760101/加入/h40/電話加入数（住宅用）",
              "label": "電話加入数（住宅用）",
              "cat01": "H760101",
              "unit": "加入",
              "sourceId": "h40"
            },
            {
              "statId": "0000010108/H7602/個/h40/公衆電話施設数",
              "label": "公衆電話施設数",
              "cat01": "H7602",
              "unit": "個",
              "sourceId": "h40"
            },
            {
              "statId": "0000010108/H7604/件/h41/携帯電話契約数",
              "label": "携帯電話契約数",
              "cat01": "H7604",
              "unit": "件",
              "sourceId": "h41"
            },
            {
              "statId": "0000010108/H7701/‐/h42/テレビ放送受信契約数",
              "label": "テレビ放送受信契約数",
              "cat01": "H7701",
              "unit": "‐",
              "sourceId": "h42"
            },
            {
              "statId": "0000010108/H770101/‐/h42/衛星放送受信契約数",
              "label": "衛星放送受信契約数",
              "cat01": "H770101",
              "unit": "‐",
              "sourceId": "h42"
            },
            {
              "statId": "0000010108/H7702/加入/h43/ケーブルテレビ加入世帯数",
              "label": "ケーブルテレビ加入世帯数",
              "cat01": "H7702",
              "unit": "加入",
              "sourceId": "h43"
            },
            {
              "statId": "0000010108/H7703/契約/h44/ブロードバンドサービス契約数",
              "label": "ブロードバンドサービス契約数",
              "cat01": "H7703",
              "unit": "契約",
              "sourceId": "h44"
            },
            {
              "statId": "0000010108/H8101/ｈａ/h45/都市計画区域指定面積",
              "label": "都市計画区域指定面積",
              "cat01": "H8101",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H8102/ｈａ/h45/市街化調整区域面積",
              "label": "市街化調整区域面積",
              "cat01": "H8102",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H8103/ｈａ/h45/市街化区域面積",
              "label": "市街化区域面積",
              "cat01": "H8103",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H8104/ｈａ/h45/用途地域面積",
              "label": "用途地域面積",
              "cat01": "H8104",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810401/ｈａ/h45/住居専用地域面積",
              "label": "住居専用地域面積",
              "cat01": "H810401",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810402/ｈａ/h45/住居地域面積",
              "label": "住居地域面積",
              "cat01": "H810402",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810403/ｈａ/h45/近隣商業地域面積",
              "label": "近隣商業地域面積",
              "cat01": "H810403",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810404/ｈａ/h45/商業地域面積",
              "label": "商業地域面積",
              "cat01": "H810404",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810405/ｈａ/h45/準工業地域面積",
              "label": "準工業地域面積",
              "cat01": "H810405",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810406/ｈａ/h45/工業地域面積",
              "label": "工業地域面積",
              "cat01": "H810406",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810407/ｈａ/h45/工業専用地域面積",
              "label": "工業専用地域面積",
              "cat01": "H810407",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810408/ｈａ/h45/商業・近隣商業地域面積",
              "label": "商業・近隣商業地域面積",
              "cat01": "H810408",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H810409/ｈａ/h45/工業・準工業地域面積",
              "label": "工業・準工業地域面積",
              "cat01": "H810409",
              "unit": "ｈａ",
              "sourceId": "h45"
            },
            {
              "statId": "0000010108/H9101/箇所/h46/都市公園数",
              "label": "都市公園数",
              "cat01": "H9101",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9102/箇所/h46/街区公園数",
              "label": "街区公園数",
              "cat01": "H9102",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9103/箇所/h46/近隣公園数",
              "label": "近隣公園数",
              "cat01": "H9103",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9104/箇所/h46/運動公園数",
              "label": "運動公園数",
              "cat01": "H9104",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9106/箇所/h46/地区公園数",
              "label": "地区公園数",
              "cat01": "H9106",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9107/箇所/h46/総合公園数",
              "label": "総合公園数",
              "cat01": "H9107",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9108/箇所/h46/特殊公園数",
              "label": "特殊公園数",
              "cat01": "H9108",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H910801/箇所/h46/風致公園数",
              "label": "風致公園数",
              "cat01": "H910801",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H910802/箇所/h46/動植物公園数",
              "label": "動植物公園数",
              "cat01": "H910802",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H910803/箇所/h46/歴史公園数",
              "label": "歴史公園数",
              "cat01": "H910803",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H910804/箇所/h46/墓園数",
              "label": "墓園数",
              "cat01": "H910804",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9109/箇所/h46/大規模公園数",
              "label": "大規模公園数",
              "cat01": "H9109",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H910901/箇所/h46/広域公園数",
              "label": "広域公園数",
              "cat01": "H910901",
              "unit": "箇所",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9201/ｈａ/h46/都市公園面積",
              "label": "都市公園面積",
              "cat01": "H9201",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9202/ｈａ/h46/街区公園面積",
              "label": "街区公園面積",
              "cat01": "H9202",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9203/ｈａ/h46/近隣公園面積",
              "label": "近隣公園面積",
              "cat01": "H9203",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9204/ｈａ/h46/運動公園面積",
              "label": "運動公園面積",
              "cat01": "H9204",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H920501/ｈａ/h46/緩衝緑地面積",
              "label": "緩衝緑地面積",
              "cat01": "H920501",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H920502/ｈａ/h46/都市緑地面積",
              "label": "都市緑地面積",
              "cat01": "H920502",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H920503/ｈａ/h46/緑道面積",
              "label": "緑道面積",
              "cat01": "H920503",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9207/ｈａ/h46/総合公園面積",
              "label": "総合公園面積",
              "cat01": "H9207",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H9209/ｈａ/h46/大規模公園面積",
              "label": "大規模公園面積",
              "cat01": "H9209",
              "unit": "ｈａ",
              "sourceId": "h46"
            },
            {
              "statId": "0000010108/H920901/ｈａ/h46/広域公園面積",
              "label": "広域公園面積",
              "cat01": "H920901",
              "unit": "ｈａ",
              "sourceId": "h46"
            }
          ]
        },
        {
          "label": "Ｉ健康・医療",
          "statId": "0000010109",
          "children": [
            {
              "statId": "0000010109/I1101/年/i01/平均余命（０歳）（男）",
              "label": "平均余命（０歳）（男）",
              "cat01": "I1101",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1102/年/i01/平均余命（０歳）（女）",
              "label": "平均余命（０歳）（女）",
              "cat01": "I1102",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1201/年/i01/平均余命（２０歳）（男）",
              "label": "平均余命（２０歳）（男）",
              "cat01": "I1201",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1202/年/i01/平均余命（２０歳）（女）",
              "label": "平均余命（２０歳）（女）",
              "cat01": "I1202",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1301/年/i01/平均余命（４０歳）（男）",
              "label": "平均余命（４０歳）（男）",
              "cat01": "I1301",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1302/年/i01/平均余命（４０歳）（女）",
              "label": "平均余命（４０歳）（女）",
              "cat01": "I1302",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1401/年/i01/平均余命（６０歳）（男）",
              "label": "平均余命（６０歳）（男）",
              "cat01": "I1401",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1402/年/i01/平均余命（６０歳）（女）",
              "label": "平均余命（６０歳）（女）",
              "cat01": "I1402",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1501/年/i01/平均余命（６５歳）（男）",
              "label": "平均余命（６５歳）（男）",
              "cat01": "I1501",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1502/年/i01/平均余命（６５歳）（女）",
              "label": "平均余命（６５歳）（女）",
              "cat01": "I1502",
              "unit": "年",
              "sourceId": "i01"
            },
            {
              "statId": "0000010109/I1601/年/i02/健康寿命（男）",
              "label": "健康寿命（男）",
              "cat01": "I1601",
              "unit": "年",
              "sourceId": "i02"
            },
            {
              "statId": "0000010109/I1602/年/i02/健康寿命（女）",
              "label": "健康寿命（女）",
              "cat01": "I1602",
              "unit": "年",
              "sourceId": "i02"
            },
            {
              "statId": "0000010109/I210101/人/i03/健康診断受診者数（保健所及び市区町村実施分）（結核）",
              "label": "健康診断受診者数（保健所及び市区町村実施分）（結核）",
              "cat01": "I210101",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210104/人/i03/健康診断受診者数（保健所及び市区町村実施分）（生活習慣病）",
              "label": "健康診断受診者数（保健所及び市区町村実施分）（生活習慣病）",
              "cat01": "I210104",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210110/人/i03/健康診断受診者数（保健所実施分）",
              "label": "健康診断受診者数（保健所実施分）",
              "cat01": "I210110",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210112/人/i03/健康診断受診者数（保健所実施分・精神）",
              "label": "健康診断受診者数（保健所実施分・精神）",
              "cat01": "I210112",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210114/人/i03/健康診断受診者数（保健所実施分・生活習慣病）",
              "label": "健康診断受診者数（保健所実施分・生活習慣病）",
              "cat01": "I210114",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210115/人/i03/健康診断受診者数（保健所実施分・妊産婦）",
              "label": "健康診断受診者数（保健所実施分・妊産婦）",
              "cat01": "I210115",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210116/人/i03/健康診断受診者数（保健所実施分・乳幼児）",
              "label": "健康診断受診者数（保健所実施分・乳幼児）",
              "cat01": "I210116",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210117/人/i03/健康診断受診者数（保健所実施分・一般）",
              "label": "健康診断受診者数（保健所実施分・一般）",
              "cat01": "I210117",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210120/人/i03/健康診断受診者数（市町村実施分）",
              "label": "健康診断受診者数（市町村実施分）",
              "cat01": "I210120",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I210121/人/i03/健康診断受診者数（市町村実施分・結核）",
              "label": "健康診断受診者数（市町村実施分・結核）",
              "cat01": "I210121",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2201/人/i03/妊娠の届出者数",
              "label": "妊娠の届出者数",
              "cat01": "I2201",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2211/人/i03/妊産婦保健指導数",
              "label": "妊産婦保健指導数",
              "cat01": "I2211",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221110/人/i03/妊産婦保健指導数（保健所実施分）",
              "label": "妊産婦保健指導数（保健所実施分）",
              "cat01": "I221110",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221112/人/i03/産婦保健指導数（保健所実施分）",
              "label": "産婦保健指導数（保健所実施分）",
              "cat01": "I221112",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221120/人/i03/妊産婦保健指導数（市町村実施分）",
              "label": "妊産婦保健指導数（市町村実施分）",
              "cat01": "I221120",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221121/人/i03/妊婦保健指導数（市町村実施分）",
              "label": "妊婦保健指導数（市町村実施分）",
              "cat01": "I221121",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221122/人/i03/産婦保健指導数（市町村実施分）",
              "label": "産婦保健指導数（市町村実施分）",
              "cat01": "I221122",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2212/人/i03/乳幼児保健指導数",
              "label": "乳幼児保健指導数",
              "cat01": "I2212",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221210/人/i03/乳幼児保健指導数（保健所実施分）",
              "label": "乳幼児保健指導数（保健所実施分）",
              "cat01": "I221210",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I221220/人/i03/乳幼児保健指導数（市町村実施分）",
              "label": "乳幼児保健指導数（市町村実施分）",
              "cat01": "I221220",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2221/人/i03/妊産婦訪問指導数",
              "label": "妊産婦訪問指導数",
              "cat01": "I2221",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I222110/人/i03/妊産婦訪問指導数（保健所実施分）",
              "label": "妊産婦訪問指導数（保健所実施分）",
              "cat01": "I222110",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I222120/人/i03/妊産婦訪問指導数（市町村実施分）",
              "label": "妊産婦訪問指導数（市町村実施分）",
              "cat01": "I222120",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2222/人/i03/乳幼児訪問指導数",
              "label": "乳幼児訪問指導数",
              "cat01": "I2222",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I222210/人/i03/乳幼児訪問指導数（保健所実施分）",
              "label": "乳幼児訪問指導数（保健所実施分）",
              "cat01": "I222210",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I222220/人/i03/乳幼児訪問指導数（市町村実施分）",
              "label": "乳幼児訪問指導数（市町村実施分）",
              "cat01": "I222220",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I223110/人/i03/身体障害児療育指導数（保健所実施分）",
              "label": "身体障害児療育指導数（保健所実施分）",
              "cat01": "I223110",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I223210/人/i03/長期療養児療育指導数（保健所実施分）",
              "label": "長期療養児療育指導数（保健所実施分）",
              "cat01": "I223210",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2301/人/i03/歯科健診・保健指導延人員",
              "label": "歯科健診・保健指導延人員",
              "cat01": "I2301",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230101/人/i03/歯科健診・保健指導延人員（妊産婦）",
              "label": "歯科健診・保健指導延人員（妊産婦）",
              "cat01": "I230101",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230102/人/i03/歯科健診・保健指導延人員（乳幼児）",
              "label": "歯科健診・保健指導延人員（乳幼児）",
              "cat01": "I230102",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230103/人/i03/歯科健診・保健指導延人員（その他）",
              "label": "歯科健診・保健指導延人員（その他）",
              "cat01": "I230103",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230122/人/i03/歯科健診・保健指導延人員（市町村実施分・乳幼児）",
              "label": "歯科健診・保健指導延人員（市町村実施分・乳幼児）",
              "cat01": "I230122",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2302/人/i03/歯科予防処置延人員",
              "label": "歯科予防処置延人員",
              "cat01": "I2302",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230201/人/i03/歯科予防処置延人員（妊産婦）",
              "label": "歯科予防処置延人員（妊産婦）",
              "cat01": "I230201",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230202/人/i03/歯科予防処置延人員（乳幼児）",
              "label": "歯科予防処置延人員（乳幼児）",
              "cat01": "I230202",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230203/人/i03/歯科予防処置延人員（その他）",
              "label": "歯科予防処置延人員（その他）",
              "cat01": "I230203",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I230210/人/i03/歯科予防処置延人員（保健所実施分）",
              "label": "歯科予防処置延人員（保健所実施分）",
              "cat01": "I230210",
              "unit": "人",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2401/件/i03/試験検査件数",
              "label": "試験検査件数",
              "cat01": "I2401",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2402/件/i03/細菌学的検査件数",
              "label": "細菌学的検査件数",
              "cat01": "I2402",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2403/件/i03/食品衛生関係検査件数",
              "label": "食品衛生関係検査件数",
              "cat01": "I2403",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2404/件/i03/臨床学的検査件数",
              "label": "臨床学的検査件数",
              "cat01": "I2404",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2405/件/i03/水質検査件数",
              "label": "水質検査件数",
              "cat01": "I2405",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I240501/件/i03/水質検査件数（飲用水）",
              "label": "水質検査件数（飲用水）",
              "cat01": "I240501",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2406/件/i03/廃棄物関係検査件数",
              "label": "廃棄物関係検査件数",
              "cat01": "I2406",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2407/件/i03/環境・公害関係検査件数",
              "label": "環境・公害関係検査件数",
              "cat01": "I2407",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2501/件/i03/保健所の環境衛生監視員等による調査及び監視指導延施設数",
              "label": "保健所の環境衛生監視員等による調査及び監視指導延施設数",
              "cat01": "I2501",
              "unit": "件",
              "sourceId": "i03"
            },
            {
              "statId": "0000010109/I2502/所/i04/食品営業施設数",
              "label": "食品営業施設数",
              "cat01": "I2502",
              "unit": "所",
              "sourceId": "i04"
            },
            {
              "statId": "0000010109/I2503/件/i04/食品営業施設処分件数",
              "label": "食品営業施設処分件数",
              "cat01": "I2503",
              "unit": "件",
              "sourceId": "i04"
            },
            {
              "statId": "0000010109/I2601/千人/i05/胃がん検診受診者数（勤め先）",
              "label": "胃がん検診受診者数（勤め先）",
              "cat01": "I2601",
              "unit": "千人",
              "sourceId": "i05"
            },
            {
              "statId": "0000010109/I2602/千人/i05/肺がん検診受診者数（勤め先）",
              "label": "肺がん検診受診者数（勤め先）",
              "cat01": "I2602",
              "unit": "千人",
              "sourceId": "i05"
            },
            {
              "statId": "0000010109/I2603/千人/i05/子宮頸がん検診受診者数（勤め先）",
              "label": "子宮頸がん検診受診者数（勤め先）",
              "cat01": "I2603",
              "unit": "千人",
              "sourceId": "i05"
            },
            {
              "statId": "0000010109/I2604/千人/i05/乳がん検診受診者数（勤め先）",
              "label": "乳がん検診受診者数（勤め先）",
              "cat01": "I2604",
              "unit": "千人",
              "sourceId": "i05"
            },
            {
              "statId": "0000010109/I2605/千人/i05/大腸がん検診受診者数（勤め先）",
              "label": "大腸がん検診受診者数（勤め先）",
              "cat01": "I2605",
              "unit": "千人",
              "sourceId": "i05"
            },
            {
              "statId": "0000010109/I2701/人/i06/健康増進（栄養指導）被指導延人員",
              "label": "健康増進（栄養指導）被指導延人員",
              "cat01": "I2701",
              "unit": "人",
              "sourceId": "i06"
            },
            {
              "statId": "0000010109/I2801/人/i07/精神保健福祉相談，デイ・ケア，訪問指導実人員",
              "label": "精神保健福祉相談，デイ・ケア，訪問指導実人員",
              "cat01": "I2801",
              "unit": "人",
              "sourceId": "i07"
            },
            {
              "statId": "0000010109/I3301/％/i08/食糧自給率（カロリーベース）",
              "label": "食糧自給率（カロリーベース）",
              "cat01": "I3301",
              "unit": "％",
              "sourceId": "i08"
            },
            {
              "statId": "0000010109/I411101/ｃｍ/i09/身長（小学５年）（男）",
              "label": "身長（小学５年）（男）",
              "cat01": "I411101",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I411102/ｃｍ/i09/身長（小学５年）（女）",
              "label": "身長（小学５年）（女）",
              "cat01": "I411102",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I411201/ｃｍ/i09/身長（中学２年）（男）",
              "label": "身長（中学２年）（男）",
              "cat01": "I411201",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I411202/ｃｍ/i09/身長（中学２年）（女）",
              "label": "身長（中学２年）（女）",
              "cat01": "I411202",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I411301/ｃｍ/i09/身長（高校２年）（男）",
              "label": "身長（高校２年）（男）",
              "cat01": "I411301",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I411302/ｃｍ/i09/身長（高校２年）（女）",
              "label": "身長（高校２年）（女）",
              "cat01": "I411302",
              "unit": "ｃｍ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412101/ｋｇ/i09/体重（小学５年）（男）",
              "label": "体重（小学５年）（男）",
              "cat01": "I412101",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412102/ｋｇ/i09/体重（小学５年）（女）",
              "label": "体重（小学５年）（女）",
              "cat01": "I412102",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412201/ｋｇ/i09/体重（中学２年）（男）",
              "label": "体重（中学２年）（男）",
              "cat01": "I412201",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412202/ｋｇ/i09/体重（中学２年）（女）",
              "label": "体重（中学２年）（女）",
              "cat01": "I412202",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412301/ｋｇ/i09/体重（高校２年）（男）",
              "label": "体重（高校２年）（男）",
              "cat01": "I412301",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I412302/ｋｇ/i09/体重（高校２年）（女）",
              "label": "体重（高校２年）（女）",
              "cat01": "I412302",
              "unit": "ｋｇ",
              "sourceId": "i09"
            },
            {
              "statId": "0000010109/I421101/秒/i10/５０ｍ走（小学５年）（男）",
              "label": "５０ｍ走（小学５年）（男）",
              "cat01": "I421101",
              "unit": "秒",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I421102/秒/i10/５０ｍ走（小学５年）（女）",
              "label": "５０ｍ走（小学５年）（女）",
              "cat01": "I421102",
              "unit": "秒",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I421201/秒/i10/５０ｍ走（中学２年）（男）",
              "label": "５０ｍ走（中学２年）（男）",
              "cat01": "I421201",
              "unit": "秒",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I421202/秒/i10/５０ｍ走（中学２年）（女）",
              "label": "５０ｍ走（中学２年）（女）",
              "cat01": "I421202",
              "unit": "秒",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I423101/ｍ/i10/ソフトボール投げ（小学５年）（男）",
              "label": "ソフトボール投げ（小学５年）（男）",
              "cat01": "I423101",
              "unit": "ｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I423102/ｍ/i10/ソフトボール投げ（小学５年）（女）",
              "label": "ソフトボール投げ（小学５年）（女）",
              "cat01": "I423102",
              "unit": "ｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I423201/ｍ/i10/ハンドボール投げ（中学２年）（男）",
              "label": "ハンドボール投げ（中学２年）（男）",
              "cat01": "I423201",
              "unit": "ｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I423202/ｍ/i10/ハンドボール投げ（中学２年）（女）",
              "label": "ハンドボール投げ（中学２年）（女）",
              "cat01": "I423202",
              "unit": "ｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I431101/ｃｍ/i10/立ち幅跳び（小学５年）（男）",
              "label": "立ち幅跳び（小学５年）（男）",
              "cat01": "I431101",
              "unit": "ｃｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I431102/ｃｍ/i10/立ち幅跳び（小学５年）（女）",
              "label": "立ち幅跳び（小学５年）（女）",
              "cat01": "I431102",
              "unit": "ｃｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I431201/ｃｍ/i10/立ち幅跳び（中学２年）（男）",
              "label": "立ち幅跳び（中学２年）（男）",
              "cat01": "I431201",
              "unit": "ｃｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I431202/ｃｍ/i10/立ち幅跳び（中学２年）（女）",
              "label": "立ち幅跳び（中学２年）（女）",
              "cat01": "I431202",
              "unit": "ｃｍ",
              "sourceId": "i10"
            },
            {
              "statId": "0000010109/I5101/施設/i11/病院数",
              "label": "病院数",
              "cat01": "I5101",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510101/施設/i11/病院数（公立医療機関）",
              "label": "病院数（公立医療機関）",
              "cat01": "I510101",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510102/施設/i11/病院数（公的医療機関）",
              "label": "病院数（公的医療機関）",
              "cat01": "I510102",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510110/施設/i11/精神科病院数",
              "label": "精神科病院数",
              "cat01": "I510110",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510111/施設/i11/精神科病院数（公立医療機関）",
              "label": "精神科病院数（公立医療機関）",
              "cat01": "I510111",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510120/施設/i11/一般病院数",
              "label": "一般病院数",
              "cat01": "I510120",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510121/施設/i11/一般病院数（公立医療機関）",
              "label": "一般病院数（公立医療機関）",
              "cat01": "I510121",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510122/施設/i11/一般病院数（公的医療機関）",
              "label": "一般病院数（公的医療機関）",
              "cat01": "I510122",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510150/施設/i11/療養病床を有する病院数",
              "label": "療養病床を有する病院数",
              "cat01": "I510150",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5102/施設/i11/一般診療所数",
              "label": "一般診療所数",
              "cat01": "I5102",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I510201/施設/i11/有床一般診療所数",
              "label": "有床一般診療所数",
              "cat01": "I510201",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5103/施設/i11/歯科診療所数",
              "label": "歯科診療所数",
              "cat01": "I5103",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520101/施設/i11/病床規模別病院数（２０～４９病床）",
              "label": "病床規模別病院数（２０～４９病床）",
              "cat01": "I520101",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520102/施設/i11/病床規模別病院数（５０～９９病床）",
              "label": "病床規模別病院数（５０～９９病床）",
              "cat01": "I520102",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520103/施設/i11/病床規模別病院数（１００～１９９病床）",
              "label": "病床規模別病院数（１００～１９９病床）",
              "cat01": "I520103",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520104/施設/i11/病床規模別病院数（２００～２９９病床）",
              "label": "病床規模別病院数（２００～２９９病床）",
              "cat01": "I520104",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520105/施設/i11/病床規模別病院数（３００病床以上）",
              "label": "病床規模別病院数（３００病床以上）",
              "cat01": "I520105",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520113/施設/i11/病床規模別一般病院数（１００～１９９病床）",
              "label": "病床規模別一般病院数（１００～１９９病床）",
              "cat01": "I520113",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520114/施設/i11/病床規模別一般病院数（２００～２９９病床）",
              "label": "病床規模別一般病院数（２００～２９９病床）",
              "cat01": "I520114",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I520115/施設/i11/病床規模別一般病院数（３００病床以上）",
              "label": "病床規模別一般病院数（３００病床以上）",
              "cat01": "I520115",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5211/床/i11/病院病床数",
              "label": "病院病床数",
              "cat01": "I5211",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521101/床/i11/病院病床数（公立医療機関）",
              "label": "病院病床数（公立医療機関）",
              "cat01": "I521101",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521102/床/i11/病院病床数（公的医療機関）",
              "label": "病院病床数（公的医療機関）",
              "cat01": "I521102",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521110/床/i11/一般病院病床数",
              "label": "一般病院病床数",
              "cat01": "I521110",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521111/床/i11/一般病院病床数（公立医療機関）",
              "label": "一般病院病床数（公立医療機関）",
              "cat01": "I521111",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521112/床/i11/一般病院病床数（公的医療機関）",
              "label": "一般病院病床数（公的医療機関）",
              "cat01": "I521112",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521120/床/i11/精神科病院病床数",
              "label": "精神科病院病床数",
              "cat01": "I521120",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521121/床/i11/精神科病院病床数（公立医療機関）",
              "label": "精神科病院病床数（公立医療機関）",
              "cat01": "I521121",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521130/床/i11/精神病床数",
              "label": "精神病床数",
              "cat01": "I521130",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521140/床/i11/感染症病床数",
              "label": "感染症病床数",
              "cat01": "I521140",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521150/床/i11/一般病床数",
              "label": "一般病床数",
              "cat01": "I521150",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5212/床/i11/一般診療所病床数",
              "label": "一般診療所病床数",
              "cat01": "I5212",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521201/床/i11/一般診療所病床数（公立医療機関）",
              "label": "一般診療所病床数（公立医療機関）",
              "cat01": "I521201",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I521202/床/i11/一般診療所病床数（公的医療機関）",
              "label": "一般診療所病床数（公的医療機関）",
              "cat01": "I521202",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5213/床/i11/歯科診療所病床数",
              "label": "歯科診療所病床数",
              "cat01": "I5213",
              "unit": "床",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530101/施設/i11/診療科目別一般病院数（内科）",
              "label": "診療科目別一般病院数（内科）",
              "cat01": "I530101",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530102/施設/i11/診療科目別一般病院数（呼吸器科）",
              "label": "診療科目別一般病院数（呼吸器科）",
              "cat01": "I530102",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530103/施設/i11/診療科目別一般病院数（消化器科）",
              "label": "診療科目別一般病院数（消化器科）",
              "cat01": "I530103",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530104/施設/i11/診療科目別一般病院数（循環器科）",
              "label": "診療科目別一般病院数（循環器科）",
              "cat01": "I530104",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530105/施設/i11/診療科目別一般病院数（小児科）",
              "label": "診療科目別一般病院数（小児科）",
              "cat01": "I530105",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530106/施設/i11/診療科目別一般病院数（精神科）",
              "label": "診療科目別一般病院数（精神科）",
              "cat01": "I530106",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530107/施設/i11/診療科目別一般病院数（神経科）",
              "label": "診療科目別一般病院数（神経科）",
              "cat01": "I530107",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530108/施設/i11/診療科目別一般病院数（神経内科）",
              "label": "診療科目別一般病院数（神経内科）",
              "cat01": "I530108",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530109/施設/i11/診療科目別一般病院数（心療内科）",
              "label": "診療科目別一般病院数（心療内科）",
              "cat01": "I530109",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530110/施設/i11/診療科目別一般病院数（アレルギー科）",
              "label": "診療科目別一般病院数（アレルギー科）",
              "cat01": "I530110",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530111/施設/i11/診療科目別一般病院数（リウマチ科）",
              "label": "診療科目別一般病院数（リウマチ科）",
              "cat01": "I530111",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530112/施設/i11/診療科目別一般病院数（外科）",
              "label": "診療科目別一般病院数（外科）",
              "cat01": "I530112",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530113/施設/i11/診療科目別一般病院数（整形外科）",
              "label": "診療科目別一般病院数（整形外科）",
              "cat01": "I530113",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530114/施設/i11/診療科目別一般病院数（形成外科）",
              "label": "診療科目別一般病院数（形成外科）",
              "cat01": "I530114",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530115/施設/i11/診療科目別一般病院数（美容外科）",
              "label": "診療科目別一般病院数（美容外科）",
              "cat01": "I530115",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530116/施設/i11/診療科目別一般病院数（脳神経外科）",
              "label": "診療科目別一般病院数（脳神経外科）",
              "cat01": "I530116",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530117/施設/i11/診療科目別一般病院数（呼吸器外科）",
              "label": "診療科目別一般病院数（呼吸器外科）",
              "cat01": "I530117",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530118/施設/i11/診療科目別一般病院数（心臓血管外科）",
              "label": "診療科目別一般病院数（心臓血管外科）",
              "cat01": "I530118",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530119/施設/i11/診療科目別一般病院数（小児外科）",
              "label": "診療科目別一般病院数（小児外科）",
              "cat01": "I530119",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530120/施設/i11/診療科目別一般病院数（産婦人科）",
              "label": "診療科目別一般病院数（産婦人科）",
              "cat01": "I530120",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530121/施設/i11/診療科目別一般病院数（産科）",
              "label": "診療科目別一般病院数（産科）",
              "cat01": "I530121",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530122/施設/i11/診療科目別一般病院数（婦人科）",
              "label": "診療科目別一般病院数（婦人科）",
              "cat01": "I530122",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530123/施設/i11/診療科目別一般病院数（眼科）",
              "label": "診療科目別一般病院数（眼科）",
              "cat01": "I530123",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530124/施設/i11/診療科目別一般病院数（耳鼻いんこう科）",
              "label": "診療科目別一般病院数（耳鼻いんこう科）",
              "cat01": "I530124",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530125/施設/i11/診療科目別一般病院数（気管食道科）",
              "label": "診療科目別一般病院数（気管食道科）",
              "cat01": "I530125",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530126/施設/i11/診療科目別一般病院数（皮膚科）",
              "label": "診療科目別一般病院数（皮膚科）",
              "cat01": "I530126",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530127/施設/i11/診療科目別一般病院数（泌尿器科）",
              "label": "診療科目別一般病院数（泌尿器科）",
              "cat01": "I530127",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530128/施設/i11/診療科目別一般病院数（性病科）",
              "label": "診療科目別一般病院数（性病科）",
              "cat01": "I530128",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530129/施設/i11/診療科目別一般病院数（こう門科）",
              "label": "診療科目別一般病院数（こう門科）",
              "cat01": "I530129",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530130/施設/i11/診療科目別一般病院数（リハビリテーション科）",
              "label": "診療科目別一般病院数（リハビリテーション科）",
              "cat01": "I530130",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530131/施設/i11/診療科目別一般病院数（放射線科）",
              "label": "診療科目別一般病院数（放射線科）",
              "cat01": "I530131",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530132/施設/i11/診療科目別一般病院数（麻酔科）",
              "label": "診療科目別一般病院数（麻酔科）",
              "cat01": "I530132",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530133/施設/i11/診療科目別一般病院数（歯科）",
              "label": "診療科目別一般病院数（歯科）",
              "cat01": "I530133",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530134/施設/i11/診療科目別一般病院数（矯正歯科）",
              "label": "診療科目別一般病院数（矯正歯科）",
              "cat01": "I530134",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530135/施設/i11/診療科目別一般病院数（小児歯科）",
              "label": "診療科目別一般病院数（小児歯科）",
              "cat01": "I530135",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530136/施設/i11/診療科目別一般病院数（歯科口腔外科）",
              "label": "診療科目別一般病院数（歯科口腔外科）",
              "cat01": "I530136",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530137/施設/i11/診療科目別一般病院数（呼吸器内科）",
              "label": "診療科目別一般病院数（呼吸器内科）",
              "cat01": "I530137",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530138/施設/i11/診療科目別一般病院数（循環器内科）",
              "label": "診療科目別一般病院数（循環器内科）",
              "cat01": "I530138",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530139/施設/i11/診療科目別一般病院数（気管食道外科）",
              "label": "診療科目別一般病院数（気管食道外科）",
              "cat01": "I530139",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530140/施設/i11/診療科目別一般病院数（消化器内科（胃腸内科））",
              "label": "診療科目別一般病院数（消化器内科（胃腸内科））",
              "cat01": "I530140",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530141/施設/i11/診療科目別一般病院数（消化器外科（胃腸外科））",
              "label": "診療科目別一般病院数（消化器外科（胃腸外科））",
              "cat01": "I530141",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530142/施設/i11/診療科目別一般病院数（腎臓内科）",
              "label": "診療科目別一般病院数（腎臓内科）",
              "cat01": "I530142",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530143/施設/i11/診療科目別一般病院数（糖尿病内科（代謝内科））",
              "label": "診療科目別一般病院数（糖尿病内科（代謝内科））",
              "cat01": "I530143",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530144/施設/i11/診療科目別一般病院数（血液内科）",
              "label": "診療科目別一般病院数（血液内科）",
              "cat01": "I530144",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530145/施設/i11/診療科目別一般病院数（感染症内科）",
              "label": "診療科目別一般病院数（感染症内科）",
              "cat01": "I530145",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530146/施設/i11/診療科目別一般病院数（乳腺外科）",
              "label": "診療科目別一般病院数（乳腺外科）",
              "cat01": "I530146",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530147/施設/i11/診療科目別一般病院数（肛門外科）",
              "label": "診療科目別一般病院数（肛門外科）",
              "cat01": "I530147",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530148/施設/i11/診療科目別一般病院数（病理診断科）",
              "label": "診療科目別一般病院数（病理診断科）",
              "cat01": "I530148",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530149/施設/i11/診療科目別一般病院数（臨床検査科）",
              "label": "診療科目別一般病院数（臨床検査科）",
              "cat01": "I530149",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530150/施設/i11/診療科目別一般病院数（救急科）",
              "label": "診療科目別一般病院数（救急科）",
              "cat01": "I530150",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530201/施設/i11/診療科目別一般診療所数（内科）",
              "label": "診療科目別一般診療所数（内科）",
              "cat01": "I530201",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530202/施設/i11/診療科目別一般診療所数（呼吸器科）",
              "label": "診療科目別一般診療所数（呼吸器科）",
              "cat01": "I530202",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530203/施設/i11/診療科目別一般診療所数（消化器科）",
              "label": "診療科目別一般診療所数（消化器科）",
              "cat01": "I530203",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530204/施設/i11/診療科目別一般診療所数（循環器科）",
              "label": "診療科目別一般診療所数（循環器科）",
              "cat01": "I530204",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530205/施設/i11/診療科目別一般診療所数（小児科）",
              "label": "診療科目別一般診療所数（小児科）",
              "cat01": "I530205",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530206/施設/i11/診療科目別一般診療所数（精神科）",
              "label": "診療科目別一般診療所数（精神科）",
              "cat01": "I530206",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530207/施設/i11/診療科目別一般診療所数（神経科）",
              "label": "診療科目別一般診療所数（神経科）",
              "cat01": "I530207",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530208/施設/i11/診療科目別一般診療所数（神経内科）",
              "label": "診療科目別一般診療所数（神経内科）",
              "cat01": "I530208",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530209/施設/i11/診療科目別一般診療所数（心療内科）",
              "label": "診療科目別一般診療所数（心療内科）",
              "cat01": "I530209",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530210/施設/i11/診療科目別一般診療所数（アレルギー科）",
              "label": "診療科目別一般診療所数（アレルギー科）",
              "cat01": "I530210",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530211/施設/i11/診療科目別一般診療所数（リウマチ科）",
              "label": "診療科目別一般診療所数（リウマチ科）",
              "cat01": "I530211",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530212/施設/i11/診療科目別一般診療所数（外科）",
              "label": "診療科目別一般診療所数（外科）",
              "cat01": "I530212",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530213/施設/i11/診療科目別一般診療所数（整形外科）",
              "label": "診療科目別一般診療所数（整形外科）",
              "cat01": "I530213",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530214/施設/i11/診療科目別一般診療所数（形成外科）",
              "label": "診療科目別一般診療所数（形成外科）",
              "cat01": "I530214",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530215/施設/i11/診療科目別一般診療所数（脳神経外科）",
              "label": "診療科目別一般診療所数（脳神経外科）",
              "cat01": "I530215",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530216/施設/i11/診療科目別一般診療所数（産婦人科）",
              "label": "診療科目別一般診療所数（産婦人科）",
              "cat01": "I530216",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530217/施設/i11/診療科目別一般診療所数（産科）",
              "label": "診療科目別一般診療所数（産科）",
              "cat01": "I530217",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530218/施設/i11/診療科目別一般診療所数（婦人科）",
              "label": "診療科目別一般診療所数（婦人科）",
              "cat01": "I530218",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530219/施設/i11/診療科目別一般診療所数（眼科）",
              "label": "診療科目別一般診療所数（眼科）",
              "cat01": "I530219",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530220/施設/i11/診療科目別一般診療所数（耳鼻いんこう科）",
              "label": "診療科目別一般診療所数（耳鼻いんこう科）",
              "cat01": "I530220",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530221/施設/i11/診療科目別一般診療所数（気管食道科）",
              "label": "診療科目別一般診療所数（気管食道科）",
              "cat01": "I530221",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530222/施設/i11/診療科目別一般診療所数（皮膚科）",
              "label": "診療科目別一般診療所数（皮膚科）",
              "cat01": "I530222",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530223/施設/i11/診療科目別一般診療所数（泌尿器科）",
              "label": "診療科目別一般診療所数（泌尿器科）",
              "cat01": "I530223",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530224/施設/i11/診療科目別一般診療所数（性病科）",
              "label": "診療科目別一般診療所数（性病科）",
              "cat01": "I530224",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530225/施設/i11/診療科目別一般診療所数（こう門科）",
              "label": "診療科目別一般診療所数（こう門科）",
              "cat01": "I530225",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530226/施設/i11/診療科目別一般診療所数（リハビリテーション科）",
              "label": "診療科目別一般診療所数（リハビリテーション科）",
              "cat01": "I530226",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530227/施設/i11/診療科目別一般診療所数（放射線科）",
              "label": "診療科目別一般診療所数（放射線科）",
              "cat01": "I530227",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530228/施設/i11/診療科目別一般診療所数（麻酔科）",
              "label": "診療科目別一般診療所数（麻酔科）",
              "cat01": "I530228",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530229/施設/i11/診療科目別歯科診療所数（歯科）",
              "label": "診療科目別歯科診療所数（歯科）",
              "cat01": "I530229",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530230/施設/i11/診療科目別歯科診療所数（矯正歯科）",
              "label": "診療科目別歯科診療所数（矯正歯科）",
              "cat01": "I530230",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530231/施設/i11/診療科目別歯科診療所数（小児歯科）",
              "label": "診療科目別歯科診療所数（小児歯科）",
              "cat01": "I530231",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530232/施設/i11/診療科目別歯科診療所数（歯科口腔外科）",
              "label": "診療科目別歯科診療所数（歯科口腔外科）",
              "cat01": "I530232",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530233/施設/i11/診療科目別一般診療所数（呼吸器内科）",
              "label": "診療科目別一般診療所数（呼吸器内科）",
              "cat01": "I530233",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530234/施設/i11/診療科目別一般診療所数（循環器内科）",
              "label": "診療科目別一般診療所数（循環器内科）",
              "cat01": "I530234",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530235/施設/i11/診療科目別一般診療所数（気管食道外科）",
              "label": "診療科目別一般診療所数（気管食道外科）",
              "cat01": "I530235",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530236/施設/i11/診療科目別一般診療所数（消化器内科（胃腸内科））",
              "label": "診療科目別一般診療所数（消化器内科（胃腸内科））",
              "cat01": "I530236",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530237/施設/i11/診療科目別一般診療所数（消化器外科（胃腸外科））",
              "label": "診療科目別一般診療所数（消化器外科（胃腸外科））",
              "cat01": "I530237",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530238/施設/i11/診療科目別一般診療所数（腎臓内科）",
              "label": "診療科目別一般診療所数（腎臓内科）",
              "cat01": "I530238",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530239/施設/i11/診療科目別一般診療所数（糖尿病内科（代謝内科））",
              "label": "診療科目別一般診療所数（糖尿病内科（代謝内科））",
              "cat01": "I530239",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530240/施設/i11/診療科目別一般診療所数（血液内科）",
              "label": "診療科目別一般診療所数（血液内科）",
              "cat01": "I530240",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530241/施設/i11/診療科目別一般診療所数（感染症内科）",
              "label": "診療科目別一般診療所数（感染症内科）",
              "cat01": "I530241",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530242/施設/i11/診療科目別一般診療所数（呼吸器外科）",
              "label": "診療科目別一般診療所数（呼吸器外科）",
              "cat01": "I530242",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530243/施設/i11/診療科目別一般診療所数（心臓血管外科）",
              "label": "診療科目別一般診療所数（心臓血管外科）",
              "cat01": "I530243",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530244/施設/i11/診療科目別一般診療所数（乳腺外科）",
              "label": "診療科目別一般診療所数（乳腺外科）",
              "cat01": "I530244",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530245/施設/i11/診療科目別一般診療所数（肛門外科）",
              "label": "診療科目別一般診療所数（肛門外科）",
              "cat01": "I530245",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530246/施設/i11/診療科目別一般診療所数（美容外科）",
              "label": "診療科目別一般診療所数（美容外科）",
              "cat01": "I530246",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530247/施設/i11/診療科目別一般診療所数（小児外科）",
              "label": "診療科目別一般診療所数（小児外科）",
              "cat01": "I530247",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530248/施設/i11/診療科目別一般診療所数（病理診断科）",
              "label": "診療科目別一般診療所数（病理診断科）",
              "cat01": "I530248",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530249/施設/i11/診療科目別一般診療所数（臨床検査科）",
              "label": "診療科目別一般診療所数（臨床検査科）",
              "cat01": "I530249",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I530250/施設/i11/診療科目別一般診療所数（救急科）",
              "label": "診療科目別一般診療所数（救急科）",
              "cat01": "I530250",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5401/施設/i11/救急医療体制病院数",
              "label": "救急医療体制病院数",
              "cat01": "I5401",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I540201/施設/i11/救急告示病院数",
              "label": "救急告示病院数",
              "cat01": "I540201",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I540202/施設/i11/救急告示一般診療所数",
              "label": "救急告示一般診療所数",
              "cat01": "I540202",
              "unit": "施設",
              "sourceId": "i11"
            },
            {
              "statId": "0000010109/I5501/所/i12/介護老人保健施設数",
              "label": "介護老人保健施設数",
              "cat01": "I5501",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5502/人/i12/介護老人保健施設定員数",
              "label": "介護老人保健施設定員数",
              "cat01": "I5502",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5503/人/i12/介護老人保健施設在所者数",
              "label": "介護老人保健施設在所者数",
              "cat01": "I5503",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5506/所/i12/介護療養型医療施設数",
              "label": "介護療養型医療施設数",
              "cat01": "I5506",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5507/人/i12/介護療養型医療施設在院者数",
              "label": "介護療養型医療施設在院者数",
              "cat01": "I5507",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5508/人/i12/介護療養型医療施設従事者数（常勤）",
              "label": "介護療養型医療施設従事者数（常勤）",
              "cat01": "I5508",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5509/人/i12/介護老人保健施設従事者数（常勤）",
              "label": "介護老人保健施設従事者数（常勤）",
              "cat01": "I5509",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5510/人/i12/介護療養型医療施設定員数",
              "label": "介護療養型医療施設定員数",
              "cat01": "I5510",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5601/所/i12/訪問看護ステーション数",
              "label": "訪問看護ステーション数",
              "cat01": "I5601",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I5602/人/i12/訪問看護ステーション利用者数",
              "label": "訪問看護ステーション利用者数",
              "cat01": "I5602",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560501/所/i12/通所リハビリテーション事業所数（介護老人保健施設）",
              "label": "通所リハビリテーション事業所数（介護老人保健施設）",
              "cat01": "I560501",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560502/人/i12/通所リハビリテーション利用者数（介護老人保健施設）",
              "label": "通所リハビリテーション利用者数（介護老人保健施設）",
              "cat01": "I560502",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560601/所/i12/通所リハビリテーション事業所数（医療施設）",
              "label": "通所リハビリテーション事業所数（医療施設）",
              "cat01": "I560601",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560602/人/i12/通所リハビリテーション利用者数（医療施設）",
              "label": "通所リハビリテーション利用者数（医療施設）",
              "cat01": "I560602",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560701/所/i12/短期入所療養介護事業所数（介護老人保健施設）",
              "label": "短期入所療養介護事業所数（介護老人保健施設）",
              "cat01": "I560701",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560702/人/i12/短期入所療養介護利用者数（介護老人保健施設）",
              "label": "短期入所療養介護利用者数（介護老人保健施設）",
              "cat01": "I560702",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560801/所/i12/短期入所療養介護事業所数（医療施設）",
              "label": "短期入所療養介護事業所数（医療施設）",
              "cat01": "I560801",
              "unit": "所",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I560802/人/i12/短期入所療養介護利用者数（医療施設）",
              "label": "短期入所療養介護利用者数（医療施設）",
              "cat01": "I560802",
              "unit": "人",
              "sourceId": "i12"
            },
            {
              "statId": "0000010109/I6100/人/i13/医師数",
              "label": "医師数",
              "cat01": "I6100",
              "unit": "人",
              "sourceId": "i13"
            },
            {
              "statId": "0000010109/I6101/人/i13/医療施設医師数",
              "label": "医療施設医師数",
              "cat01": "I6101",
              "unit": "人",
              "sourceId": "i13"
            },
            {
              "statId": "0000010109/I610101/人/i13/医療施設産婦人科医師数",
              "label": "医療施設産婦人科医師数",
              "cat01": "I610101",
              "unit": "人",
              "sourceId": "i13"
            },
            {
              "statId": "0000010109/I610102/人/i13/医療施設産科医師数",
              "label": "医療施設産科医師数",
              "cat01": "I610102",
              "unit": "人",
              "sourceId": "i13"
            },
            {
              "statId": "0000010109/I610110/人/i14/病院医師数（常勤）",
              "label": "病院医師数（常勤）",
              "cat01": "I610110",
              "unit": "人",
              "sourceId": "i14"
            },
            {
              "statId": "0000010109/I610111/人/i14/精神科病院医師数（常勤）",
              "label": "精神科病院医師数（常勤）",
              "cat01": "I610111",
              "unit": "人",
              "sourceId": "i14"
            },
            {
              "statId": "0000010109/I610112/人/i14/一般病院医師数（常勤）",
              "label": "一般病院医師数（常勤）",
              "cat01": "I610112",
              "unit": "人",
              "sourceId": "i14"
            },
            {
              "statId": "0000010109/I610120/人/i14/一般診療所医師数（常勤）",
              "label": "一般診療所医師数（常勤）",
              "cat01": "I610120",
              "unit": "人",
              "sourceId": "i14"
            },
            {
              "statId": "0000010109/I6102/人/i15/介護老人保健施設医師数",
              "label": "介護老人保健施設医師数",
              "cat01": "I6102",
              "unit": "人",
              "sourceId": "i15"
            },
            {
              "statId": "0000010109/I6200/人/i16/歯科医師数",
              "label": "歯科医師数",
              "cat01": "I6200",
              "unit": "人",
              "sourceId": "i16"
            },
            {
              "statId": "0000010109/I6201/人/i16/医療施設歯科医師数",
              "label": "医療施設歯科医師数",
              "cat01": "I6201",
              "unit": "人",
              "sourceId": "i16"
            },
            {
              "statId": "0000010109/I620110/人/i17/病院歯科医師数（常勤）",
              "label": "病院歯科医師数（常勤）",
              "cat01": "I620110",
              "unit": "人",
              "sourceId": "i17"
            },
            {
              "statId": "0000010109/I620111/人/i17/一般病院歯科医師数（常勤）",
              "label": "一般病院歯科医師数（常勤）",
              "cat01": "I620111",
              "unit": "人",
              "sourceId": "i17"
            },
            {
              "statId": "0000010109/I620120/人//歯科診療所歯科医師数（常勤）",
              "label": "歯科診療所歯科医師数（常勤）",
              "cat01": "I620120",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010109/I6300/人/i18/薬剤師数",
              "label": "薬剤師数",
              "cat01": "I6300",
              "unit": "人",
              "sourceId": "i18"
            },
            {
              "statId": "0000010109/I6310/人/i18/薬局・医療施設薬剤師数",
              "label": "薬局・医療施設薬剤師数",
              "cat01": "I6310",
              "unit": "人",
              "sourceId": "i18"
            },
            {
              "statId": "0000010109/I6311/人/i18/薬局薬剤師数",
              "label": "薬局薬剤師数",
              "cat01": "I6311",
              "unit": "人",
              "sourceId": "i18"
            },
            {
              "statId": "0000010109/I6312/人/i18/医療施設薬剤師数",
              "label": "医療施設薬剤師数",
              "cat01": "I6312",
              "unit": "人",
              "sourceId": "i18"
            },
            {
              "statId": "0000010109/I631210/人/i19/病院薬剤師数",
              "label": "病院薬剤師数",
              "cat01": "I631210",
              "unit": "人",
              "sourceId": "i19"
            },
            {
              "statId": "0000010109/I631211/人/i19/一般病院薬剤師数",
              "label": "一般病院薬剤師数",
              "cat01": "I631211",
              "unit": "人",
              "sourceId": "i19"
            },
            {
              "statId": "0000010109/I6320/人/i20/主な従事先が大学である薬剤師数",
              "label": "主な従事先が大学である薬剤師数",
              "cat01": "I6320",
              "unit": "人",
              "sourceId": "i20"
            },
            {
              "statId": "0000010109/I6330/人/i20/主な従事先が医薬品関係企業である薬剤師数",
              "label": "主な従事先が医薬品関係企業である薬剤師数",
              "cat01": "I6330",
              "unit": "人",
              "sourceId": "i20"
            },
            {
              "statId": "0000010109/I6400/人/i21/看護師数",
              "label": "看護師数",
              "cat01": "I6400",
              "unit": "人",
              "sourceId": "i21"
            },
            {
              "statId": "0000010109/I6401/人/i21/医療施設看護師数",
              "label": "医療施設看護師数",
              "cat01": "I6401",
              "unit": "人",
              "sourceId": "i21"
            },
            {
              "statId": "0000010109/I640110/人/i22/病院看護師数",
              "label": "病院看護師数",
              "cat01": "I640110",
              "unit": "人",
              "sourceId": "i22"
            },
            {
              "statId": "0000010109/I640111/人/i22/一般病院看護師数",
              "label": "一般病院看護師数",
              "cat01": "I640111",
              "unit": "人",
              "sourceId": "i22"
            },
            {
              "statId": "0000010109/I640112/人/i22/精神科病院看護師数",
              "label": "精神科病院看護師数",
              "cat01": "I640112",
              "unit": "人",
              "sourceId": "i22"
            },
            {
              "statId": "0000010109/I640120/人/i22/一般診療所看護師数",
              "label": "一般診療所看護師数",
              "cat01": "I640120",
              "unit": "人",
              "sourceId": "i22"
            },
            {
              "statId": "0000010109/I640130/人//歯科診療所看護師数",
              "label": "歯科診療所看護師数",
              "cat01": "I640130",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010109/I6402/人/i23/介護老人保健施設看護師数",
              "label": "介護老人保健施設看護師数",
              "cat01": "I6402",
              "unit": "人",
              "sourceId": "i23"
            },
            {
              "statId": "0000010109/I6500/人/i24/准看護師数",
              "label": "准看護師数",
              "cat01": "I6500",
              "unit": "人",
              "sourceId": "i24"
            },
            {
              "statId": "0000010109/I6501/人/i24/医療施設准看護師数",
              "label": "医療施設准看護師数",
              "cat01": "I6501",
              "unit": "人",
              "sourceId": "i24"
            },
            {
              "statId": "0000010109/I650110/人/i25/病院准看護師数",
              "label": "病院准看護師数",
              "cat01": "I650110",
              "unit": "人",
              "sourceId": "i25"
            },
            {
              "statId": "0000010109/I650111/人/i25/一般病院准看護師数",
              "label": "一般病院准看護師数",
              "cat01": "I650111",
              "unit": "人",
              "sourceId": "i25"
            },
            {
              "statId": "0000010109/I650112/人/i25/精神科病院准看護師数",
              "label": "精神科病院准看護師数",
              "cat01": "I650112",
              "unit": "人",
              "sourceId": "i25"
            },
            {
              "statId": "0000010109/I650120/人/i25/一般診療所准看護師数",
              "label": "一般診療所准看護師数",
              "cat01": "I650120",
              "unit": "人",
              "sourceId": "i25"
            },
            {
              "statId": "0000010109/I650130/人/i25/歯科診療所准看護師数",
              "label": "歯科診療所准看護師数",
              "cat01": "I650130",
              "unit": "人",
              "sourceId": "i25"
            },
            {
              "statId": "0000010109/I6502/人/i26/介護老人保健施設准看護師数",
              "label": "介護老人保健施設准看護師数",
              "cat01": "I6502",
              "unit": "人",
              "sourceId": "i26"
            },
            {
              "statId": "0000010109/I6700/人/i27/助産師数",
              "label": "助産師数",
              "cat01": "I6700",
              "unit": "人",
              "sourceId": "i27"
            },
            {
              "statId": "0000010109/I6801/人/i28/保健師数",
              "label": "保健師数",
              "cat01": "I6801",
              "unit": "人",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I6901/人/i28/あんま・マッサージ師数",
              "label": "あんま・マッサージ師数",
              "cat01": "I6901",
              "unit": "人",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I6902/人/i28/はり・きゅう師数",
              "label": "はり・きゅう師数",
              "cat01": "I6902",
              "unit": "人",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I6903/人/i28/柔道整復師数",
              "label": "柔道整復師数",
              "cat01": "I6903",
              "unit": "人",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I7101/所/i28/医薬品販売業数",
              "label": "医薬品販売業数",
              "cat01": "I7101",
              "unit": "所",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I7102/所/i28/薬局数",
              "label": "薬局数",
              "cat01": "I7102",
              "unit": "所",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I7103/町村/i28/無薬局町村数",
              "label": "無薬局町村数",
              "cat01": "I7103",
              "unit": "町村",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I7201/所/i28/医療機器の販売業数",
              "label": "医療機器の販売業数",
              "cat01": "I7201",
              "unit": "所",
              "sourceId": "i28"
            },
            {
              "statId": "0000010109/I8101/千人/i29/有訴者数",
              "label": "有訴者数",
              "cat01": "I8101",
              "unit": "千人",
              "sourceId": "i29"
            },
            {
              "statId": "0000010109/I8102/千人/i29/通院者数",
              "label": "通院者数",
              "cat01": "I8102",
              "unit": "千人",
              "sourceId": "i29"
            },
            {
              "statId": "0000010109/I8103/‐/i29/有訴者率",
              "label": "有訴者率",
              "cat01": "I8103",
              "unit": "‐",
              "sourceId": "i29"
            },
            {
              "statId": "0000010109/I8104/‐/i29/通院者率",
              "label": "通院者率",
              "cat01": "I8104",
              "unit": "‐",
              "sourceId": "i29"
            },
            {
              "statId": "0000010109/I820101/千人/i30/医療施設推計入院患者数（施設所在地）",
              "label": "医療施設推計入院患者数（施設所在地）",
              "cat01": "I820101",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201011/千人/i30/医療施設推計入院患者数（生活習慣病）（施設所在地）",
              "label": "医療施設推計入院患者数（生活習慣病）（施設所在地）",
              "cat01": "I8201011",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201012/千人/i30/医療施設推計入院患者数（悪性新生物）（施設所在地）",
              "label": "医療施設推計入院患者数（悪性新生物）（施設所在地）",
              "cat01": "I8201012",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201013/千人/i30/医療施設推計入院患者数（糖尿病）（施設所在地）",
              "label": "医療施設推計入院患者数（糖尿病）（施設所在地）",
              "cat01": "I8201013",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201014/千人/i30/医療施設推計入院患者数（高血圧性疾患）（施設所在地）",
              "label": "医療施設推計入院患者数（高血圧性疾患）（施設所在地）",
              "cat01": "I8201014",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201015/千人/i30/医療施設推計入院患者数（心疾患（高血圧疾患を除く））（施設所在地）",
              "label": "医療施設推計入院患者数（心疾患（高血圧疾患を除く））（施設所在地）",
              "cat01": "I8201015",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201016/千人/i30/医療施設推計入院患者数（脳血管疾患）（施設所在地）",
              "label": "医療施設推計入院患者数（脳血管疾患）（施設所在地）",
              "cat01": "I8201016",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I820102/千人/i30/医療施設推計外来患者数（施設所在地）",
              "label": "医療施設推計外来患者数（施設所在地）",
              "cat01": "I820102",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201021/千人/i30/医療施設推計外来患者数（生活習慣病）（施設所在地）",
              "label": "医療施設推計外来患者数（生活習慣病）（施設所在地）",
              "cat01": "I8201021",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201022/千人/i30/医療施設推計外来患者数（悪性新生物）（施設所在地）",
              "label": "医療施設推計外来患者数（悪性新生物）（施設所在地）",
              "cat01": "I8201022",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201023/千人/i30/医療施設推計外来患者数（糖尿病）（施設所在地）",
              "label": "医療施設推計外来患者数（糖尿病）（施設所在地）",
              "cat01": "I8201023",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201024/千人/i30/医療施設推計外来患者数（高血圧性疾患）（施設所在地）",
              "label": "医療施設推計外来患者数（高血圧性疾患）（施設所在地）",
              "cat01": "I8201024",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201025/千人/i30/医療施設推計外来患者数（心疾患（高血圧疾患を除く））（施設所在地）",
              "label": "医療施設推計外来患者数（心疾患（高血圧疾患を除く））（施設所在地）",
              "cat01": "I8201025",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8201026/千人/i30/医療施設推計外来患者数（脳血管疾患）（施設所在地）",
              "label": "医療施設推計外来患者数（脳血管疾患）（施設所在地）",
              "cat01": "I8201026",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I820201/千人/i30/医療施設推計入院患者数（患者住所地）",
              "label": "医療施設推計入院患者数（患者住所地）",
              "cat01": "I820201",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202011/千人/i30/医療施設推計入院患者数（生活習慣病）（患者住所地）",
              "label": "医療施設推計入院患者数（生活習慣病）（患者住所地）",
              "cat01": "I8202011",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202012/千人/i30/医療施設推計入院患者数（悪性新生物）（患者住所地）",
              "label": "医療施設推計入院患者数（悪性新生物）（患者住所地）",
              "cat01": "I8202012",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202013/千人/i30/医療施設推計入院患者数（糖尿病）（患者住所地）",
              "label": "医療施設推計入院患者数（糖尿病）（患者住所地）",
              "cat01": "I8202013",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202014/千人/i30/医療施設推計入院患者数（高血圧性疾患）（患者住所地）",
              "label": "医療施設推計入院患者数（高血圧性疾患）（患者住所地）",
              "cat01": "I8202014",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202015/千人/i30/医療施設推計入院患者数（心疾患（高血圧疾患を除く））（患者住所地）",
              "label": "医療施設推計入院患者数（心疾患（高血圧疾患を除く））（患者住所地）",
              "cat01": "I8202015",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202016/千人/i30/医療施設推計入院患者数（脳血管疾患）（患者住所地）",
              "label": "医療施設推計入院患者数（脳血管疾患）（患者住所地）",
              "cat01": "I8202016",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I820202/千人/i30/医療施設推計外来患者数（患者住所地）",
              "label": "医療施設推計外来患者数（患者住所地）",
              "cat01": "I820202",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202021/千人/i30/医療施設推計外来患者数（生活習慣病）（患者住所地）",
              "label": "医療施設推計外来患者数（生活習慣病）（患者住所地）",
              "cat01": "I8202021",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202022/千人/i30/医療施設推計外来患者数（悪性新生物）（患者住所地）",
              "label": "医療施設推計外来患者数（悪性新生物）（患者住所地）",
              "cat01": "I8202022",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202023/千人/i30/医療施設推計外来患者数（糖尿病）（患者住所地）",
              "label": "医療施設推計外来患者数（糖尿病）（患者住所地）",
              "cat01": "I8202023",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202024/千人/i30/医療施設推計外来患者数（高血圧性疾患）（患者住所地）",
              "label": "医療施設推計外来患者数（高血圧性疾患）（患者住所地）",
              "cat01": "I8202024",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202025/千人/i30/医療施設推計外来患者数（心疾患（高血圧疾患を除く））（患者住所地）",
              "label": "医療施設推計外来患者数（心疾患（高血圧疾患を除く））（患者住所地）",
              "cat01": "I8202025",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I8202026/千人/i30/医療施設推計外来患者数（脳血管疾患）（患者住所地）",
              "label": "医療施設推計外来患者数（脳血管疾患）（患者住所地）",
              "cat01": "I8202026",
              "unit": "千人",
              "sourceId": "i30"
            },
            {
              "statId": "0000010109/I821001/人/i31/外来患者延数",
              "label": "外来患者延数",
              "cat01": "I821001",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821002/人/i31/新入院患者数",
              "label": "新入院患者数",
              "cat01": "I821002",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821003/人/i31/退院患者数",
              "label": "退院患者数",
              "cat01": "I821003",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821004/人/i31/在院患者延数",
              "label": "在院患者延数",
              "cat01": "I821004",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821101/人/i31/外来患者延数（一般病院）",
              "label": "外来患者延数（一般病院）",
              "cat01": "I821101",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821102/人/i31/新入院患者数（一般病院）",
              "label": "新入院患者数（一般病院）",
              "cat01": "I821102",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821103/人/i31/退院患者数（一般病院）",
              "label": "退院患者数（一般病院）",
              "cat01": "I821103",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821104/人/i31/在院患者延数（一般病院）",
              "label": "在院患者延数（一般病院）",
              "cat01": "I821104",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821201/人/i31/外来患者延数（精神科病院）",
              "label": "外来患者延数（精神科病院）",
              "cat01": "I821201",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821202/人/i31/新入院患者数（精神科病院）",
              "label": "新入院患者数（精神科病院）",
              "cat01": "I821202",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821203/人/i31/退院患者数（精神科病院）",
              "label": "退院患者数（精神科病院）",
              "cat01": "I821203",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I821204/人/i31/在院患者延数（精神科病院）",
              "label": "在院患者延数（精神科病院）",
              "cat01": "I821204",
              "unit": "人",
              "sourceId": "i31"
            },
            {
              "statId": "0000010109/I8303/人/i32/食中毒患者数",
              "label": "食中毒患者数",
              "cat01": "I8303",
              "unit": "人",
              "sourceId": "i32"
            },
            {
              "statId": "0000010109/I8401/人/i33/２５００ｇ未満の出生数",
              "label": "２５００ｇ未満の出生数",
              "cat01": "I8401",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I840101/人/i33/２５００ｇ未満の出生数（男）",
              "label": "２５００ｇ未満の出生数（男）",
              "cat01": "I840101",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I840102/人/i33/２５００ｇ未満の出生数（女）",
              "label": "２５００ｇ未満の出生数（女）",
              "cat01": "I840102",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9101/人/i33/生活習慣病による死亡者数",
              "label": "生活習慣病による死亡者数",
              "cat01": "I9101",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910101/人/i33/生活習慣病による死亡者数（男）",
              "label": "生活習慣病による死亡者数（男）",
              "cat01": "I910101",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910102/人/i33/生活習慣病による死亡者数（女）",
              "label": "生活習慣病による死亡者数（女）",
              "cat01": "I910102",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9102/人/i33/悪性新生物（腫瘍）による死亡者数",
              "label": "悪性新生物（腫瘍）による死亡者数",
              "cat01": "I9102",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910201/人/i33/悪性新生物による死亡者数（男）",
              "label": "悪性新生物による死亡者数（男）",
              "cat01": "I910201",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910202/人/i33/悪性新生物による死亡者数（女）",
              "label": "悪性新生物による死亡者数（女）",
              "cat01": "I910202",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9103/人/i33/糖尿病による死亡者数",
              "label": "糖尿病による死亡者数",
              "cat01": "I9103",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9104/人/i33/高血圧性疾患による死亡者数",
              "label": "高血圧性疾患による死亡者数",
              "cat01": "I9104",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910401/人/i33/高血圧性疾患による死亡者数（男）",
              "label": "高血圧性疾患による死亡者数（男）",
              "cat01": "I910401",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910402/人/i33/高血圧性疾患による死亡者数（女）",
              "label": "高血圧性疾患による死亡者数（女）",
              "cat01": "I910402",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9105/人/i33/心疾患（高血圧性を除く）による死亡者数",
              "label": "心疾患（高血圧性を除く）による死亡者数",
              "cat01": "I9105",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910501/人/i33/心疾患（高血圧性を除く）による死亡者数（男）",
              "label": "心疾患（高血圧性を除く）による死亡者数（男）",
              "cat01": "I910501",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910502/人/i33/心疾患（高血圧性を除く）による死亡者数（女）",
              "label": "心疾患（高血圧性を除く）による死亡者数（女）",
              "cat01": "I910502",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9106/人/i33/脳血管疾患による死亡者数",
              "label": "脳血管疾患による死亡者数",
              "cat01": "I9106",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910601/人/i33/脳血管疾患による死亡者数（男）",
              "label": "脳血管疾患による死亡者数（男）",
              "cat01": "I910601",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910602/人/i33/脳血管疾患による死亡者数（女）",
              "label": "脳血管疾患による死亡者数（女）",
              "cat01": "I910602",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9108/人/i33/自殺者数",
              "label": "自殺者数",
              "cat01": "I9108",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910801/人/i33/自殺者数（男）",
              "label": "自殺者数（男）",
              "cat01": "I910801",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910802/人/i33/自殺者数（女）",
              "label": "自殺者数（女）",
              "cat01": "I910802",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I910803/‐/i33/自殺率（人口１０万対）",
              "label": "自殺率（人口１０万対）",
              "cat01": "I910803",
              "unit": "‐",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9109/人/i33/６５歳以上の自殺者数",
              "label": "６５歳以上の自殺者数",
              "cat01": "I9109",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9110/人/i33/不慮の事故による死亡者数",
              "label": "不慮の事故による死亡者数",
              "cat01": "I9110",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911001/人/i33/不慮の事故による死亡者数（男）",
              "label": "不慮の事故による死亡者数（男）",
              "cat01": "I911001",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911002/人/i33/不慮の事故による死亡者数（女）",
              "label": "不慮の事故による死亡者数（女）",
              "cat01": "I911002",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9111/人/i33/妊娠，分娩及び産じょくによる死亡数",
              "label": "妊娠，分娩及び産じょくによる死亡数",
              "cat01": "I9111",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9112/人/i33/感染症及び寄生虫症による死亡者数",
              "label": "感染症及び寄生虫症による死亡者数",
              "cat01": "I9112",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911201/人/i33/感染症及び寄生虫症による死亡者数（男）",
              "label": "感染症及び寄生虫症による死亡者数（男）",
              "cat01": "I911201",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911202/人/i33/感染症及び寄生虫症による死亡者数（女）",
              "label": "感染症及び寄生虫症による死亡者数（女）",
              "cat01": "I911202",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9113/人/i33/結核による死亡者数",
              "label": "結核による死亡者数",
              "cat01": "I9113",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911301/人/i33/結核による死亡者数（男）",
              "label": "結核による死亡者数（男）",
              "cat01": "I911301",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911302/人/i33/結核による死亡者数（女）",
              "label": "結核による死亡者数（女）",
              "cat01": "I911302",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9114/人/i33/呼吸器系の疾患による死亡者数",
              "label": "呼吸器系の疾患による死亡者数",
              "cat01": "I9114",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911401/人/i33/呼吸器系の疾患による死亡者数（男）",
              "label": "呼吸器系の疾患による死亡者数（男）",
              "cat01": "I911401",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911402/人/i33/呼吸器系の疾患による死亡者数（女）",
              "label": "呼吸器系の疾患による死亡者数（女）",
              "cat01": "I911402",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9115/人/i33/肺炎による死亡者数",
              "label": "肺炎による死亡者数",
              "cat01": "I9115",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911501/人/i33/肺炎による死亡者数（男）",
              "label": "肺炎による死亡者数（男）",
              "cat01": "I911501",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911502/人/i33/肺炎による死亡者数（女）",
              "label": "肺炎による死亡者数（女）",
              "cat01": "I911502",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I9117/人/i33/消化器系の疾患による死亡者数",
              "label": "消化器系の疾患による死亡者数",
              "cat01": "I9117",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911701/人/i33/消化器系の疾患による死亡者数（男）",
              "label": "消化器系の疾患による死亡者数（男）",
              "cat01": "I911701",
              "unit": "人",
              "sourceId": "i33"
            },
            {
              "statId": "0000010109/I911702/人/i33/消化器系の疾患による死亡者数（女）",
              "label": "消化器系の疾患による死亡者数（女）",
              "cat01": "I911702",
              "unit": "人",
              "sourceId": "i33"
            }
          ]
        },
        {
          "label": "Ｊ福祉・社会保障",
          "statId": "0000010110",
          "children": [
            {
              "statId": "0000010110/J1101/世帯/j01/生活保護被保護実世帯数",
              "label": "生活保護被保護実世帯数",
              "cat01": "J1101",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1102/世帯/j01/現に保護を受けた生活保護被保護実世帯数",
              "label": "現に保護を受けた生活保護被保護実世帯数",
              "cat01": "J1102",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110201/世帯/j01/現に保護を受けた生活保護被保護実世帯数（母子世帯）",
              "label": "現に保護を受けた生活保護被保護実世帯数（母子世帯）",
              "cat01": "J110201",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110202/世帯/j01/現に保護を受けた生活保護被保護実世帯数（傷病・障害者世帯）",
              "label": "現に保護を受けた生活保護被保護実世帯数（傷病・障害者世帯）",
              "cat01": "J110202",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110203/世帯/j01/現に保護を受けた生活保護被保護実世帯数（高齢者世帯）",
              "label": "現に保護を受けた生活保護被保護実世帯数（高齢者世帯）",
              "cat01": "J110203",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110204/世帯/j01/現に保護を受けた医療扶助単給世帯数",
              "label": "現に保護を受けた医療扶助単給世帯数",
              "cat01": "J110204",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1103/世帯/j01/保護開始世帯数",
              "label": "保護開始世帯数",
              "cat01": "J1103",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110301/世帯/j01/保護開始世帯数（母子世帯）",
              "label": "保護開始世帯数（母子世帯）",
              "cat01": "J110301",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110302/世帯/j01/保護開始世帯数（高齢者世帯）",
              "label": "保護開始世帯数（高齢者世帯）",
              "cat01": "J110302",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110303/世帯/j01/保護開始世帯数（その他の世帯）",
              "label": "保護開始世帯数（その他の世帯）",
              "cat01": "J110303",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1104/世帯/j01/生活保護扶助世帯数",
              "label": "生活保護扶助世帯数",
              "cat01": "J1104",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110401/世帯/j01/生活保護扶助世帯数（生活）",
              "label": "生活保護扶助世帯数（生活）",
              "cat01": "J110401",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110402/世帯/j01/生活保護扶助世帯数（住宅）",
              "label": "生活保護扶助世帯数（住宅）",
              "cat01": "J110402",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110403/世帯/j01/生活保護扶助世帯数（教育）",
              "label": "生活保護扶助世帯数（教育）",
              "cat01": "J110403",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110404/世帯/j01/生活保護扶助世帯数（医療）",
              "label": "生活保護扶助世帯数（医療）",
              "cat01": "J110404",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1104041/世帯/j01/生活保護扶助世帯数（介護）",
              "label": "生活保護扶助世帯数（介護）",
              "cat01": "J1104041",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110405/世帯/j01/生活保護扶助世帯数（出産）",
              "label": "生活保護扶助世帯数（出産）",
              "cat01": "J110405",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110406/世帯/j01/生活保護扶助世帯数（生業）",
              "label": "生活保護扶助世帯数（生業）",
              "cat01": "J110406",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110407/世帯/j01/生活保護扶助世帯数（葬祭）",
              "label": "生活保護扶助世帯数（葬祭）",
              "cat01": "J110407",
              "unit": "世帯",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1105/人/j01/生活保護被保護実人員",
              "label": "生活保護被保護実人員",
              "cat01": "J1105",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1106/人/j01/生活保護扶助人員",
              "label": "生活保護扶助人員",
              "cat01": "J1106",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110601/人/j01/生活保護扶助人員（生活）",
              "label": "生活保護扶助人員（生活）",
              "cat01": "J110601",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110602/人/j01/生活保護扶助人員（住宅）",
              "label": "生活保護扶助人員（住宅）",
              "cat01": "J110602",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110603/人/j01/生活保護扶助人員（教育）",
              "label": "生活保護扶助人員（教育）",
              "cat01": "J110603",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110604/人/j01/生活保護扶助人員（医療）",
              "label": "生活保護扶助人員（医療）",
              "cat01": "J110604",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1106041/人/j01/生活保護扶助人員（介護）",
              "label": "生活保護扶助人員（介護）",
              "cat01": "J1106041",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110605/人/j01/生活保護扶助人員（出産）",
              "label": "生活保護扶助人員（出産）",
              "cat01": "J110605",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110606/人/j01/生活保護扶助人員（生業）",
              "label": "生活保護扶助人員（生業）",
              "cat01": "J110606",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110607/人/j01/生活保護扶助人員（葬祭）",
              "label": "生活保護扶助人員（葬祭）",
              "cat01": "J110607",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110702/人/j01/生活保護被保護高齢者数（６５歳以上）",
              "label": "生活保護被保護高齢者数（６５歳以上）",
              "cat01": "J110702",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110703/人/j01/教育扶助受給人員，小－中学校",
              "label": "教育扶助受給人員，小－中学校",
              "cat01": "J110703",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J110704/人/j01/高等学校等就学費受給人員",
              "label": "高等学校等就学費受給人員",
              "cat01": "J110704",
              "unit": "人",
              "sourceId": "j01"
            },
            {
              "statId": "0000010110/J1200/人/j02/身体障害者手帳交付数",
              "label": "身体障害者手帳交付数",
              "cat01": "J1200",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120001/人/j02/身体障害者手帳交付数（１８歳以上）",
              "label": "身体障害者手帳交付数（１８歳以上）",
              "cat01": "J120001",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120002/人/j02/身体障害者手帳交付数（１８歳未満）",
              "label": "身体障害者手帳交付数（１８歳未満）",
              "cat01": "J120002",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1201/人/j02/身体障害者手帳交付数（視覚障害）",
              "label": "身体障害者手帳交付数（視覚障害）",
              "cat01": "J1201",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120101/人/j02/身体障害者手帳交付数（視覚障害）（１８歳以上）",
              "label": "身体障害者手帳交付数（視覚障害）（１８歳以上）",
              "cat01": "J120101",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120102/人/j02/身体障害者手帳交付数（視覚障害）（１８歳未満）",
              "label": "身体障害者手帳交付数（視覚障害）（１８歳未満）",
              "cat01": "J120102",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1202/人/j02/身体障害者手帳交付数（聴覚・平衡機能障害）",
              "label": "身体障害者手帳交付数（聴覚・平衡機能障害）",
              "cat01": "J1202",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120201/人/j02/身体障害者手帳交付数（聴覚・平衡機能障害）（１８歳以上）",
              "label": "身体障害者手帳交付数（聴覚・平衡機能障害）（１８歳以上）",
              "cat01": "J120201",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120202/人/j02/身体障害者手帳交付数（聴覚・平衡機能障害）（１８歳未満）",
              "label": "身体障害者手帳交付数（聴覚・平衡機能障害）（１８歳未満）",
              "cat01": "J120202",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1203/人/j02/身体障害者手帳交付数（音声・言語・そしゃく機能障害）",
              "label": "身体障害者手帳交付数（音声・言語・そしゃく機能障害）",
              "cat01": "J1203",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120301/人/j02/身体障害者手帳交付数（音声・言語・そしゃく機能障害）（１８歳以上）",
              "label": "身体障害者手帳交付数（音声・言語・そしゃく機能障害）（１８歳以上）",
              "cat01": "J120301",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120302/人/j02/身体障害者手帳交付数（音声・言語・そしゃく機能障害）（１８歳未満）",
              "label": "身体障害者手帳交付数（音声・言語・そしゃく機能障害）（１８歳未満）",
              "cat01": "J120302",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1204/人/j02/身体障害者手帳交付数（肢体不自由障害）",
              "label": "身体障害者手帳交付数（肢体不自由障害）",
              "cat01": "J1204",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120401/人/j02/身体障害者手帳交付数（肢体不自由障害）（１８歳以上）",
              "label": "身体障害者手帳交付数（肢体不自由障害）（１８歳以上）",
              "cat01": "J120401",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120402/人/j02/身体障害者手帳交付数（肢体不自由障害）（１８歳未満）",
              "label": "身体障害者手帳交付数（肢体不自由障害）（１８歳未満）",
              "cat01": "J120402",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1205/人/j02/身体障害者手帳交付数（内部障害）",
              "label": "身体障害者手帳交付数（内部障害）",
              "cat01": "J1205",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120501/人/j02/身体障害者手帳交付数（内部障害）（１８歳以上）",
              "label": "身体障害者手帳交付数（内部障害）（１８歳以上）",
              "cat01": "J120501",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J120502/人/j02/身体障害者手帳交付数（内部障害）（１８歳未満）",
              "label": "身体障害者手帳交付数（内部障害）（１８歳未満）",
              "cat01": "J120502",
              "unit": "人",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1210/件/j02/身体障害者補装具交付決定件数",
              "label": "身体障害者補装具交付決定件数",
              "cat01": "J1210",
              "unit": "件",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1212/件/j02/身体障害者補装具修理決定件数",
              "label": "身体障害者補装具修理決定件数",
              "cat01": "J1212",
              "unit": "件",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1213/円/j02/身体障害者補装具修理負担額",
              "label": "身体障害者補装具修理負担額",
              "cat01": "J1213",
              "unit": "円",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J121301/円/j02/身体障害者補装具修理負担額（公費負担額）",
              "label": "身体障害者補装具修理負担額（公費負担額）",
              "cat01": "J121301",
              "unit": "円",
              "sourceId": "j02"
            },
            {
              "statId": "0000010110/J1301/件/j03/精神障害者保健福祉手帳交付件数",
              "label": "精神障害者保健福祉手帳交付件数",
              "cat01": "J1301",
              "unit": "件",
              "sourceId": "j03"
            },
            {
              "statId": "0000010110/J130101/件/j03/精神障害保健福祉手帳交付件数（１級）",
              "label": "精神障害保健福祉手帳交付件数（１級）",
              "cat01": "J130101",
              "unit": "件",
              "sourceId": "j03"
            },
            {
              "statId": "0000010110/J130102/件/j03/精神障害保健福祉手帳交付件数（２級）",
              "label": "精神障害保健福祉手帳交付件数（２級）",
              "cat01": "J130102",
              "unit": "件",
              "sourceId": "j03"
            },
            {
              "statId": "0000010110/J130103/件/j03/精神障害保健福祉手帳交付件数（３級）",
              "label": "精神障害保健福祉手帳交付件数（３級）",
              "cat01": "J130103",
              "unit": "件",
              "sourceId": "j03"
            },
            {
              "statId": "0000010110/J1401/人/j04/児童扶養手当受給者数",
              "label": "児童扶養手当受給者数",
              "cat01": "J1401",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J1501/人/j04/知的障害者療育手帳交付数",
              "label": "知的障害者療育手帳交付数",
              "cat01": "J1501",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2101/所/j04/社会福祉施設数",
              "label": "社会福祉施設数",
              "cat01": "J2101",
              "unit": "所",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2103/人/j04/社会福祉施設従事者数（常勤）",
              "label": "社会福祉施設従事者数（常勤）",
              "cat01": "J2103",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2201/所/j04/保護施設数（医療保護施設を除く）",
              "label": "保護施設数（医療保護施設を除く）",
              "cat01": "J2201",
              "unit": "所",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2202/人/j04/保護施設定員数（医療保護施設を含む）",
              "label": "保護施設定員数（医療保護施設を含む）",
              "cat01": "J2202",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2203/人/j04/保護施設定員数（医療保護施設を除く）",
              "label": "保護施設定員数（医療保護施設を除く）",
              "cat01": "J2203",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2205/人/j04/保護施設在所者数（医療保護施設を含む）",
              "label": "保護施設在所者数（医療保護施設を含む）",
              "cat01": "J2205",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2206/人/j04/保護施設在所者数（医療保護施設を除く）",
              "label": "保護施設在所者数（医療保護施設を除く）",
              "cat01": "J2206",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2209/人/j04/保護施設従事者数（医療保護施設を除く）（専任）",
              "label": "保護施設従事者数（医療保護施設を除く）（専任）",
              "cat01": "J2209",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2212/人/j04/保護施設従事者数（医療保護施設を除く）（常勤）",
              "label": "保護施設従事者数（医療保護施設を除く）（常勤）",
              "cat01": "J2212",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2300/所/j04/老人福祉関係施設数",
              "label": "老人福祉関係施設数",
              "cat01": "J2300",
              "unit": "所",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J2301/所/j04/老人福祉施設数",
              "label": "老人福祉施設数",
              "cat01": "J2301",
              "unit": "所",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J230111/所/j04/養護老人ホーム数",
              "label": "養護老人ホーム数",
              "cat01": "J230111",
              "unit": "所",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J230112/人/j04/養護老人ホーム定員数",
              "label": "養護老人ホーム定員数",
              "cat01": "J230112",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J230113/人/j04/養護老人ホーム在所者数",
              "label": "養護老人ホーム在所者数",
              "cat01": "J230113",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J230115/人/j04/養護老人ホーム従事者数（常勤）",
              "label": "養護老人ホーム従事者数（常勤）",
              "cat01": "J230115",
              "unit": "人",
              "sourceId": "j04"
            },
            {
              "statId": "0000010110/J230121/所/j05/介護老人福祉施設数",
              "label": "介護老人福祉施設数",
              "cat01": "J230121",
              "unit": "所",
              "sourceId": "j05"
            },
            {
              "statId": "0000010110/J230124/人/j05/介護老人福祉施設定員数",
              "label": "介護老人福祉施設定員数",
              "cat01": "J230124",
              "unit": "人",
              "sourceId": "j05"
            },
            {
              "statId": "0000010110/J230125/人/j05/介護老人福祉施設在所者数",
              "label": "介護老人福祉施設在所者数",
              "cat01": "J230125",
              "unit": "人",
              "sourceId": "j05"
            },
            {
              "statId": "0000010110/J230126/人/j05/介護老人福祉施設従事者数",
              "label": "介護老人福祉施設従事者数",
              "cat01": "J230126",
              "unit": "人",
              "sourceId": "j05"
            },
            {
              "statId": "0000010110/J230131/所/j06/軽費老人ホーム数",
              "label": "軽費老人ホーム数",
              "cat01": "J230131",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230132/人/j06/軽費老人ホーム定員数",
              "label": "軽費老人ホーム定員数",
              "cat01": "J230132",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230133/人/j06/軽費老人ホーム在所者数",
              "label": "軽費老人ホーム在所者数",
              "cat01": "J230133",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230135/人/j06/軽費老人ホーム従事者数（常勤）",
              "label": "軽費老人ホーム従事者数（常勤）",
              "cat01": "J230135",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230141/所/j06/老人福祉センター数",
              "label": "老人福祉センター数",
              "cat01": "J230141",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230144/人/j06/老人福祉センター従事者数（専任）",
              "label": "老人福祉センター従事者数（専任）",
              "cat01": "J230144",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230145/人/j06/老人福祉センター従事者数（常勤）",
              "label": "老人福祉センター従事者数（常勤）",
              "cat01": "J230145",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230155/所/j06/訪問介護事業所数",
              "label": "訪問介護事業所数",
              "cat01": "J230155",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230156/人/j06/訪問介護利用者数",
              "label": "訪問介護利用者数",
              "cat01": "J230156",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230162/所/j06/訪問入浴介護事業所数",
              "label": "訪問入浴介護事業所数",
              "cat01": "J230162",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230163/人/j06/訪問入浴介護利用者数",
              "label": "訪問入浴介護利用者数",
              "cat01": "J230163",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230165/所/j06/通所介護事業所数",
              "label": "通所介護事業所数",
              "cat01": "J230165",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230166/人/j06/通所介護定員数",
              "label": "通所介護定員数",
              "cat01": "J230166",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230167/人/j06/通所介護従事者数",
              "label": "通所介護従事者数",
              "cat01": "J230167",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230168/人/j06/通所介護利用者数",
              "label": "通所介護利用者数",
              "cat01": "J230168",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230171/所/j06/短期入所生活介護事業所数",
              "label": "短期入所生活介護事業所数",
              "cat01": "J230171",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230172/人/j06/短期入所生活介護定員数",
              "label": "短期入所生活介護定員数",
              "cat01": "J230172",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230173/人/j06/短期入所生活介護従事者数",
              "label": "短期入所生活介護従事者数",
              "cat01": "J230173",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230174/人/j06/短期入所生活介護利用者数",
              "label": "短期入所生活介護利用者数",
              "cat01": "J230174",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230181/所/j06/居宅介護支援事業所数",
              "label": "居宅介護支援事業所数",
              "cat01": "J230181",
              "unit": "所",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230182/人/j06/居宅介護支援事業利用者数",
              "label": "居宅介護支援事業利用者数",
              "cat01": "J230182",
              "unit": "人",
              "sourceId": "j06"
            },
            {
              "statId": "0000010110/J230191/所/j07/老人介護支援センター数",
              "label": "老人介護支援センター数",
              "cat01": "J230191",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2302/所/j07/その他の老人福祉施設数",
              "label": "その他の老人福祉施設数",
              "cat01": "J2302",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230211/所/j07/老人憩の家数",
              "label": "老人憩の家数",
              "cat01": "J230211",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230214/人/j07/老人憩の家従事者数（専任）",
              "label": "老人憩の家従事者数（専任）",
              "cat01": "J230214",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230215/人/j07/老人憩の家従事者数（常勤）",
              "label": "老人憩の家従事者数（常勤）",
              "cat01": "J230215",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230221/所/j07/有料老人ホーム数",
              "label": "有料老人ホーム数",
              "cat01": "J230221",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230222/人/j07/有料老人ホーム定員数",
              "label": "有料老人ホーム定員数",
              "cat01": "J230222",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230223/人/j07/有料老人ホーム在所者数",
              "label": "有料老人ホーム在所者数",
              "cat01": "J230223",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J230225/人/j07/有料老人ホーム従事者数（常勤）",
              "label": "有料老人ホーム従事者数（常勤）",
              "cat01": "J230225",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2303/所/j07/その他の社会福祉施設等数",
              "label": "その他の社会福祉施設等数",
              "cat01": "J2303",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J232101/所/j07/老人ホーム数",
              "label": "老人ホーム数",
              "cat01": "J232101",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J232102/人/j07/老人ホーム定員数",
              "label": "老人ホーム定員数",
              "cat01": "J232102",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J232103/人/j07/老人ホーム在所者数",
              "label": "老人ホーム在所者数",
              "cat01": "J232103",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J232104/人/j07/老人ホーム従事者数（専任）",
              "label": "老人ホーム従事者数（専任）",
              "cat01": "J232104",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J232105/人/j07/老人ホーム従事者数（常勤）",
              "label": "老人ホーム従事者数（常勤）",
              "cat01": "J232105",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2401/所/j07/身体障害者更生援護施設数",
              "label": "身体障害者更生援護施設数",
              "cat01": "J2401",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2402/人/j07/身体障害者更生援護施設定員数",
              "label": "身体障害者更生援護施設定員数",
              "cat01": "J2402",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2403/人/j07/身体障害者更生援護施設在所者数",
              "label": "身体障害者更生援護施設在所者数",
              "cat01": "J2403",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2404/人/j07/身体障害者更生援護施設従事者数（専任）",
              "label": "身体障害者更生援護施設従事者数（専任）",
              "cat01": "J2404",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2405/人/j07/身体障害者更生援護施設従事者数（常勤）",
              "label": "身体障害者更生援護施設従事者数（常勤）",
              "cat01": "J2405",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2501/所/j07/児童福祉施設等数（助産施設，児童遊園を除く）",
              "label": "児童福祉施設等数（助産施設，児童遊園を除く）",
              "cat01": "J2501",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J250101/所/j07/児童福祉施設等数（助産施設、保育所等、児童館、児童遊園を除く）",
              "label": "児童福祉施設等数（助産施設、保育所等、児童館、児童遊園を除く）",
              "cat01": "J250101",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J250201/人/j07/児童福祉施設従事者数（保育所，児童館，児童遊園を除く）（専任）",
              "label": "児童福祉施設従事者数（保育所，児童館，児童遊園を除く）（専任）",
              "cat01": "J250201",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J250202/人/j07/児童福祉施設等従事者数（助産施設，児童遊園を除く）（常勤）",
              "label": "児童福祉施設等従事者数（助産施設，児童遊園を除く）（常勤）",
              "cat01": "J250202",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J250203/人/j07/児童福祉施設等従事者数（助産施設，保育所等，児童館，児童遊園を除く）（常勤）",
              "label": "児童福祉施設等従事者数（助産施設，保育所等，児童館，児童遊園を除く）（常勤）",
              "cat01": "J250203",
              "unit": "人",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2503/所/j07/保育所等数",
              "label": "保育所等数",
              "cat01": "J2503",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J250301/所/j07/公営保育所等数",
              "label": "公営保育所等数",
              "cat01": "J250301",
              "unit": "所",
              "sourceId": "j07"
            },
            {
              "statId": "0000010110/J2504/人/j08/保育所保育士数（専任）",
              "label": "保育所保育士数（専任）",
              "cat01": "J2504",
              "unit": "人",
              "sourceId": "j08"
            },
            {
              "statId": "0000010110/J2505/人/j08/保育所等定員数",
              "label": "保育所等定員数",
              "cat01": "J2505",
              "unit": "人",
              "sourceId": "j08"
            },
            {
              "statId": "0000010110/J250501/人/j08/公営保育所等定員数",
              "label": "公営保育所等定員数",
              "cat01": "J250501",
              "unit": "人",
              "sourceId": "j08"
            },
            {
              "statId": "0000010110/J250502/人/j09/保育所等入所待機児童数",
              "label": "保育所等入所待機児童数",
              "cat01": "J250502",
              "unit": "人",
              "sourceId": "j09"
            },
            {
              "statId": "0000010110/J2506/人/j10/保育所等在所児数",
              "label": "保育所等在所児数",
              "cat01": "J2506",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J250601/人/j10/保育所在所児数（３歳児）",
              "label": "保育所在所児数（３歳児）",
              "cat01": "J250601",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J250602/人/j10/保育所在所児数（４歳児）",
              "label": "保育所在所児数（４歳児）",
              "cat01": "J250602",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J250603/人/j10/保育所在所児数（５歳児）",
              "label": "保育所在所児数（５歳児）",
              "cat01": "J250603",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J250604/人/j10/公営保育所等在所児数",
              "label": "公営保育所等在所児数",
              "cat01": "J250604",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2508/人/j10/保育所等修了者数",
              "label": "保育所等修了者数",
              "cat01": "J2508",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2509/所/j10/児童館数",
              "label": "児童館数",
              "cat01": "J2509",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2510/所/j10/児童遊園数",
              "label": "児童遊園数",
              "cat01": "J2510",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2511/所/j10/助産施設数",
              "label": "助産施設数",
              "cat01": "J2511",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2513/所/j10/乳児院数",
              "label": "乳児院数",
              "cat01": "J2513",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2514/人/j10/乳児院定員数",
              "label": "乳児院定員数",
              "cat01": "J2514",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2515/人/j10/乳児院在所者数",
              "label": "乳児院在所者数",
              "cat01": "J2515",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2517/所/j10/母子生活支援施設数",
              "label": "母子生活支援施設数",
              "cat01": "J2517",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2519/人/j10/母子生活支援施設在所者数",
              "label": "母子生活支援施設在所者数",
              "cat01": "J2519",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2521/所/j10/児童養護施設数",
              "label": "児童養護施設数",
              "cat01": "J2521",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2522/人/j10/児童養護施設定員数",
              "label": "児童養護施設定員数",
              "cat01": "J2522",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2523/人/j10/児童養護施設在所者数",
              "label": "児童養護施設在所者数",
              "cat01": "J2523",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2525/所/j10/心身障害児童施設数",
              "label": "心身障害児童施設数",
              "cat01": "J2525",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252501/所/j10/知的障害児施設数",
              "label": "知的障害児施設数",
              "cat01": "J252501",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252502/所/j10/知的障害児通園施設数",
              "label": "知的障害児通園施設数",
              "cat01": "J252502",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252503/所/j10/盲児施設数",
              "label": "盲児施設数",
              "cat01": "J252503",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252504/所/j10/ろうあ児施設数",
              "label": "ろうあ児施設数",
              "cat01": "J252504",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252505/所/j10/難聴幼児通園施設数",
              "label": "難聴幼児通園施設数",
              "cat01": "J252505",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252507/所/j10/肢体不自由児施設数",
              "label": "肢体不自由児施設数",
              "cat01": "J252507",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252508/所/j10/肢体不自由児通園施設数",
              "label": "肢体不自由児通園施設数",
              "cat01": "J252508",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252509/所/j10/肢体不自由児療護施設数",
              "label": "肢体不自由児療護施設数",
              "cat01": "J252509",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252510/所/j10/重症心身障害児施設数",
              "label": "重症心身障害児施設数",
              "cat01": "J252510",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252511/所/j10/情緒障害児短期治療施設数",
              "label": "情緒障害児短期治療施設数",
              "cat01": "J252511",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252512/所/j10/自閉症児施設数",
              "label": "自閉症児施設数",
              "cat01": "J252512",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2526/人/j10/保育所等保育士数",
              "label": "保育所等保育士数",
              "cat01": "J2526",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J252601/人/j10/公営保育所等保育士数",
              "label": "公営保育所等保育士数",
              "cat01": "J252601",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2527/人/j10/保育所従事者数（常勤）",
              "label": "保育所従事者数（常勤）",
              "cat01": "J2527",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2528/人/j10/乳児院従事者数（常勤）",
              "label": "乳児院従事者数（常勤）",
              "cat01": "J2528",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2529/人/j10/母子生活支援施設従事者数（常勤）",
              "label": "母子生活支援施設従事者数（常勤）",
              "cat01": "J2529",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2530/人/j10/児童養護施設従事者数（常勤）",
              "label": "児童養護施設従事者数（常勤）",
              "cat01": "J2530",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2540/園/j11/認定こども園数",
              "label": "認定こども園数",
              "cat01": "J2540",
              "unit": "園",
              "sourceId": "j11"
            },
            {
              "statId": "0000010110/J2541/園/j11/認定こども園数（幼保連携型）",
              "label": "認定こども園数（幼保連携型）",
              "cat01": "J2541",
              "unit": "園",
              "sourceId": "j11"
            },
            {
              "statId": "0000010110/J2542/園/j11/認定こども園数(幼稚園型）",
              "label": "認定こども園数(幼稚園型）",
              "cat01": "J2542",
              "unit": "園",
              "sourceId": "j11"
            },
            {
              "statId": "0000010110/J2543/園/j11/認定こども園数（保育所型）",
              "label": "認定こども園数（保育所型）",
              "cat01": "J2543",
              "unit": "園",
              "sourceId": "j11"
            },
            {
              "statId": "0000010110/J2544/園/j11/認定こども園数（地方裁量型）",
              "label": "認定こども園数（地方裁量型）",
              "cat01": "J2544",
              "unit": "園",
              "sourceId": "j11"
            },
            {
              "statId": "0000010110/J2626/人/j10/心身障害児施設定員数",
              "label": "心身障害児施設定員数",
              "cat01": "J2626",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262601/人/j10/知的障害児施設定員数",
              "label": "知的障害児施設定員数",
              "cat01": "J262601",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262602/人/j10/知的障害児通園施設定員数",
              "label": "知的障害児通園施設定員数",
              "cat01": "J262602",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262608/人/j10/肢体不自由児通園施設定員数",
              "label": "肢体不自由児通園施設定員数",
              "cat01": "J262608",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262610/人/j10/重症心身障害児施設定員数",
              "label": "重症心身障害児施設定員数",
              "cat01": "J262610",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2627/人/j10/心身障害児施設在所者数",
              "label": "心身障害児施設在所者数",
              "cat01": "J2627",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262701/人/j10/知的障害児施設在所者数",
              "label": "知的障害児施設在所者数",
              "cat01": "J262701",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262703/人/j10/盲児施設在所者数",
              "label": "盲児施設在所者数",
              "cat01": "J262703",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J262709/人/j10/肢体不自由児療護施設在所者数",
              "label": "肢体不自由児療護施設在所者数",
              "cat01": "J262709",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2629/所/j10/児童自立支援施設数",
              "label": "児童自立支援施設数",
              "cat01": "J2629",
              "unit": "所",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2631/人/j10/児童自立支援施設在所者数",
              "label": "児童自立支援施設在所者数",
              "cat01": "J2631",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2633/人/j10/児童自立支援施設従事者数（常勤）",
              "label": "児童自立支援施設従事者数（常勤）",
              "cat01": "J2633",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2634/人/j10/心身障害児施設従事者数（常勤）",
              "label": "心身障害児施設従事者数（常勤）",
              "cat01": "J2634",
              "unit": "人",
              "sourceId": "j10"
            },
            {
              "statId": "0000010110/J2641/所/j12/へき地保育所数",
              "label": "へき地保育所数",
              "cat01": "J2641",
              "unit": "所",
              "sourceId": "j12"
            },
            {
              "statId": "0000010110/J2642/人/j12/へき地保育所在所児数",
              "label": "へき地保育所在所児数",
              "cat01": "J2642",
              "unit": "人",
              "sourceId": "j12"
            },
            {
              "statId": "0000010110/J2651/施設/j13/認可外保育施設数",
              "label": "認可外保育施設数",
              "cat01": "J2651",
              "unit": "施設",
              "sourceId": "j13"
            },
            {
              "statId": "0000010110/J2652/人/j13/認可外保育施設在所児数",
              "label": "認可外保育施設在所児数",
              "cat01": "J2652",
              "unit": "人",
              "sourceId": "j13"
            },
            {
              "statId": "0000010110/J2701/所/j14/知的障害者援護施設数",
              "label": "知的障害者援護施設数",
              "cat01": "J2701",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2702/人/j14/知的障害者援護施設定員数",
              "label": "知的障害者援護施設定員数",
              "cat01": "J2702",
              "unit": "人",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2703/人/j14/知的障害者援護施設在所者数",
              "label": "知的障害者援護施設在所者数",
              "cat01": "J2703",
              "unit": "人",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2704/人/j14/知的障害者援護施設従事者数（専任）",
              "label": "知的障害者援護施設従事者数（専任）",
              "cat01": "J2704",
              "unit": "人",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2705/人/j14/知的障害者援護施設従事者数（常勤）",
              "label": "知的障害者援護施設従事者数（常勤）",
              "cat01": "J2705",
              "unit": "人",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2801/所/j14/母子・父子福祉施設数",
              "label": "母子・父子福祉施設数",
              "cat01": "J2801",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2803/人/j14/母子・父子福祉施設従事者数（常勤）",
              "label": "母子・父子福祉施設従事者数（常勤）",
              "cat01": "J2803",
              "unit": "人",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2901/所/j14/障害者支援施設等数",
              "label": "障害者支援施設等数",
              "cat01": "J2901",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2902/所/j14/精神障害者社会復帰施設数",
              "label": "精神障害者社会復帰施設数",
              "cat01": "J2902",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2903/所/j14/身体障害者社会参加支援施設数",
              "label": "身体障害者社会参加支援施設数",
              "cat01": "J2903",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J2904/所/j14/婦人保護施設数",
              "label": "婦人保護施設数",
              "cat01": "J2904",
              "unit": "所",
              "sourceId": "j14"
            },
            {
              "statId": "0000010110/J3101/人/j15/民生委員（児童委員）数",
              "label": "民生委員（児童委員）数",
              "cat01": "J3101",
              "unit": "人",
              "sourceId": "j15"
            },
            {
              "statId": "0000010110/J3102/人/j16/身体障害者相談員数",
              "label": "身体障害者相談員数",
              "cat01": "J3102",
              "unit": "人",
              "sourceId": "j16"
            },
            {
              "statId": "0000010110/J3103/人/j16/知的障害者相談員数",
              "label": "知的障害者相談員数",
              "cat01": "J3103",
              "unit": "人",
              "sourceId": "j16"
            },
            {
              "statId": "0000010110/J3108/人/j17/訪問介護員（ホームヘルパー）数",
              "label": "訪問介護員（ホームヘルパー）数",
              "cat01": "J3108",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3201/件/j17/民生委員（児童委員）相談・支援件数",
              "label": "民生委員（児童委員）相談・支援件数",
              "cat01": "J3201",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3202/件/j17/福祉事務所生活保護申請件数",
              "label": "福祉事務所生活保護申請件数",
              "cat01": "J3202",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3203/人/j17/身体障害者更生援護取扱実人員",
              "label": "身体障害者更生援護取扱実人員",
              "cat01": "J3203",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3204/人/j17/福祉事務所知的障害者相談実人員",
              "label": "福祉事務所知的障害者相談実人員",
              "cat01": "J3204",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3205/人/j17/身体障害者更生相談所取扱実人員",
              "label": "身体障害者更生相談所取扱実人員",
              "cat01": "J3205",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3206/人/j17/知的障害者更生相談所取扱実人員",
              "label": "知的障害者更生相談所取扱実人員",
              "cat01": "J3206",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3207/件/j17/児童相談所受付件数",
              "label": "児童相談所受付件数",
              "cat01": "J3207",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3208/人/j17/市町村における知的障害者相談実人員",
              "label": "市町村における知的障害者相談実人員",
              "cat01": "J3208",
              "unit": "人",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J3209/件/j17/児童相談所における児童虐待相談の対応件数",
              "label": "児童相談所における児童虐待相談の対応件数",
              "cat01": "J3209",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J320901/件/j17/児童相談所における児童虐待相談の対応件数（被虐待者が０～２歳）",
              "label": "児童相談所における児童虐待相談の対応件数（被虐待者が０～２歳）",
              "cat01": "J320901",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J320902/件/j17/児童相談所における児童虐待相談の対応件数（被虐待者が３～６歳）",
              "label": "児童相談所における児童虐待相談の対応件数（被虐待者が３～６歳）",
              "cat01": "J320902",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J320903/件/j17/児童相談所における児童虐待相談の対応件数（被虐待者が７～１２歳）",
              "label": "児童相談所における児童虐待相談の対応件数（被虐待者が７～１２歳）",
              "cat01": "J320903",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J320904/件/j17/児童相談所における児童虐待相談の対応件数（被虐待者が１３～１５歳）",
              "label": "児童相談所における児童虐待相談の対応件数（被虐待者が１３～１５歳）",
              "cat01": "J320904",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J320905/件/j17/児童相談所における児童虐待相談の対応件数（被虐待者が１６～１８歳）",
              "label": "児童相談所における児童虐待相談の対応件数（被虐待者が１６～１８歳）",
              "cat01": "J320905",
              "unit": "件",
              "sourceId": "j17"
            },
            {
              "statId": "0000010110/J4001/億円/j18/国民医療費（総額）",
              "label": "国民医療費（総額）",
              "cat01": "J4001",
              "unit": "億円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4002/億円/j18/国民医療費（一般診療）（入院）",
              "label": "国民医療費（一般診療）（入院）",
              "cat01": "J4002",
              "unit": "億円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4003/億円/j18/国民医療費（一般診療）（入院外）",
              "label": "国民医療費（一般診療）（入院外）",
              "cat01": "J4003",
              "unit": "億円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4004/千円/j18/一人当たりの医療費",
              "label": "一人当たりの医療費",
              "cat01": "J4004",
              "unit": "千円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4005/億円/j18/国民医療費（医科診療）（入院）",
              "label": "国民医療費（医科診療）（入院）",
              "cat01": "J4005",
              "unit": "億円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4006/億円/j18/国民医療費（医科診療）（入院外）",
              "label": "国民医療費（医科診療）（入院外）",
              "cat01": "J4006",
              "unit": "億円",
              "sourceId": "j18"
            },
            {
              "statId": "0000010110/J4101/人/j19/国民健康保険被保険者数",
              "label": "国民健康保険被保険者数",
              "cat01": "J4101",
              "unit": "人",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4102/件/j19/国民健康保険給付件数",
              "label": "国民健康保険給付件数",
              "cat01": "J4102",
              "unit": "件",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4104/件/j19/国民健康保険医療費件数（診療費）",
              "label": "国民健康保険医療費件数（診療費）",
              "cat01": "J4104",
              "unit": "件",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4105/千円/j19/国民健康保険給付金額（診療費）（費用額）",
              "label": "国民健康保険給付金額（診療費）（費用額）",
              "cat01": "J4105",
              "unit": "千円",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4106/‐/j19/国民健康保険被保険者受診率（１０００人当たり）",
              "label": "国民健康保険被保険者受診率（１０００人当たり）",
              "cat01": "J4106",
              "unit": "‐",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4107/円/j19/国民健康保険被保険者１人当たり診療費",
              "label": "国民健康保険被保険者１人当たり診療費",
              "cat01": "J4107",
              "unit": "円",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4108/千円/j19/国民健康保険給付金額",
              "label": "国民健康保険給付金額",
              "cat01": "J4108",
              "unit": "千円",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4109/千円/j19/国民健康保険医療費金額（診療費）",
              "label": "国民健康保険医療費金額（診療費）",
              "cat01": "J4109",
              "unit": "千円",
              "sourceId": "j19"
            },
            {
              "statId": "0000010110/J4201/所/j20/全国健康保険協会管掌健康保険事業所数",
              "label": "全国健康保険協会管掌健康保険事業所数",
              "cat01": "J4201",
              "unit": "所",
              "sourceId": "j20"
            },
            {
              "statId": "0000010110/J4202/人/j20/全国健康保険協会管掌健康保険被保険者数",
              "label": "全国健康保険協会管掌健康保険被保険者数",
              "cat01": "J4202",
              "unit": "人",
              "sourceId": "j20"
            },
            {
              "statId": "0000010110/J4203/人/j20/全国健康保険協会管掌健康保険被扶養者数",
              "label": "全国健康保険協会管掌健康保険被扶養者数",
              "cat01": "J4203",
              "unit": "人",
              "sourceId": "j20"
            },
            {
              "statId": "0000010110/J4204/件/j20/全国健康保険協会管掌健康保険給付件数",
              "label": "全国健康保険協会管掌健康保険給付件数",
              "cat01": "J4204",
              "unit": "件",
              "sourceId": "j20"
            },
            {
              "statId": "0000010110/J420401/件/j21/政府管掌健康保険給付件数（被保険者）",
              "label": "政府管掌健康保険給付件数（被保険者）",
              "cat01": "J420401",
              "unit": "件",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420402/件/j21/政府管掌健康保険給付件数（被扶養者）",
              "label": "政府管掌健康保険給付件数（被扶養者）",
              "cat01": "J420402",
              "unit": "件",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420410/件/j21/全国健康保険協会管掌健康保険給付件数（診療費）",
              "label": "全国健康保険協会管掌健康保険給付件数（診療費）",
              "cat01": "J420410",
              "unit": "件",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420411/件/j21/全国健康保険協会管掌健康保険給付件数（診療費・被保険者）",
              "label": "全国健康保険協会管掌健康保険給付件数（診療費・被保険者）",
              "cat01": "J420411",
              "unit": "件",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420412/件/j21/全国健康保険協会管掌健康保険給付件数（診療費・被扶養者）",
              "label": "全国健康保険協会管掌健康保険給付件数（診療費・被扶養者）",
              "cat01": "J420412",
              "unit": "件",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420421/‐/j21/全国健康保険協会管掌健康保険受診率（被保険者）",
              "label": "全国健康保険協会管掌健康保険受診率（被保険者）",
              "cat01": "J420421",
              "unit": "‐",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420422/‐/j21/全国健康保険協会管掌健康保険受診率（被扶養者）",
              "label": "全国健康保険協会管掌健康保険受診率（被扶養者）",
              "cat01": "J420422",
              "unit": "‐",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J4205/千円/j21/全国健康保険協会管掌健康保険給付金額",
              "label": "全国健康保険協会管掌健康保険給付金額",
              "cat01": "J4205",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420501/千円/j21/政府管掌健康保険給付金額（被保険者）",
              "label": "政府管掌健康保険給付金額（被保険者）",
              "cat01": "J420501",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420502/千円/j21/政府管掌健康保険給付金額（被扶養者）",
              "label": "政府管掌健康保険給付金額（被扶養者）",
              "cat01": "J420502",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420510/千円/j21/全国健康保険協会管掌健康保険給付金額（診療費）",
              "label": "全国健康保険協会管掌健康保険給付金額（診療費）",
              "cat01": "J420510",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420511/千円/j21/全国健康保険協会管掌健康保険給付金額（診療費・被保険者）",
              "label": "全国健康保険協会管掌健康保険給付金額（診療費・被保険者）",
              "cat01": "J420511",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420512/千円/j21/全国健康保険協会管掌健康保険給付金額（診療費・被扶養者）",
              "label": "全国健康保険協会管掌健康保険給付金額（診療費・被扶養者）",
              "cat01": "J420512",
              "unit": "千円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420521/円/j21/政府管掌健康保険１人当たり受診金額（被保険者）",
              "label": "政府管掌健康保険１人当たり受診金額（被保険者）",
              "cat01": "J420521",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420522/円/j21/政府管掌健康保険１人当たり受診金額（被扶養者）",
              "label": "政府管掌健康保険１人当たり受診金額（被扶養者）",
              "cat01": "J420522",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420531/円/j21/全国健康保険協会管掌健康保険１人当たり医療費（被保険者）",
              "label": "全国健康保険協会管掌健康保険１人当たり医療費（被保険者）",
              "cat01": "J420531",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420532/円/j21/全国健康保険協会管掌健康保険１人当たり医療費（被扶養者）",
              "label": "全国健康保険協会管掌健康保険１人当たり医療費（被扶養者）",
              "cat01": "J420532",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J420533/円/j21/全国健康保険協会管掌健康保険１人当たり医療費（加入者合計）",
              "label": "全国健康保険協会管掌健康保険１人当たり医療費（加入者合計）",
              "cat01": "J420533",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J4206/円/j21/全国健康保険協会管掌健康保険１人当たり医療費の地域差指数",
              "label": "全国健康保険協会管掌健康保険１人当たり医療費の地域差指数",
              "cat01": "J4206",
              "unit": "円",
              "sourceId": "j21"
            },
            {
              "statId": "0000010110/J4301/組合/j22/組合管掌健康保険組合数",
              "label": "組合管掌健康保険組合数",
              "cat01": "J4301",
              "unit": "組合",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J4302/人/j22/組合管掌健康保険被保険者数",
              "label": "組合管掌健康保険被保険者数",
              "cat01": "J4302",
              "unit": "人",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J4303/人/j22/組合管掌健康保険被扶養者数",
              "label": "組合管掌健康保険被扶養者数",
              "cat01": "J4303",
              "unit": "人",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J4304/件/j22/組合管掌健康保険給付件数",
              "label": "組合管掌健康保険給付件数",
              "cat01": "J4304",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430401/件/j22/組合管掌健康保険給付件数（被保険者）",
              "label": "組合管掌健康保険給付件数（被保険者）",
              "cat01": "J430401",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430402/件/j22/組合管掌健康保険給付件数（被扶養者）",
              "label": "組合管掌健康保険給付件数（被扶養者）",
              "cat01": "J430402",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430410/件/j22/組合管掌健康保険給付件数（診療費）",
              "label": "組合管掌健康保険給付件数（診療費）",
              "cat01": "J430410",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430411/件/j22/組合管掌健康保険給付件数（診療費・被保険者）",
              "label": "組合管掌健康保険給付件数（診療費・被保険者）",
              "cat01": "J430411",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430412/件/j22/組合管掌健康保険給付件数（診療費・被扶養者）",
              "label": "組合管掌健康保険給付件数（診療費・被扶養者）",
              "cat01": "J430412",
              "unit": "件",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430421/‐/j22/組合管掌健康保険受診率（被保険者）",
              "label": "組合管掌健康保険受診率（被保険者）",
              "cat01": "J430421",
              "unit": "‐",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430422/‐/j22/組合管掌健康保険受診率（被扶養者）",
              "label": "組合管掌健康保険受診率（被扶養者）",
              "cat01": "J430422",
              "unit": "‐",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J4305/千円/j22/組合管掌健康保険給付金額",
              "label": "組合管掌健康保険給付金額",
              "cat01": "J4305",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430501/千円/j22/組合管掌健康保険給付金額（被保険者）",
              "label": "組合管掌健康保険給付金額（被保険者）",
              "cat01": "J430501",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430502/千円/j22/組合管掌健康保険給付金額（被扶養者）",
              "label": "組合管掌健康保険給付金額（被扶養者）",
              "cat01": "J430502",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430510/千円/j22/組合管掌健康保険給付金額（診療費）",
              "label": "組合管掌健康保険給付金額（診療費）",
              "cat01": "J430510",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430511/千円/j22/組合管掌健康保険給付金額（診療費・被保険者）",
              "label": "組合管掌健康保険給付金額（診療費・被保険者）",
              "cat01": "J430511",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430512/千円/j22/組合管掌健康保険給付金額（診療費・被扶養者）",
              "label": "組合管掌健康保険給付金額（診療費・被扶養者）",
              "cat01": "J430512",
              "unit": "千円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J430521/円/j22/組合管掌健康保険１人当たり受診金額（被保険者）",
              "label": "組合管掌健康保険１人当たり受診金額（被保険者）",
              "cat01": "J430521",
              "unit": "円",
              "sourceId": "j22"
            },
            {
              "statId": "0000010110/J4401/人/j23/船員保険（疾病分）船舶所有者数",
              "label": "船員保険（疾病分）船舶所有者数",
              "cat01": "J4401",
              "unit": "人",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J4402/人/j23/船員保険（疾病分）被保険者数",
              "label": "船員保険（疾病分）被保険者数",
              "cat01": "J4402",
              "unit": "人",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J4403/人/j23/船員保険（疾病分）被扶養者数",
              "label": "船員保険（疾病分）被扶養者数",
              "cat01": "J4403",
              "unit": "人",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J4404/件/j23/船員保険（疾病分）給付件数",
              "label": "船員保険（疾病分）給付件数",
              "cat01": "J4404",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J440401/件/j23/船員保険（疾病分）給付件数（被保険者）",
              "label": "船員保険（疾病分）給付件数（被保険者）",
              "cat01": "J440401",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J440402/件/j23/船員保険（疾病分）給付件数（被扶養者）",
              "label": "船員保険（疾病分）給付件数（被扶養者）",
              "cat01": "J440402",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J440410/件/j23/船員保険（疾病分）給付件数（診療費）",
              "label": "船員保険（疾病分）給付件数（診療費）",
              "cat01": "J440410",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J440411/件/j23/船員保険（疾病分）給付件数（診療費・被保険者）",
              "label": "船員保険（疾病分）給付件数（診療費・被保険者）",
              "cat01": "J440411",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J440412/件/j23/船員保険（疾病分）給付件数（診療費・被扶養者）",
              "label": "船員保険（疾病分）給付件数（診療費・被扶養者）",
              "cat01": "J440412",
              "unit": "件",
              "sourceId": "j23"
            },
            {
              "statId": "0000010110/J4405/千円/j24/船員保険（疾病分）給付金額",
              "label": "船員保険（疾病分）給付金額",
              "cat01": "J4405",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J440501/千円/j24/船員保険（疾病分）給付金額（被保険者）",
              "label": "船員保険（疾病分）給付金額（被保険者）",
              "cat01": "J440501",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J440502/千円/j24/船員保険（疾病分）給付金額（被扶養者）",
              "label": "船員保険（疾病分）給付金額（被扶養者）",
              "cat01": "J440502",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J440510/千円/j24/船員保険（疾病分）給付金額（診療費）",
              "label": "船員保険（疾病分）給付金額（診療費）",
              "cat01": "J440510",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J440511/千円/j24/船員保険（疾病分）給付金額（診療費・被保険者）",
              "label": "船員保険（疾病分）給付金額（診療費・被保険者）",
              "cat01": "J440511",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J440512/千円/j24/船員保険（疾病分）給付金額（診療費・被扶養者）",
              "label": "船員保険（疾病分）給付金額（診療費・被扶養者）",
              "cat01": "J440512",
              "unit": "千円",
              "sourceId": "j24"
            },
            {
              "statId": "0000010110/J4501/人/j25/後期高齢者医療被保険者数",
              "label": "後期高齢者医療被保険者数",
              "cat01": "J4501",
              "unit": "人",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J4502/件/j25/老人医療受給件数",
              "label": "老人医療受給件数",
              "cat01": "J4502",
              "unit": "件",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J450210/件/j25/老人医療受給件数（診療費）",
              "label": "老人医療受給件数（診療費）",
              "cat01": "J450210",
              "unit": "件",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J450220/‐/j25/老人医療受診率（１０００人当たり）",
              "label": "老人医療受診率（１０００人当たり）",
              "cat01": "J450220",
              "unit": "‐",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J4503/千円/j25/後期高齢者医療費",
              "label": "後期高齢者医療費",
              "cat01": "J4503",
              "unit": "千円",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J450310/千円/j25/老人医療費（診療費）",
              "label": "老人医療費（診療費）",
              "cat01": "J450310",
              "unit": "千円",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J450320/円/j25/１人当たり後期高齢者医療費",
              "label": "１人当たり後期高齢者医療費",
              "cat01": "J450320",
              "unit": "円",
              "sourceId": "j25"
            },
            {
              "statId": "0000010110/J5101/所/j26/厚生年金保険適用事業所数",
              "label": "厚生年金保険適用事業所数",
              "cat01": "J5101",
              "unit": "所",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5102/人/j26/厚生年金保険被保険者数",
              "label": "厚生年金保険被保険者数",
              "cat01": "J5102",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5103/人/j26/厚生年金保険受給権者数",
              "label": "厚生年金保険受給権者数",
              "cat01": "J5103",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510301/人/j26/厚生年金保険受給権者数（老齢年金）",
              "label": "厚生年金保険受給権者数（老齢年金）",
              "cat01": "J510301",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510302/人/j26/厚生年金保険受給権者数（通算老齢年金）",
              "label": "厚生年金保険受給権者数（通算老齢年金）",
              "cat01": "J510302",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510303/人/j26/厚生年金保険受給権者数（障害年金）",
              "label": "厚生年金保険受給権者数（障害年金）",
              "cat01": "J510303",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510304/人/j26/厚生年金保険受給権者数（遺族年金）",
              "label": "厚生年金保険受給権者数（遺族年金）",
              "cat01": "J510304",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510305/人/j26/厚生年金保険受給権者数（通算遺族年金）",
              "label": "厚生年金保険受給権者数（通算遺族年金）",
              "cat01": "J510305",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5104/千円/j26/厚生年金保険受給権者年金総額",
              "label": "厚生年金保険受給権者年金総額",
              "cat01": "J5104",
              "unit": "千円",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J510401/千円/j26/厚生年金保険受給権者年金総額（老齢年金）",
              "label": "厚生年金保険受給権者年金総額（老齢年金）",
              "cat01": "J510401",
              "unit": "千円",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5201/人/j26/国民年金被保険者数",
              "label": "国民年金被保険者数",
              "cat01": "J5201",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520101/人/j26/国民年金第１号被保険者数",
              "label": "国民年金第１号被保険者数",
              "cat01": "J520101",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520102/人/j26/国民年金第３号被保険者数",
              "label": "国民年金第３号被保険者数",
              "cat01": "J520102",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520111/％/j26/国民年金保険料全額免除割合",
              "label": "国民年金保険料全額免除割合",
              "cat01": "J520111",
              "unit": "％",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520112/％/j26/国民年金保険料申請一部免除割合",
              "label": "国民年金保険料申請一部免除割合",
              "cat01": "J520112",
              "unit": "％",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520120/％/j26/国民年金保険料納付率",
              "label": "国民年金保険料納付率",
              "cat01": "J520120",
              "unit": "％",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5202/人/j26/国民年金受給権者数",
              "label": "国民年金受給権者数",
              "cat01": "J5202",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520201/人/j26/国民年金受給権者数（老齢年金）",
              "label": "国民年金受給権者数（老齢年金）",
              "cat01": "J520201",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520202/人/j26/国民年金受給権者数（通算老齢年金）",
              "label": "国民年金受給権者数（通算老齢年金）",
              "cat01": "J520202",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520203/人/j26/国民年金受給権者数（障害年金）",
              "label": "国民年金受給権者数（障害年金）",
              "cat01": "J520203",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520204/人/j26/国民年金受給権者数（遺族年金）",
              "label": "国民年金受給権者数（遺族年金）",
              "cat01": "J520204",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5203/千円/j26/国民年金受給権者年金総額",
              "label": "国民年金受給権者年金総額",
              "cat01": "J5203",
              "unit": "千円",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J520301/千円/j26/国民年金受給権者年金総額（老齢年金）",
              "label": "国民年金受給権者年金総額（老齢年金）",
              "cat01": "J520301",
              "unit": "千円",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5301/人/j26/福祉年金受給者数",
              "label": "福祉年金受給者数",
              "cat01": "J5301",
              "unit": "人",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J5302/千円/j26/福祉年金支給年額",
              "label": "福祉年金支給年額",
              "cat01": "J5302",
              "unit": "千円",
              "sourceId": "j26"
            },
            {
              "statId": "0000010110/J6101/所/j27/雇用保険適用事業所数",
              "label": "雇用保険適用事業所数",
              "cat01": "J6101",
              "unit": "所",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6102/人/j27/雇用保険被保険者数",
              "label": "雇用保険被保険者数",
              "cat01": "J6102",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6103/円/j27/雇用保険求職者給付支給額",
              "label": "雇用保険求職者給付支給額",
              "cat01": "J6103",
              "unit": "円",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6104/円/j27/雇用保険基本手当支給額",
              "label": "雇用保険基本手当支給額",
              "cat01": "J6104",
              "unit": "円",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6105/人/j27/雇用保険基本手当受給者実人員",
              "label": "雇用保険基本手当受給者実人員",
              "cat01": "J6105",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6106/件/j27/雇用保険基本手当受給資格決定件数",
              "label": "雇用保険基本手当受給資格決定件数",
              "cat01": "J6106",
              "unit": "件",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6107/人/j27/雇用保険基本手当初回受給者数",
              "label": "雇用保険基本手当初回受給者数",
              "cat01": "J6107",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J610701/人/j27/雇用保険基本手当初回受給者数（４５歳以上）",
              "label": "雇用保険基本手当初回受給者数（４５歳以上）",
              "cat01": "J610701",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6109/人/j27/雇用保険（日雇）労働被保険者数",
              "label": "雇用保険（日雇）労働被保険者数",
              "cat01": "J6109",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6110/人/j27/雇用保険（日雇）受給者実人員",
              "label": "雇用保険（日雇）受給者実人員",
              "cat01": "J6110",
              "unit": "人",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6111/千円/j27/雇用保険（日雇）給付支給額",
              "label": "雇用保険（日雇）給付支給額",
              "cat01": "J6111",
              "unit": "千円",
              "sourceId": "j27"
            },
            {
              "statId": "0000010110/J6201/人/j28/船員保険（失業分）船舶所有者数",
              "label": "船員保険（失業分）船舶所有者数",
              "cat01": "J6201",
              "unit": "人",
              "sourceId": "j28"
            },
            {
              "statId": "0000010110/J6202/人/j28/船員保険（失業分）被保険者数",
              "label": "船員保険（失業分）被保険者数",
              "cat01": "J6202",
              "unit": "人",
              "sourceId": "j28"
            },
            {
              "statId": "0000010110/J6203/件/j28/船員保険（失業分）失業保険金給付件数",
              "label": "船員保険（失業分）失業保険金給付件数",
              "cat01": "J6203",
              "unit": "件",
              "sourceId": "j28"
            },
            {
              "statId": "0000010110/J6204/千円/j28/船員保険（失業分）失業保険金給付金額",
              "label": "船員保険（失業分）失業保険金給付金額",
              "cat01": "J6204",
              "unit": "千円",
              "sourceId": "j28"
            },
            {
              "statId": "0000010110/J6301/事業場/j29/労働者災害補償保険適用事業場数",
              "label": "労働者災害補償保険適用事業場数",
              "cat01": "J6301",
              "unit": "事業場",
              "sourceId": "j29"
            },
            {
              "statId": "0000010110/J6302/人/j29/労働者災害補償保険適用労働者数",
              "label": "労働者災害補償保険適用労働者数",
              "cat01": "J6302",
              "unit": "人",
              "sourceId": "j29"
            },
            {
              "statId": "0000010110/J6303/件/j29/労働者災害補償保険給付件数",
              "label": "労働者災害補償保険給付件数",
              "cat01": "J6303",
              "unit": "件",
              "sourceId": "j29"
            },
            {
              "statId": "0000010110/J6304/円/j29/労働者災害補償保険給付支給額",
              "label": "労働者災害補償保険給付支給額",
              "cat01": "J6304",
              "unit": "円",
              "sourceId": "j29"
            },
            {
              "statId": "0000010110/J7101/件/j30/介護給付（件数）",
              "label": "介護給付（件数）",
              "cat01": "J7101",
              "unit": "件",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710101/件/j30/居宅介護（支援）サービス介護給付（件数）",
              "label": "居宅介護（支援）サービス介護給付（件数）",
              "cat01": "J710101",
              "unit": "件",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710102/件/j30/施設介護サービス介護給付（件数）",
              "label": "施設介護サービス介護給付（件数）",
              "cat01": "J710102",
              "unit": "件",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J7102/千円/j30/介護給付（費用額）",
              "label": "介護給付（費用額）",
              "cat01": "J7102",
              "unit": "千円",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710201/千円/j30/居宅介護（支援）サービス介護給付（費用額）",
              "label": "居宅介護（支援）サービス介護給付（費用額）",
              "cat01": "J710201",
              "unit": "千円",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710202/千円/j30/施設介護サービス介護給付（費用額）",
              "label": "施設介護サービス介護給付（費用額）",
              "cat01": "J710202",
              "unit": "千円",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J7103/千円/j30/介護給付（支給額）",
              "label": "介護給付（支給額）",
              "cat01": "J7103",
              "unit": "千円",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710301/千円/j30/居宅介護（支援）サービス介護給付（支給額）",
              "label": "居宅介護（支援）サービス介護給付（支給額）",
              "cat01": "J710301",
              "unit": "千円",
              "sourceId": "j30"
            },
            {
              "statId": "0000010110/J710302/千円/j30/施設介護サービス介護給付（支給額）",
              "label": "施設介護サービス介護給付（支給額）",
              "cat01": "J710302",
              "unit": "千円",
              "sourceId": "j30"
            }
          ]
        },
        {
          "label": "Ｋ安全",
          "statId": "0000010111",
          "children": [
            {
              "statId": "0000010111/K1101/署/k01/消防本部・署数",
              "label": "消防本部・署数",
              "cat01": "K1101",
              "unit": "署",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1102/人/k01/消防職員数",
              "label": "消防職員数",
              "cat01": "K1102",
              "unit": "人",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1103/人/k01/消防吏員数",
              "label": "消防吏員数",
              "cat01": "K1103",
              "unit": "人",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1104/団/k01/消防団・分団数",
              "label": "消防団・分団数",
              "cat01": "K1104",
              "unit": "団",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K110401/団/k01/消防団数",
              "label": "消防団数",
              "cat01": "K110401",
              "unit": "団",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K110402/団/k01/消防分団数",
              "label": "消防分団数",
              "cat01": "K110402",
              "unit": "団",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1105/人/k01/消防団員数",
              "label": "消防団員数",
              "cat01": "K1105",
              "unit": "人",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1106/台/k01/消防ポンプ自動車等現有数",
              "label": "消防ポンプ自動車等現有数",
              "cat01": "K1106",
              "unit": "台",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1107/所/k01/消防水利数",
              "label": "消防水利数",
              "cat01": "K1107",
              "unit": "所",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1108/所/k01/消火栓数",
              "label": "消火栓数",
              "cat01": "K1108",
              "unit": "所",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1109/所/k01/防火水槽数",
              "label": "防火水槽数",
              "cat01": "K1109",
              "unit": "所",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1201/回/k01/消防機関出動回数",
              "label": "消防機関出動回数",
              "cat01": "K1201",
              "unit": "回",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K120201/回/k01/消防機関出動回数（火災）",
              "label": "消防機関出動回数（火災）",
              "cat01": "K120201",
              "unit": "回",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K120202/回/k01/消防機関出動回数（風水害）",
              "label": "消防機関出動回数（風水害）",
              "cat01": "K120202",
              "unit": "回",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1205/人/k01/消防機関出動延人員",
              "label": "消防機関出動延人員",
              "cat01": "K1205",
              "unit": "人",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K120601/人/k01/消防機関出動延人員（火災）",
              "label": "消防機関出動延人員（火災）",
              "cat01": "K120601",
              "unit": "人",
              "sourceId": "k01"
            },
            {
              "statId": "0000010111/K1209/台/k02/救急自動車数",
              "label": "救急自動車数",
              "cat01": "K1209",
              "unit": "台",
              "sourceId": "k02"
            },
            {
              "statId": "0000010111/K1210/回/k02/救急出動件数",
              "label": "救急出動件数",
              "cat01": "K1210",
              "unit": "回",
              "sourceId": "k02"
            },
            {
              "statId": "0000010111/K1214/回/k02/救急出場件数（転院搬送）",
              "label": "救急出場件数（転院搬送）",
              "cat01": "K1214",
              "unit": "回",
              "sourceId": "k02"
            },
            {
              "statId": "0000010111/K2101/件/k03/出火件数",
              "label": "出火件数",
              "cat01": "K2101",
              "unit": "件",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2102/件/k03/建物火災出火件数",
              "label": "建物火災出火件数",
              "cat01": "K2102",
              "unit": "件",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K210311/ｍ2/k03/建物焼損床面積",
              "label": "建物焼損床面積",
              "cat01": "K210311",
              "unit": "ｍ2",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2105/千円/k03/火災損害額",
              "label": "火災損害額",
              "cat01": "K2105",
              "unit": "千円",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2106/千円/k03/建物火災損害額",
              "label": "建物火災損害額",
              "cat01": "K2106",
              "unit": "千円",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2107/世帯/k03/火災り災世帯数",
              "label": "火災り災世帯数",
              "cat01": "K2107",
              "unit": "世帯",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2108/人/k03/火災り災人員数",
              "label": "火災り災人員数",
              "cat01": "K2108",
              "unit": "人",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2109/人/k03/火災死傷者数",
              "label": "火災死傷者数",
              "cat01": "K2109",
              "unit": "人",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2110/人/k03/火災死亡者数",
              "label": "火災死亡者数",
              "cat01": "K2110",
              "unit": "人",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2111/人/k03/火災負傷者数",
              "label": "火災負傷者数",
              "cat01": "K2111",
              "unit": "人",
              "sourceId": "k03"
            },
            {
              "statId": "0000010111/K2201/件/k04/火災保険新契約件数",
              "label": "火災保険新契約件数",
              "cat01": "K2201",
              "unit": "件",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2202/件/k04/火災保険住宅物件・一般物件新契約件数",
              "label": "火災保険住宅物件・一般物件新契約件数",
              "cat01": "K2202",
              "unit": "件",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2203/千円/k04/火災保険新契約保険金額",
              "label": "火災保険新契約保険金額",
              "cat01": "K2203",
              "unit": "千円",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2204/千円/k04/火災保険住宅物件・一般物件新契約保険金額",
              "label": "火災保険住宅物件・一般物件新契約保険金額",
              "cat01": "K2204",
              "unit": "千円",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2205/件/k04/火災保険保険金支払件数",
              "label": "火災保険保険金支払件数",
              "cat01": "K2205",
              "unit": "件",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2206/件/k04/火災保険住宅物件・一般物件保険金支払件数",
              "label": "火災保険住宅物件・一般物件保険金支払件数",
              "cat01": "K2206",
              "unit": "件",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2207/円/k04/火災保険保険金支払金額",
              "label": "火災保険保険金支払金額",
              "cat01": "K2207",
              "unit": "円",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K2208/円/k04/火災保険住宅物件・一般物件保険金支払金額",
              "label": "火災保険住宅物件・一般物件保険金支払金額",
              "cat01": "K2208",
              "unit": "円",
              "sourceId": "k04"
            },
            {
              "statId": "0000010111/K3101/件/k05/交通事故発生件数",
              "label": "交通事故発生件数",
              "cat01": "K3101",
              "unit": "件",
              "sourceId": "k05"
            },
            {
              "statId": "0000010111/K3102/人/k05/交通事故死傷者数",
              "label": "交通事故死傷者数",
              "cat01": "K3102",
              "unit": "人",
              "sourceId": "k05"
            },
            {
              "statId": "0000010111/K310201/人/k06/交通事故死傷者数（乳幼児：０～６歳）",
              "label": "交通事故死傷者数（乳幼児：０～６歳）",
              "cat01": "K310201",
              "unit": "人",
              "sourceId": "k06"
            },
            {
              "statId": "0000010111/K310202/人/k06/交通事故死傷者数（小学生：７～１２歳）",
              "label": "交通事故死傷者数（小学生：７～１２歳）",
              "cat01": "K310202",
              "unit": "人",
              "sourceId": "k06"
            },
            {
              "statId": "0000010111/K310203/人/k06/交通事故死傷者数（高齢者：６５歳以上）",
              "label": "交通事故死傷者数（高齢者：６５歳以上）",
              "cat01": "K310203",
              "unit": "人",
              "sourceId": "k06"
            },
            {
              "statId": "0000010111/K3103/人/k07/交通事故死者数",
              "label": "交通事故死者数",
              "cat01": "K3103",
              "unit": "人",
              "sourceId": "k07"
            },
            {
              "statId": "0000010111/K3104/人/k07/交通事故負傷者数",
              "label": "交通事故負傷者数",
              "cat01": "K3104",
              "unit": "人",
              "sourceId": "k07"
            },
            {
              "statId": "0000010111/K3201/箇所/k08/立体横断施設数",
              "label": "立体横断施設数",
              "cat01": "K3201",
              "unit": "箇所",
              "sourceId": "k08"
            },
            {
              "statId": "0000010111/K3301/台/k09/任意自動車保険契約台数",
              "label": "任意自動車保険契約台数",
              "cat01": "K3301",
              "unit": "台",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3302/千円/k09/任意自動車保険契約保険料",
              "label": "任意自動車保険契約保険料",
              "cat01": "K3302",
              "unit": "千円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3303/件/k09/任意自動車保険保険金支払件数",
              "label": "任意自動車保険保険金支払件数",
              "cat01": "K3303",
              "unit": "件",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3304/千円/k09/任意自動車保険保険金支払金額",
              "label": "任意自動車保険保険金支払金額",
              "cat01": "K3304",
              "unit": "千円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K330501/％/k09/任意自動車保険普及率（車両）",
              "label": "任意自動車保険普及率（車両）",
              "cat01": "K330501",
              "unit": "％",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K330502/％/k09/任意自動車保険普及率（対人）",
              "label": "任意自動車保険普及率（対人）",
              "cat01": "K330502",
              "unit": "％",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K330503/％/k09/任意自動車保険普及率（対物）",
              "label": "任意自動車保険普及率（対物）",
              "cat01": "K330503",
              "unit": "％",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K330504/％/k09/任意自動車保険普及率（搭乗者傷害）",
              "label": "任意自動車保険普及率（搭乗者傷害）",
              "cat01": "K330504",
              "unit": "％",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3401/台/k09/自動車損害賠償責任保険新契約台数",
              "label": "自動車損害賠償責任保険新契約台数",
              "cat01": "K3401",
              "unit": "台",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3402/台/k09/自動車損害賠償責任保険自家用乗用車新契約台数",
              "label": "自動車損害賠償責任保険自家用乗用車新契約台数",
              "cat01": "K3402",
              "unit": "台",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3403/円/k09/自動車損害賠償責任保険新契約保険料",
              "label": "自動車損害賠償責任保険新契約保険料",
              "cat01": "K3403",
              "unit": "円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3404/円/k09/自動車損害賠償責任保険自家用乗用車新契約保険料",
              "label": "自動車損害賠償責任保険自家用乗用車新契約保険料",
              "cat01": "K3404",
              "unit": "円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3405/件/k09/自動車損害賠償責任保険保険金支払件数",
              "label": "自動車損害賠償責任保険保険金支払件数",
              "cat01": "K3405",
              "unit": "件",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3406/件/k09/自動車損害賠償責任保険自家用乗用車保険金支払件数",
              "label": "自動車損害賠償責任保険自家用乗用車保険金支払件数",
              "cat01": "K3406",
              "unit": "件",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3407/円/k09/自動車損害賠償責任保険保険金支払金額",
              "label": "自動車損害賠償責任保険保険金支払金額",
              "cat01": "K3407",
              "unit": "円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3408/円/k09/自動車損害賠償責任保険自家用乗用車保険金支払金額",
              "label": "自動車損害賠償責任保険自家用乗用車保険金支払金額",
              "cat01": "K3408",
              "unit": "円",
              "sourceId": "k09"
            },
            {
              "statId": "0000010111/K3501/人/k10/運転免許保有者数（第一種免許　大型）",
              "label": "運転免許保有者数（第一種免許　大型）",
              "cat01": "K3501",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350101/人/k10/運転免許保有者数（第一種免許　大型　７５歳以上）",
              "label": "運転免許保有者数（第一種免許　大型　７５歳以上）",
              "cat01": "K350101",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3502/人/k10/運転免許保有者数（第一種免許　中型）",
              "label": "運転免許保有者数（第一種免許　中型）",
              "cat01": "K3502",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350201/人/k10/運転免許保有者数（第一種免許　中型　７５歳以上）",
              "label": "運転免許保有者数（第一種免許　中型　７５歳以上）",
              "cat01": "K350201",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3503/人/k10/運転免許保有者数（第一種免許　普通）",
              "label": "運転免許保有者数（第一種免許　普通）",
              "cat01": "K3503",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350301/人/k10/運転免許保有者数（第一種免許　普通　７５歳以上）",
              "label": "運転免許保有者数（第一種免許　普通　７５歳以上）",
              "cat01": "K350301",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3504/人/k10/高齢者講習受講者数（７０～７４歳講習受講者）",
              "label": "高齢者講習受講者数（７０～７４歳講習受講者）",
              "cat01": "K3504",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3505/人/k10/高齢者講習受講者数（７５歳以上講習受講者）",
              "label": "高齢者講習受講者数（７５歳以上講習受講者）",
              "cat01": "K3505",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3506/人/k10/運転免許保有者数（第一種免許　中型　車両総重量11t未満）",
              "label": "運転免許保有者数（第一種免許　中型　車両総重量11t未満）",
              "cat01": "K3506",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350601/人/k10/運転免許保有者数（第一種免許　中型　車両総重量11t未満　75歳以上）",
              "label": "運転免許保有者数（第一種免許　中型　車両総重量11t未満　75歳以上）",
              "cat01": "K350601",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3507/人/k10/運転免許保有者数（第一種免許　準中型　車両総重量7.5t未満）",
              "label": "運転免許保有者数（第一種免許　準中型　車両総重量7.5t未満）",
              "cat01": "K3507",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350701/人/k10/運転免許保有者数（第一種免許　準中型　車両総重量7.5t未満　75歳以上）",
              "label": "運転免許保有者数（第一種免許　準中型　車両総重量7.5t未満　75歳以上）",
              "cat01": "K350701",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K3508/人/k10/運転免許保有者数（第一種免許　普通　車両総重量3.5t未満）",
              "label": "運転免許保有者数（第一種免許　普通　車両総重量3.5t未満）",
              "cat01": "K3508",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K350801/人/k10/運転免許保有者数（第一種免許　普通　車両総重量3.5t未満　75歳以上）",
              "label": "運転免許保有者数（第一種免許　普通　車両総重量3.5t未満　75歳以上）",
              "cat01": "K350801",
              "unit": "人",
              "sourceId": "k10"
            },
            {
              "statId": "0000010111/K4102/人/k11/警察官数",
              "label": "警察官数",
              "cat01": "K4102",
              "unit": "人",
              "sourceId": "k11"
            },
            {
              "statId": "0000010111/K4201/件/k12/刑法犯認知件数",
              "label": "刑法犯認知件数",
              "cat01": "K4201",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420101/件/k12/凶悪犯認知件数",
              "label": "凶悪犯認知件数",
              "cat01": "K420101",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420102/件/k12/粗暴犯認知件数",
              "label": "粗暴犯認知件数",
              "cat01": "K420102",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420103/件/k12/窃盗犯認知件数",
              "label": "窃盗犯認知件数",
              "cat01": "K420103",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420104/件/k12/知能犯認知件数",
              "label": "知能犯認知件数",
              "cat01": "K420104",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420105/件/k12/風俗犯認知件数",
              "label": "風俗犯認知件数",
              "cat01": "K420105",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4202/件/k12/刑法犯検挙件数",
              "label": "刑法犯検挙件数",
              "cat01": "K4202",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420201/件/k12/凶悪犯検挙件数",
              "label": "凶悪犯検挙件数",
              "cat01": "K420201",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420202/件/k12/粗暴犯検挙件数",
              "label": "粗暴犯検挙件数",
              "cat01": "K420202",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420203/件/k12/窃盗犯検挙件数",
              "label": "窃盗犯検挙件数",
              "cat01": "K420203",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420204/件/k12/知能犯検挙件数",
              "label": "知能犯検挙件数",
              "cat01": "K420204",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420205/件/k12/風俗犯検挙件数",
              "label": "風俗犯検挙件数",
              "cat01": "K420205",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4203/人/k12/刑法犯検挙人員",
              "label": "刑法犯検挙人員",
              "cat01": "K4203",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420301/人/k12/凶悪犯検挙人員",
              "label": "凶悪犯検挙人員",
              "cat01": "K420301",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420302/人/k12/粗暴犯検挙人員",
              "label": "粗暴犯検挙人員",
              "cat01": "K420302",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420303/人/k12/窃盗犯検挙人員",
              "label": "窃盗犯検挙人員",
              "cat01": "K420303",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420304/人/k12/知能犯検挙人員",
              "label": "知能犯検挙人員",
              "cat01": "K420304",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420305/人/k12/風俗犯検挙人員",
              "label": "風俗犯検挙人員",
              "cat01": "K420305",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4204/人/k12/少年刑法犯検挙人員",
              "label": "少年刑法犯検挙人員",
              "cat01": "K4204",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420401/人/k12/少年凶悪犯検挙人員",
              "label": "少年凶悪犯検挙人員",
              "cat01": "K420401",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420402/人/k12/少年粗暴犯検挙人員",
              "label": "少年粗暴犯検挙人員",
              "cat01": "K420402",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420403/人/k12/少年窃盗犯検挙人員",
              "label": "少年窃盗犯検挙人員",
              "cat01": "K420403",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420404/人/k12/少年知能犯検挙人員",
              "label": "少年知能犯検挙人員",
              "cat01": "K420404",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K420405/人/k12/少年風俗犯検挙人員",
              "label": "少年風俗犯検挙人員",
              "cat01": "K420405",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4301/件/k12/特別法犯送致件数",
              "label": "特別法犯送致件数",
              "cat01": "K4301",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4302/人/k12/特別法犯送致人員",
              "label": "特別法犯送致人員",
              "cat01": "K4302",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4303/件/k12/覚せい剤取締送致件数",
              "label": "覚せい剤取締送致件数",
              "cat01": "K4303",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4304/人/k12/覚せい剤取締送致人員",
              "label": "覚せい剤取締送致人員",
              "cat01": "K4304",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4305/件/k12/売春事犯の送致件数",
              "label": "売春事犯の送致件数",
              "cat01": "K4305",
              "unit": "件",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4306/人/k12/売春事犯の送致人員",
              "label": "売春事犯の送致人員",
              "cat01": "K4306",
              "unit": "人",
              "sourceId": "k12"
            },
            {
              "statId": "0000010111/K4401/件/k13/道路交通法違反検挙総件数（告知・送致）",
              "label": "道路交通法違反検挙総件数（告知・送致）",
              "cat01": "K4401",
              "unit": "件",
              "sourceId": "k13"
            },
            {
              "statId": "0000010111/K4402/件/k13/交通事故事件件数",
              "label": "交通事故事件件数",
              "cat01": "K4402",
              "unit": "件",
              "sourceId": "k13"
            },
            {
              "statId": "0000010111/K4403/件/k13/交通事故事件少年件数",
              "label": "交通事故事件少年件数",
              "cat01": "K4403",
              "unit": "件",
              "sourceId": "k13"
            },
            {
              "statId": "0000010111/K4404/人/k13/交通事故事件人員",
              "label": "交通事故事件人員",
              "cat01": "K4404",
              "unit": "人",
              "sourceId": "k13"
            },
            {
              "statId": "0000010111/K4501/人/k14/触法少年補導人員",
              "label": "触法少年補導人員",
              "cat01": "K4501",
              "unit": "人",
              "sourceId": "k14"
            },
            {
              "statId": "0000010111/K4502/人/k15/少年保護事件新受人員",
              "label": "少年保護事件新受人員",
              "cat01": "K4502",
              "unit": "人",
              "sourceId": "k15"
            },
            {
              "statId": "0000010111/K4701/件/k16/民事事件件数",
              "label": "民事事件件数",
              "cat01": "K4701",
              "unit": "件",
              "sourceId": "k16"
            },
            {
              "statId": "0000010111/K4702/件/k16/行政事件件数",
              "label": "行政事件件数",
              "cat01": "K4702",
              "unit": "件",
              "sourceId": "k16"
            },
            {
              "statId": "0000010111/K4703/件/k17/家事事件件数（総数）",
              "label": "家事事件件数（総数）",
              "cat01": "K4703",
              "unit": "件",
              "sourceId": "k17"
            },
            {
              "statId": "0000010111/K470301/件/k17/家事事件件数（調停）",
              "label": "家事事件件数（調停）",
              "cat01": "K470301",
              "unit": "件",
              "sourceId": "k17"
            },
            {
              "statId": "0000010111/K4801/件/k18/出入国管理及び難民認定法の送致件数",
              "label": "出入国管理及び難民認定法の送致件数",
              "cat01": "K4801",
              "unit": "件",
              "sourceId": "k18"
            },
            {
              "statId": "0000010111/K4802/人/k18/出入国管理及び難民認定法の送致人員",
              "label": "出入国管理及び難民認定法の送致人員",
              "cat01": "K4802",
              "unit": "人",
              "sourceId": "k18"
            },
            {
              "statId": "0000010111/K4803/人/k18/外国人被疑事件受理人員",
              "label": "外国人被疑事件受理人員",
              "cat01": "K4803",
              "unit": "人",
              "sourceId": "k18"
            },
            {
              "statId": "0000010111/K480301/人/k18/外国人被疑事件既済人員",
              "label": "外国人被疑事件既済人員",
              "cat01": "K480301",
              "unit": "人",
              "sourceId": "k18"
            },
            {
              "statId": "0000010111/K480302/人/k18/外国人被疑事件未済人員",
              "label": "外国人被疑事件未済人員",
              "cat01": "K480302",
              "unit": "人",
              "sourceId": "k18"
            },
            {
              "statId": "0000010111/K5112/百万円/k19/災害被害額",
              "label": "災害被害額",
              "cat01": "K5112",
              "unit": "百万円",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K5113/戸/k19/建物被害床上浸水",
              "label": "建物被害床上浸水",
              "cat01": "K5113",
              "unit": "戸",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K5114/戸/k19/建物被害床下浸水",
              "label": "建物被害床下浸水",
              "cat01": "K5114",
              "unit": "戸",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K5115/世帯/k19/自然災害によるり災世帯数",
              "label": "自然災害によるり災世帯数",
              "cat01": "K5115",
              "unit": "世帯",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K5116/人/k19/自然災害によるり災者数",
              "label": "自然災害によるり災者数",
              "cat01": "K5116",
              "unit": "人",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K5117/箇所/k19/橋りょう流失箇所数",
              "label": "橋りょう流失箇所数",
              "cat01": "K5117",
              "unit": "箇所",
              "sourceId": "k19"
            },
            {
              "statId": "0000010111/K6101/件/k20/公害苦情受付件数",
              "label": "公害苦情受付件数",
              "cat01": "K6101",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610101/件/k20/公害苦情新規受付件数",
              "label": "公害苦情新規受付件数",
              "cat01": "K610101",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610102/件/k20/公害苦情前年度繰越受付件数",
              "label": "公害苦情前年度繰越受付件数",
              "cat01": "K610102",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K6102/件/k20/公害苦情処理件数",
              "label": "公害苦情処理件数",
              "cat01": "K6102",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610201/件/k20/公害苦情直接処理件数",
              "label": "公害苦情直接処理件数",
              "cat01": "K610201",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610202/件/k20/公害苦情翌年度繰越処理件数",
              "label": "公害苦情翌年度繰越処理件数",
              "cat01": "K610202",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K6103/件/k20/公害苦情件数（典型７公害）",
              "label": "公害苦情件数（典型７公害）",
              "cat01": "K6103",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610301/件/k20/公害苦情件数（大気汚染）",
              "label": "公害苦情件数（大気汚染）",
              "cat01": "K610301",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610302/件/k20/公害苦情件数（水質汚濁）",
              "label": "公害苦情件数（水質汚濁）",
              "cat01": "K610302",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610303/件/k20/公害苦情件数（土壌汚染）",
              "label": "公害苦情件数（土壌汚染）",
              "cat01": "K610303",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610304/件/k20/公害苦情件数（騒音）",
              "label": "公害苦情件数（騒音）",
              "cat01": "K610304",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610305/件/k20/公害苦情件数（振動）",
              "label": "公害苦情件数（振動）",
              "cat01": "K610305",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610306/件/k20/公害苦情件数（地盤沈下）",
              "label": "公害苦情件数（地盤沈下）",
              "cat01": "K610306",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610307/件/k20/公害苦情件数（悪臭）",
              "label": "公害苦情件数（悪臭）",
              "cat01": "K610307",
              "unit": "件",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K6104/人/k20/公害苦情処理担当職員数",
              "label": "公害苦情処理担当職員数",
              "cat01": "K6104",
              "unit": "人",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610420/人/k20/その他の公害苦情処理担当職員数",
              "label": "その他の公害苦情処理担当職員数",
              "cat01": "K610420",
              "unit": "人",
              "sourceId": "k20"
            },
            {
              "statId": "0000010111/K610501/施設/k21/ばい煙発生施設数",
              "label": "ばい煙発生施設数",
              "cat01": "K610501",
              "unit": "施設",
              "sourceId": "k21"
            },
            {
              "statId": "0000010111/K610502/施設/k21/一般粉じん発生施設数",
              "label": "一般粉じん発生施設数",
              "cat01": "K610502",
              "unit": "施設",
              "sourceId": "k21"
            },
            {
              "statId": "0000010111/K610503/施設/k21/特定粉じん発生施設数",
              "label": "特定粉じん発生施設数",
              "cat01": "K610503",
              "unit": "施設",
              "sourceId": "k21"
            },
            {
              "statId": "0000010111/K6106/所/k22/水質汚濁防止法上の特定事業場数",
              "label": "水質汚濁防止法上の特定事業場数",
              "cat01": "K6106",
              "unit": "所",
              "sourceId": "k22"
            },
            {
              "statId": "0000010111/K6107/tCO2/k23/温室効果ガス算定排出量（実数）",
              "label": "温室効果ガス算定排出量（実数）",
              "cat01": "K6107",
              "unit": "tCO2",
              "sourceId": "k23"
            },
            {
              "statId": "0000010111/K6108/％/k23/温室効果ガス算定排出量（率）",
              "label": "温室効果ガス算定排出量（率）",
              "cat01": "K6108",
              "unit": "％",
              "sourceId": "k23"
            },
            {
              "statId": "0000010111/K7102/件/k24/民間生命保険新契約件数（個人契約分）",
              "label": "民間生命保険新契約件数（個人契約分）",
              "cat01": "K7102",
              "unit": "件",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7104/千円/k24/民間生命保険新契約保険金額（個人契約分）",
              "label": "民間生命保険新契約保険金額（個人契約分）",
              "cat01": "K7104",
              "unit": "千円",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7105/件/k24/民間生命保険保有契約件数",
              "label": "民間生命保険保有契約件数",
              "cat01": "K7105",
              "unit": "件",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7106/件/k24/民間生命保険保有契約件数（個人契約分）",
              "label": "民間生命保険保有契約件数（個人契約分）",
              "cat01": "K7106",
              "unit": "件",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7107/千円/k24/民間生命保険保有契約保険金額",
              "label": "民間生命保険保有契約保険金額",
              "cat01": "K7107",
              "unit": "千円",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7108/千円/k24/民間生命保険保有契約保険金額（個人契約分）",
              "label": "民間生命保険保有契約保険金額（個人契約分）",
              "cat01": "K7108",
              "unit": "千円",
              "sourceId": "k24"
            },
            {
              "statId": "0000010111/K7201/件/k25/簡易生命保険新契約件数",
              "label": "簡易生命保険新契約件数",
              "cat01": "K7201",
              "unit": "件",
              "sourceId": "k25"
            },
            {
              "statId": "0000010111/K7203/件/k25/簡易生命保険保有契約件数",
              "label": "簡易生命保険保有契約件数",
              "cat01": "K7203",
              "unit": "件",
              "sourceId": "k25"
            },
            {
              "statId": "0000010111/K7204/千円/k25/簡易生命保険保有契約保険金額",
              "label": "簡易生命保険保有契約保険金額",
              "cat01": "K7204",
              "unit": "千円",
              "sourceId": "k25"
            },
            {
              "statId": "0000010111/K8101/団体/k26/防犯ボランティア団体数",
              "label": "防犯ボランティア団体数",
              "cat01": "K8101",
              "unit": "団体",
              "sourceId": "k26"
            },
            {
              "statId": "0000010111/K8102/人/k26/防犯ボランティア構成員数",
              "label": "防犯ボランティア構成員数",
              "cat01": "K8102",
              "unit": "人",
              "sourceId": "k26"
            }
          ]
        },
        {
          "label": "Ｌ家計",
          "statId": "0000010112",
          "children": [
            {
              "statId": "0000010112/L2100/千円/l01/農家総所得",
              "label": "農家総所得",
              "cat01": "L2100",
              "unit": "千円",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L210101/千円/l01/農業所得",
              "label": "農業所得",
              "cat01": "L210101",
              "unit": "千円",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L210102/千円/l01/農外所得",
              "label": "農外所得",
              "cat01": "L210102",
              "unit": "千円",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L2103/千円/l01/農家収入（可処分所得）",
              "label": "農家収入（可処分所得）",
              "cat01": "L2103",
              "unit": "千円",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L2201/千円/l01/農家支出（家計費）",
              "label": "農家支出（家計費）",
              "cat01": "L2201",
              "unit": "千円",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L2203/％/l01/農家支出（平均消費性向）",
              "label": "農家支出（平均消費性向）",
              "cat01": "L2203",
              "unit": "％",
              "sourceId": "l01"
            },
            {
              "statId": "0000010112/L3110/円/l02/実収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "実収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3110",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3111/円/l02/経常収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "経常収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3111",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L311101/円/l02/勤め先収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "勤め先収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L311101",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3111011/円/l02/世帯主収入（二人以上の世帯のうち勤労者世帯）",
              "label": "世帯主収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3111011",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3111012/円/l02/世帯主の配偶者の収入（二人以上の世帯のうち勤労者世帯）",
              "label": "世帯主の配偶者の収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3111012",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3111013/円/l02/他の世帯員収入（二人以上の世帯のうち勤労者世帯）",
              "label": "他の世帯員収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3111013",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L311102/円/l02/事業・内職収入（二人以上の世帯のうち勤労者世帯）",
              "label": "事業・内職収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L311102",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L311103/円/l02/他の経常収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "他の経常収入（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L311103",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3112/円/l02/特別収入（二人以上の世帯のうち勤労者世帯）",
              "label": "特別収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3112",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3120/円/l02/実収入以外の受取（二人以上の世帯のうち勤労者世帯）",
              "label": "実収入以外の受取（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3120",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3121/円/l02/預貯金引出（二人以上の世帯のうち勤労者世帯）",
              "label": "預貯金引出（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3121",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3122/円/l02/保険金（二人以上の世帯のうち勤労者世帯）",
              "label": "保険金（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3122",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3123/円/l02/土地家屋借入金（二人以上の世帯のうち勤労者世帯）",
              "label": "土地家屋借入金（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3123",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3124/円/l02/分割払購入借入金と一括払購入借入金（二人以上の世帯のうち勤労者世帯）",
              "label": "分割払購入借入金と一括払購入借入金（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3124",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3130/円/l02/可処分所得（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "可処分所得（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3130",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3201/円/l02/消費支出（全世帯）",
              "label": "消費支出（全世帯）",
              "cat01": "L3201",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320101/円/l02/食料費（全世帯）",
              "label": "食料費（全世帯）",
              "cat01": "L320101",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320102/円/l02/住居費（全世帯）",
              "label": "住居費（全世帯）",
              "cat01": "L320102",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320103/円/l02/光熱・水道費（全世帯）",
              "label": "光熱・水道費（全世帯）",
              "cat01": "L320103",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320104/円/l02/家具・家事用品費（全世帯）",
              "label": "家具・家事用品費（全世帯）",
              "cat01": "L320104",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320105/円/l02/被服及び履物費（全世帯）",
              "label": "被服及び履物費（全世帯）",
              "cat01": "L320105",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320106/円/l02/保健医療費（全世帯）",
              "label": "保健医療費（全世帯）",
              "cat01": "L320106",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320107/円/l02/交通・通信費（全世帯）",
              "label": "交通・通信費（全世帯）",
              "cat01": "L320107",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320108/円/l02/教育費（全世帯）",
              "label": "教育費（全世帯）",
              "cat01": "L320108",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320109/円/l02/教養娯楽費（全世帯）",
              "label": "教養娯楽費（全世帯）",
              "cat01": "L320109",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3201091/円/l02/教養娯楽用品費（全世帯）",
              "label": "教養娯楽用品費（全世帯）",
              "cat01": "L3201091",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3201092/円/l02/書籍・他の印刷物費（全世帯）",
              "label": "書籍・他の印刷物費（全世帯）",
              "cat01": "L3201092",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3201093/円/l02/教養娯楽サービス費（全世帯）",
              "label": "教養娯楽サービス費（全世帯）",
              "cat01": "L3201093",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L320110/円/l02/その他の消費支出（全世帯）",
              "label": "その他の消費支出（全世帯）",
              "cat01": "L320110",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3210/円/l02/実支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "実支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3210",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3211/円/l02/消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3211",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321101/円/l02/食料費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "食料費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321101",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321102/円/l02/住居費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "住居費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321102",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321103/円/l02/光熱・水道費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "光熱・水道費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321103",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321104/円/l02/家具・家事用品費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "家具・家事用品費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321104",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321105/円/l02/被服及び履物費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "被服及び履物費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321105",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321106/円/l02/保健医療費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "保健医療費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321106",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321107/円/l02/交通・通信費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "交通・通信費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321107",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321108/円/l02/教育費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "教育費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321108",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321109/円/l02/教養娯楽費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "教養娯楽費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321109",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3211091/円/l02/教養娯楽用品費（二人以上の世帯のうち勤労者世帯）",
              "label": "教養娯楽用品費（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3211091",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3211092/円/l02/書籍・他の印刷物費（二人以上の世帯のうち勤労者世帯）",
              "label": "書籍・他の印刷物費（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3211092",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3211093/円/l02/教養娯楽サービス費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "教養娯楽サービス費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3211093",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321110/円/l02/その他の消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "その他の消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321110",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321121/円/l02/教育関係費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "教育関係費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321121",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321122/円/l02/教養娯楽関係費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "教養娯楽関係費（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L321122",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3212/円/l02/非消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "label": "非消費支出（二人以上の世帯のうち勤労者世帯）（家計調査結果）",
              "cat01": "L3212",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3213/円/l02/実支出以外の支出（二人以上の世帯のうち勤労者世帯）",
              "label": "実支出以外の支出（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L3213",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321301/円/l02/預貯金（二人以上の世帯のうち勤労者世帯）",
              "label": "預貯金（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L321301",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321302/円/l02/保険料（二人以上の世帯のうち勤労者世帯）",
              "label": "保険料（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L321302",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321303/円/l02/土地家屋借金返済（二人以上の世帯のうち勤労者世帯）",
              "label": "土地家屋借金返済（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L321303",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L321304/円/l02/分割払購入借入金返済と一括払購入借入金返済（二人以上の世帯のうち勤労者世帯）",
              "label": "分割払購入借入金返済と一括払購入借入金返済（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L321304",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3221/円/l02/消費支出（二人以上の世帯）（家計調査結果）",
              "label": "消費支出（二人以上の世帯）（家計調査結果）",
              "cat01": "L3221",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322101/円/l02/食料費（二人以上の世帯）（家計調査結果）",
              "label": "食料費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322101",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322102/円/l02/住居費（二人以上の世帯）",
              "label": "住居費（二人以上の世帯）",
              "cat01": "L322102",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322103/円/l02/光熱・水道費（二人以上の世帯）（家計調査結果）",
              "label": "光熱・水道費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322103",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322104/円/l02/家具・家事用品費（二人以上の世帯）（家計調査結果）",
              "label": "家具・家事用品費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322104",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322105/円/l02/被服及び履物費（二人以上の世帯）（家計調査結果）",
              "label": "被服及び履物費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322105",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322106/円/l02/保健医療費（二人以上の世帯）（家計調査結果）",
              "label": "保健医療費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322106",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322107/円/l02/交通・通信費（二人以上の世帯）（家計調査結果）",
              "label": "交通・通信費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322107",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322108/円/l02/教育費（二人以上の世帯）（家計調査結果）",
              "label": "教育費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322108",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322109/円/l02/教養娯楽費（二人以上の世帯）（家計調査結果）",
              "label": "教養娯楽費（二人以上の世帯）（家計調査結果）",
              "cat01": "L322109",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3221091/円/l02/教養娯楽用品（二人以上の世帯）",
              "label": "教養娯楽用品（二人以上の世帯）",
              "cat01": "L3221091",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3221092/円/l02/書籍・他の印刷物（二人以上の世帯）",
              "label": "書籍・他の印刷物（二人以上の世帯）",
              "cat01": "L3221092",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L3221093/円/l02/教養娯楽サービス費（二人以上の世帯）（家計調査結果）",
              "label": "教養娯楽サービス費（二人以上の世帯）（家計調査結果）",
              "cat01": "L3221093",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L322110/円/l02/その他の消費支出（二人以上の世帯）（家計調査結果）",
              "label": "その他の消費支出（二人以上の世帯）（家計調査結果）",
              "cat01": "L322110",
              "unit": "円",
              "sourceId": "l02"
            },
            {
              "statId": "0000010112/L4110/円/l03/実収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "実収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4110",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4111/円/l03/経常収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "経常収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4111",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L411101/円/l03/勤め先収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "勤め先収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L411101",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4111011/円/l03/世帯主の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "label": "世帯主の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L4111011",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4111012/円/l03/世帯主の配偶者の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "label": "世帯主の配偶者の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L4111012",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4111013/円/l03/他の世帯員の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "label": "他の世帯員の勤め先収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L4111013",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L411102/円/l03/本業以外の勤め先・事業・内職収入（二人以上の世帯のうち勤労者世帯）",
              "label": "本業以外の勤め先・事業・内職収入（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L411102",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L411103/円/l03/他の経常収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "他の経常収入（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L411103",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4130/円/l03/可処分所得（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "可処分所得（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4130",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4201/円/l03/消費支出（二人以上の世帯）（全国消費実態調査結果）",
              "label": "消費支出（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L4201",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420101/円/l03/食料費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "食料費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420101",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420102/円/l03/住居費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "住居費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420102",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420103/円/l03/光熱・水道費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "光熱・水道費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420103",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420104/円/l03/家具・家事用品費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "家具・家事用品費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420104",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420105/円/l03/被服及び履物費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "被服及び履物費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420105",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420106/円/l03/保健医療費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "保健医療費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420106",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420107/円/l03/交通・通信費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "交通・通信費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420107",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420108/円/l03/教育費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "教育費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420108",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420109/円/l03/教養娯楽費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "教養娯楽費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420109",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4201091/円/l03/教養娯楽サービス費（二人以上の世帯）（全国消費実態調査結果）",
              "label": "教養娯楽サービス費（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L4201091",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420110/円/l03/その他の消費支出（二人以上の世帯）（全国消費実態調査結果）",
              "label": "その他の消費支出（二人以上の世帯）（全国消費実態調査結果）",
              "cat01": "L420110",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420121/円/l03/教育関係費（二人以上の世帯）",
              "label": "教育関係費（二人以上の世帯）",
              "cat01": "L420121",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L420122/円/l03/教養娯楽関係費（二人以上の世帯）",
              "label": "教養娯楽関係費（二人以上の世帯）",
              "cat01": "L420122",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4210/円/l03/実支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "実支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4210",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4211/円/l03/消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4211",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421101/円/l03/食料費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "食料費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421101",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421102/円/l03/住居費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "住居費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421102",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421103/円/l03/光熱・水道費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "光熱・水道費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421103",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421104/円/l03/家具・家事用品費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "家具・家事用品費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421104",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421105/円/l03/被服及び履物費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "被服及び履物費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421105",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421106/円/l03/保健医療費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "保健医療費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421106",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421107/円/l03/交通・通信費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "交通・通信費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421107",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421108/円/l03/教育費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "教育費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421108",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421109/円/l03/教養娯楽費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "教養娯楽費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421109",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4211091/円/l03/教養娯楽サービス費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "教養娯楽サービス費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4211091",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421110/円/l03/その他の消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "その他の消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421110",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421121/円/l03/教育関係費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "教育関係費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421121",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L421122/円/l03/教養娯楽関係費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "教養娯楽関係費（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L421122",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4212/円/l03/非消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "label": "非消費支出（二人以上の世帯のうち勤労者世帯）（全国消費実態調査結果）",
              "cat01": "L4212",
              "unit": "円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430101/千円/l03/貯蓄現在高（二人以上の世帯）",
              "label": "貯蓄現在高（二人以上の世帯）",
              "cat01": "L430101",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430102/千円/l03/預貯金（通貨性＋定期性）（二人以上の世帯）",
              "label": "預貯金（通貨性＋定期性）（二人以上の世帯）",
              "cat01": "L430102",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430103/千円/l03/生命保険など（二人以上の世帯）",
              "label": "生命保険など（二人以上の世帯）",
              "cat01": "L430103",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430104/千円/l03/有価証券（二人以上の世帯）",
              "label": "有価証券（二人以上の世帯）",
              "cat01": "L430104",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430201/千円/l03/貯蓄現在高（二人以上の世帯のうち勤労者世帯）",
              "label": "貯蓄現在高（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L430201",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430202/千円/l03/預貯金（通貨性＋定期性）（二人以上の世帯のうち勤労者世帯）",
              "label": "預貯金（通貨性＋定期性）（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L430202",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430203/千円/l03/生命保険（二人以上の世帯のうち勤労者世帯）",
              "label": "生命保険（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L430203",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L430204/千円/l03/有価証券（二人以上の世帯のうち勤労者世帯）",
              "label": "有価証券（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L430204",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L440101/千円/l03/負債現在高（二人以上の世帯）",
              "label": "負債現在高（二人以上の世帯）",
              "cat01": "L440101",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L440102/千円/l03/住宅・土地のための負債（二人以上の世帯）",
              "label": "住宅・土地のための負債（二人以上の世帯）",
              "cat01": "L440102",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L440201/千円/l03/負債現在高（二人以上の世帯のうち勤労者世帯）",
              "label": "負債現在高（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L440201",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L440202/千円/l03/住宅・土地のための負債（二人以上の世帯のうち勤労者世帯）",
              "label": "住宅・土地のための負債（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L440202",
              "unit": "千円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450101/万円/l03/年間収入平均（全世帯）",
              "label": "年間収入平均（全世帯）",
              "cat01": "L450101",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450102/万円/l03/Ｉ・ＩＩ十分位階級（全世帯）",
              "label": "Ｉ・ＩＩ十分位階級（全世帯）",
              "cat01": "L450102",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450103/万円/l03/ＩＩ・ＩＩＩ十分位階級（全世帯）",
              "label": "ＩＩ・ＩＩＩ十分位階級（全世帯）",
              "cat01": "L450103",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450104/万円/l03/ＩＩＩ・ＩＶ十分位階級（全世帯）",
              "label": "ＩＩＩ・ＩＶ十分位階級（全世帯）",
              "cat01": "L450104",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450105/万円/l03/ＩＶ・Ｖ十分位階級（全世帯）",
              "label": "ＩＶ・Ｖ十分位階級（全世帯）",
              "cat01": "L450105",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450106/万円/l03/Ｖ・ＶＩ十分位階級（全世帯）",
              "label": "Ｖ・ＶＩ十分位階級（全世帯）",
              "cat01": "L450106",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450107/万円/l03/ＶＩ・ＶＩＩ十分位階級（全世帯）",
              "label": "ＶＩ・ＶＩＩ十分位階級（全世帯）",
              "cat01": "L450107",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450108/万円/l03/ＶＩＩ・ＶＩＩＩ十分位階級（全世帯）",
              "label": "ＶＩＩ・ＶＩＩＩ十分位階級（全世帯）",
              "cat01": "L450108",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450109/万円/l03/ＶＩＩＩ・ＩＸ十分位階級（全世帯）",
              "label": "ＶＩＩＩ・ＩＸ十分位階級（全世帯）",
              "cat01": "L450109",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450110/万円/l03/ＩＸ・Ｘ十分位階級（全世帯）",
              "label": "ＩＸ・Ｘ十分位階級（全世帯）",
              "cat01": "L450110",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450201/万円/l03/年間収入平均（勤労者世帯）",
              "label": "年間収入平均（勤労者世帯）",
              "cat01": "L450201",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450202/万円/l03/Ｉ・ＩＩ十分位階級（勤労者世帯）",
              "label": "Ｉ・ＩＩ十分位階級（勤労者世帯）",
              "cat01": "L450202",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450203/万円/l03/ＩＩ・ＩＩＩ十分位階級（勤労者世帯）",
              "label": "ＩＩ・ＩＩＩ十分位階級（勤労者世帯）",
              "cat01": "L450203",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450204/万円/l03/ＩＩＩ・ＩＶ十分位階級（勤労者世帯）",
              "label": "ＩＩＩ・ＩＶ十分位階級（勤労者世帯）",
              "cat01": "L450204",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450205/万円/l03/ＩＶ・Ｖ十分位階級（勤労者世帯）",
              "label": "ＩＶ・Ｖ十分位階級（勤労者世帯）",
              "cat01": "L450205",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450206/万円/l03/Ｖ・ＶＩ十分位階級（勤労者世帯）",
              "label": "Ｖ・ＶＩ十分位階級（勤労者世帯）",
              "cat01": "L450206",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450207/万円/l03/ＶＩ・ＶＩＩ十分位階級（勤労者世帯）",
              "label": "ＶＩ・ＶＩＩ十分位階級（勤労者世帯）",
              "cat01": "L450207",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450208/万円/l03/ＶＩＩ・ＶＩＩＩ十分位階級（勤労者世帯）",
              "label": "ＶＩＩ・ＶＩＩＩ十分位階級（勤労者世帯）",
              "cat01": "L450208",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450209/万円/l03/ＶＩＩＩ・ＩＸ十分位階級（勤労者世帯）",
              "label": "ＶＩＩＩ・ＩＸ十分位階級（勤労者世帯）",
              "cat01": "L450209",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L450210/万円/l03/ＩＸ・Ｘ十分位階級（勤労者世帯）",
              "label": "ＩＸ・Ｘ十分位階級（勤労者世帯）",
              "cat01": "L450210",
              "unit": "万円",
              "sourceId": "l03"
            },
            {
              "statId": "0000010112/L4601/万円/l04/年間収入のジニ係数（二人以上の世帯）",
              "label": "年間収入のジニ係数（二人以上の世帯）",
              "cat01": "L4601",
              "unit": "万円",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L4602/万円/l04/年間収入のジニ係数（二人以上の世帯のうち勤労者世帯）",
              "label": "年間収入のジニ係数（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L4602",
              "unit": "万円",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L4603/万円/l04/貯蓄現在高のジニ係数（二人以上の世帯）",
              "label": "貯蓄現在高のジニ係数（二人以上の世帯）",
              "cat01": "L4603",
              "unit": "万円",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L4604/万円/l04/貯蓄現在高のジニ係数（二人以上の世帯のうち勤労者世帯）",
              "label": "貯蓄現在高のジニ係数（二人以上の世帯のうち勤労者世帯）",
              "cat01": "L4604",
              "unit": "万円",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5101/セット/l04/耐久消費財所有数量（応接セット）",
              "label": "耐久消費財所有数量（応接セット）",
              "cat01": "L5101",
              "unit": "セット",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5103/台/l04/耐久消費財所有数量（二人以上の世帯）（電子レンジ（電子オーブンレンジを含む））",
              "label": "耐久消費財所有数量（二人以上の世帯）（電子レンジ（電子オーブンレンジを含む））",
              "cat01": "L5103",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5104/台/l04/耐久消費財所有数量（二人以上の世帯）（ルームエアコン）",
              "label": "耐久消費財所有数量（二人以上の世帯）（ルームエアコン）",
              "cat01": "L5104",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5105/台/l04/耐久消費財所有数量（ステレオ）（全世帯）（千世帯当たり）",
              "label": "耐久消費財所有数量（ステレオ）（全世帯）（千世帯当たり）",
              "cat01": "L5105",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5106/台/l04/耐久消費財所有数量（ビデオテープレコーダ）（全世帯）（千世帯当たり）",
              "label": "耐久消費財所有数量（ビデオテープレコーダ）（全世帯）（千世帯当たり）",
              "cat01": "L5106",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5107/台/l04/耐久消費財所有数量（二人以上の世帯）（ピアノ・電子ピアノ）",
              "label": "耐久消費財所有数量（二人以上の世帯）（ピアノ・電子ピアノ）",
              "cat01": "L5107",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5108/台/l04/耐久消費財所有数量（二人以上の世帯）（自動車）",
              "label": "耐久消費財所有数量（二人以上の世帯）（自動車）",
              "cat01": "L5108",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5109/台/l04/耐久消費財所有数量（二人以上の世帯）（オートバイ・スクーター）",
              "label": "耐久消費財所有数量（二人以上の世帯）（オートバイ・スクーター）",
              "cat01": "L5109",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5110/台/l04/耐久消費財所有数量（給湯器（ガス瞬間湯沸器を除く））（全世帯）（千世帯当たり）",
              "label": "耐久消費財所有数量（給湯器（ガス瞬間湯沸器を除く））（全世帯）（千世帯当たり）",
              "cat01": "L5110",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5111/台/l04/耐久消費財所有数量（二人以上の世帯）（温水洗浄便座）",
              "label": "耐久消費財所有数量（二人以上の世帯）（温水洗浄便座）",
              "cat01": "L5111",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5112/台/l04/耐久消費財所有数量（二人以上の世帯）（携帯電話（ＰＨＳを含み，スマートフォンを除く））",
              "label": "耐久消費財所有数量（二人以上の世帯）（携帯電話（ＰＨＳを含み，スマートフォンを除く））",
              "cat01": "L5112",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5113/台/l04/耐久消費財所有数量（ファクシミリ（コピー付を含む））",
              "label": "耐久消費財所有数量（ファクシミリ（コピー付を含む））",
              "cat01": "L5113",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5114/台/l04/耐久消費財所有数量（二人以上の世帯）（パソコン）",
              "label": "耐久消費財所有数量（二人以上の世帯）（パソコン）",
              "cat01": "L5114",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5115/台/l04/耐久消費財所有数量（二人以上の世帯）（ビデオカメラ）",
              "label": "耐久消費財所有数量（二人以上の世帯）（ビデオカメラ）",
              "cat01": "L5115",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5116/台/l04/耐久消費財所有数量（ステレオセットまたはＣＤ・ＭＤラジオカセット）",
              "label": "耐久消費財所有数量（ステレオセットまたはＣＤ・ＭＤラジオカセット）",
              "cat01": "L5116",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5117/台/l04/耐久消費財所有数量（二人以上の世帯）（ビデオレコーダ（ＤＶＤ　ブルーレイを含む））",
              "label": "耐久消費財所有数量（二人以上の世帯）（ビデオレコーダ（ＤＶＤ　ブルーレイを含む））",
              "cat01": "L5117",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5118/台/l04/耐久消費財所有数量（二人以上の世帯）（ハイブリッド・電気自動車（国産））",
              "label": "耐久消費財所有数量（二人以上の世帯）（ハイブリッド・電気自動車（国産））",
              "cat01": "L5118",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5119/畳/l04/耐久消費財所有数量（二人以上の世帯）（床暖房）",
              "label": "耐久消費財所有数量（二人以上の世帯）（床暖房）",
              "cat01": "L5119",
              "unit": "畳",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5120/台/l04/耐久消費財所有数量（二人以上の世帯）（太陽光発電システム）",
              "label": "耐久消費財所有数量（二人以上の世帯）（太陽光発電システム）",
              "cat01": "L5120",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5121/台/l04/耐久消費財所有数量（二人以上の世帯）（タブレット端末）",
              "label": "耐久消費財所有数量（二人以上の世帯）（タブレット端末）",
              "cat01": "L5121",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5122/台/l04/耐久消費財所有数量（二人以上の世帯）（スマートフォン）",
              "label": "耐久消費財所有数量（二人以上の世帯）（スマートフォン）",
              "cat01": "L5122",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5123/台/l04/耐久消費財所有数量（二人以上の世帯）（パソコン（ノート型（モバイル・ネットブックを含む）））",
              "label": "耐久消費財所有数量（二人以上の世帯）（パソコン（ノート型（モバイル・ネットブックを含む）））",
              "cat01": "L5123",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L5124/台/l04/耐久消費財所有数量（二人以上の世帯）（パソコン（デスクトップ型））",
              "label": "耐久消費財所有数量（二人以上の世帯）（パソコン（デスクトップ型））",
              "cat01": "L5124",
              "unit": "台",
              "sourceId": "l04"
            },
            {
              "statId": "0000010112/L6101/世帯/l05/農林漁業就業者世帯数（農林漁業・業主世帯）",
              "label": "農林漁業就業者世帯数（農林漁業・業主世帯）",
              "cat01": "L6101",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6102/世帯/l05/農林漁業就業者世帯数（農林漁業・雇用者世帯）",
              "label": "農林漁業就業者世帯数（農林漁業・雇用者世帯）",
              "cat01": "L6102",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6103/世帯/l05/農林漁業就業者世帯数（農林漁業・業主混合世帯）",
              "label": "農林漁業就業者世帯数（農林漁業・業主混合世帯）",
              "cat01": "L6103",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6104/世帯/l05/農林漁業就業者世帯数（農林漁業・雇用者混合世帯）",
              "label": "農林漁業就業者世帯数（農林漁業・雇用者混合世帯）",
              "cat01": "L6104",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6105/世帯/l05/農林漁業就業者世帯数（非農林漁業・業主混合世帯）",
              "label": "農林漁業就業者世帯数（非農林漁業・業主混合世帯）",
              "cat01": "L6105",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6106/世帯/l05/農林漁業就業者世帯数（非農林漁業・雇用者混合世帯）",
              "label": "農林漁業就業者世帯数（非農林漁業・雇用者混合世帯）",
              "cat01": "L6106",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6107/世帯/l05/非農林漁業就業者世帯数（非農林漁業・業主世帯）",
              "label": "非農林漁業就業者世帯数（非農林漁業・業主世帯）",
              "cat01": "L6107",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6108/世帯/l05/非農林漁業就業者世帯数（非農林漁業・雇用者世帯）",
              "label": "非農林漁業就業者世帯数（非農林漁業・雇用者世帯）",
              "cat01": "L6108",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6109/世帯/l05/非農林漁業就業者世帯数（非農林漁業・業主・雇用者世帯）",
              "label": "非農林漁業就業者世帯数（非農林漁業・業主・雇用者世帯）",
              "cat01": "L6109",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6110/世帯/l05/非農林漁業就業者世帯数（世帯主の主な就業者が雇用者）",
              "label": "非農林漁業就業者世帯数（世帯主の主な就業者が雇用者）",
              "cat01": "L6110",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6111/世帯/l05/非就業者世帯数",
              "label": "非就業者世帯数",
              "cat01": "L6111",
              "unit": "世帯",
              "sourceId": "l05"
            },
            {
              "statId": "0000010112/L6201/世帯/l06/賃金・給料が主な世帯数",
              "label": "賃金・給料が主な世帯数",
              "cat01": "L6201",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6202/世帯/l06/農業収入が主な世帯数",
              "label": "農業収入が主な世帯数",
              "cat01": "L6202",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6203/世帯/l06/農業収入以外の事業収入が主な世帯数",
              "label": "農業収入以外の事業収入が主な世帯数",
              "cat01": "L6203",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6204/世帯/l06/内職収入が主な世帯数",
              "label": "内職収入が主な世帯数",
              "cat01": "L6204",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6205/世帯/l06/恩給・年金が主な世帯数",
              "label": "恩給・年金が主な世帯数",
              "cat01": "L6205",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6206/世帯/l06/仕送りが主な世帯数",
              "label": "仕送りが主な世帯数",
              "cat01": "L6206",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6207/世帯/l06/その他の収入が主な世帯数",
              "label": "その他の収入が主な世帯数",
              "cat01": "L6207",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6301/世帯/l06/６０歳以上高齢単身世帯数（賃金・給料が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（賃金・給料が主な世帯）",
              "cat01": "L6301",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6302/世帯/l06/６０歳以上高齢単身世帯数（農業収入が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（農業収入が主な世帯）",
              "cat01": "L6302",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6303/世帯/l06/６０歳以上高齢単身世帯数（農業収入以外の事業収入が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（農業収入以外の事業収入が主な世帯）",
              "cat01": "L6303",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6304/世帯/l06/６０歳以上高齢単身世帯数（内職収入が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（内職収入が主な世帯）",
              "cat01": "L6304",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6305/世帯/l06/６０歳以上高齢単身世帯数（恩給・年金が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（恩給・年金が主な世帯）",
              "cat01": "L6305",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6306/世帯/l06/６０歳以上高齢単身世帯数（仕送りが主な世帯）",
              "label": "６０歳以上高齢単身世帯数（仕送りが主な世帯）",
              "cat01": "L6306",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6307/世帯/l06/６０歳以上高齢単身世帯数（その他の収入が主な世帯）",
              "label": "６０歳以上高齢単身世帯数（その他の収入が主な世帯）",
              "cat01": "L6307",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6401/世帯/l06/６５歳以上高齢単身世帯数（賃金・給料が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（賃金・給料が主な世帯）",
              "cat01": "L6401",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6402/世帯/l06/６５歳以上高齢単身世帯数（農業収入が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（農業収入が主な世帯）",
              "cat01": "L6402",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6403/世帯/l06/６５歳以上高齢単身世帯数（農業収入以外の事業収入が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（農業収入以外の事業収入が主な世帯）",
              "cat01": "L6403",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6404/世帯/l06/６５歳以上高齢単身世帯数（内職収入が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（内職収入が主な世帯）",
              "cat01": "L6404",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6405/世帯/l06/６５歳以上高齢単身世帯数（恩給・年金が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（恩給・年金が主な世帯）",
              "cat01": "L6405",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6406/世帯/l06/６５歳以上高齢単身世帯数（仕送りが主な世帯）",
              "label": "６５歳以上高齢単身世帯数（仕送りが主な世帯）",
              "cat01": "L6406",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6407/世帯/l06/６５歳以上高齢単身世帯数（その他の収入が主な世帯）",
              "label": "６５歳以上高齢単身世帯数（その他の収入が主な世帯）",
              "cat01": "L6407",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6501/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（賃金・給料が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（賃金・給料が主な世帯）",
              "cat01": "L6501",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6502/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（農業収入が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（農業収入が主な世帯）",
              "cat01": "L6502",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6503/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（農業収入以外の事業収入が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（農業収入以外の事業収入が主な世帯）",
              "cat01": "L6503",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6504/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（内職収入が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（内職収入が主な世帯）",
              "cat01": "L6504",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6505/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（恩給・年金が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（恩給・年金が主な世帯）",
              "cat01": "L6505",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6506/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（仕送りが主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（仕送りが主な世帯）",
              "cat01": "L6506",
              "unit": "世帯",
              "sourceId": "l06"
            },
            {
              "statId": "0000010112/L6507/世帯/l06/いずれも６５歳以上高齢夫婦世帯数（その他の収入が主な世帯）",
              "label": "いずれも６５歳以上高齢夫婦世帯数（その他の収入が主な世帯）",
              "cat01": "L6507",
              "unit": "世帯",
              "sourceId": "l06"
            }
          ]
        },
        {
          "label": "Ｍ生活時間",
          "statId": "0000010113",
          "children": [
            {
              "statId": "0000010113/M1001/分/m01/１次活動の平均時間（男）",
              "label": "１次活動の平均時間（男）",
              "cat01": "M1001",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100100/分/m01/１次活動の平均時間（１５歳以上）（男）",
              "label": "１次活動の平均時間（１５歳以上）（男）",
              "cat01": "M100100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100101/分/m01/１次活動の平均時間（有業者）（男）",
              "label": "１次活動の平均時間（有業者）（男）",
              "cat01": "M100101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100102/分/m01/１次活動の平均時間（無業者）（男）",
              "label": "１次活動の平均時間（無業者）（男）",
              "cat01": "M100102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100110/分/m01/１次活動の平均時間（１５～２４歳）（男）",
              "label": "１次活動の平均時間（１５～２４歳）（男）",
              "cat01": "M100110",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100120/分/m01/１次活動の平均時間（２５～３４歳）（男）",
              "label": "１次活動の平均時間（２５～３４歳）（男）",
              "cat01": "M100120",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100130/分/m01/１次活動の平均時間（３５～４４歳）（男）",
              "label": "１次活動の平均時間（３５～４４歳）（男）",
              "cat01": "M100130",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100140/分/m01/１次活動の平均時間（４５～５４歳）（男）",
              "label": "１次活動の平均時間（４５～５４歳）（男）",
              "cat01": "M100140",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100150/分/m01/１次活動の平均時間（５５～６４歳）（男）",
              "label": "１次活動の平均時間（５５～６４歳）（男）",
              "cat01": "M100150",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100160/分/m01/１次活動の平均時間（６５～７４歳）（男）",
              "label": "１次活動の平均時間（６５～７４歳）（男）",
              "cat01": "M100160",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100170/分/m01/１次活動の平均時間（７５歳以上）（男）",
              "label": "１次活動の平均時間（７５歳以上）（男）",
              "cat01": "M100170",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1002/分/m01/１次活動の平均時間（女）",
              "label": "１次活動の平均時間（女）",
              "cat01": "M1002",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100200/分/m01/１次活動の平均時間（１５歳以上）（女）",
              "label": "１次活動の平均時間（１５歳以上）（女）",
              "cat01": "M100200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100201/分/m01/１次活動の平均時間（有業者）（女）",
              "label": "１次活動の平均時間（有業者）（女）",
              "cat01": "M100201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100202/分/m01/１次活動の平均時間（無業者）（女）",
              "label": "１次活動の平均時間（無業者）（女）",
              "cat01": "M100202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100210/分/m01/１次活動の平均時間（１５～２４歳）（女）",
              "label": "１次活動の平均時間（１５～２４歳）（女）",
              "cat01": "M100210",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100220/分/m01/１次活動の平均時間（２５～３４歳）（女）",
              "label": "１次活動の平均時間（２５～３４歳）（女）",
              "cat01": "M100220",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100230/分/m01/１次活動の平均時間（３５～４４歳）（女）",
              "label": "１次活動の平均時間（３５～４４歳）（女）",
              "cat01": "M100230",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100240/分/m01/１次活動の平均時間（４５～５４歳）（女）",
              "label": "１次活動の平均時間（４５～５４歳）（女）",
              "cat01": "M100240",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100250/分/m01/１次活動の平均時間（５５～６４歳）（女）",
              "label": "１次活動の平均時間（５５～６４歳）（女）",
              "cat01": "M100250",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100260/分/m01/１次活動の平均時間（６５～７４歳）（女）",
              "label": "１次活動の平均時間（６５～７４歳）（女）",
              "cat01": "M100260",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M100270/分/m01/１次活動の平均時間（７５歳以上）（女）",
              "label": "１次活動の平均時間（７５歳以上）（女）",
              "cat01": "M100270",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1101/分/m01/睡眠の平均時間（男）",
              "label": "睡眠の平均時間（男）",
              "cat01": "M1101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110100/分/m01/睡眠の平均時間（１５歳以上）（男）",
              "label": "睡眠の平均時間（１５歳以上）（男）",
              "cat01": "M110100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110101/分/m01/睡眠の平均時間（有業者）（男）",
              "label": "睡眠の平均時間（有業者）（男）",
              "cat01": "M110101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110102/分/m01/睡眠の平均時間（無業者）（男）",
              "label": "睡眠の平均時間（無業者）（男）",
              "cat01": "M110102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1102/分/m01/睡眠の平均時間（女）",
              "label": "睡眠の平均時間（女）",
              "cat01": "M1102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110200/分/m01/睡眠の平均時間（１５歳以上）（女）",
              "label": "睡眠の平均時間（１５歳以上）（女）",
              "cat01": "M110200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110201/分/m01/睡眠の平均時間（有業者）（女）",
              "label": "睡眠の平均時間（有業者）（女）",
              "cat01": "M110201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M110202/分/m01/睡眠の平均時間（無業者）（女）",
              "label": "睡眠の平均時間（無業者）（女）",
              "cat01": "M110202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1201/分/m01/身の回りの用事の平均時間（男）",
              "label": "身の回りの用事の平均時間（男）",
              "cat01": "M1201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120100/分/m01/身の回りの用事の平均時間（１５歳以上）（男）",
              "label": "身の回りの用事の平均時間（１５歳以上）（男）",
              "cat01": "M120100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120101/分/m01/身の回りの用事の平均時間（有業者）（男）",
              "label": "身の回りの用事の平均時間（有業者）（男）",
              "cat01": "M120101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120102/分/m01/身の回りの用事の平均時間（無業者）（男）",
              "label": "身の回りの用事の平均時間（無業者）（男）",
              "cat01": "M120102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1202/分/m01/身の回りの用事の平均時間（女）",
              "label": "身の回りの用事の平均時間（女）",
              "cat01": "M1202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120200/分/m01/身の回りの用事の平均時間（１５歳以上）（女）",
              "label": "身の回りの用事の平均時間（１５歳以上）（女）",
              "cat01": "M120200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120201/分/m01/身の回りの用事の平均時間（有業者）（女）",
              "label": "身の回りの用事の平均時間（有業者）（女）",
              "cat01": "M120201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M120202/分/m01/身の回りの用事の平均時間（無業者）（女）",
              "label": "身の回りの用事の平均時間（無業者）（女）",
              "cat01": "M120202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1301/分/m01/食事の平均時間（男）",
              "label": "食事の平均時間（男）",
              "cat01": "M1301",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130100/分/m01/食事の平均時間（１５歳以上）（男）",
              "label": "食事の平均時間（１５歳以上）（男）",
              "cat01": "M130100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130101/分/m01/食事の平均時間（有業者）（男）",
              "label": "食事の平均時間（有業者）（男）",
              "cat01": "M130101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130102/分/m01/食事の平均時間（無業者）（男）",
              "label": "食事の平均時間（無業者）（男）",
              "cat01": "M130102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M1302/分/m01/食事の平均時間（女）",
              "label": "食事の平均時間（女）",
              "cat01": "M1302",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130200/分/m01/食事の平均時間（１５歳以上）（女）",
              "label": "食事の平均時間（１５歳以上）（女）",
              "cat01": "M130200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130201/分/m01/食事の平均時間（有業者）（女）",
              "label": "食事の平均時間（有業者）（女）",
              "cat01": "M130201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M130202/分/m01/食事の平均時間（無業者）（女）",
              "label": "食事の平均時間（無業者）（女）",
              "cat01": "M130202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2001/分/m01/２次活動の平均時間（男）",
              "label": "２次活動の平均時間（男）",
              "cat01": "M2001",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200100/分/m01/２次活動の平均時間（１５歳以上）（男）",
              "label": "２次活動の平均時間（１５歳以上）（男）",
              "cat01": "M200100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200101/分/m01/２次活動の平均時間（有業者）（男）",
              "label": "２次活動の平均時間（有業者）（男）",
              "cat01": "M200101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200102/分/m01/２次活動の平均時間（無業者）（男）",
              "label": "２次活動の平均時間（無業者）（男）",
              "cat01": "M200102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200110/分/m01/２次活動の平均時間（１５～２４歳）（男）",
              "label": "２次活動の平均時間（１５～２４歳）（男）",
              "cat01": "M200110",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200120/分/m01/２次活動の平均時間（２５～３４歳）（男）",
              "label": "２次活動の平均時間（２５～３４歳）（男）",
              "cat01": "M200120",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200130/分/m01/２次活動の平均時間（３５～４４歳）（男）",
              "label": "２次活動の平均時間（３５～４４歳）（男）",
              "cat01": "M200130",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200140/分/m01/２次活動の平均時間（４５～５４歳）（男）",
              "label": "２次活動の平均時間（４５～５４歳）（男）",
              "cat01": "M200140",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200150/分/m01/２次活動の平均時間（５５～６４歳）（男）",
              "label": "２次活動の平均時間（５５～６４歳）（男）",
              "cat01": "M200150",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200160/分/m01/２次活動の平均時間（６５～７４歳）（男）",
              "label": "２次活動の平均時間（６５～７４歳）（男）",
              "cat01": "M200160",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200170/分/m01/２次活動の平均時間（７５歳以上）（男）",
              "label": "２次活動の平均時間（７５歳以上）（男）",
              "cat01": "M200170",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2002/分/m01/２次活動の平均時間（女）",
              "label": "２次活動の平均時間（女）",
              "cat01": "M2002",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200200/分/m01/２次活動の平均時間（１５歳以上）（女）",
              "label": "２次活動の平均時間（１５歳以上）（女）",
              "cat01": "M200200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200201/分/m01/２次活動の平均時間（有業者）（女）",
              "label": "２次活動の平均時間（有業者）（女）",
              "cat01": "M200201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200202/分/m01/２次活動の平均時間（無業者）（女）",
              "label": "２次活動の平均時間（無業者）（女）",
              "cat01": "M200202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200210/分/m01/２次活動の平均時間（１５～２４歳）（女）",
              "label": "２次活動の平均時間（１５～２４歳）（女）",
              "cat01": "M200210",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200220/分/m01/２次活動の平均時間（２５～３４歳）（女）",
              "label": "２次活動の平均時間（２５～３４歳）（女）",
              "cat01": "M200220",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200230/分/m01/２次活動の平均時間（３５～４４歳）（女）",
              "label": "２次活動の平均時間（３５～４４歳）（女）",
              "cat01": "M200230",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200240/分/m01/２次活動の平均時間（４５～５４歳）（女）",
              "label": "２次活動の平均時間（４５～５４歳）（女）",
              "cat01": "M200240",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200250/分/m01/２次活動の平均時間（５５～６４歳）（女）",
              "label": "２次活動の平均時間（５５～６４歳）（女）",
              "cat01": "M200250",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200260/分/m01/２次活動の平均時間（６５～７４歳）（女）",
              "label": "２次活動の平均時間（６５～７４歳）（女）",
              "cat01": "M200260",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M200270/分/m01/２次活動の平均時間（７５歳以上）（女）",
              "label": "２次活動の平均時間（７５歳以上）（女）",
              "cat01": "M200270",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2101/分/m01/通勤・通学の平均時間（男）",
              "label": "通勤・通学の平均時間（男）",
              "cat01": "M2101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M210100/分/m01/通勤・通学の平均時間（１５歳以上）（男）",
              "label": "通勤・通学の平均時間（１５歳以上）（男）",
              "cat01": "M210100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M210101/分/m01/通勤・通学の平均時間（有業者）（男）",
              "label": "通勤・通学の平均時間（有業者）（男）",
              "cat01": "M210101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2102/分/m01/通勤・通学の平均時間（女）",
              "label": "通勤・通学の平均時間（女）",
              "cat01": "M2102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M210200/分/m01/通勤・通学の平均時間（１５歳以上）（女）",
              "label": "通勤・通学の平均時間（１５歳以上）（女）",
              "cat01": "M210200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M210201/分/m01/通勤・通学の平均時間（有業者）（女）",
              "label": "通勤・通学の平均時間（有業者）（女）",
              "cat01": "M210201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2201/分/m01/仕事の平均時間（男）",
              "label": "仕事の平均時間（男）",
              "cat01": "M2201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220100/分/m01/仕事の平均時間（１５歳以上）（男）",
              "label": "仕事の平均時間（１５歳以上）（男）",
              "cat01": "M220100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220101/分/m01/仕事の平均時間（有業者）（男）",
              "label": "仕事の平均時間（有業者）（男）",
              "cat01": "M220101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220102/分/m01/仕事の平均時間（無業者）（男）",
              "label": "仕事の平均時間（無業者）（男）",
              "cat01": "M220102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2202/分/m01/仕事の平均時間（女）",
              "label": "仕事の平均時間（女）",
              "cat01": "M2202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220200/分/m01/仕事の平均時間（１５歳以上）（女）",
              "label": "仕事の平均時間（１５歳以上）（女）",
              "cat01": "M220200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220201/分/m01/仕事の平均時間（有業者）（女）",
              "label": "仕事の平均時間（有業者）（女）",
              "cat01": "M220201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M220202/分/m01/仕事の平均時間（無業者）（女）",
              "label": "仕事の平均時間（無業者）（女）",
              "cat01": "M220202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2301/分/m01/学業の平均時間（男）",
              "label": "学業の平均時間（男）",
              "cat01": "M2301",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230100/分/m01/学業の平均時間（１５歳以上）（男）",
              "label": "学業の平均時間（１５歳以上）（男）",
              "cat01": "M230100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230101/分/m01/学業の平均時間（有業者）（男）",
              "label": "学業の平均時間（有業者）（男）",
              "cat01": "M230101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230102/分/m01/学業の平均時間（無業者）（男）",
              "label": "学業の平均時間（無業者）（男）",
              "cat01": "M230102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2302/分/m01/学業の平均時間（女）",
              "label": "学業の平均時間（女）",
              "cat01": "M2302",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230200/分/m01/学業の平均時間（１５歳以上）（女）",
              "label": "学業の平均時間（１５歳以上）（女）",
              "cat01": "M230200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230201/分/m01/学業の平均時間（有業者）（女）",
              "label": "学業の平均時間（有業者）（女）",
              "cat01": "M230201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M230202/分/m01/学業の平均時間（無業者）（女）",
              "label": "学業の平均時間（無業者）（女）",
              "cat01": "M230202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2401/分/m01/家事の平均時間（男）",
              "label": "家事の平均時間（男）",
              "cat01": "M2401",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240100/分/m01/家事の平均時間（１５歳以上）（男）",
              "label": "家事の平均時間（１５歳以上）（男）",
              "cat01": "M240100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240101/分/m01/家事の平均時間（有業者）（男）",
              "label": "家事の平均時間（有業者）（男）",
              "cat01": "M240101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240102/分/m01/家事の平均時間（無業者）（男）",
              "label": "家事の平均時間（無業者）（男）",
              "cat01": "M240102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2402/分/m01/家事の平均時間（女）",
              "label": "家事の平均時間（女）",
              "cat01": "M2402",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240200/分/m01/家事の平均時間（１５歳以上）（女）",
              "label": "家事の平均時間（１５歳以上）（女）",
              "cat01": "M240200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240201/分/m01/家事の平均時間（有業者）（女）",
              "label": "家事の平均時間（有業者）（女）",
              "cat01": "M240201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M240202/分/m01/家事の平均時間（無業者）（女）",
              "label": "家事の平均時間（無業者）（女）",
              "cat01": "M240202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2501/分/m01/介護・看護の平均時間（男）",
              "label": "介護・看護の平均時間（男）",
              "cat01": "M2501",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250100/分/m01/介護・看護の平均時間（１５歳以上）（男）",
              "label": "介護・看護の平均時間（１５歳以上）（男）",
              "cat01": "M250100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250101/分/m01/介護・看護の平均時間（有業者）（男）",
              "label": "介護・看護の平均時間（有業者）（男）",
              "cat01": "M250101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250102/分/m01/介護・看護の平均時間（無業者）（男）",
              "label": "介護・看護の平均時間（無業者）（男）",
              "cat01": "M250102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2502/分/m01/介護・看護の平均時間（女）",
              "label": "介護・看護の平均時間（女）",
              "cat01": "M2502",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250200/分/m01/介護・看護の平均時間（１５歳以上）（女）",
              "label": "介護・看護の平均時間（１５歳以上）（女）",
              "cat01": "M250200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250201/分/m01/介護・看護の平均時間（有業者）（女）",
              "label": "介護・看護の平均時間（有業者）（女）",
              "cat01": "M250201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M250202/分/m01/介護・看護の平均時間（無業者）（女）",
              "label": "介護・看護の平均時間（無業者）（女）",
              "cat01": "M250202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2601/分/m01/育児の平均時間（男）",
              "label": "育児の平均時間（男）",
              "cat01": "M2601",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260100/分/m01/育児の平均時間（１５歳以上）（男）",
              "label": "育児の平均時間（１５歳以上）（男）",
              "cat01": "M260100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260101/分/m01/育児の平均時間（有業者）（男）",
              "label": "育児の平均時間（有業者）（男）",
              "cat01": "M260101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260102/分/m01/育児の平均時間（無業者）（男）",
              "label": "育児の平均時間（無業者）（男）",
              "cat01": "M260102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2602/分/m01/育児の平均時間（女）",
              "label": "育児の平均時間（女）",
              "cat01": "M2602",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260200/分/m01/育児の平均時間（１５歳以上）（女）",
              "label": "育児の平均時間（１５歳以上）（女）",
              "cat01": "M260200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260201/分/m01/育児の平均時間（有業者）（女）",
              "label": "育児の平均時間（有業者）（女）",
              "cat01": "M260201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M260202/分/m01/育児の平均時間（無業者）（女）",
              "label": "育児の平均時間（無業者）（女）",
              "cat01": "M260202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2701/分/m01/買い物の平均時間（男）",
              "label": "買い物の平均時間（男）",
              "cat01": "M2701",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M270100/分/m01/買い物の平均時間（１５歳以上）（男）",
              "label": "買い物の平均時間（１５歳以上）（男）",
              "cat01": "M270100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M270101/分/m01/買い物の平均時間（有業者）（男）",
              "label": "買い物の平均時間（有業者）（男）",
              "cat01": "M270101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M2702/分/m01/買い物の平均時間（女）",
              "label": "買い物の平均時間（女）",
              "cat01": "M2702",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M270200/分/m01/買い物の平均時間（１５歳以上）（女）",
              "label": "買い物の平均時間（１５歳以上）（女）",
              "cat01": "M270200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M270201/分/m01/買い物の平均時間（有業者）（女）",
              "label": "買い物の平均時間（有業者）（女）",
              "cat01": "M270201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3001/分/m01/３次活動の平均時間（男）",
              "label": "３次活動の平均時間（男）",
              "cat01": "M3001",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300100/分/m01/３次活動の平均時間（１５歳以上）（男）",
              "label": "３次活動の平均時間（１５歳以上）（男）",
              "cat01": "M300100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300101/分/m01/３次活動の平均時間（有業者）（男）",
              "label": "３次活動の平均時間（有業者）（男）",
              "cat01": "M300101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300102/分/m01/３次活動の平均時間（無業者）（男）",
              "label": "３次活動の平均時間（無業者）（男）",
              "cat01": "M300102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300110/分/m01/３次活動の平均時間（１５～２４歳）（男）",
              "label": "３次活動の平均時間（１５～２４歳）（男）",
              "cat01": "M300110",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300120/分/m01/３次活動の平均時間（２５～３４歳）（男）",
              "label": "３次活動の平均時間（２５～３４歳）（男）",
              "cat01": "M300120",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300130/分/m01/３次活動の平均時間（３５～４４歳）（男）",
              "label": "３次活動の平均時間（３５～４４歳）（男）",
              "cat01": "M300130",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300140/分/m01/３次活動の平均時間（４５～５４歳）（男）",
              "label": "３次活動の平均時間（４５～５４歳）（男）",
              "cat01": "M300140",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300150/分/m01/３次活動の平均時間（５５～６４歳）（男）",
              "label": "３次活動の平均時間（５５～６４歳）（男）",
              "cat01": "M300150",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300160/分/m01/３次活動の平均時間（６５～７４歳）（男）",
              "label": "３次活動の平均時間（６５～７４歳）（男）",
              "cat01": "M300160",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300170/分/m01/３次活動の平均時間（７５歳以上）（男）",
              "label": "３次活動の平均時間（７５歳以上）（男）",
              "cat01": "M300170",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3002/分/m01/３次活動の平均時間（女）",
              "label": "３次活動の平均時間（女）",
              "cat01": "M3002",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300200/分/m01/３次活動の平均時間（１５歳以上）（女）",
              "label": "３次活動の平均時間（１５歳以上）（女）",
              "cat01": "M300200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300201/分/m01/３次活動の平均時間（有業者）（女）",
              "label": "３次活動の平均時間（有業者）（女）",
              "cat01": "M300201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300202/分/m01/３次活動の平均時間（無業者）（女）",
              "label": "３次活動の平均時間（無業者）（女）",
              "cat01": "M300202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300210/分/m01/３次活動の平均時間（１５～２４歳）（女）",
              "label": "３次活動の平均時間（１５～２４歳）（女）",
              "cat01": "M300210",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300220/分/m01/３次活動の平均時間（２５～３４歳）（女）",
              "label": "３次活動の平均時間（２５～３４歳）（女）",
              "cat01": "M300220",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300230/分/m01/３次活動の平均時間（３５～４４歳）（女）",
              "label": "３次活動の平均時間（３５～４４歳）（女）",
              "cat01": "M300230",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300240/分/m01/３次活動の平均時間（４５～５４歳）（女）",
              "label": "３次活動の平均時間（４５～５４歳）（女）",
              "cat01": "M300240",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300250/分/m01/３次活動の平均時間（５５～６４歳）（女）",
              "label": "３次活動の平均時間（５５～６４歳）（女）",
              "cat01": "M300250",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300260/分/m01/３次活動の平均時間（６５～７４歳）（女）",
              "label": "３次活動の平均時間（６５～７４歳）（女）",
              "cat01": "M300260",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M300270/分/m01/３次活動の平均時間（７５歳以上）（女）",
              "label": "３次活動の平均時間（７５歳以上）（女）",
              "cat01": "M300270",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3101/分/m01/移動の平均時間（通勤・通学を除く）（男）",
              "label": "移動の平均時間（通勤・通学を除く）（男）",
              "cat01": "M3101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310100/分/m01/移動の平均時間（通勤・通学を除く）（１５歳以上）（男）",
              "label": "移動の平均時間（通勤・通学を除く）（１５歳以上）（男）",
              "cat01": "M310100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310101/分/m01/移動の平均時間（通勤・通学を除く）（有業者）（男）",
              "label": "移動の平均時間（通勤・通学を除く）（有業者）（男）",
              "cat01": "M310101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310102/分/m01/移動の平均時間（通勤・通学を除く）（無業者）（男）",
              "label": "移動の平均時間（通勤・通学を除く）（無業者）（男）",
              "cat01": "M310102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3102/分/m01/移動の平均時間（通勤・通学を除く）（女）",
              "label": "移動の平均時間（通勤・通学を除く）（女）",
              "cat01": "M3102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310200/分/m01/移動の平均時間（通勤・通学を除く）（１５歳以上）（女）",
              "label": "移動の平均時間（通勤・通学を除く）（１５歳以上）（女）",
              "cat01": "M310200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310201/分/m01/移動の平均時間（通勤・通学を除く）（有業者）（女）",
              "label": "移動の平均時間（通勤・通学を除く）（有業者）（女）",
              "cat01": "M310201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M310202/分/m01/移動の平均時間（通勤・通学を除く）（無業者）（女）",
              "label": "移動の平均時間（通勤・通学を除く）（無業者）（女）",
              "cat01": "M310202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3201/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（男）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（男）",
              "cat01": "M3201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320100/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（１５歳以上）（男）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（１５歳以上）（男）",
              "cat01": "M320100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320101/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（有業者）（男）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（有業者）（男）",
              "cat01": "M320101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320102/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（無業者）（男）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（無業者）（男）",
              "cat01": "M320102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3202/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（女）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（女）",
              "cat01": "M3202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320200/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（１５歳以上）（女）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（１５歳以上）（女）",
              "cat01": "M320200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320201/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（有業者）（女）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（有業者）（女）",
              "cat01": "M320201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M320202/分/m01/テレビ・ラジオ・新聞・雑誌の平均時間（無業者）（女）",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間（無業者）（女）",
              "cat01": "M320202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3301/分/m01/休養・くつろぎの平均時間（男）",
              "label": "休養・くつろぎの平均時間（男）",
              "cat01": "M3301",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330100/分/m01/休養・くつろぎの平均時間（１５歳以上）（男）",
              "label": "休養・くつろぎの平均時間（１５歳以上）（男）",
              "cat01": "M330100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330101/分/m01/休養・くつろぎの平均時間（有業者）（男）",
              "label": "休養・くつろぎの平均時間（有業者）（男）",
              "cat01": "M330101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330102/分/m01/休養・くつろぎの平均時間（無業者）（男）",
              "label": "休養・くつろぎの平均時間（無業者）（男）",
              "cat01": "M330102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3302/分/m01/休養・くつろぎの平均時間（女）",
              "label": "休養・くつろぎの平均時間（女）",
              "cat01": "M3302",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330200/分/m01/休養・くつろぎの平均時間（１５歳以上）（女）",
              "label": "休養・くつろぎの平均時間（１５歳以上）（女）",
              "cat01": "M330200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330201/分/m01/休養・くつろぎの平均時間（有業者）（女）",
              "label": "休養・くつろぎの平均時間（有業者）（女）",
              "cat01": "M330201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M330202/分/m01/休養・くつろぎの平均時間（無業者）（女）",
              "label": "休養・くつろぎの平均時間（無業者）（女）",
              "cat01": "M330202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3401/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（男）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（男）",
              "cat01": "M3401",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340100/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（１５歳以上）（男）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（１５歳以上）（男）",
              "cat01": "M340100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340101/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（有業者）（男）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（有業者）（男）",
              "cat01": "M340101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340102/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（無業者）（男）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（無業者）（男）",
              "cat01": "M340102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3402/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（女）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（女）",
              "cat01": "M3402",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340200/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（１５歳以上）（女）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（１５歳以上）（女）",
              "cat01": "M340200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340201/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（有業者）（女）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（有業者）（女）",
              "cat01": "M340201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M340202/分/m01/学習・自己啓発・訓練の平均時間（学業以外）（無業者）（女）",
              "label": "学習・自己啓発・訓練の平均時間（学業以外）（無業者）（女）",
              "cat01": "M340202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3501/分/m01/趣味・娯楽の平均時間（男）",
              "label": "趣味・娯楽の平均時間（男）",
              "cat01": "M3501",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350100/分/m01/趣味・娯楽の平均時間（１５歳以上）（男）",
              "label": "趣味・娯楽の平均時間（１５歳以上）（男）",
              "cat01": "M350100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350101/分/m01/趣味・娯楽の平均時間（有業者）（男）",
              "label": "趣味・娯楽の平均時間（有業者）（男）",
              "cat01": "M350101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350102/分/m01/趣味・娯楽の平均時間（無業者）（男）",
              "label": "趣味・娯楽の平均時間（無業者）（男）",
              "cat01": "M350102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3502/分/m01/趣味・娯楽の平均時間（女）",
              "label": "趣味・娯楽の平均時間（女）",
              "cat01": "M3502",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350200/分/m01/趣味・娯楽の平均時間（１５歳以上）（女）",
              "label": "趣味・娯楽の平均時間（１５歳以上）（女）",
              "cat01": "M350200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350201/分/m01/趣味・娯楽の平均時間（有業者）（女）",
              "label": "趣味・娯楽の平均時間（有業者）（女）",
              "cat01": "M350201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M350202/分/m01/趣味・娯楽の平均時間（無業者）（女）",
              "label": "趣味・娯楽の平均時間（無業者）（女）",
              "cat01": "M350202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3601/分/m01/スポーツの平均時間（男）",
              "label": "スポーツの平均時間（男）",
              "cat01": "M3601",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360100/分/m01/スポーツの平均時間（１５歳以上）（男）",
              "label": "スポーツの平均時間（１５歳以上）（男）",
              "cat01": "M360100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360101/分/m01/スポーツの平均時間（有業者）（男）",
              "label": "スポーツの平均時間（有業者）（男）",
              "cat01": "M360101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360102/分/m01/スポーツの平均時間（無業者）（男）",
              "label": "スポーツの平均時間（無業者）（男）",
              "cat01": "M360102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3602/分/m01/スポーツの平均時間（女）",
              "label": "スポーツの平均時間（女）",
              "cat01": "M3602",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360200/分/m01/スポーツの平均時間（１５歳以上）（女）",
              "label": "スポーツの平均時間（１５歳以上）（女）",
              "cat01": "M360200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360201/分/m01/スポーツの平均時間（有業者）（女）",
              "label": "スポーツの平均時間（有業者）（女）",
              "cat01": "M360201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M360202/分/m01/スポーツの平均時間（無業者）（女）",
              "label": "スポーツの平均時間（無業者）（女）",
              "cat01": "M360202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3701/分/m01/ボランティア活動・社会参加活動の平均時間（男）",
              "label": "ボランティア活動・社会参加活動の平均時間（男）",
              "cat01": "M3701",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370100/分/m01/ボランティア活動・社会参加活動の平均時間（１５歳以上）（男）",
              "label": "ボランティア活動・社会参加活動の平均時間（１５歳以上）（男）",
              "cat01": "M370100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370101/分/m01/ボランティア活動・社会参加活動の平均時間（有業者）（男）",
              "label": "ボランティア活動・社会参加活動の平均時間（有業者）（男）",
              "cat01": "M370101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370102/分/m01/ボランティア活動・社会参加活動の平均時間（無業者）（男）",
              "label": "ボランティア活動・社会参加活動の平均時間（無業者）（男）",
              "cat01": "M370102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3702/分/m01/ボランティア活動・社会参加活動の平均時間（女）",
              "label": "ボランティア活動・社会参加活動の平均時間（女）",
              "cat01": "M3702",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370200/分/m01/ボランティア活動・社会参加活動の平均時間（１５歳以上）（女）",
              "label": "ボランティア活動・社会参加活動の平均時間（１５歳以上）（女）",
              "cat01": "M370200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370201/分/m01/ボランティア活動・社会参加活動の平均時間（有業者）（女）",
              "label": "ボランティア活動・社会参加活動の平均時間（有業者）（女）",
              "cat01": "M370201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M370202/分/m01/ボランティア活動・社会参加活動の平均時間（無業者）（女）",
              "label": "ボランティア活動・社会参加活動の平均時間（無業者）（女）",
              "cat01": "M370202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3801/分/m01/交際・付き合いの平均時間（男）",
              "label": "交際・付き合いの平均時間（男）",
              "cat01": "M3801",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380100/分/m01/交際・付き合いの平均時間（１５歳以上）（男）",
              "label": "交際・付き合いの平均時間（１５歳以上）（男）",
              "cat01": "M380100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380101/分/m01/交際・付き合いの平均時間（有業者）（男）",
              "label": "交際・付き合いの平均時間（有業者）（男）",
              "cat01": "M380101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380102/分/m01/交際・付き合いの平均時間（無業者）（男）",
              "label": "交際・付き合いの平均時間（無業者）（男）",
              "cat01": "M380102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3802/分/m01/交際・付き合いの平均時間（女）",
              "label": "交際・付き合いの平均時間（女）",
              "cat01": "M3802",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380200/分/m01/交際・付き合いの平均時間（１５歳以上）（女）",
              "label": "交際・付き合いの平均時間（１５歳以上）（女）",
              "cat01": "M380200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380201/分/m01/交際・付き合いの平均時間（有業者）（女）",
              "label": "交際・付き合いの平均時間（有業者）（女）",
              "cat01": "M380201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M380202/分/m01/交際・付き合いの平均時間（無業者）（女）",
              "label": "交際・付き合いの平均時間（無業者）（女）",
              "cat01": "M380202",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3901/分/m01/受診・療養の平均時間（男）",
              "label": "受診・療養の平均時間（男）",
              "cat01": "M3901",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390100/分/m01/受診・療養の平均時間（１５歳以上）（男）",
              "label": "受診・療養の平均時間（１５歳以上）（男）",
              "cat01": "M390100",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390101/分/m01/受診・療養の平均時間（有業者）（男）",
              "label": "受診・療養の平均時間（有業者）（男）",
              "cat01": "M390101",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390102/分/m01/受診・療養の平均時間（無業者）（男）",
              "label": "受診・療養の平均時間（無業者）（男）",
              "cat01": "M390102",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M3902/分/m01/受診・療養の平均時間（女）",
              "label": "受診・療養の平均時間（女）",
              "cat01": "M3902",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390200/分/m01/受診・療養の平均時間（１５歳以上）（女）",
              "label": "受診・療養の平均時間（１５歳以上）（女）",
              "cat01": "M390200",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390201/分/m01/受診・療養の平均時間（有業者）（女）",
              "label": "受診・療養の平均時間（有業者）（女）",
              "cat01": "M390201",
              "unit": "分",
              "sourceId": "m01"
            },
            {
              "statId": "0000010113/M390202/分/m01/受診・療養の平均時間（無業者）（女）",
              "label": "受診・療養の平均時間（無業者）（女）",
              "cat01": "M390202",
              "unit": "分",
              "sourceId": "m01"
            }
          ]
        }
      ]
    },
    {
      "label": "社会生活統計指標",
      "statId": "syakai",
      "children": [
        {
          "label": "Ａ人口・世帯",
          "statId": "0000010201",
          "children": [
            {
              "statId": "0000010201/#A011000/万人//総人口",
              "label": "総人口",
              "cat01": "#A011000",
              "unit": "万人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0110001/万人//総人口〔男〕",
              "label": "総人口〔男〕",
              "cat01": "#A0110001",
              "unit": "万人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0110002/万人//総人口〔女〕",
              "label": "総人口〔女〕",
              "cat01": "#A0110002",
              "unit": "万人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01101/％//全国総人口に占める人口割合",
              "label": "全国総人口に占める人口割合",
              "cat01": "#A01101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01201/人//総面積１km2当たり人口密度",
              "label": "総面積１km2当たり人口密度",
              "cat01": "#A01201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01202/人//可住地面積１km2当たり人口密度",
              "label": "可住地面積１km2当たり人口密度",
              "cat01": "#A01202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01302/％//昼夜間人口比率",
              "label": "昼夜間人口比率",
              "cat01": "#A01302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01401/％//人口集中地区人口比率",
              "label": "人口集中地区人口比率",
              "cat01": "#A01401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01402/％//人口集中地区面積比率",
              "label": "人口集中地区面積比率",
              "cat01": "#A01402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01403/人//人口集中地区人口密度（人口集中地区面積１km2当たり ）",
              "label": "人口集中地区人口密度（人口集中地区面積１km2当たり ）",
              "cat01": "#A01403",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01404/％//人口集中地区面積の変化率",
              "label": "人口集中地区面積の変化率",
              "cat01": "#A01404",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A01601/人//外国人人口（人口10万人当たり）",
              "label": "外国人人口（人口10万人当たり）",
              "cat01": "#A01601",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0160101/人//外国人人口［韓国・朝鮮］（人口10万人当たり）",
              "label": "外国人人口［韓国・朝鮮］（人口10万人当たり）",
              "cat01": "#A0160101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0160102/人//外国人人口［中国］（人口10万人当たり）",
              "label": "外国人人口［中国］（人口10万人当たり）",
              "cat01": "#A0160102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0160103/人//外国人人口［アメリカ］（人口10万人当たり）",
              "label": "外国人人口［アメリカ］（人口10万人当たり）",
              "cat01": "#A0160103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191001/人//将来推計人口(2020年)",
              "label": "将来推計人口(2020年)",
              "cat01": "#A0191001",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191002/人//将来推計人口(2025年)",
              "label": "将来推計人口(2025年)",
              "cat01": "#A0191002",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191003/人//将来推計人口(2030年)",
              "label": "将来推計人口(2030年)",
              "cat01": "#A0191003",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191004/人//将来推計人口(2035年)",
              "label": "将来推計人口(2035年)",
              "cat01": "#A0191004",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191005/人//将来推計人口(2040年)",
              "label": "将来推計人口(2040年)",
              "cat01": "#A0191005",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0191006/人//将来推計人口(2045年)",
              "label": "将来推計人口(2045年)",
              "cat01": "#A0191006",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A02101/‐//人口性比［総数］",
              "label": "人口性比［総数］",
              "cat01": "#A02101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A02102/‐//人口性比［15歳未満人口］",
              "label": "人口性比［15歳未満人口］",
              "cat01": "#A02102",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A02103/‐//人口性比［15～64歳人口］",
              "label": "人口性比［15～64歳人口］",
              "cat01": "#A02103",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A02104/‐//人口性比［65歳以上人口］",
              "label": "人口性比［65歳以上人口］",
              "cat01": "#A02104",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03401/‐//年少人口指数",
              "label": "年少人口指数",
              "cat01": "#A03401",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03402/‐//老年人口指数",
              "label": "老年人口指数",
              "cat01": "#A03402",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03403/‐//従属人口指数",
              "label": "従属人口指数",
              "cat01": "#A03403",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03404/‐//老年化指数",
              "label": "老年化指数",
              "cat01": "#A03404",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03501/％//年少人口割合［15歳未満人口］",
              "label": "年少人口割合［15歳未満人口］",
              "cat01": "#A03501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03502/％//生産年齢人口割合［15～64歳人口］",
              "label": "生産年齢人口割合［15～64歳人口］",
              "cat01": "#A03502",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A03503/％//老年人口割合［65歳以上人口］",
              "label": "老年人口割合［65歳以上人口］",
              "cat01": "#A03503",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410301/％//未婚者割合［20～24歳・男］",
              "label": "未婚者割合［20～24歳・男］",
              "cat01": "#A0410301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410302/％//未婚者割合［20～24歳・女］",
              "label": "未婚者割合［20～24歳・女］",
              "cat01": "#A0410302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410401/％//未婚者割合［25～29歳・男］",
              "label": "未婚者割合［25～29歳・男］",
              "cat01": "#A0410401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410402/％//未婚者割合［25～29歳・女］",
              "label": "未婚者割合［25～29歳・女］",
              "cat01": "#A0410402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410501/％//未婚者割合［30～34歳・男］",
              "label": "未婚者割合［30～34歳・男］",
              "cat01": "#A0410501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410502/％//未婚者割合［30～34歳・女］",
              "label": "未婚者割合［30～34歳・女］",
              "cat01": "#A0410502",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410601/％//未婚者割合［35～39歳・男］",
              "label": "未婚者割合［35～39歳・男］",
              "cat01": "#A0410601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410602/％//未婚者割合［35～39歳・女］",
              "label": "未婚者割合［35～39歳・女］",
              "cat01": "#A0410602",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410701/％//未婚者割合［40～44歳・男］",
              "label": "未婚者割合［40～44歳・男］",
              "cat01": "#A0410701",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410702/％//未婚者割合［40～44歳・女］",
              "label": "未婚者割合［40～44歳・女］",
              "cat01": "#A0410702",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410801/％//未婚者割合［45～49歳・男］",
              "label": "未婚者割合［45～49歳・男］",
              "cat01": "#A0410801",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0410802/％//未婚者割合［45～49歳・女］",
              "label": "未婚者割合［45～49歳・女］",
              "cat01": "#A0410802",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0411001/％//未婚者割合（15歳以上人口）",
              "label": "未婚者割合（15歳以上人口）",
              "cat01": "#A0411001",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0430701/％//死別者割合［60歳以上・男］",
              "label": "死別者割合［60歳以上・男］",
              "cat01": "#A0430701",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0430702/％//死別者割合［60歳以上・女］",
              "label": "死別者割合［60歳以上・女］",
              "cat01": "#A0430702",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0440501/％//離別者割合［40～49歳・男］",
              "label": "離別者割合［40～49歳・男］",
              "cat01": "#A0440501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0440502/％//離別者割合［40～49歳・女］",
              "label": "離別者割合［40～49歳・女］",
              "cat01": "#A0440502",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0440601/％//離別者割合［50～59歳・男］",
              "label": "離別者割合［50～59歳・男］",
              "cat01": "#A0440601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0440602/％//離別者割合［50～59歳・女］",
              "label": "離別者割合［50～59歳・女］",
              "cat01": "#A0440602",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05101/％//人口増減率",
              "label": "人口増減率",
              "cat01": "#A05101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05201/％//自然増減率",
              "label": "自然増減率",
              "cat01": "#A05201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05202/‐//粗出生率（人口千人当たり）",
              "label": "粗出生率（人口千人当たり）",
              "cat01": "#A05202",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05203/‐//合計特殊出生率",
              "label": "合計特殊出生率",
              "cat01": "#A05203",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05204/‐//粗死亡率（人口千人当たり）",
              "label": "粗死亡率（人口千人当たり）",
              "cat01": "#A05204",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0520401/‐//粗死亡率[男]（人口千人当たり）",
              "label": "粗死亡率[男]（人口千人当たり）",
              "cat01": "#A0520401",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0520402/‐//粗死亡率[女]（人口千人当たり）",
              "label": "粗死亡率[女]（人口千人当たり）",
              "cat01": "#A0520402",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05205/‐//年齢別死亡率［０～４歳］（人口千人当たり）",
              "label": "年齢別死亡率［０～４歳］（人口千人当たり）",
              "cat01": "#A05205",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05218/‐//年齢別死亡率［65歳以上］（人口千人当たり）",
              "label": "年齢別死亡率［65歳以上］（人口千人当たり）",
              "cat01": "#A05218",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0521901/‐//年齢調整死亡率［男］（人口千人当たり）",
              "label": "年齢調整死亡率［男］（人口千人当たり）",
              "cat01": "#A0521901",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0521902/‐//年齢調整死亡率［女］（人口千人当たり）",
              "label": "年齢調整死亡率［女］（人口千人当たり）",
              "cat01": "#A0521902",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05301/％//転入超過率",
              "label": "転入超過率",
              "cat01": "#A05301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05302/％//転入率",
              "label": "転入率",
              "cat01": "#A05302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05303/％//転出率",
              "label": "転出率",
              "cat01": "#A05303",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05304/％//流入人口比率",
              "label": "流入人口比率",
              "cat01": "#A05304",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A05305/％//流出人口比率",
              "label": "流出人口比率",
              "cat01": "#A05305",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A0610101/％//全国一般世帯に占める一般世帯割合",
              "label": "全国一般世帯に占める一般世帯割合",
              "cat01": "#A0610101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06102/人//一般世帯の平均人員",
              "label": "一般世帯の平均人員",
              "cat01": "#A06102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06103/万世帯//一般世帯数",
              "label": "一般世帯数",
              "cat01": "#A06103",
              "unit": "万世帯",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06202/％//核家族世帯割合",
              "label": "核家族世帯割合",
              "cat01": "#A06202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06205/％//単独世帯割合",
              "label": "単独世帯割合",
              "cat01": "#A06205",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06301/％//65歳以上の世帯員のいる世帯割合",
              "label": "65歳以上の世帯員のいる世帯割合",
              "cat01": "#A06301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06302/％//高齢夫婦のみの世帯の割合",
              "label": "高齢夫婦のみの世帯の割合",
              "cat01": "#A06302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06304/％//高齢単身世帯の割合",
              "label": "高齢単身世帯の割合",
              "cat01": "#A06304",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06601/‐//婚姻率（人口千人当たり）",
              "label": "婚姻率（人口千人当たり）",
              "cat01": "#A06601",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010201/#A06602/‐//離婚率（人口千人当たり）",
              "label": "離婚率（人口千人当たり）",
              "cat01": "#A06602",
              "unit": "‐",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｂ自然環境",
          "statId": "0000010202",
          "children": [
            {
              "statId": "0000010202/#B011001/１００Ｋm2//総面積［北方地域及び竹島を含む］",
              "label": "総面積［北方地域及び竹島を含む］",
              "cat01": "#B011001",
              "unit": "１００Ｋm2",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B01101/％//面積割合（全国面積に占める割合）",
              "label": "面積割合（全国面積に占める割合）",
              "cat01": "#B01101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B01202/％//森林面積割合",
              "label": "森林面積割合",
              "cat01": "#B01202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B01204/％//自然公園面積割合",
              "label": "自然公園面積割合",
              "cat01": "#B01204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B01301/％//可住地面積割合",
              "label": "可住地面積割合",
              "cat01": "#B01301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B01401/％//評価総地積割合［課税対象土地］",
              "label": "評価総地積割合［課税対象土地］",
              "cat01": "#B01401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B0140101/％//評価総地積割合［田］",
              "label": "評価総地積割合［田］",
              "cat01": "#B0140101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B0140102/％//評価総地積割合［畑］",
              "label": "評価総地積割合［畑］",
              "cat01": "#B0140102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B0140103/％//評価総地積割合［宅地］",
              "label": "評価総地積割合［宅地］",
              "cat01": "#B0140103",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02101/ﾟC//年平均気温",
              "label": "年平均気温",
              "cat01": "#B02101",
              "unit": "ﾟC",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02102/ﾟC//最高気温（日最高気温の月平均の最高値）",
              "label": "最高気温（日最高気温の月平均の最高値）",
              "cat01": "#B02102",
              "unit": "ﾟC",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02103/ﾟC//最低気温（日最低気温の月平均の最低値）",
              "label": "最低気温（日最低気温の月平均の最低値）",
              "cat01": "#B02103",
              "unit": "ﾟC",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02201/％//年平均相対湿度",
              "label": "年平均相対湿度",
              "cat01": "#B02201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02301/日//快晴日数（年間）",
              "label": "快晴日数（年間）",
              "cat01": "#B02301",
              "unit": "日",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02303/日//降水日数（年間）",
              "label": "降水日数（年間）",
              "cat01": "#B02303",
              "unit": "日",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02304/日//雪日数（年間）",
              "label": "雪日数（年間）",
              "cat01": "#B02304",
              "unit": "日",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02401/時間//日照時間（年間）",
              "label": "日照時間（年間）",
              "cat01": "#B02401",
              "unit": "時間",
              "sourceId": ""
            },
            {
              "statId": "0000010202/#B02402/mm//降水量（年間）",
              "label": "降水量（年間）",
              "cat01": "#B02402",
              "unit": "mm",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｃ経済基盤",
          "statId": "0000010203",
          "children": [
            {
              "statId": "0000010203/#C01101/％//県内総生産額対前年増加率（平成17年基準）",
              "label": "県内総生産額対前年増加率（平成17年基準）",
              "cat01": "#C01101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01105/％//県民所得対前年増加率（平成17年基準）",
              "label": "県民所得対前年増加率（平成17年基準）",
              "cat01": "#C01105",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01106/％//県民総所得対前年増加率［名目］（平成17年基準）",
              "label": "県民総所得対前年増加率［名目］（平成17年基準）",
              "cat01": "#C01106",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01107/％//県民総所得対前年増加率［実質］（平成17年基準）",
              "label": "県民総所得対前年増加率［実質］（平成17年基準）",
              "cat01": "#C01107",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01111/％//県内総生産額対前年増加率（平成23年基準）",
              "label": "県内総生産額対前年増加率（平成23年基準）",
              "cat01": "#C01111",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01115/％//県民所得対前年増加率（平成23年基準）",
              "label": "県民所得対前年増加率（平成23年基準）",
              "cat01": "#C01115",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01116/％//県民総所得対前年増加率（名目）（平成23年基準）",
              "label": "県民総所得対前年増加率（名目）（平成23年基準）",
              "cat01": "#C01116",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01301/千円//１人当たり県民所得（平成17年基準）",
              "label": "１人当たり県民所得（平成17年基準）",
              "cat01": "#C01301",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C01311/千円//１人当たり県民所得（平成23年基準）",
              "label": "１人当たり県民所得（平成23年基準）",
              "cat01": "#C01311",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02102/％//第２次産業事業所数構成比（事業所・企業統計調査結果）",
              "label": "第２次産業事業所数構成比（事業所・企業統計調査結果）",
              "cat01": "#C02102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02103/％//第３次産業事業所数構成比（事業所・企業統計調査結果）",
              "label": "第３次産業事業所数構成比（事業所・企業統計調査結果）",
              "cat01": "#C02103",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02104/％//第２次産業事業所数構成比",
              "label": "第２次産業事業所数構成比",
              "cat01": "#C02104",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02105/％//第３次産業事業所数構成比",
              "label": "第３次産業事業所数構成比",
              "cat01": "#C02105",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02206/％//従業者１～４人の事業所割合〔民営〕",
              "label": "従業者１～４人の事業所割合〔民営〕",
              "cat01": "#C02206",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02207/％//従業者５～９人の事業所割合〔民営〕",
              "label": "従業者５～９人の事業所割合〔民営〕",
              "cat01": "#C02207",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02208/％//従業者10～29人の事業所割合〔民営〕",
              "label": "従業者10～29人の事業所割合〔民営〕",
              "cat01": "#C02208",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02209/％//従業者100～299人の事業所割合〔民営〕",
              "label": "従業者100～299人の事業所割合〔民営〕",
              "cat01": "#C02209",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C02210/％//従業者300人以上の事業所割合〔民営〕",
              "label": "従業者300人以上の事業所割合〔民営〕",
              "cat01": "#C02210",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03206/％//従業者１～４人の事業所の従業者割合［民営］",
              "label": "従業者１～４人の事業所の従業者割合［民営］",
              "cat01": "#C03206",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03207/％//従業者５～９人の事業所の従業者割合［民営］",
              "label": "従業者５～９人の事業所の従業者割合［民営］",
              "cat01": "#C03207",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03208/％//従業者10～29人の事業所の従業者割合［民営］",
              "label": "従業者10～29人の事業所の従業者割合［民営］",
              "cat01": "#C03208",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03209/％//従業者100～299人の事業所の従業者割合［民営］",
              "label": "従業者100～299人の事業所の従業者割合［民営］",
              "cat01": "#C03209",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03210/％//従業者300人以上の事業所の従業者割合［民営］",
              "label": "従業者300人以上の事業所の従業者割合［民営］",
              "cat01": "#C03210",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03303/人//第２次産業従業者数（１事業所当たり）（事業所・企業統計調査結果）",
              "label": "第２次産業従業者数（１事業所当たり）（事業所・企業統計調査結果）",
              "cat01": "#C03303",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03304/人//第３次産業従業者数（１事業所当たり）（事業所・企業統計調査結果）",
              "label": "第３次産業従業者数（１事業所当たり）（事業所・企業統計調査結果）",
              "cat01": "#C03304",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03305/人//第２次産業従業者数（１事業所当たり）",
              "label": "第２次産業従業者数（１事業所当たり）",
              "cat01": "#C03305",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C03306/人//第３次産業従業者数（１事業所当たり）",
              "label": "第３次産業従業者数（１事業所当たり）",
              "cat01": "#C03306",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C0410101/万円//就業者１人当たり農業産出額(販売農家）",
              "label": "就業者１人当たり農業産出額(販売農家）",
              "cat01": "#C0410101",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04105/％//耕地面積比率",
              "label": "耕地面積比率",
              "cat01": "#C04105",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04106/万円//土地生産性（耕地面積１ヘクタール当たり）",
              "label": "土地生産性（耕地面積１ヘクタール当たり）",
              "cat01": "#C04106",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C0410701/ｍ2//耕地面積（農家１戸当たり）",
              "label": "耕地面積（農家１戸当たり）",
              "cat01": "#C0410701",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04401/万円//製造品出荷額等（従業者１人当たり）",
              "label": "製造品出荷額等（従業者１人当たり）",
              "cat01": "#C04401",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04404/百万円//製造品出荷額等（１事業所当たり）",
              "label": "製造品出荷額等（１事業所当たり）",
              "cat01": "#C04404",
              "unit": "百万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04505/万円//商業年間商品販売額［卸売業＋小売業］（従業者１人当たり）",
              "label": "商業年間商品販売額［卸売業＋小売業］（従業者１人当たり）",
              "cat01": "#C04505",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04507/百万円//商業年間商品販売額［卸売業＋小売業］（事業所当たり）",
              "label": "商業年間商品販売額［卸売業＋小売業］（事業所当たり）",
              "cat01": "#C04507",
              "unit": "百万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04601/万円//預貯金残高（人口１人当たり）",
              "label": "預貯金残高（人口１人当たり）",
              "cat01": "#C04601",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C0460101/万円//郵便貯金残高（人口１人当たり）",
              "label": "郵便貯金残高（人口１人当たり）",
              "cat01": "#C0460101",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010203/#C04605/万円//国内銀行預金残高（人口１人当たり）",
              "label": "国内銀行預金残高（人口１人当たり）",
              "cat01": "#C04605",
              "unit": "万円",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｄ行政基盤",
          "statId": "0000010204",
          "children": [
            {
              "statId": "0000010204/#D0110101/‐//財政力指数［県財政］",
              "label": "財政力指数［県財政］",
              "cat01": "#D0110101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D01102/％//実質収支比率［県財政］",
              "label": "実質収支比率［県財政］",
              "cat01": "#D01102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0120101/％//自主財源の割合［県財政］",
              "label": "自主財源の割合［県財政］",
              "cat01": "#D0120101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0130201/％//地方債現在高の割合［県財政］",
              "label": "地方債現在高の割合［県財政］",
              "cat01": "#D0130201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D01401/％//経常収支比率［県財政］",
              "label": "経常収支比率［県財政］",
              "cat01": "#D01401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0140201/％//投資的経費の割合［県財政］",
              "label": "投資的経費の割合［県財政］",
              "cat01": "#D0140201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0140301/％//一般財源の割合［県財政］",
              "label": "一般財源の割合［県財政］",
              "cat01": "#D0140301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0210101/％//地方税割合［県財政］",
              "label": "地方税割合［県財政］",
              "cat01": "#D0210101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0210201/％//地方交付税割合［県財政］",
              "label": "地方交付税割合［県財政］",
              "cat01": "#D0210201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0210301/％//国庫支出金割合［県財政］",
              "label": "国庫支出金割合［県財政］",
              "cat01": "#D0210301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0220103/千円//人口１人当たり住民税［県・市町村財政合計］",
              "label": "人口１人当たり住民税［県・市町村財政合計］",
              "cat01": "#D0220103",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D02202/千円//人口１人当たり固定資産税［県・市町村財政合計］",
              "label": "人口１人当たり固定資産税［県・市町村財政合計］",
              "cat01": "#D02202",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D02204/千円//国税徴収決定済額（人口１人当たり）",
              "label": "国税徴収決定済額（人口１人当たり）",
              "cat01": "#D02204",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D02206/千円//課税対象所得（納税義務者１人当たり）",
              "label": "課税対象所得（納税義務者１人当たり）",
              "cat01": "#D02206",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D02207/％//納税義務者割合",
              "label": "納税義務者割合",
              "cat01": "#D02207",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310301/％//民生費割合［県財政］",
              "label": "民生費割合［県財政］",
              "cat01": "#D0310301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310401/％//社会福祉費割合［県財政］",
              "label": "社会福祉費割合［県財政］",
              "cat01": "#D0310401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310501/％//老人福祉費割合［県財政］",
              "label": "老人福祉費割合［県財政］",
              "cat01": "#D0310501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310601/％//児童福祉費割合［県財政］",
              "label": "児童福祉費割合［県財政］",
              "cat01": "#D0310601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310701/％//生活保護費割合［県財政］",
              "label": "生活保護費割合［県財政］",
              "cat01": "#D0310701",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310801/％//衛生費割合［県財政］",
              "label": "衛生費割合［県財政］",
              "cat01": "#D0310801",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0310901/％//労働費割合［県財政］",
              "label": "労働費割合［県財政］",
              "cat01": "#D0310901",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0311001/％//農林水産業費割合［県財政］",
              "label": "農林水産業費割合［県財政］",
              "cat01": "#D0311001",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0311101/％//商工費割合［県財政］",
              "label": "商工費割合［県財政］",
              "cat01": "#D0311101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0311201/％//土木費割合［県財政］",
              "label": "土木費割合［県財政］",
              "cat01": "#D0311201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D03113/％//警察費割合［県財政］",
              "label": "警察費割合［県財政］",
              "cat01": "#D03113",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D03114/％//消防費割合［都・市町村財政合計］",
              "label": "消防費割合［都・市町村財政合計］",
              "cat01": "#D03114",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0311501/％//教育費割合［県財政］",
              "label": "教育費割合［県財政］",
              "cat01": "#D0311501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0312301/％//災害復旧費割合［県財政］",
              "label": "災害復旧費割合［県財政］",
              "cat01": "#D0312301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0320101/％//人件費割合［県財政］",
              "label": "人件費割合［県財政］",
              "cat01": "#D0320101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0320201/％//扶助費割合［県財政］",
              "label": "扶助費割合［県財政］",
              "cat01": "#D0320201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0320301/％//普通建設事業費割合［県財政］",
              "label": "普通建設事業費割合［県財政］",
              "cat01": "#D0320301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330103/千円//人口１人当たり歳出決算総額［県・市町村財政合計］",
              "label": "人口１人当たり歳出決算総額［県・市町村財政合計］",
              "cat01": "#D0330103",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330203/千円//人口１人当たり民生費［県・市町村財政合計］",
              "label": "人口１人当たり民生費［県・市町村財政合計］",
              "cat01": "#D0330203",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330303/千円//人口１人当たり社会福祉費［県・市町村財政合計］",
              "label": "人口１人当たり社会福祉費［県・市町村財政合計］",
              "cat01": "#D0330303",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330403/千円//65歳以上人口１人当たり老人福祉費［県・市町村財政合計］",
              "label": "65歳以上人口１人当たり老人福祉費［県・市町村財政合計］",
              "cat01": "#D0330403",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330503/千円//17歳以下人口１人当たり児童福祉費［県・市町村財政合計］",
              "label": "17歳以下人口１人当たり児童福祉費［県・市町村財政合計］",
              "cat01": "#D0330503",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330603/千円//被保護実人員１人当たり生活保護費［県・市町村財政合計］",
              "label": "被保護実人員１人当たり生活保護費［県・市町村財政合計］",
              "cat01": "#D0330603",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0330703/千円//人口１人当たり衛生費［県・市町村財政合計］",
              "label": "人口１人当たり衛生費［県・市町村財政合計］",
              "cat01": "#D0330703",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331103/千円//人口１人当たり土木費［県・市町村財政合計］",
              "label": "人口１人当たり土木費［県・市町村財政合計］",
              "cat01": "#D0331103",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D03312/千円//人口１人当たり警察費［県財政］",
              "label": "人口１人当たり警察費［県財政］",
              "cat01": "#D03312",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D03313/千円//人口１人当たり消防費［都・市町村財政合計］",
              "label": "人口１人当たり消防費［都・市町村財政合計］",
              "cat01": "#D03313",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331403/千円//人口１人当たり教育費［県・市町村財政合計］",
              "label": "人口１人当たり教育費［県・市町村財政合計］",
              "cat01": "#D0331403",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331503/千円//児童１人当たり公立小学校費［県・市町村財政合計］",
              "label": "児童１人当たり公立小学校費［県・市町村財政合計］",
              "cat01": "#D0331503",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331603/千円//生徒１人当たり公立中学校費［県・市町村財政合計］",
              "label": "生徒１人当たり公立中学校費［県・市町村財政合計］",
              "cat01": "#D0331603",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331703/千円//生徒１人当たり公立高等学校費［県・市町村財政合計］",
              "label": "生徒１人当たり公立高等学校費［県・市町村財政合計］",
              "cat01": "#D0331703",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331804/千円//児童・生徒１人当たり特別支援学校費［県・市町村財政合計］",
              "label": "児童・生徒１人当たり特別支援学校費［県・市町村財政合計］",
              "cat01": "#D0331804",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0331903/千円//児童１人当たり幼稚園費［県・市町村財政合計］",
              "label": "児童１人当たり幼稚園費［県・市町村財政合計］",
              "cat01": "#D0331903",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0332003/千円//人口１人当たり社会教育費［県・市町村財政合計］",
              "label": "人口１人当たり社会教育費［県・市町村財政合計］",
              "cat01": "#D0332003",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010204/#D0332103/千円//人口１人当たり災害復旧費［県・市町村財政合計］",
              "label": "人口１人当たり災害復旧費［県・市町村財政合計］",
              "cat01": "#D0332103",
              "unit": "千円",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｅ教育",
          "statId": "0000010205",
          "children": [
            {
              "statId": "0000010205/#E0110101/校//小学校数（６～11歳人口10万人当たり）",
              "label": "小学校数（６～11歳人口10万人当たり）",
              "cat01": "#E0110101",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110102/校//中学校数（12～14歳人口10万人当たり）",
              "label": "中学校数（12～14歳人口10万人当たり）",
              "cat01": "#E0110102",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110103/校//高等学校数（15～17歳人口10万人当たり）",
              "label": "高等学校数（15～17歳人口10万人当たり）",
              "cat01": "#E0110103",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110104/園//幼稚園数（３～５歳人口10万人当たり）",
              "label": "幼稚園数（３～５歳人口10万人当たり）",
              "cat01": "#E0110104",
              "unit": "園",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110105/所//保育所等数（０～５歳人口10万人当たり）",
              "label": "保育所等数（０～５歳人口10万人当たり）",
              "cat01": "#E0110105",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110201/校//小学校数（可住地面積100km2当たり）",
              "label": "小学校数（可住地面積100km2当たり）",
              "cat01": "#E0110201",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110202/校//中学校数（可住地面積100km2当たり）",
              "label": "中学校数（可住地面積100km2当たり）",
              "cat01": "#E0110202",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0110203/校//高等学校数（可住地面積100km2当たり）",
              "label": "高等学校数（可住地面積100km2当たり）",
              "cat01": "#E0110203",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E01303/％//公立高等学校割合",
              "label": "公立高等学校割合",
              "cat01": "#E01303",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E01304/％//公立幼稚園割合",
              "label": "公立幼稚園割合",
              "cat01": "#E01304",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E01305/％//公営保育所等割合",
              "label": "公営保育所等割合",
              "cat01": "#E01305",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0210101/ｍ2//公立小学校校地面積（児童１人当たり）",
              "label": "公立小学校校地面積（児童１人当たり）",
              "cat01": "#E0210101",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0210102/ｍ2//公立中学校校地面積（生徒１人当たり）",
              "label": "公立中学校校地面積（生徒１人当たり）",
              "cat01": "#E0210102",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0210103/ｍ2//公立高等学校校地面積（生徒１人当たり）",
              "label": "公立高等学校校地面積（生徒１人当たり）",
              "cat01": "#E0210103",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0240101/ｍ2//公立小学校屋外運動場面積（児童１人当たり）",
              "label": "公立小学校屋外運動場面積（児童１人当たり）",
              "cat01": "#E0240101",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0240102/ｍ2//公立中学校屋外運動場面積（生徒１人当たり）",
              "label": "公立中学校屋外運動場面積（生徒１人当たり）",
              "cat01": "#E0240102",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02601/％//公立小学校屋内運動場設置率",
              "label": "公立小学校屋内運動場設置率",
              "cat01": "#E02601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02602/％//公立中学校屋内運動場設置率",
              "label": "公立中学校屋内運動場設置率",
              "cat01": "#E02602",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02603/％//公立高等学校屋内運動場設置率",
              "label": "公立高等学校屋内運動場設置率",
              "cat01": "#E02603",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02701/％//公立小学校プール設置率",
              "label": "公立小学校プール設置率",
              "cat01": "#E02701",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02702/％//公立中学校プール設置率",
              "label": "公立中学校プール設置率",
              "cat01": "#E02702",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E02703/％//公立高等学校プール設置率",
              "label": "公立高等学校プール設置率",
              "cat01": "#E02703",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0410201/％//女子教員割合［小学校］",
              "label": "女子教員割合［小学校］",
              "cat01": "#E0410201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0410202/％//女子教員割合［中学校］",
              "label": "女子教員割合［中学校］",
              "cat01": "#E0410202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510205/人//小学校児童数（１学級当たり）",
              "label": "小学校児童数（１学級当たり）",
              "cat01": "#E0510205",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510206/人//中学校生徒数（１学級当たり）",
              "label": "中学校生徒数（１学級当たり）",
              "cat01": "#E0510206",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510301/人//小学校児童数（教員１人当たり）",
              "label": "小学校児童数（教員１人当たり）",
              "cat01": "#E0510301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510302/人//中学校生徒数（教員１人当たり）",
              "label": "中学校生徒数（教員１人当たり）",
              "cat01": "#E0510302",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510303/人//高等学校生徒数（教員１人当たり）",
              "label": "高等学校生徒数（教員１人当たり）",
              "cat01": "#E0510303",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510304/人//幼稚園在園者数（教員１人当たり）",
              "label": "幼稚園在園者数（教員１人当たり）",
              "cat01": "#E0510304",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0510305/人//保育所等在所児数（保育士１人当たり）",
              "label": "保育所等在所児数（保育士１人当たり）",
              "cat01": "#E0510305",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E05203/％//公立高等学校生徒比率",
              "label": "公立高等学校生徒比率",
              "cat01": "#E05203",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E05204/％//公立幼稚園在園者比率",
              "label": "公立幼稚園在園者比率",
              "cat01": "#E05204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E05205/％//公営保育所等在所児比率",
              "label": "公営保育所等在所児比率",
              "cat01": "#E05205",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0610101/校//短期大学数（人口10万人当たり）",
              "label": "短期大学数（人口10万人当たり）",
              "cat01": "#E0610101",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0610102/校//大学数（人口10万人当たり）",
              "label": "大学数（人口10万人当たり）",
              "cat01": "#E0610102",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0610201/‐//短期大学収容力指数",
              "label": "短期大学収容力指数",
              "cat01": "#E0610201",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0610202/‐//大学収容力指数",
              "label": "大学収容力指数",
              "cat01": "#E0610202",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0620401/％//国立大学学生数割合",
              "label": "国立大学学生数割合",
              "cat01": "#E0620401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0620402/％//公立大学学生数割合",
              "label": "公立大学学生数割合",
              "cat01": "#E0620402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0620403/％//私立大学学生数割合",
              "label": "私立大学学生数割合",
              "cat01": "#E0620403",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E08101/校//専修学校数（人口10万人当たり）",
              "label": "専修学校数（人口10万人当たり）",
              "cat01": "#E08101",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E08102/校//各種学校数（人口10万人当たり）",
              "label": "各種学校数（人口10万人当たり）",
              "cat01": "#E08102",
              "unit": "校",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E08201/人//専修学校生徒数（人口千人当たり）",
              "label": "専修学校生徒数（人口千人当たり）",
              "cat01": "#E08201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E08202/人//各種学校生徒数（人口千人当たり）",
              "label": "各種学校生徒数（人口千人当たり）",
              "cat01": "#E08202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0910101/％//教育普及度［幼稚園］",
              "label": "教育普及度［幼稚園］",
              "cat01": "#E0910101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0910102/％//教育普及度［保育所等］",
              "label": "教育普及度［保育所等］",
              "cat01": "#E0910102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0910402/％//保育所等利用率",
              "label": "保育所等利用率",
              "cat01": "#E0910402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09211/‐//小学校長期欠席児童比率［年度間30日以上］（児童千人当たり）",
              "label": "小学校長期欠席児童比率［年度間30日以上］（児童千人当たり）",
              "cat01": "#E09211",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09212/‐//中学校長期欠席生徒比率［年度間30日以上］（生徒千人当たり）",
              "label": "中学校長期欠席生徒比率［年度間30日以上］（生徒千人当たり）",
              "cat01": "#E09212",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09213/‐//不登校による小学校長期欠席児童比率[年度間30日以上](児童千人当たり)",
              "label": "不登校による小学校長期欠席児童比率[年度間30日以上](児童千人当たり)",
              "cat01": "#E09213",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09214/‐//不登校による中学校長期欠席生徒比率[年度間30日以上](生徒千人当たり)",
              "label": "不登校による中学校長期欠席生徒比率[年度間30日以上](生徒千人当たり)",
              "cat01": "#E09214",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09401/％//中学校卒業者の進学率",
              "label": "中学校卒業者の進学率",
              "cat01": "#E09401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09402/％//高等学校卒業者の進学率",
              "label": "高等学校卒業者の進学率",
              "cat01": "#E09402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E0940302/％//出身高校所在地県の県内大学への入学者割合",
              "label": "出身高校所在地県の県内大学への入学者割合",
              "cat01": "#E0940302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09501/％//最終学歴が小学・中学卒の者の割合",
              "label": "最終学歴が小学・中学卒の者の割合",
              "cat01": "#E09501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09502/％//最終学歴が高校・旧中卒の者の割合",
              "label": "最終学歴が高校・旧中卒の者の割合",
              "cat01": "#E09502",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09503/％//最終学歴が短大・高専卒の者の割合",
              "label": "最終学歴が短大・高専卒の者の割合",
              "cat01": "#E09503",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E09504/％//最終学歴が大学・大学院卒の者の割合",
              "label": "最終学歴が大学・大学院卒の者の割合",
              "cat01": "#E09504",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E10101/円//幼稚園教育費（在園者１人当たり）",
              "label": "幼稚園教育費（在園者１人当たり）",
              "cat01": "#E10101",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E10102/円//小学校教育費（児童１人当たり）",
              "label": "小学校教育費（児童１人当たり）",
              "cat01": "#E10102",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E10103/円//中学校教育費（生徒１人当たり）",
              "label": "中学校教育費（生徒１人当たり）",
              "cat01": "#E10103",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010205/#E10104/円//高等学校教育費［全日制］（生徒１人当たり）",
              "label": "高等学校教育費［全日制］（生徒１人当たり）",
              "cat01": "#E10104",
              "unit": "円",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｆ労働",
          "statId": "0000010206",
          "children": [
            {
              "statId": "0000010206/#F0110101/％//労働力人口比率［男］",
              "label": "労働力人口比率［男］",
              "cat01": "#F0110101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0110102/％//労働力人口比率［女］",
              "label": "労働力人口比率［女］",
              "cat01": "#F0110102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01102/％//就業者比率",
              "label": "就業者比率",
              "cat01": "#F01102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01201/％//第１次産業就業者比率",
              "label": "第１次産業就業者比率",
              "cat01": "#F01201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01202/％//第２次産業就業者比率",
              "label": "第２次産業就業者比率",
              "cat01": "#F01202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01203/％//第３次産業就業者比率",
              "label": "第３次産業就業者比率",
              "cat01": "#F01203",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01204/％//第２次産業及び第３次産業就業者比率（対就業者）",
              "label": "第２次産業及び第３次産業就業者比率（対就業者）",
              "cat01": "#F01204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01301/％//完全失業率",
              "label": "完全失業率",
              "cat01": "#F01301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0130101/％//完全失業率［男］",
              "label": "完全失業率［男］",
              "cat01": "#F0130101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0130102/％//完全失業率［女］",
              "label": "完全失業率［女］",
              "cat01": "#F0130102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F01503/％//共働き世帯割合",
              "label": "共働き世帯割合",
              "cat01": "#F01503",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F02301/％//雇用者比率",
              "label": "雇用者比率",
              "cat01": "#F02301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F02501/％//県内就業者比率",
              "label": "県内就業者比率",
              "cat01": "#F02501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0260101/％//出稼者比率（販売農家）",
              "label": "出稼者比率（販売農家）",
              "cat01": "#F0260101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F02701/％//他市区町村への通勤者比率",
              "label": "他市区町村への通勤者比率",
              "cat01": "#F02701",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F02702/％//他市区町村からの通勤者比率",
              "label": "他市区町村からの通勤者比率",
              "cat01": "#F02702",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03101/％//就職率",
              "label": "就職率",
              "cat01": "#F03101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03102/％//県外就職者比率",
              "label": "県外就職者比率",
              "cat01": "#F03102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03103/倍//有効求人倍率",
              "label": "有効求人倍率",
              "cat01": "#F03103",
              "unit": "倍",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03104/％//充足率",
              "label": "充足率",
              "cat01": "#F03104",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0320101/％//パートタイム就職率［常用］",
              "label": "パートタイム就職率［常用］",
              "cat01": "#F0320101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03230/人//女性パートタイム労働者数",
              "label": "女性パートタイム労働者数",
              "cat01": "#F03230",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03240/人//男性パートタイム労働者数",
              "label": "男性パートタイム労働者数",
              "cat01": "#F03240",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03301/％//高等学校新規卒業者の就職率",
              "label": "高等学校新規卒業者の就職率",
              "cat01": "#F03301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03302/％//高卒者に占める県外就職者の割合",
              "label": "高卒者に占める県外就職者の割合",
              "cat01": "#F03302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03303/％//高卒者に占める就職者の割合",
              "label": "高卒者に占める就職者の割合",
              "cat01": "#F03303",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03304/倍//高等学校新規卒業者の求人倍率",
              "label": "高等学校新規卒業者の求人倍率",
              "cat01": "#F03304",
              "unit": "倍",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03401/％//短大新規卒業者の無業者率",
              "label": "短大新規卒業者の無業者率",
              "cat01": "#F03401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03402/％//大学新規卒業者の無業者率",
              "label": "大学新規卒業者の無業者率",
              "cat01": "#F03402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03403/％//大学卒業者に占める就職者の割合",
              "label": "大学卒業者に占める就職者の割合",
              "cat01": "#F03403",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0350101/％//中高年齢者就職率［45歳以上］",
              "label": "中高年齢者就職率［45歳以上］",
              "cat01": "#F0350101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0350201/％//就職者に占める中高年齢者の比率［45歳以上］",
              "label": "就職者に占める中高年齢者の比率［45歳以上］",
              "cat01": "#F0350201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0350303/％//高齢就業者割合[65歳以上]",
              "label": "高齢就業者割合[65歳以上]",
              "cat01": "#F0350303",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0350403/％//高齢一般労働者割合[65歳以上]",
              "label": "高齢一般労働者割合[65歳以上]",
              "cat01": "#F0350403",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F03601/‐//就職者に占める身体障害者の比率（就職件数千件当たり）",
              "label": "就職者に占める身体障害者の比率（就職件数千件当たり）",
              "cat01": "#F03601",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F04101/％//転職率",
              "label": "転職率",
              "cat01": "#F04101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F04102/％//離職率",
              "label": "離職率",
              "cat01": "#F04102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F04103/％//新規就業率",
              "label": "新規就業率",
              "cat01": "#F04103",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F04104/％//就業異動率",
              "label": "就業異動率",
              "cat01": "#F04104",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F05101/所//公共職業能力開発施設数（15歳以上人口100万人当たり）",
              "label": "公共職業能力開発施設数（15歳以上人口100万人当たり）",
              "cat01": "#F05101",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0610101/時間//月間平均実労働時間数［男］",
              "label": "月間平均実労働時間数［男］",
              "cat01": "#F0610101",
              "unit": "時間",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0610102/時間//月間平均実労働時間数［女］",
              "label": "月間平均実労働時間数［女］",
              "cat01": "#F0610102",
              "unit": "時間",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620101/千円//きまって支給する現金給与月額［男］",
              "label": "きまって支給する現金給与月額［男］",
              "cat01": "#F0620101",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620102/千円//きまって支給する現金給与月額［女］",
              "label": "きまって支給する現金給与月額［女］",
              "cat01": "#F0620102",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620301/千円//高等学校新規卒業者初任給［男］",
              "label": "高等学校新規卒業者初任給［男］",
              "cat01": "#F0620301",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620302/千円//高等学校新規卒業者初任給［女］",
              "label": "高等学校新規卒業者初任給［女］",
              "cat01": "#F0620302",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620303/千円//大学新規卒業者初任給［男］",
              "label": "大学新規卒業者初任給［男］",
              "cat01": "#F0620303",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F0620304/千円//短大新規卒業者初任給［女］",
              "label": "短大新規卒業者初任給［女］",
              "cat01": "#F0620304",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F06204/円//女性パートタイムの給与（１時間当たり）",
              "label": "女性パートタイムの給与（１時間当たり）",
              "cat01": "#F06204",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F06205/円//男性パートタイムの給与（１時間当たり）",
              "label": "男性パートタイムの給与（１時間当たり）",
              "cat01": "#F06205",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F07101/％//雇用保険受給率",
              "label": "雇用保険受給率",
              "cat01": "#F07101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F07102/千円//雇用保険基本手当平均支給額",
              "label": "雇用保険基本手当平均支給額",
              "cat01": "#F07102",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F07201/％//雇用保険［日雇］受給率",
              "label": "雇用保険［日雇］受給率",
              "cat01": "#F07201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F07202/千円//雇用保険［日雇］基本手当平均支給額",
              "label": "雇用保険［日雇］基本手当平均支給額",
              "cat01": "#F07202",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F08101/％//労働者災害補償保険給付率",
              "label": "労働者災害補償保険給付率",
              "cat01": "#F08101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F08102/千円//労働者災害補償保険給付平均支給額",
              "label": "労働者災害補償保険給付平均支給額",
              "cat01": "#F08102",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F08201/‐//労働災害発生の頻度",
              "label": "労働災害発生の頻度",
              "cat01": "#F08201",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010206/#F08202/‐//労働災害の重さの程度",
              "label": "労働災害の重さの程度",
              "cat01": "#F08202",
              "unit": "‐",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｇ文化・スポーツ",
          "statId": "0000010207",
          "children": [
            {
              "statId": "0000010207/#G01101/館//公民館数（人口100万人当たり）",
              "label": "公民館数（人口100万人当たり）",
              "cat01": "#G01101",
              "unit": "館",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01104/館//図書館数（人口100万人当たり）",
              "label": "図書館数（人口100万人当たり）",
              "cat01": "#G01104",
              "unit": "館",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01107/館//博物館数（人口100万人当たり）",
              "label": "博物館数（人口100万人当たり）",
              "cat01": "#G01107",
              "unit": "館",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01109/所//青少年教育施設数（人口100万人当たり）",
              "label": "青少年教育施設数（人口100万人当たり）",
              "cat01": "#G01109",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01115/所//勤労青少年・婦人福祉施設数（人口100万人当たり）",
              "label": "勤労青少年・婦人福祉施設数（人口100万人当たり）",
              "cat01": "#G01115",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01202/館//常設映画館数（人口100万人当たり）",
              "label": "常設映画館数（人口100万人当たり）",
              "cat01": "#G01202",
              "unit": "館",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01321/施設//社会体育施設数（人口100万人当たり）",
              "label": "社会体育施設数（人口100万人当たり）",
              "cat01": "#G01321",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01323/施設//多目的運動広場数（人口100万人当たり）",
              "label": "多目的運動広場数（人口100万人当たり）",
              "cat01": "#G01323",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01325/所//体育館数（人口100万人当たり）",
              "label": "体育館数（人口100万人当たり）",
              "cat01": "#G01325",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G01326/所//水泳プール数［屋内，屋外］（人口100万人当たり）",
              "label": "水泳プール数［屋内，屋外］（人口100万人当たり）",
              "cat01": "#G01326",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G03201/学級･講座//青少年学級・講座数（人口100万人当たり）",
              "label": "青少年学級・講座数（人口100万人当たり）",
              "cat01": "#G03201",
              "unit": "学級･講座",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G03203/学級･講座//成人一般学級・講座数（人口100万人当たり）",
              "label": "成人一般学級・講座数（人口100万人当たり）",
              "cat01": "#G03203",
              "unit": "学級･講座",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G0320501/学級･講座//女性学級・講座数（女性人口100万人当たり）",
              "label": "女性学級・講座数（女性人口100万人当たり）",
              "cat01": "#G0320501",
              "unit": "学級･講座",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G03207/学級･講座//高齢者学級・講座数（人口100万人当たり）",
              "label": "高齢者学級・講座数（人口100万人当たり）",
              "cat01": "#G03207",
              "unit": "学級･講座",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G04101/％//ボランティア活動の年間行動者率（１５歳以上）",
              "label": "ボランティア活動の年間行動者率（１５歳以上）",
              "cat01": "#G04101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G041011/％//ボランティア活動の年間行動者率（１０歳以上）",
              "label": "ボランティア活動の年間行動者率（１０歳以上）",
              "cat01": "#G041011",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G042111/％//スポーツの年間行動者率（１０歳以上）",
              "label": "スポーツの年間行動者率（１０歳以上）",
              "cat01": "#G042111",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G0430501/件//一般旅券発行件数（人口千人当たり）",
              "label": "一般旅券発行件数（人口千人当たり）",
              "cat01": "#G0430501",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G04306/％//旅行・行楽の年間行動者率（１５歳以上）",
              "label": "旅行・行楽の年間行動者率（１５歳以上）",
              "cat01": "#G04306",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G043061/％//旅行・行楽の年間行動者率（１０歳以上）",
              "label": "旅行・行楽の年間行動者率（１０歳以上）",
              "cat01": "#G043061",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G04307/％//海外旅行の年間行動者率（１５歳以上）",
              "label": "海外旅行の年間行動者率（１５歳以上）",
              "cat01": "#G04307",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G043071/％//海外旅行の年間行動者率（１０歳以上）",
              "label": "海外旅行の年間行動者率（１０歳以上）",
              "cat01": "#G043071",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G04308/％//客室稼働率",
              "label": "客室稼働率",
              "cat01": "#G04308",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010207/#G05102/円//書籍・雑誌小売業年間商品販売額（人口１人当たり）",
              "label": "書籍・雑誌小売業年間商品販売額（人口１人当たり）",
              "cat01": "#G05102",
              "unit": "円",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｈ居住",
          "statId": "0000010208",
          "children": [
            {
              "statId": "0000010208/#H01204/％//着工新設住宅比率",
              "label": "着工新設住宅比率",
              "cat01": "#H01204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01301/％//持ち家比率",
              "label": "持ち家比率",
              "cat01": "#H01301",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01302/％//借家比率",
              "label": "借家比率",
              "cat01": "#H01302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0130202/％//民営借家比率",
              "label": "民営借家比率",
              "cat01": "#H0130202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01401/％//一戸建住宅比率",
              "label": "一戸建住宅比率",
              "cat01": "#H01401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01402/％//長屋建住宅比率",
              "label": "長屋建住宅比率",
              "cat01": "#H01402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01403/％//共同住宅比率",
              "label": "共同住宅比率",
              "cat01": "#H01403",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01405/％//空き家比率",
              "label": "空き家比率",
              "cat01": "#H01405",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01601/％//着工新設持ち家比率",
              "label": "着工新設持ち家比率",
              "cat01": "#H01601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H01603/％//着工新設貸家比率",
              "label": "着工新設貸家比率",
              "cat01": "#H01603",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H02101/室//居住室数（１住宅当たり）",
              "label": "居住室数（１住宅当たり）",
              "cat01": "#H02101",
              "unit": "室",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210101/室//居住室数（１住宅当たり）[持ち家]",
              "label": "居住室数（１住宅当たり）[持ち家]",
              "cat01": "#H0210101",
              "unit": "室",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210102/室//居住室数（１住宅当たり）[借家]",
              "label": "居住室数（１住宅当たり）[借家]",
              "cat01": "#H0210102",
              "unit": "室",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210201/畳//持ち家住宅の居住室の畳数（１住宅当たり）",
              "label": "持ち家住宅の居住室の畳数（１住宅当たり）",
              "cat01": "#H0210201",
              "unit": "畳",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210202/畳//借家住宅の居住室の畳数（１住宅当たり）",
              "label": "借家住宅の居住室の畳数（１住宅当たり）",
              "cat01": "#H0210202",
              "unit": "畳",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210301/ｍ2//持ち家住宅の延べ面積（１住宅当たり）",
              "label": "持ち家住宅の延べ面積（１住宅当たり）",
              "cat01": "#H0210301",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210302/ｍ2//借家住宅の延べ面積（１住宅当たり）",
              "label": "借家住宅の延べ面積（１住宅当たり）",
              "cat01": "#H0210302",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H02104/ｍ2//１住宅当たりの敷地面積",
              "label": "１住宅当たりの敷地面積",
              "cat01": "#H02104",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210701/ｍ2//着工新設持ち家住宅の床面積（１住宅当たり）",
              "label": "着工新設持ち家住宅の床面積（１住宅当たり）",
              "cat01": "#H0210701",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0210703/ｍ2//着工新設貸家住宅の床面積（１住宅当たり）",
              "label": "着工新設貸家住宅の床面積（１住宅当たり）",
              "cat01": "#H0210703",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0220301/畳//持ち家住宅の畳数（１人当たり）",
              "label": "持ち家住宅の畳数（１人当たり）",
              "cat01": "#H0220301",
              "unit": "畳",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0220302/畳//借家住宅の畳数（１人当たり）",
              "label": "借家住宅の畳数（１人当たり）",
              "cat01": "#H0220302",
              "unit": "畳",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H02302/％//水洗トイレのある住宅比率",
              "label": "水洗トイレのある住宅比率",
              "cat01": "#H02302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H02303/％//浴室のある住宅比率",
              "label": "浴室のある住宅比率",
              "cat01": "#H02303",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H02602/％//最低居住面積水準以上世帯割合",
              "label": "最低居住面積水準以上世帯割合",
              "cat01": "#H02602",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H03101/‐//家計を主に支える者が雇用者である普通世帯比率（通勤時間90分以上）（普通世帯千世帯当たり）",
              "label": "家計を主に支える者が雇用者である普通世帯比率（通勤時間90分以上）（普通世帯千世帯当たり）",
              "cat01": "#H03101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H04101/円//公営賃貸住宅の家賃（１か月3.3m2当たり）",
              "label": "公営賃貸住宅の家賃（１か月3.3m2当たり）",
              "cat01": "#H04101",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H04102/円//民営賃貸住宅の家賃（１か月3.3m2当たり）",
              "label": "民営賃貸住宅の家賃（１か月3.3m2当たり）",
              "cat01": "#H04102",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H04201/千円//住宅敷地価額（公庫貸付分，3.3m2当たり）",
              "label": "住宅敷地価額（公庫貸付分，3.3m2当たり）",
              "cat01": "#H04201",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H04301/千円//着工居住用建築物工事費予定額（床面積１m2当たり）",
              "label": "着工居住用建築物工事費予定額（床面積１m2当たり）",
              "cat01": "#H04301",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05102/％//都市ガス供給区域内世帯比率",
              "label": "都市ガス供給区域内世帯比率",
              "cat01": "#H05102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H051041/万ＭＪ//都市ガス販売量",
              "label": "都市ガス販売量",
              "cat01": "#H051041",
              "unit": "万ＭＪ",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05105/ＫＬ//ガソリン販売量",
              "label": "ガソリン販売量",
              "cat01": "#H05105",
              "unit": "ＫＬ",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05201/％//上水道給水人口比率（-2011）",
              "label": "上水道給水人口比率（-2011）",
              "cat01": "#H05201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0520101/％//上水道給水人口比率（2012-）",
              "label": "上水道給水人口比率（2012-）",
              "cat01": "#H0520101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05304/％//下水道普及率（-2011）",
              "label": "下水道普及率（-2011）",
              "cat01": "#H05304",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0530401/％//下水道普及率（2012-）",
              "label": "下水道普及率（2012-）",
              "cat01": "#H0530401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05306/％//水洗化人口比率",
              "label": "水洗化人口比率",
              "cat01": "#H05306",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0540101/％//し尿処理人口比率（-2011）",
              "label": "し尿処理人口比率（-2011）",
              "cat01": "#H0540101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0540102/％//し尿処理人口比率（2012-）",
              "label": "し尿処理人口比率（2012-）",
              "cat01": "#H0540102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H055031/％//ごみのリサイクル率",
              "label": "ごみのリサイクル率",
              "cat01": "#H055031",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H055041/％//ごみ埋立率",
              "label": "ごみ埋立率",
              "cat01": "#H055041",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H05505/千ｍ3//最終処分場残余容量",
              "label": "最終処分場残余容量",
              "cat01": "#H05505",
              "unit": "千ｍ3",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06101/店//小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "label": "小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "cat01": "#H06101",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06103/店//織物・衣服・身の回り品小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "label": "織物・衣服・身の回り品小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "cat01": "#H06103",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06105/店//飲食料品小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "label": "飲食料品小売店数(事業所・企業統計調査結果）（人口千人当たり）",
              "cat01": "#H06105",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06107/店//飲食店数(事業所・企業統計調査結果）（人口千人当たり）",
              "label": "飲食店数(事業所・企業統計調査結果）（人口千人当たり）",
              "cat01": "#H06107",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06109/店//大型小売店数(事業所・企業統計調査結果）（人口10万人当たり）",
              "label": "大型小売店数(事業所・企業統計調査結果）（人口10万人当たり）",
              "cat01": "#H06109",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06111/店//百貨店数(事業所・企業統計調査結果）（人口10万人当たり）",
              "label": "百貨店数(事業所・企業統計調査結果）（人口10万人当たり）",
              "cat01": "#H06111",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06113/所//セルフサービス事業所数（人口10万人当たり）",
              "label": "セルフサービス事業所数（人口10万人当たり）",
              "cat01": "#H06113",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0611302/所//コンビニエンスストア数（人口10万人当たり）",
              "label": "コンビニエンスストア数（人口10万人当たり）",
              "cat01": "#H0611302",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06117/所//理容・美容所数（人口10万人当たり）",
              "label": "理容・美容所数（人口10万人当たり）",
              "cat01": "#H06117",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06119/所//クリーニング所数（人口10万人当たり）",
              "label": "クリーニング所数（人口10万人当たり）",
              "cat01": "#H06119",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06121/所//公衆浴場数（人口10万人当たり）",
              "label": "公衆浴場数（人口10万人当たり）",
              "cat01": "#H06121",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06126/箇所//給油所数（道路実延長100km当たり）",
              "label": "給油所数（道路実延長100km当たり）",
              "cat01": "#H06126",
              "unit": "箇所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06127/店//小売店数（人口千人当たり）",
              "label": "小売店数（人口千人当たり）",
              "cat01": "#H06127",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06128/店//織物・衣服・身の回り品小売店数（人口千人当たり）",
              "label": "織物・衣服・身の回り品小売店数（人口千人当たり）",
              "cat01": "#H06128",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06129/店//飲食料品小売店数（人口千人当たり）",
              "label": "飲食料品小売店数（人口千人当たり）",
              "cat01": "#H06129",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06130/店//飲食店数（人口千人当たり）",
              "label": "飲食店数（人口千人当たり）",
              "cat01": "#H06130",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06131/店//大型小売店数（人口10万人当たり）",
              "label": "大型小売店数（人口10万人当たり）",
              "cat01": "#H06131",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06132/店//百貨店，総合スーパー数（人口10万人当たり）",
              "label": "百貨店，総合スーパー数（人口10万人当たり）",
              "cat01": "#H06132",
              "unit": "店",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06302/局//郵便局数（可住地面積100km2当たり）",
              "label": "郵便局数（可住地面積100km2当たり）",
              "cat01": "#H06302",
              "unit": "局",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06305/加入//電話加入数（人口千人当たり）",
              "label": "電話加入数（人口千人当たり）",
              "cat01": "#H06305",
              "unit": "加入",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06306/加入//住宅用電話加入数（人口千人当たり）",
              "label": "住宅用電話加入数（人口千人当たり）",
              "cat01": "#H06306",
              "unit": "加入",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06307/個//公衆電話施設数（人口千人当たり）",
              "label": "公衆電話施設数（人口千人当たり）",
              "cat01": "#H06307",
              "unit": "個",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06309/万通//郵便物引受数",
              "label": "郵便物引受数",
              "cat01": "#H06309",
              "unit": "万通",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06310/契約//携帯電話契約数（人口千人当たり）",
              "label": "携帯電話契約数（人口千人当たり）",
              "cat01": "#H06310",
              "unit": "契約",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06401/km//道路実延長（総面積１km2当たり）",
              "label": "道路実延長（総面積１km2当たり）",
              "cat01": "#H06401",
              "unit": "km",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06402/km//主要道路実延長（総面積１km2当たり）",
              "label": "主要道路実延長（総面積１km2当たり）",
              "cat01": "#H06402",
              "unit": "km",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06406/％//主要道路舗装率",
              "label": "主要道路舗装率",
              "cat01": "#H06406",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06408/％//市町村道舗装率",
              "label": "市町村道舗装率",
              "cat01": "#H06408",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06412/千台･km/12h//自動車走行台キロ",
              "label": "自動車走行台キロ",
              "cat01": "#H06412",
              "unit": "千台･km/12h",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H06413/台/12h//道路平均交通量",
              "label": "道路平均交通量",
              "cat01": "#H06413",
              "unit": "台/12h",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H07201/％//市街化調整区域面積比率",
              "label": "市街化調整区域面積比率",
              "cat01": "#H07201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720201/％//住居専用地域面積比率",
              "label": "住居専用地域面積比率",
              "cat01": "#H0720201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720202/％//住居専用・住居地域面積比率",
              "label": "住居専用・住居地域面積比率",
              "cat01": "#H0720202",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720203/％//近隣商業地域面積比率",
              "label": "近隣商業地域面積比率",
              "cat01": "#H0720203",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720204/％//商業・近隣商業地域面積比率",
              "label": "商業・近隣商業地域面積比率",
              "cat01": "#H0720204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720205/％//工業・準工業地域面積比率",
              "label": "工業・準工業地域面積比率",
              "cat01": "#H0720205",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H0720206/％//工業専用地域面積比率",
              "label": "工業専用地域面積比率",
              "cat01": "#H0720206",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H08101/ｍ2//都市公園面積（人口１人当たり）",
              "label": "都市公園面積（人口１人当たり）",
              "cat01": "#H08101",
              "unit": "ｍ2",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H08301/所//都市公園数（可住地面積100km2当たり）",
              "label": "都市公園数（可住地面積100km2当たり）",
              "cat01": "#H08301",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H08302/所//街区公園数（可住地面積100km2当たり）",
              "label": "街区公園数（可住地面積100km2当たり）",
              "cat01": "#H08302",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H08303/所//近隣公園数（可住地面積100km2当たり）",
              "label": "近隣公園数（可住地面積100km2当たり）",
              "cat01": "#H08303",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010208/#H08304/所//運動公園数（可住地面積100km2当たり）",
              "label": "運動公園数（可住地面積100km2当たり）",
              "cat01": "#H08304",
              "unit": "所",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｉ健康・医療",
          "statId": "0000010209",
          "children": [
            {
              "statId": "0000010209/#I0210101/cm//平均身長（小学５年・男）",
              "label": "平均身長（小学５年・男）",
              "cat01": "#I0210101",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210102/cm//平均身長（小学５年・女）",
              "label": "平均身長（小学５年・女）",
              "cat01": "#I0210102",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210103/cm//平均身長（中学２年・男）",
              "label": "平均身長（中学２年・男）",
              "cat01": "#I0210103",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210104/cm//平均身長（中学２年・女）",
              "label": "平均身長（中学２年・女）",
              "cat01": "#I0210104",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210105/cm//平均身長（高校２年・男）",
              "label": "平均身長（高校２年・男）",
              "cat01": "#I0210105",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210106/cm//平均身長（高校２年・女）",
              "label": "平均身長（高校２年・女）",
              "cat01": "#I0210106",
              "unit": "cm",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210201/kg//平均体重（小学５年・男）",
              "label": "平均体重（小学５年・男）",
              "cat01": "#I0210201",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210202/kg//平均体重（小学５年・女）",
              "label": "平均体重（小学５年・女）",
              "cat01": "#I0210202",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210203/kg//平均体重（中学２年・男）",
              "label": "平均体重（中学２年・男）",
              "cat01": "#I0210203",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210204/kg//平均体重（中学２年・女）",
              "label": "平均体重（中学２年・女）",
              "cat01": "#I0210204",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210205/kg//平均体重（高校２年・男）",
              "label": "平均体重（高校２年・男）",
              "cat01": "#I0210205",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0210206/kg//平均体重（高校２年・女）",
              "label": "平均体重（高校２年・女）",
              "cat01": "#I0210206",
              "unit": "kg",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I04102/人//一般病院年間新入院患者数（人口10万人当たり）",
              "label": "一般病院年間新入院患者数（人口10万人当たり）",
              "cat01": "#I04102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I04103/人//精神科病院年間新入院患者数（人口10万人当たり）",
              "label": "精神科病院年間新入院患者数（人口10万人当たり）",
              "cat01": "#I04103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I04104/‐//通院者率（人口千人当たり）",
              "label": "通院者率（人口千人当たり）",
              "cat01": "#I04104",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I04105/‐//有訴者率（人口千人当たり）",
              "label": "有訴者率（人口千人当たり）",
              "cat01": "#I04105",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0420102/人//一般病院の１日平均外来患者数（人口10万人当たり）",
              "label": "一般病院の１日平均外来患者数（人口10万人当たり）",
              "cat01": "#I0420102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0420103/人//精神科病院の１日平均外来患者数（人口10万人当たり）",
              "label": "精神科病院の１日平均外来患者数（人口10万人当たり）",
              "cat01": "#I0420103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0420202/人//一般病院の１日平均在院患者数（人口10万人当たり）",
              "label": "一般病院の１日平均在院患者数（人口10万人当たり）",
              "cat01": "#I0420202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0420203/人//精神科病院の１日平均在院患者数（人口10万人当たり）",
              "label": "精神科病院の１日平均在院患者数（人口10万人当たり）",
              "cat01": "#I0420203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I05101/‐//標準化死亡率〔基準人口＝昭和５年〕（人口千人当たり）",
              "label": "標準化死亡率〔基準人口＝昭和５年〕（人口千人当たり）",
              "cat01": "#I05101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520101/年//平均余命［０歳・男］",
              "label": "平均余命［０歳・男］",
              "cat01": "#I0520101",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520102/年//平均余命［０歳・女］",
              "label": "平均余命［０歳・女］",
              "cat01": "#I0520102",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520201/年//平均余命［20歳・男］",
              "label": "平均余命［20歳・男］",
              "cat01": "#I0520201",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520202/年//平均余命［20歳・女］",
              "label": "平均余命［20歳・女］",
              "cat01": "#I0520202",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520501/年//平均余命［65歳・男］",
              "label": "平均余命［65歳・男］",
              "cat01": "#I0520501",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0520502/年//平均余命［65歳・女］",
              "label": "平均余命［65歳・女］",
              "cat01": "#I0520502",
              "unit": "年",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06101/人//生活習慣病による死亡者数（人口10万人当たり）",
              "label": "生活習慣病による死亡者数（人口10万人当たり）",
              "cat01": "#I06101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06102/人//悪性新生物（腫瘍）による死亡者数（人口10万人当たり）",
              "label": "悪性新生物（腫瘍）による死亡者数（人口10万人当たり）",
              "cat01": "#I06102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06103/人//糖尿病による死亡者数（人口10万人当たり）",
              "label": "糖尿病による死亡者数（人口10万人当たり）",
              "cat01": "#I06103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06104/人//高血圧性疾患による死亡者数（人口10万人当たり）",
              "label": "高血圧性疾患による死亡者数（人口10万人当たり）",
              "cat01": "#I06104",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06105/人//心疾患［高血圧性を除く］による死亡者数（人口10万人当たり）",
              "label": "心疾患［高血圧性を除く］による死亡者数（人口10万人当たり）",
              "cat01": "#I06105",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06106/人//脳血管疾患による死亡者数（人口10万人当たり）",
              "label": "脳血管疾患による死亡者数（人口10万人当たり）",
              "cat01": "#I06106",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I06201/人//自殺者数（人口10万人当たり）",
              "label": "自殺者数（人口10万人当たり）",
              "cat01": "#I06201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07101/‐//死産率（出生数千当たり）",
              "label": "死産率（出生数千当たり）",
              "cat01": "#I07101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07102/‐//新生児死亡率（出生数千当たり）",
              "label": "新生児死亡率（出生数千当たり）",
              "cat01": "#I07102",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07104/‐//乳児死亡率（出生数千当たり）",
              "label": "乳児死亡率（出生数千当たり）",
              "cat01": "#I07104",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07105/‐//妊娠，分娩及び産じょくによる死亡率（出産数10万当たり）",
              "label": "妊娠，分娩及び産じょくによる死亡率（出産数10万当たり）",
              "cat01": "#I07105",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07106/‐//周産期死亡率（出生数千当たり）",
              "label": "周産期死亡率（出生数千当たり）",
              "cat01": "#I07106",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I07201/‐//2,500g未満の出生率（出生数千当たり）",
              "label": "2,500g未満の出生率（出生数千当たり）",
              "cat01": "#I07201",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0821101/‐//病気による小学校長期欠席児童比率［年度間30日以上］（児童千人当たり）",
              "label": "病気による小学校長期欠席児童比率［年度間30日以上］（児童千人当たり）",
              "cat01": "#I0821101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0821102/‐//病気による中学校長期欠席生徒比率［年度間30日以上］（生徒千人当たり）",
              "label": "病気による中学校長期欠席生徒比率［年度間30日以上］（生徒千人当たり）",
              "cat01": "#I0821102",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910103/施設//一般病院数（人口10万人当たり）",
              "label": "一般病院数（人口10万人当たり）",
              "cat01": "#I0910103",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910105/施設//一般診療所数（人口10万人当たり）",
              "label": "一般診療所数（人口10万人当たり）",
              "cat01": "#I0910105",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910106/施設//歯科診療所数（人口10万人当たり）",
              "label": "歯科診療所数（人口10万人当たり）",
              "cat01": "#I0910106",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910107/施設//精神科病院数（人口10万人当たり）",
              "label": "精神科病院数（人口10万人当たり）",
              "cat01": "#I0910107",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910203/床//一般病院病床数（人口10万人当たり）",
              "label": "一般病院病床数（人口10万人当たり）",
              "cat01": "#I0910203",
              "unit": "床",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910205/床//精神病床数（人口10万人当たり）",
              "label": "精神病床数（人口10万人当たり）",
              "cat01": "#I0910205",
              "unit": "床",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0910206/所//介護療養型医療施設数（65歳以上人口10万人当たり）",
              "label": "介護療養型医療施設数（65歳以上人口10万人当たり）",
              "cat01": "#I0910206",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0920101/人//医療施設に従事する医師数（人口10万人当たり）",
              "label": "医療施設に従事する医師数（人口10万人当たり）",
              "cat01": "#I0920101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0920201/人//医療施設に従事する歯科医師数（人口10万人当たり）",
              "label": "医療施設に従事する歯科医師数（人口10万人当たり）",
              "cat01": "#I0920201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0920301/人//医療施設に従事する看護師・准看護師数（人口10万人当たり）",
              "label": "医療施設に従事する看護師・准看護師数（人口10万人当たり）",
              "cat01": "#I0920301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0930201/人//一般病院常勤医師数（100病床当たり）",
              "label": "一般病院常勤医師数（100病床当たり）",
              "cat01": "#I0930201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0930301/人//一般病院看護師・准看護師数（100病床当たり）",
              "label": "一般病院看護師・准看護師数（100病床当たり）",
              "cat01": "#I0930301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I09401/％//公立一般病院数の割合",
              "label": "公立一般病院数の割合",
              "cat01": "#I09401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I09402/％//公立一般病院病床数の割合",
              "label": "公立一般病院病床数の割合",
              "cat01": "#I09402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0950102/施設//一般病院数（可住地面積100km2当たり）",
              "label": "一般病院数（可住地面積100km2当たり）",
              "cat01": "#I0950102",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0950103/施設//一般診療所数（可住地面積100km2当たり）",
              "label": "一般診療所数（可住地面積100km2当たり）",
              "cat01": "#I0950103",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I0950104/施設//歯科診療所数（可住地面積100km2当たり）",
              "label": "歯科診療所数（可住地面積100km2当たり）",
              "cat01": "#I0950104",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10101/人//一般病院外来患者数（常勤医師１人１日当たり）",
              "label": "一般病院外来患者数（常勤医師１人１日当たり）",
              "cat01": "#I10101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10102/人//一般病院在院患者数（常勤医師１人１日当たり）",
              "label": "一般病院在院患者数（常勤医師１人１日当たり）",
              "cat01": "#I10102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10103/人//一般病院在院患者数（看護師・准看護師１人１日当たり）",
              "label": "一般病院在院患者数（看護師・准看護師１人１日当たり）",
              "cat01": "#I10103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10104/％//一般病院病床利用率",
              "label": "一般病院病床利用率",
              "cat01": "#I10104",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10105/日//一般病院平均在院日数",
              "label": "一般病院平均在院日数",
              "cat01": "#I10105",
              "unit": "日",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10201/人//精神科病院外来患者数（常勤医師１人１日当たり）",
              "label": "精神科病院外来患者数（常勤医師１人１日当たり）",
              "cat01": "#I10201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10202/人//精神科病院在院患者数（常勤医師１人１日当たり）",
              "label": "精神科病院在院患者数（常勤医師１人１日当たり）",
              "cat01": "#I10202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10203/人//精神科病院在院患者数（看護師・准看護師１人１日当たり）",
              "label": "精神科病院在院患者数（看護師・准看護師１人１日当たり）",
              "cat01": "#I10203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10204/％//精神科病院病床利用率",
              "label": "精神科病院病床利用率",
              "cat01": "#I10204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I10205/日//精神科病院平均在院日数",
              "label": "精神科病院平均在院日数",
              "cat01": "#I10205",
              "unit": "日",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I11101/施設//救急告示病院・一般診療所数（人口10万人当たり）",
              "label": "救急告示病院・一般診療所数（人口10万人当たり）",
              "cat01": "#I11101",
              "unit": "施設",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I11102/台//救急自動車数（人口10万人当たり）",
              "label": "救急自動車数（人口10万人当たり）",
              "cat01": "#I11102",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I11201/件//年間救急出動件数（人口千人当たり）",
              "label": "年間救急出動件数（人口千人当たり）",
              "cat01": "#I11201",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I12201/人//保健師数（人口10万人当たり）",
              "label": "保健師数（人口10万人当たり）",
              "cat01": "#I12201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I13102/％//生活習慣病健康診断受診率",
              "label": "生活習慣病健康診断受診率",
              "cat01": "#I13102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I13201/人//妊産婦保健指導数（出産数100当たり）",
              "label": "妊産婦保健指導数（出産数100当たり）",
              "cat01": "#I13201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I13207/人//歯科健診・保健指導延人員（人口千人当たり）",
              "label": "歯科健診・保健指導延人員（人口千人当たり）",
              "cat01": "#I13207",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I13402/件//食品営業施設処分件数（千施設当たり）",
              "label": "食品営業施設処分件数（千施設当たり）",
              "cat01": "#I13402",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I14101/所//薬局数（人口10万人当たり）",
              "label": "薬局数（人口10万人当たり）",
              "cat01": "#I14101",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I14102/所//医薬品販売業数（人口10万人当たり）",
              "label": "医薬品販売業数（人口10万人当たり）",
              "cat01": "#I14102",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I14201/所//薬局数（可住地面積100km2当たり）",
              "label": "薬局数（可住地面積100km2当たり）",
              "cat01": "#I14201",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I14202/所//医薬品販売業数（可住地面積100km2当たり）",
              "label": "医薬品販売業数（可住地面積100km2当たり）",
              "cat01": "#I14202",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I15101/人//国民健康保険被保険者数（人口千人当たり）",
              "label": "国民健康保険被保険者数（人口千人当たり）",
              "cat01": "#I15101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I15102/‐//国民健康保険受診率（被保険者千人当たり）",
              "label": "国民健康保険受診率（被保険者千人当たり）",
              "cat01": "#I15102",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I15103/円//国民健康保険診療費（被保険者１人当たり）",
              "label": "国民健康保険診療費（被保険者１人当たり）",
              "cat01": "#I15103",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I15106/千円//１人当たりの国民医療費",
              "label": "１人当たりの国民医療費",
              "cat01": "#I15106",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I15202/人//全国保険協会管掌健康保険加入者数（人口千人当たり）",
              "label": "全国保険協会管掌健康保険加入者数（人口千人当たり）",
              "cat01": "#I15202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520301/‐//全国保険協会管掌健康保険受診率（被保険者千人当たり）",
              "label": "全国保険協会管掌健康保険受診率（被保険者千人当たり）",
              "cat01": "#I1520301",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520302/‐//全国保険協会管掌健康保険受診率（被扶養者千人当たり）",
              "label": "全国保険協会管掌健康保険受診率（被扶養者千人当たり）",
              "cat01": "#I1520302",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520401/円//政府管掌健康保険受診金額（被保険者１人当たり）",
              "label": "政府管掌健康保険受診金額（被保険者１人当たり）",
              "cat01": "#I1520401",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520402/円//政府管掌健康保険受診金額（被扶養者１人当たり）",
              "label": "政府管掌健康保険受診金額（被扶養者１人当たり）",
              "cat01": "#I1520402",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520501/円//全国保険協会管掌健康保険医療費（被保険者１人当たり）",
              "label": "全国保険協会管掌健康保険医療費（被保険者１人当たり）",
              "cat01": "#I1520501",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010209/#I1520502/円//全国保険協会管掌健康保険医療費（被扶養者１人当たり）",
              "label": "全国保険協会管掌健康保険医療費（被扶養者１人当たり）",
              "cat01": "#I1520502",
              "unit": "円",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｊ福祉・社会保障",
          "statId": "0000010210",
          "children": [
            {
              "statId": "0000010210/#J01101/世帯//生活保護被保護実世帯数（月平均一般世帯千世帯当たり）",
              "label": "生活保護被保護実世帯数（月平均一般世帯千世帯当たり）",
              "cat01": "#J01101",
              "unit": "世帯",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J01107/人//生活保護被保護実人員（月平均人口千人当たり）",
              "label": "生活保護被保護実人員（月平均人口千人当たり）",
              "cat01": "#J01107",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0110803/人//生活保護教育扶助人員（月平均人口千人当たり）",
              "label": "生活保護教育扶助人員（月平均人口千人当たり）",
              "cat01": "#J0110803",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0110804/人//生活保護医療扶助人員（月平均人口千人当たり）",
              "label": "生活保護医療扶助人員（月平均人口千人当たり）",
              "cat01": "#J0110804",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0110805/人//生活保護住宅扶助人員（月平均人口千人当たり）",
              "label": "生活保護住宅扶助人員（月平均人口千人当たり）",
              "cat01": "#J0110805",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0110806/人//生活保護介護扶助人員（月平均人口千人当たり）",
              "label": "生活保護介護扶助人員（月平均人口千人当たり）",
              "cat01": "#J0110806",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0110902/人//生活保護被保護高齢者数（月平均65歳以上人口千人当たり）",
              "label": "生活保護被保護高齢者数（月平均65歳以上人口千人当たり）",
              "cat01": "#J0110902",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J01200/人//身体障害者手帳交付数（人口千人当たり）",
              "label": "身体障害者手帳交付数（人口千人当たり）",
              "cat01": "#J01200",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02101/所//保護施設数（生活保護被保護実人員10万人当たり）",
              "label": "保護施設数（生活保護被保護実人員10万人当たり）",
              "cat01": "#J02101",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J022011/所//老人ホーム数（65歳以上人口10万人当たり）",
              "label": "老人ホーム数（65歳以上人口10万人当たり）",
              "cat01": "#J022011",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02202/所//老人福祉センター数（65歳以上人口10万人当たり）",
              "label": "老人福祉センター数（65歳以上人口10万人当たり）",
              "cat01": "#J02202",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02203/所//老人憩の家数（65歳以上人口10万人当たり）",
              "label": "老人憩の家数（65歳以上人口10万人当たり）",
              "cat01": "#J02203",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02204/所//有料老人ホーム数（65歳以上人口10万人当たり）",
              "label": "有料老人ホーム数（65歳以上人口10万人当たり）",
              "cat01": "#J02204",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02205/所//介護老人福祉施設（65歳以上人口10万人当たり）",
              "label": "介護老人福祉施設（65歳以上人口10万人当たり）",
              "cat01": "#J02205",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02301/所//身体障害者更生援護施設数（人口100万人当たり）",
              "label": "身体障害者更生援護施設数（人口100万人当たり）",
              "cat01": "#J02301",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02401/所//知的障害者援護施設数（人口100万人当たり）",
              "label": "知的障害者援護施設数（人口100万人当たり）",
              "cat01": "#J02401",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J02501/所//児童福祉施設数（人口10万人当たり）",
              "label": "児童福祉施設数（人口10万人当たり）",
              "cat01": "#J02501",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03101/人//保護施設従事者数（生活保護被保護実人員千人当たり）",
              "label": "保護施設従事者数（生活保護被保護実人員千人当たり）",
              "cat01": "#J03101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J032011/人//老人ホーム従事者数（65歳以上人口10万人当たり）",
              "label": "老人ホーム従事者数（65歳以上人口10万人当たり）",
              "cat01": "#J032011",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03202/人//老人福祉センター従事者数（65歳以上人口10万人当たり）",
              "label": "老人福祉センター従事者数（65歳以上人口10万人当たり）",
              "cat01": "#J03202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03203/人//老人憩の家従事者数（65歳以上人口10万人当たり）",
              "label": "老人憩の家従事者数（65歳以上人口10万人当たり）",
              "cat01": "#J03203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03301/人//身体障害者更生援護施設従事者数（人口10万人当たり）",
              "label": "身体障害者更生援護施設従事者数（人口10万人当たり）",
              "cat01": "#J03301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03401/人//知的障害者援護施設従事者数（人口10万人当たり）",
              "label": "知的障害者援護施設従事者数（人口10万人当たり）",
              "cat01": "#J03401",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J03501/人//児童福祉施設従事者数（人口10万人当たり）",
              "label": "児童福祉施設従事者数（人口10万人当たり）",
              "cat01": "#J03501",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04101/人//生活保護施設定員数（被保護実人員千人当たり）",
              "label": "生活保護施設定員数（被保護実人員千人当たり）",
              "cat01": "#J04101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04102/人//生活保護施設在所者数（被保護実人員千人当たり）",
              "label": "生活保護施設在所者数（被保護実人員千人当たり）",
              "cat01": "#J04102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J042011/人//老人ホーム定員数（65歳以上人口千人当たり）",
              "label": "老人ホーム定員数（65歳以上人口千人当たり）",
              "cat01": "#J042011",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J042021/人//老人ホーム在所者数（65歳以上人口千人当たり）",
              "label": "老人ホーム在所者数（65歳以上人口千人当たり）",
              "cat01": "#J042021",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04203/人//有料老人ホーム定員数（65歳以上人口千人当たり）",
              "label": "有料老人ホーム定員数（65歳以上人口千人当たり）",
              "cat01": "#J04203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04204/人//有料老人ホーム在所者数（65歳以上人口千人当たり）",
              "label": "有料老人ホーム在所者数（65歳以上人口千人当たり）",
              "cat01": "#J04204",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04301/人//身体障害者更生援護施設定員数（人口10万人当たり）",
              "label": "身体障害者更生援護施設定員数（人口10万人当たり）",
              "cat01": "#J04301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04302/人//身体障害者更生援護施設在所者数（人口10万人当たり）",
              "label": "身体障害者更生援護施設在所者数（人口10万人当たり）",
              "cat01": "#J04302",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04401/人//知的障害者援護施設定員数（人口10万人当たり）",
              "label": "知的障害者援護施設定員数（人口10万人当たり）",
              "cat01": "#J04401",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J04402/人//知的障害者援護施設在所者数（人口10万人当たり）",
              "label": "知的障害者援護施設在所者数（人口10万人当たり）",
              "cat01": "#J04402",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05101/人//民生委員（児童委員）数（人口10万人当たり）",
              "label": "民生委員（児童委員）数（人口10万人当たり）",
              "cat01": "#J05101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05102/人//身体障害者相談員数（人口10万人当たり）",
              "label": "身体障害者相談員数（人口10万人当たり）",
              "cat01": "#J05102",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05103/人//知的障害者相談員数（人口10万人当たり）",
              "label": "知的障害者相談員数（人口10万人当たり）",
              "cat01": "#J05103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05108/人//訪問介護員（ホームヘルパー）数（人口10万人当たり）",
              "label": "訪問介護員（ホームヘルパー）数（人口10万人当たり）",
              "cat01": "#J05108",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05109/人//訪問介護利用者数（訪問介護１事業所当たり）",
              "label": "訪問介護利用者数（訪問介護１事業所当たり）",
              "cat01": "#J05109",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05201/件//民生委員（児童委員）１人当たり相談・支援件数",
              "label": "民生委員（児童委員）１人当たり相談・支援件数",
              "cat01": "#J05201",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05202/件//福祉事務所生活保護申請件数（被保護世帯千世帯当たり）",
              "label": "福祉事務所生活保護申請件数（被保護世帯千世帯当たり）",
              "cat01": "#J05202",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05203/人//身体障害者更生援護取扱実人員（人口千人当たり）",
              "label": "身体障害者更生援護取扱実人員（人口千人当たり）",
              "cat01": "#J05203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05204/人//福祉事務所知的障害者相談実人員（人口10万人当たり）",
              "label": "福祉事務所知的障害者相談実人員（人口10万人当たり）",
              "cat01": "#J05204",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05206/人//身体障害者更生相談所取扱実人員（人口千人当たり）",
              "label": "身体障害者更生相談所取扱実人員（人口千人当たり）",
              "cat01": "#J05206",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05207/人//知的障害者更生相談所取扱実人員（人口10万人当たり）",
              "label": "知的障害者更生相談所取扱実人員（人口10万人当たり）",
              "cat01": "#J05207",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05208/円//後期高齢者医療費（被保険者１人当たり）",
              "label": "後期高齢者医療費（被保険者１人当たり）",
              "cat01": "#J05208",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05209/人//市町村における知的障害者相談実人員（人口10万人当たり）",
              "label": "市町村における知的障害者相談実人員（人口10万人当たり）",
              "cat01": "#J05209",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J05210/件//児童相談所受付件数（人口千人当たり）",
              "label": "児童相談所受付件数（人口千人当たり）",
              "cat01": "#J05210",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0610101/人//国民年金被保険者数［第１号］（20～59歳人口千人当たり）",
              "label": "国民年金被保険者数［第１号］（20～59歳人口千人当たり）",
              "cat01": "#J0610101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010210/#J0610102/人//国民年金被保険者数［第３号］（20～59歳人口千人当たり）",
              "label": "国民年金被保険者数［第３号］（20～59歳人口千人当たり）",
              "cat01": "#J0610102",
              "unit": "人",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｋ安全",
          "statId": "0000010211",
          "children": [
            {
              "statId": "0000010211/#K01102/署//消防署数（可住地面積100km2当たり）",
              "label": "消防署数（可住地面積100km2当たり）",
              "cat01": "#K01102",
              "unit": "署",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01104/団//消防団・分団数（可住地面積100km2当たり）",
              "label": "消防団・分団数（可住地面積100km2当たり）",
              "cat01": "#K01104",
              "unit": "団",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01105/台//消防ポンプ自動車等現有数（人口10万人当たり）",
              "label": "消防ポンプ自動車等現有数（人口10万人当たり）",
              "cat01": "#K01105",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01107/所//消防水利数（人口10万人当たり）",
              "label": "消防水利数（人口10万人当たり）",
              "cat01": "#K01107",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01301/人//消防関係人員数（人口10万人当たり）",
              "label": "消防関係人員数（人口10万人当たり）",
              "cat01": "#K01301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01302/人//消防吏員数（人口10万人当たり）",
              "label": "消防吏員数（人口10万人当たり）",
              "cat01": "#K01302",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01401/回//消防機関出動回数（人口10万人当たり）",
              "label": "消防機関出動回数（人口10万人当たり）",
              "cat01": "#K01401",
              "unit": "回",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K01402/回//火災のための消防機関出動回数（人口10万人当たり）",
              "label": "火災のための消防機関出動回数（人口10万人当たり）",
              "cat01": "#K01402",
              "unit": "回",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02101/件//火災出火件数（人口10万人当たり）",
              "label": "火災出火件数（人口10万人当たり）",
              "cat01": "#K02101",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02103/件//建物火災出火件数（人口10万人当たり）",
              "label": "建物火災出火件数（人口10万人当たり）",
              "cat01": "#K02103",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02203/人//火災死傷者数（人口10万人当たり）",
              "label": "火災死傷者数（人口10万人当たり）",
              "cat01": "#K02203",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02205/円//建物火災損害額（人口１人当たり）",
              "label": "建物火災損害額（人口１人当たり）",
              "cat01": "#K02205",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02301/世帯//火災り災世帯数（建物火災100件当たり）",
              "label": "火災り災世帯数（建物火災100件当たり）",
              "cat01": "#K02301",
              "unit": "世帯",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02303/人//火災死傷者数（建物火災100件当たり）",
              "label": "火災死傷者数（建物火災100件当たり）",
              "cat01": "#K02303",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K02306/万円//建物火災損害額（建物火災１件当たり）",
              "label": "建物火災損害額（建物火災１件当たり）",
              "cat01": "#K02306",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K03102/所//立体横断施設数（道路実延長千km当たり）",
              "label": "立体横断施設数（道路実延長千km当たり）",
              "cat01": "#K03102",
              "unit": "所",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04101/件//交通事故発生件数（人口10万人当たり）",
              "label": "交通事故発生件数（人口10万人当たり）",
              "cat01": "#K04101",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04102/件//交通事故発生件数（道路実延長千km当たり）",
              "label": "交通事故発生件数（道路実延長千km当たり）",
              "cat01": "#K04102",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04105/人//交通事故死傷者数（人口10万人当たり）",
              "label": "交通事故死傷者数（人口10万人当たり）",
              "cat01": "#K04105",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04106/人//交通事故死者数（人口10万人当たり）",
              "label": "交通事故死者数（人口10万人当たり）",
              "cat01": "#K04106",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04107/人//交通事故負傷者数（人口10万人当たり）",
              "label": "交通事故負傷者数（人口10万人当たり）",
              "cat01": "#K04107",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04201/人//交通事故死傷者数（交通事故100件当たり）",
              "label": "交通事故死傷者数（交通事故100件当たり）",
              "cat01": "#K04201",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04202/人//交通事故死者数（交通事故100件当たり）",
              "label": "交通事故死者数（交通事故100件当たり）",
              "cat01": "#K04202",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K04301/件//道路交通法違反検挙件数（人口千人当たり）",
              "label": "道路交通法違反検挙件数（人口千人当たり）",
              "cat01": "#K04301",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K05103/人//警察官数（人口千人当たり）",
              "label": "警察官数（人口千人当たり）",
              "cat01": "#K05103",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06101/件//刑法犯認知件数（人口千人当たり）",
              "label": "刑法犯認知件数（人口千人当たり）",
              "cat01": "#K06101",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06104/件//窃盗犯認知件数（人口千人当たり）",
              "label": "窃盗犯認知件数（人口千人当たり）",
              "cat01": "#K06104",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06201/％//刑法犯検挙率",
              "label": "刑法犯検挙率",
              "cat01": "#K06201",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06204/％//窃盗犯検挙率",
              "label": "窃盗犯検挙率",
              "cat01": "#K06204",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06301/人//少年刑法犯検挙人員（14～19歳人口千人当たり）",
              "label": "少年刑法犯検挙人員（14～19歳人口千人当たり）",
              "cat01": "#K06301",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06304/人//少年窃盗犯検挙人員（14～19歳人口千人当たり）",
              "label": "少年窃盗犯検挙人員（14～19歳人口千人当たり）",
              "cat01": "#K06304",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06401/％//刑法犯認知件数に占める凶悪犯の割合",
              "label": "刑法犯認知件数に占める凶悪犯の割合",
              "cat01": "#K06401",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06402/％//刑法犯認知件数に占める粗暴犯の割合",
              "label": "刑法犯認知件数に占める粗暴犯の割合",
              "cat01": "#K06402",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06403/％//刑法犯認知件数に占める窃盗犯の割合",
              "label": "刑法犯認知件数に占める窃盗犯の割合",
              "cat01": "#K06403",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06405/％//刑法犯認知件数に占める風俗犯の割合",
              "label": "刑法犯認知件数に占める風俗犯の割合",
              "cat01": "#K06405",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06501/件//特別法犯送致件数（人口10万人当たり）",
              "label": "特別法犯送致件数（人口10万人当たり）",
              "cat01": "#K06501",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K06503/件//覚せい剤取締送致件数（人口10万人当たり）",
              "label": "覚せい剤取締送致件数（人口10万人当たり）",
              "cat01": "#K06503",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K07105/円//災害被害額（人口１人当たり）",
              "label": "災害被害額（人口１人当たり）",
              "cat01": "#K07105",
              "unit": "円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K08101/人//不慮の事故による死亡者数（人口10万人当たり）",
              "label": "不慮の事故による死亡者数（人口10万人当たり）",
              "cat01": "#K08101",
              "unit": "人",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K09201/件//公害苦情件数（人口10万人当たり）",
              "label": "公害苦情件数（人口10万人当たり）",
              "cat01": "#K09201",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K09210/件//ばい煙発生施設数",
              "label": "ばい煙発生施設数",
              "cat01": "#K09210",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K09211/件//一般粉じん発生施設数",
              "label": "一般粉じん発生施設数",
              "cat01": "#K09211",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K09220/件//水質汚濁防止法上の特定事業場数",
              "label": "水質汚濁防止法上の特定事業場数",
              "cat01": "#K09220",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10101/件//民間生命保険保有契約件数（人口千人当たり）",
              "label": "民間生命保険保有契約件数（人口千人当たり）",
              "cat01": "#K10101",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10105/万円//民間生命保険保険金額（保有契約１件当たり）",
              "label": "民間生命保険保険金額（保有契約１件当たり）",
              "cat01": "#K10105",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10107/万円//民間生命保険保険金額（１世帯当たり）",
              "label": "民間生命保険保険金額（１世帯当たり）",
              "cat01": "#K10107",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10201/件//簡易生命保険保有契約件数（人口千人当たり）",
              "label": "簡易生命保険保有契約件数（人口千人当たり）",
              "cat01": "#K10201",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10203/万円//簡易生命保険保有契約保険金額（保有契約１件当たり）",
              "label": "簡易生命保険保有契約保険金額（保有契約１件当たり）",
              "cat01": "#K10203",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10301/件//火災保険住宅物件・一般物件新契約件数（一般世帯千世帯当たり）",
              "label": "火災保険住宅物件・一般物件新契約件数（一般世帯千世帯当たり）",
              "cat01": "#K10301",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10304/件//火災保険住宅物件・一般物件保険金受取件数（一般世帯千世帯当たり）",
              "label": "火災保険住宅物件・一般物件保険金受取件数（一般世帯千世帯当たり）",
              "cat01": "#K10304",
              "unit": "件",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10305/万円//火災保険住宅物件・一般物件受取保険金額（保有契約１件当たり）",
              "label": "火災保険住宅物件・一般物件受取保険金額（保有契約１件当たり）",
              "cat01": "#K10305",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10403/万円//自動車損害賠償責任保険受取保険金額（支払件数１件当たり）",
              "label": "自動車損害賠償責任保険受取保険金額（支払件数１件当たり）",
              "cat01": "#K10403",
              "unit": "万円",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10501/％//任意自動車保険普及率［車両］",
              "label": "任意自動車保険普及率［車両］",
              "cat01": "#K10501",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10502/％//任意自動車保険普及率［対人］",
              "label": "任意自動車保険普及率［対人］",
              "cat01": "#K10502",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010211/#K10503/％//任意自動車保険普及率［対物］",
              "label": "任意自動車保険普及率［対物］",
              "cat01": "#K10503",
              "unit": "％",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｌ家計",
          "statId": "0000010212",
          "children": [
            {
              "statId": "0000010212/#L01100/千円//農家総所得",
              "label": "農家総所得",
              "cat01": "#L01100",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L0110101/％//農業所得割合",
              "label": "農業所得割合",
              "cat01": "#L0110101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L0110102/％//農外所得割合",
              "label": "農外所得割合",
              "cat01": "#L0110102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L01201/千円//実収入［二人以上の世帯のうち勤労者世帯］（１世帯当たり１か月間）",
              "label": "実収入［二人以上の世帯のうち勤労者世帯］（１世帯当たり１か月間）",
              "cat01": "#L01201",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L01204/千円//世帯主収入［二人以上の世帯のうち勤労者世帯］（１世帯当たり１か月間）",
              "label": "世帯主収入［二人以上の世帯のうち勤労者世帯］（１世帯当たり１か月間）",
              "cat01": "#L01204",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02101/千円//農家世帯の家計費（１世帯当たり１か月間）",
              "label": "農家世帯の家計費（１世帯当たり１か月間）",
              "cat01": "#L02101",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02211/千円//消費支出［二人以上の世帯］（１世帯当たり１か月間）",
              "label": "消費支出［二人以上の世帯］（１世帯当たり１か月間）",
              "cat01": "#L02211",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02411/％//食料費割合［二人以上の世帯］",
              "label": "食料費割合［二人以上の世帯］",
              "cat01": "#L02411",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02412/％//住居費割合［二人以上の世帯］",
              "label": "住居費割合［二人以上の世帯］",
              "cat01": "#L02412",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02413/％//光熱・水道費割合［二人以上の世帯］",
              "label": "光熱・水道費割合［二人以上の世帯］",
              "cat01": "#L02413",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02414/％//家具・家事用品費割合［二人以上の世帯］",
              "label": "家具・家事用品費割合［二人以上の世帯］",
              "cat01": "#L02414",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02415/％//被服及び履物費割合［二人以上の世帯］",
              "label": "被服及び履物費割合［二人以上の世帯］",
              "cat01": "#L02415",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02416/％//保健医療費割合［二人以上の世帯］",
              "label": "保健医療費割合［二人以上の世帯］",
              "cat01": "#L02416",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02417/％//交通・通信費割合［二人以上の世帯］",
              "label": "交通・通信費割合［二人以上の世帯］",
              "cat01": "#L02417",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02418/％//教育費割合［二人以上の世帯］",
              "label": "教育費割合［二人以上の世帯］",
              "cat01": "#L02418",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02419/％//教養娯楽費割合［二人以上の世帯］",
              "label": "教養娯楽費割合［二人以上の世帯］",
              "cat01": "#L02419",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02420/％//その他の消費支出費割合［二人以上の世帯］",
              "label": "その他の消費支出費割合［二人以上の世帯］",
              "cat01": "#L02420",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02601/％//農家世帯の平均消費性向",
              "label": "農家世帯の平均消費性向",
              "cat01": "#L02601",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02602/％//平均消費性向［二人以上の世帯のうち勤労者世帯］",
              "label": "平均消費性向［二人以上の世帯のうち勤労者世帯］",
              "cat01": "#L02602",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02734/％//平均貯蓄率［二人以上の世帯のうち勤労者世帯］",
              "label": "平均貯蓄率［二人以上の世帯のうち勤労者世帯］",
              "cat01": "#L02734",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02735/％//預貯金純増率［二人以上の世帯のうち勤労者世帯］",
              "label": "預貯金純増率［二人以上の世帯のうち勤労者世帯］",
              "cat01": "#L02735",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L02736/％//土地家屋借金純減率［二人以上の世帯のうち勤労者世帯］",
              "label": "土地家屋借金純減率［二人以上の世帯のうち勤労者世帯］",
              "cat01": "#L02736",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03201/千円//貯蓄現在高［二人以上の世帯］（１世帯当たり）",
              "label": "貯蓄現在高［二人以上の世帯］（１世帯当たり）",
              "cat01": "#L03201",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03212/％//預貯金現在高割合［二人以上の世帯］",
              "label": "預貯金現在高割合［二人以上の世帯］",
              "cat01": "#L03212",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03213/％//生命保険現在高割合［二人以上の世帯］",
              "label": "生命保険現在高割合［二人以上の世帯］",
              "cat01": "#L03213",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03214/％//有価証券現在高割合［二人以上の世帯］",
              "label": "有価証券現在高割合［二人以上の世帯］",
              "cat01": "#L03214",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03401/千円//負債現在高［二人以上の世帯］（１世帯当たり）",
              "label": "負債現在高［二人以上の世帯］（１世帯当たり）",
              "cat01": "#L03401",
              "unit": "千円",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03412/％//住宅・土地のための負債割合［二人以上の世帯］",
              "label": "住宅・土地のための負債割合［二人以上の世帯］",
              "cat01": "#L03412",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03602/台//電子レンジ（電子オーブンレンジを含む）所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "電子レンジ（電子オーブンレンジを含む）所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03602",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03603/台//ルームエアコン所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "ルームエアコン所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03603",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03606/台//ピアノ･電子ピアノ所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "ピアノ･電子ピアノ所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03606",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03607/台//自動車所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "自動車所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03607",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03609/台//ステレオセットまたはCD・MDラジオカセット所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "ステレオセットまたはCD・MDラジオカセット所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03609",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03611/台//携帯電話（PHSを含む）所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "携帯電話（PHSを含む）所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03611",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03613/台//パソコン所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "パソコン所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03613",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03614/台//タブレット端末所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "タブレット端末所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03614",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L03615/台//スマートフォン所有数量［二人以上の世帯］（千世帯当たり）",
              "label": "スマートフォン所有数量［二人以上の世帯］（千世帯当たり）",
              "cat01": "#L03615",
              "unit": "台",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04101/％//消費者物価指数対前年変化率［総合］",
              "label": "消費者物価指数対前年変化率［総合］",
              "cat01": "#L04101",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04102/％//消費者物価指数対前年変化率［持ち家の帰属家賃を除く総合］",
              "label": "消費者物価指数対前年変化率［持ち家の帰属家賃を除く総合］",
              "cat01": "#L04102",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04103/％//消費者物価指数対前年変化率［生鮮食品を除く総合］",
              "label": "消費者物価指数対前年変化率［生鮮食品を除く総合］",
              "cat01": "#L04103",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04104/％//消費者物価指数対前年変化率［食料］",
              "label": "消費者物価指数対前年変化率［食料］",
              "cat01": "#L04104",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04105/％//消費者物価指数対前年変化率［住居］",
              "label": "消費者物価指数対前年変化率［住居］",
              "cat01": "#L04105",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04106/％//消費者物価指数対前年変化率［光熱・水道］",
              "label": "消費者物価指数対前年変化率［光熱・水道］",
              "cat01": "#L04106",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04107/％//消費者物価指数対前年変化率［家具・家事用品］",
              "label": "消費者物価指数対前年変化率［家具・家事用品］",
              "cat01": "#L04107",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04108/％//消費者物価指数対前年変化率［被服及び履物］",
              "label": "消費者物価指数対前年変化率［被服及び履物］",
              "cat01": "#L04108",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04109/％//消費者物価指数対前年変化率［保健医療］",
              "label": "消費者物価指数対前年変化率［保健医療］",
              "cat01": "#L04109",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04110/％//消費者物価指数対前年変化率［交通・通信］",
              "label": "消費者物価指数対前年変化率［交通・通信］",
              "cat01": "#L04110",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04111/％//消費者物価指数対前年変化率［教育］",
              "label": "消費者物価指数対前年変化率［教育］",
              "cat01": "#L04111",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04112/％//消費者物価指数対前年変化率［教養娯楽］",
              "label": "消費者物価指数対前年変化率［教養娯楽］",
              "cat01": "#L04112",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04113/％//消費者物価指数対前年変化率［諸雑費］",
              "label": "消費者物価指数対前年変化率［諸雑費］",
              "cat01": "#L04113",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04114/％//消費者物価指数対前年変化率［食料（酒類を除く）及びエネルギーを除く総合］",
              "label": "消費者物価指数対前年変化率［食料（酒類を除く）及びエネルギーを除く総合］",
              "cat01": "#L04114",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04115/％//消費者物価指数変化率・生鮮食品及びエネルギーを除く総合",
              "label": "消費者物価指数変化率・生鮮食品及びエネルギーを除く総合",
              "cat01": "#L04115",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04201/‐//消費者物価地域差指数［総合：東京都区部＝100］",
              "label": "消費者物価地域差指数［総合：東京都区部＝100］",
              "cat01": "#L04201",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L0420101/‐//消費者物価地域差指数（総合）（51市平均＝100）",
              "label": "消費者物価地域差指数（総合）（51市平均＝100）",
              "cat01": "#L0420101",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04203/‐//消費者物価地域差指数［食料：東京都区部＝100］",
              "label": "消費者物価地域差指数［食料：東京都区部＝100］",
              "cat01": "#L04203",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L0420303/‐//消費者物価地域差指数（食料）（51市平均＝100）",
              "label": "消費者物価地域差指数（食料）（51市平均＝100）",
              "cat01": "#L0420303",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04302/％//標準価格対前年平均変動率［住宅地］",
              "label": "標準価格対前年平均変動率［住宅地］",
              "cat01": "#L04302",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04304/％//標準価格対前年平均変動率［商業地］",
              "label": "標準価格対前年平均変動率［商業地］",
              "cat01": "#L04304",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04306/％//標準価格対前年平均変動率［工業地］",
              "label": "標準価格対前年平均変動率［工業地］",
              "cat01": "#L04306",
              "unit": "％",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04414/‐//消費者物価地域差指数（持家の帰属家賃を除く総合）",
              "label": "消費者物価地域差指数（持家の帰属家賃を除く総合）",
              "cat01": "#L04414",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04415/‐//消費者物価地域差指数（家賃を除く総合）",
              "label": "消費者物価地域差指数（家賃を除く総合）",
              "cat01": "#L04415",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04416/‐//消費者物価地域差指数（食料）",
              "label": "消費者物価地域差指数（食料）",
              "cat01": "#L04416",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04417/‐//消費者物価地域差指数（持家の帰属家賃を除く住居）",
              "label": "消費者物価地域差指数（持家の帰属家賃を除く住居）",
              "cat01": "#L04417",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04418/‐//消費者物価地域差指数（光熱・水道）",
              "label": "消費者物価地域差指数（光熱・水道）",
              "cat01": "#L04418",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04419/‐//消費者物価地域差指数（家具・家事用品）",
              "label": "消費者物価地域差指数（家具・家事用品）",
              "cat01": "#L04419",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04420/‐//消費者物価地域差指数（被服及び履物）",
              "label": "消費者物価地域差指数（被服及び履物）",
              "cat01": "#L04420",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04421/‐//消費者物価地域差指数（保健医療）",
              "label": "消費者物価地域差指数（保健医療）",
              "cat01": "#L04421",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04422/‐//消費者物価地域差指数（交通・通信）",
              "label": "消費者物価地域差指数（交通・通信）",
              "cat01": "#L04422",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04423/‐//消費者物価地域差指数（教育）",
              "label": "消費者物価地域差指数（教育）",
              "cat01": "#L04423",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04424/‐//消費者物価地域差指数（教養娯楽）",
              "label": "消費者物価地域差指数（教養娯楽）",
              "cat01": "#L04424",
              "unit": "‐",
              "sourceId": ""
            },
            {
              "statId": "0000010212/#L04425/‐//消費者物価地域差指数（諸雑費）",
              "label": "消費者物価地域差指数（諸雑費）",
              "cat01": "#L04425",
              "unit": "‐",
              "sourceId": ""
            }
          ]
        },
        {
          "label": "Ｍ生活時間",
          "statId": "0000010213",
          "children": [
            {
              "statId": "0000010213/#M01101/分//１次活動の平均時間［男］",
              "label": "１次活動の平均時間［男］",
              "cat01": "#M01101",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M01102/分//１次活動の平均時間［女］",
              "label": "１次活動の平均時間［女］",
              "cat01": "#M01102",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0120106/分//２次活動の平均時間［有業者・男］",
              "label": "２次活動の平均時間［有業者・男］",
              "cat01": "#M0120106",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0120107/分//２次活動の平均時間［無業者・男］",
              "label": "２次活動の平均時間［無業者・男］",
              "cat01": "#M0120107",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0120206/分//２次活動の平均時間［有業者・女］",
              "label": "２次活動の平均時間［有業者・女］",
              "cat01": "#M0120206",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0120207/分//２次活動の平均時間［無業者・女］",
              "label": "２次活動の平均時間［無業者・女］",
              "cat01": "#M0120207",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0130106/分//３次活動の平均時間［有業者・男］",
              "label": "３次活動の平均時間［有業者・男］",
              "cat01": "#M0130106",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0130107/分//３次活動の平均時間［無業者・男］",
              "label": "３次活動の平均時間［無業者・男］",
              "cat01": "#M0130107",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0130206/分//３次活動の平均時間［有業者・女］",
              "label": "３次活動の平均時間［有業者・女］",
              "cat01": "#M0130206",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0130207/分//３次活動の平均時間［無業者・女］",
              "label": "３次活動の平均時間［無業者・女］",
              "cat01": "#M0130207",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0210101/分//仕事の平均時間［有業者・男］",
              "label": "仕事の平均時間［有業者・男］",
              "cat01": "#M0210101",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0210201/分//仕事の平均時間［有業者・女］",
              "label": "仕事の平均時間［有業者・女］",
              "cat01": "#M0210201",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0310101/分//趣味・娯楽の平均時間［有業者・男］",
              "label": "趣味・娯楽の平均時間［有業者・男］",
              "cat01": "#M0310101",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0310102/分//趣味・娯楽の平均時間［無業者・男］",
              "label": "趣味・娯楽の平均時間［無業者・男］",
              "cat01": "#M0310102",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0310201/分//趣味・娯楽の平均時間［有業者・女］",
              "label": "趣味・娯楽の平均時間［有業者・女］",
              "cat01": "#M0310201",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0310202/分//趣味・娯楽の平均時間［無業者・女］",
              "label": "趣味・娯楽の平均時間［無業者・女］",
              "cat01": "#M0310202",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0330101/分//テレビ・ラジオ・新聞・雑誌の平均時間［有業者・男］",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間［有業者・男］",
              "cat01": "#M0330101",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0330102/分//テレビ・ラジオ・新聞・雑誌の平均時間［無業者・男］",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間［無業者・男］",
              "cat01": "#M0330102",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0330201/分//テレビ・ラジオ・新聞・雑誌の平均時間［有業者・女］",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間［有業者・女］",
              "cat01": "#M0330201",
              "unit": "分",
              "sourceId": ""
            },
            {
              "statId": "0000010213/#M0330202/分//テレビ・ラジオ・新聞・雑誌の平均時間［無業者・女］",
              "label": "テレビ・ラジオ・新聞・雑誌の平均時間［無業者・女］",
              "cat01": "#M0330202",
              "unit": "分",
              "sourceId": ""
            }
          ]
        }
      ]
    }
  ];
// const metaPref = [
//   {
//     label: '基礎データ',
//     statId: 'kiso',
//     children: [
//       {
//         label: 'Ａ人口・世帯',
//         statId: '0000010101',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｂ自然環境',
//         statId: '0000010102',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｃ経済基盤',
//         statId: '0000010103',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｄ行政基盤',
//         statId: '0000010104',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｅ教育',
//         statId: '0000010105',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｆ労働',
//         statId: '0000010106',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｇ文化・スポーツ',
//         statId: '0000010107',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｈ居住',
//         statId: '0000010108',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｉ健康・医療',
//         statId: '0000010109',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｊ福祉・社会保障',
//         statId: '0000010110',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｋ安全',
//         statId: '0000010111',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｌ家計',
//         statId: '0000010112',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｍ生活時間',
//         statId: '0000010113',
//         children: [
//           {}//ダミー
//         ]
//       }
//     ]
//   },
//   {
//     label: '社会生活統計指標',
//     statId: 'syakai',
//     children: [
//       {
//         label: 'Ａ人口・世帯',
//         statId: '0000010201',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｂ自然環境',
//         statId: '0000010202',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｃ経済基盤',
//         statId: '0000010203',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｄ行政基盤',
//         statId: '0000010204',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｅ教育',
//         statId: '0000010205',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｆ労働',
//         statId: '0000010206',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｇ文化・スポーツ',
//         statId: '0000010207',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｈ居住',
//         statId: '0000010208',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｉ健康・医療',
//         statId: '0000010209',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｊ福祉・社会保障',
//         statId: '0000010210',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｋ安全',
//         statId: '0000010211',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｌ家計',
//         statId: '0000010212',
//         children: [
//           {}//ダミー
//         ]
//       },
//       {
//         label: 'Ｍ生活時間',
//         statId: '0000010213',
//         children: [
//           {}//ダミー
//         ]
//       },
//     ]
//   }
// ];

export default metaPref
